import SvgIcon from '@mui/material/SvgIcon';

const Monalisa = () => {
  return (
    <SvgIcon sx={{ width: 400, height: 400, maxWidth: "100%"}}>
      <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Capa 1"
      viewBox="0 0 275.06 337.5"
      >
    <path
      d="M169.77 23.4c1.12 1.48 2.72 2.3 4.8 2.46"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m174.57 25.87-.06 1.29"
      style={{
        fill: "none",
        stroke: "#d0a231",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M174.51 27.15c-1.35-.39-2.74-.25-4.17.42"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M170.34 27.58c-10.72-1.37-19.53-6.26-26.43-14.68a.385.385 0 0 0-.5-.09.39.39 0 0 0-.18.48l2.42 6.7c.11.31.31.56.6.74 2.9 1.82 8.16 2.88 9.5 6.31.89 2.25 1.6 4.35 2.15 6.29"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M157.9 33.33c.38 3.03 1.44 5.05 3.17 6.06 3.64 2.11 7.54 3.05 11.7 2.82"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M172.77 42.21c2.5.85 3.34.69 2.51-.5"
      style={{
        fill: "none",
        stroke: "#debc5a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M175.28 41.71c.62-.77 1.11-.97 1.46-.58"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M176.74 41.12c1.29 1.65 3.15 2.35 5.58 2.08"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M182.32 43.21c.77.45 1.56.14 2.37-.93"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M184.69 42.28c.7.32 1.59.44 2.68.37"
      style={{
        fill: "none",
        stroke: "#debc5a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M187.37 42.65c1.27-.21 2.57-.98 3.91-2.33"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M191.28 40.31c.53.27.94-.03 1.24-.9"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M192.52 39.42c.21-.85.97-.93 2.27-.24.31.17.62.17.93.01l6.48-3.37"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M202.2 35.81c.25-.42.36-.74.34-.97"
      style={{
        fill: "none",
        stroke: "#d0a231",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M202.54 34.85c3.01-.53 5.27-1.75 6.77-3.68.81-1.03 1.67-1.65 2.58-1.84.32-.07.58-.22.79-.47.65-.75 1.45-1.36 2.42-1.83"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m215.1 27.03 1.16-1.44"
      style={{
        fill: "none",
        stroke: "#d0a231",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M216.26 25.58c1.63-.49 2.53-1.24 2.72-2.23.04-.19-.18-.29-.67-.28"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M218.31 23.08c-.09-.51.21-.96.89-1.37"
      style={{
        fill: "none",
        stroke: "#d0a231",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m219.2 21.71 2.8.71c.34.08.7 0 .98-.21 1.36-1.06 2.89-1.64 4.6-1.73.38-.02.46-.55.1-.68-5.15-1.81-10.34-2.33-15.59-1.56"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m212.09 18.24-.5-.08c-.43-.07-.48-.25-.15-.54.31-.27.68-.43 1.11-.49 2.96-.41 5.92-.43 8.87-.04 2.8.36 4.86.19 7.53.16"
      style={{
        fill: "none",
        stroke: "#d0a231",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M228.95 17.24c1.31 1.73 3.27 2.76 5.86 3.11"
      style={{
        fill: "none",
        stroke: "#debc5a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m234.81 20.35 2.22-.16c.32-.03.53-.19.64-.49.47-1.33 1.04-1.59 1.7-.8"
      style={{
        fill: "none",
        stroke: "#d6b048",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M239.37 18.9c-.81 2.43-.02 4.01 2.37 4.76"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M241.74 23.67c-.35.54.12.76 1.39.66.37-.03.58.13.63.49l.25 1.6"
      style={{
        fill: "none",
        stroke: "#d6b048",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m244.01 26.42.07 2.45"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M244.08 28.87c.05.87.27 1.64.67 2.29.19.29.4.31.64.07l.93-.94"
      style={{
        fill: "none",
        stroke: "#d6b048",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M246.32 30.28c1.63-2.23 2.72-4.69 3.27-7.37"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M249.59 22.92c.61-.69 1.18-1.04 1.71-1.06.39-.02.67.38.52.74l-.85 1.97a.463.463 0 0 0 .79.47c1.47-1.92 2.54-2.35 3.21-1.3"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M254.97 23.74c-5.07 3.43-8.76 7.94-11.07 13.53-.11.26-.01.55.23.7.23.15.54.11.73-.1l11.85-13.08"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M256.71 24.78c2.25.35-.63 2.58-1.27 3.23l-5.46 5.55c-.82.84-3.55 2.89-1.42 2.58 4.56-.66 6.92-7.38 10.8-8.74"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M259.92 28.17c-1.21 1.08-4.48 3.22-4.39 5.08.16 3.15 5.22.55 6.82.19"
      style={{
        fill: "none",
        stroke: "#d6b048",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M262.71 34.9c-3.23-.39-6.53.38-9.92 2.3"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m252.79 37.21-1.96.66c-.29.09-.29.19 0 .29l4.23 1.46"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m255.06 39.62 2.05-.07"
      style={{
        fill: "none",
        stroke: "#debc5a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M257.11 39.54c-.48 5.13 4.96 7.26 9.31 5.76"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M261.61 111.03c-.82.53-1.84.65-2.79.59.86 1.47 2.78 1.44 3.87 2.68"
      style={{
        fill: "none",
        stroke: "#d6b048",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M262.52 117.73c-.76-1.64-2.15-2.89-4.17-3.74"
      style={{
        fill: "none",
        stroke: "#debc5a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M258.35 113.99c-.91-.09-1.31.54-1.2 1.91"
      style={{
        fill: "none",
        stroke: "#d6ac3f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M257.15 115.9c.07-.08.17.07.29.44"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M257.44 116.34c-.28 1.08-.83 1.17-1.66.26-.2-.22-.31-.52-.3-.83.15-2.83-.77-4.76-2.76-5.81"
      style={{
        fill: "none",
        stroke: "#d6ac3f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M252.72 109.96c-4.96-7.18-4.16-16.59-2.8-24.62.04-.22-.26-.33-.37-.14-2.48 4.27-4.39 8.49-5.74 12.65"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M243.81 97.85c-.81 1.57-.91 2.74-.32 3.52"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M243.49 101.36c.11.21.21.41.31.61"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M243.8 101.97c-2.84 1.71-3.8 3.46-2.88 5.25"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M240.92 107.22c-1.33 2.39-1.64 5.11-.94 8.17"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M239.98 115.4c-2.02 4.21-2.33 8.68-.93 13.4"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M239.05 128.79c0 3.63.51 6.99 1.58 10.06"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M240.63 138.85c.07 1.36.3 2.28.69 2.77"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m241.32 141.62 3.54 10.37c.15.44.41.53.8.27 2.6-1.79 5.5-2.97 8.7-3.54"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M254.36 148.73c-.27.93-.2 1.35.2 1.26"
      style={{
        fill: "none",
        stroke: "#cd9f2b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M254.56 149.99c-8.97 1.5-13.2 8.27-15.46 16.71"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m239.1 166.7.71 1.54"
      style={{
        fill: "none",
        stroke: "#cd9f2b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M239.81 168.24c7-1.61 11-6.61 17.29-10.11"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M264.06 156.15c-6.13 3.14-11.82 7-17.09 11.59-.38.33-.32.46.17.37 6.6-1.09 12.23-4.21 16.88-9.38"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m264.02 158.74-.12 1.24"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M263.9 159.98c-2.48 3.41-5.94 5.89-10.37 7.46-.46.16-.47.82-.01.99.87.31 1.98.15 3.33-.5"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M256.85 167.93c-.17.82-.06 1.68.35 2.58"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M257.2 170.51c-1.38-.42-2.66-.55-3.85-.38-.37.05-.39.17-.06.34l5.54 2.9"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M258.83 173.37c.07.72-.1 1.15-.5 1.29"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M258.33 174.65c-3.41-2.16-6.91-3.62-10.51-4.39-1.49-.31-1.62-.02-.39.88l10.46 7.66"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m257.89 178.8-1.94 1.92"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M255.95 180.73c-4.29-5.91-9.65-9.41-16.08-10.49"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M239.87 170.24c-.71.87-.96 1.75-.75 2.62"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M239.12 172.85c-.74 1.29-1.01 2.04-.82 2.27"
      style={{
        fill: "none",
        stroke: "#cd9d2f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m238.3 175.12.14 24.03c0 .12.09.23.22.25.12 0 .24-.06.28-.18l4.87-14.53"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M243.81 184.7c.39-.93.85-.56 1.36 1.12"
      style={{
        fill: "none",
        stroke: "#cd9d2f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M245.17 185.82c-2.21 4.2-3.58 8.62-4.13 13.25"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M241.04 199.07c-.78 1.27-1.31 3.04-1.6 5.3"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m239.44 204.37-.7 7.49"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M238.74 211.85c-1 3.6-.55 7.43 1.34 11.49"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M240.08 223.35c-.47 2.52-.43 4.87.13 7.05"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M240.21 230.4c.39 2.47 1.43 4.57 3.14 6.32"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M243.35 236.71c-.33.99-.33 1.83 0 2.53"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M243.35 239.24c.18.08.41.4.68.97"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M244.03 240.21c1.11 3.97 2.83 7.91 5.18 11.82.09.15.27.21.43.15.16-.06.25-.23.22-.4-1.47-7.39-1.81-16.09 2.41-22.72"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m252.27 229.07 2.81-2.67"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M255.08 226.4c.45.47.58-.18.39-1.97"
      style={{
        fill: "none",
        stroke: "#cd9d2f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M255.47 224.43c.39-.21.49-.81.29-1.81"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m255.76 222.62 1.05-.99v2c2 1 2 4 4.79 3.81"
      style={{
        fill: "none",
        stroke: "#cd9d2f",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M266.12 283.42c-2.23-4.24-11 11.89-2.26 7.23"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M267.1 292.99c-2.03-.65-5.04-.49-7.01.39-1.56.7-4.92 4.55-1.12 4.3"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M258.97 297.68c-2.16 1.94-5.16 1.94-8.43 2.41.59.78 1.48-.83 0 0 .59.78 1.53 1.19 2.52 1.11M249.25 303.18c-2.18-1.3-4.49-3.3-7.11-2.29.67.42 1.61.61 2.29.92"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M246.2 307.73c-1.63-2.56-2.43 2.55-1.16 4.21M244.35 312.69c-.04-.2-.1-.39-.17-.58-.45 1.3-1.09 2.37-2.39 2.44M238.81 318.86c-1.17-.91-2.67-1.51-4.15-1.09M230.43 319.82c-1.24.44-1.97 1.67-1.36 2.9"
      style={{
        fill: "none",
        stroke: "#d6b048",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M180.85 314.79c-1.19.98-2.21 2.21-2.68 3.7"
      style={{
        fill: "none",
        stroke: "#d9b34e",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M176.15 319.8c1.71-1.18 1.65-4.34-.28-2"
      style={{
        fill: "none",
        stroke: "#debc5a",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M174.73 316.9c2.5-.75 3.9-1.97 4.19-3.67"
      style={{
        fill: "none",
        stroke: "#dfbf65",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M178.92 313.23c-1.22-.79-1.23-1.8-.04-3.03.17-.17.35-.2.56-.07l1.23.77c.41.25.74.18 1.01-.22.51-.77 1.22-1.13 2.12-1.07.15.01.23.09.25.23l.04.32c.05.32.23.52.54.59 4.45 1.07 10 3.2 16.63 6.39 8.16 3.93 16.95 4.41 26.36 1.42.29-.09.28-.18-.01-.26l-2.93-.78"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M224.68 317.52c-1.01-1.01-1.96-1.62-2.85-1.83-.33-.07-.62-.01-.89.2-.8.64-1.82 1.02-3.05 1.15"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M217.89 317.05c1.13-1.47 1.34-2.41.64-2.81-1.79-1.03-3.29-2.09-4.49-3.2"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M214.04 311.04c-.82-1.51-1.96-2.3-3.43-2.37"
      style={{
        fill: "none",
        stroke: "#d9b34e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M210.61 308.67c-1.44-2.37-3.35-3.82-5.74-4.33-.33-.07-.63-.22-.88-.43l-2.4-2.01"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m201.59 301.89-5.77-2.88c-.31-.16-.63-.16-.94-.01l-2.05.95"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M192.83 299.95c-.43.06-.6-.56-.51-1.85"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M192.32 298.11c-1.01-.69-1.94-.9-2.8-.63"
      style={{
        fill: "none",
        stroke: "#debc5a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M189.52 297.48c.19-.98-.03-1.53-.65-1.66-3.03-.61-5.8-.81-8.31-.59"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M180.56 295.23c-1.72-.03-3.07.82-4.06 2.53"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M176.5 297.76c.02-.21-.28-.2-.89.01-.39.13-.58 0-.59-.41v-.52"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M175.01 296.83c.25-.26.42-.55.5-.87.1-.37-.04-.51-.41-.41l-1.49.4"
      style={{
        fill: "none",
        stroke: "#debc5a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M173.61 295.95c-1.94-.31-2.72-.33-2.33-.04"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M171.28 295.92c-5.06.59-9.08 2.13-12.05 4.61"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M159.23 300.52c-.71 1.23-1.52 1.08-2.43-.46-.22-.37-.26-.68-.13-.93.16-.3.5-.48 1.02-.55"
      style={{
        fill: "none",
        stroke: "#cd9f2b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m157.69 298.58 7.36-2.84c.68-.26.66-.39-.07-.38l-25.12.21"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M139.86 295.58c-1.13 1.44-2.34 1.5-3.64.17"
      style={{
        fill: "none",
        stroke: "#cd9f2b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m136.22 295.74-4.4-.29"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m131.82 295.45-20.53-.15c-.72 0-.75.13-.08.4l7.35 3.03"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M118.56 298.73c1.91.78.03 2.8.66 3.99"
      style={{
        fill: "none",
        stroke: "#cd9f2b",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="m125.97 306.55 1.44 2.59c.12.23.3.3.55.22.23-.07.44-.24.64-.51"
      style={{
        fill: "none",
        stroke: "#d3b255",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M128.6 308.85c1.01 1.71 1.29 3.63.84 5.76-.03.13-.11.19-.25.17l-.67-.12c-.39-.07-.67.08-.84.43l-.44.87"
      style={{
        fill: "none",
        stroke: "#cd9f2b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M127.24 315.95c-3.25-.65-5.6-2.09-7.04-4.34"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M120.2 311.61c-.87-3.61-1.78-6.86-2.75-9.74-1.4-4.14-8.64-5.27-12.42-6.35"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m105.03 295.52-2.33.49"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M102.7 296.02c-.53-.41-1.15-.63-1.86-.64-.26 0-.42.28-.29.5.15.25.43.44.85.58"
      style={{
        fill: "none",
        stroke: "#ddb957",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M101.4 296.45c-.27.87-.78 1.31-1.51 1.32"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M99.89 297.77c-1.35-2.21-3.24-3.05-5.68-2.52"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M94.21 295.26c-.73-.67-1.63-.56-2.71.33-.25.2-.52.26-.83.19-2.13-.54-3.67.05-4.63 1.78"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M86.04 297.55c-.11-.14-.63-.13-1.54.03"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m84.5 297.58-1.4 1.98"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M83.1 299.57c-3.71-.57-7.32.92-10.82 4.48-.24.25-.53.37-.87.36-1.83-.03-2.96.69-3.41 2.16"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M68 306.57c-1.15.25-1.82.8-2.01 1.66-.06.3.15.59.46.62l.6.04c.17 0 .22.25.07.33-1.94 1.08-3.18-2.05-5.06 1.63"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m62.06 310.85-4.65 3.41c-.33.24-.37.52-.12.83.47.61.74 1.26.82 1.93"
      style={{
        fill: "none",
        stroke: "#d0a231",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M58.11 317.02c-1.51-.32-3.28-1.72-4.54-.7"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m53.57 316.32-5.08 1.71"
      style={{
        fill: "none",
        stroke: "#d6ac3f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M48.49 318.02c-1.5 1.94-2.41.45-4.19.57"
      style={{
        fill: "none",
        stroke: "#d0a231",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M42.96 318.22c-1.32-1.25-3.54-.76-5.13-.36M35.03 314.73c-3.22-1.1-1.22-5.1-4.22-7.1 0 0-1 1-1.44 1.04-.1-.57 1.54-1.37 0 0-.1-.57-.02-1.09.21-1.62"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M31.8 302.34c.84-1.05.65-3.15-.9-1.61"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M29.11 301.92c-1.4.12-2.79.71-3.69 1.82.4.04.81.21 1.2.22M23.54 304.92c-2.38.36-2.27-.19-3.4-2.34"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M20.14 302.58c1.41-.11 2.64-.59 3.69-1.46"
      style={{
        fill: "none",
        stroke: "#debc5a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M23.83 301.11c.84-.13 1.44-.39 1.81-.77.25-.26-.03-.68-.37-.54-.88.36-1.6.29-2.17-.2-.29-.25-.62-.42-.99-.5-2.46-.54-4.87-.57-7.22-.09"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M14.89 299.02c-1.27-.33-2.24-.26-2.9.21"
      style={{
        fill: "none",
        stroke: "#b49e48",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M11.99 299.23c-1.76.02-5.12.26-5.07 2.72"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M13.31 296.01c1.45.48 5.64 2.82 6.14.16"
      style={{
        fill: "none",
        stroke: "#d6b048",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M19.44 296.17c.04-.81.34-1.34.9-1.61"
      style={{
        fill: "none",
        stroke: "#cd9f2b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M20.34 294.57c3.59 3.91 7.75 4.83 12.46 2.74 1.75-.77 2.76-2.71 4.08-4.1.21-.22.34-.48.39-.78.61-3.48.18-6.77-1.29-9.88-.15-.32-.44-.55-.79-.63l-.64-.13"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M34.55 281.79c-.03-.39-.41-.77-1.13-1.14-.23-.12-.49-.16-.74-.13-5.59.73-6.23 8.69-1.45 7.53.57-.13.88-.82.94-2.05"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M32.17 285.99c.63 1.24.57 2.27-.19 3.1"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M31.98 289.1c-1.6 1.41-3.4.92-5.4-1.47"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M26.58 287.62c-.53-.05-.53-.67 0-1.88.06-.14.07-.28.04-.42l-.65-2.81c-.12-.52.08-.8.61-.83 1.05-.07 1.7-.6 1.95-1.58.09-.34.43-.55.77-.48.25.05.43-.02.56-.19.21-.29.14-.47-.21-.53-3.98-.68-5.75.39-9.3 1.61-.33.11-.52.37-.57.76-.04.32.3.54.57.38.83-.48 1.58-.42 2.23.17.25.22.27.59.06.85-.09.11-.21.18-.35.21"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m22.3 282.89-3.6-.25c-.93-.07-1.31-1.23-.6-1.83 2.21-1.86 4.73-2.91 7.57-3.14.45-.04.65-.57.34-.9l-3.04-3.16c-.81-.84-.21-2.23.95-2.23 2.31.01 4.43.66 6.34 1.96.29.2.68-.07.58-.41-1-3.54-1.05-7.1-.15-10.67.18-.68 1.15-.66 1.3.03.27 1.21 1.02 2.31 2.26 3.3"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m34.25 265.58 1.87 3.57c.31.58 1.18.37 1.19-.29l.25-22.95"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m37.56 245.92.02-10.59"
      style={{
        fill: "none",
        stroke: "#cd9f2b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m37.58 235.32-.04-3.58c0-.37-.17-.45-.48-.26-.2.12-.26.34-.18.65"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m36.88 232.13-.71.13c-.17.03-.28-.03-.33-.19a.363.363 0 0 0-.23-.25"
      style={{
        fill: "none",
        stroke: "#cd9f2b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M35.61 231.82c.83-3.56 1.08-6.74.74-9.53"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M36.35 222.29c1.11-3.11 1.55-6.68 1.33-10.73-.23-4.34-.64-12.12-4.53-14.49"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M33.15 197.07c-.31-.42-.65-.66-1.02-.71-.34-.05-.52.09-.55.43l-.06.73c-.05.75-.32.84-.81.25-.65-.79-.96-1.68-.92-2.67a.64.64 0 0 1 .91-.56l3.58 1.61c.54.25.72.09.53-.47l-3.19-9.51a.608.608 0 0 0-.96-.27c-2.6 2.18-5.62 3.35-9.07 3.52-.45.02-.6.24-.47.67 3.09 9.79 4.83 18.73 2.07 28.48"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m23.19 218.57-.87.07"
      style={{
        fill: "none",
        stroke: "#cd9f2b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M22.32 218.65c-.51-1.4-.72-3.18-2.36-3.62"
      style={{
        fill: "none",
        stroke: "#d9b34e",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M17.56 189.02c3.23-.61 6.7-.87 9.48-2.4 6.44-3.53 7.17-8.05 10.06-13.98"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M37.1 172.65c.21-.32.35-.62.42-.91.24-1-.66-1.9-1.66-1.66l-.65.16"
      style={{
        fill: "none",
        stroke: "#d2a839",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M35.21 170.24c-5.79 1.69-10.61 4.99-14.46 9.91"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M20.75 180.15c-1.11.12-1.67-.47-1.7-1.76"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m19.05 178.38 10.17-7.68c.47-.36.41-.5-.18-.43-3.18.39-6.26 1.52-9.24 3.39"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m19.8 173.66-.34-.29c-.21-.17-.25-.38-.14-.62l.2-.43"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m19.52 172.32 3.5-1.94c.28-.16.28-.31-.01-.46-.39-.21-1.03-.13-1.92.23"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M21.09 170.15c-.48-.27-.61-.7-.39-1.27.09-.25.19-.41.29-.46.13-.07.33-.14.6-.19"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M21.59 168.24c.27.17.69.21 1.26.11"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M22.85 168.35c.41.21.95-.26 1.62-1.42"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m24.47 166.93 4.87 1.32c.54.15.6.04.17-.33a87.166 87.166 0 0 0-17.39-11.81"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M19.02 156.6c2.19.5 4.84 5.11 6.76 6.62 2.76 2.16 5.91 3.76 9.25 4.8"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M35.03 168.02c1.22.59 1.99.22 2.3-1.09"
      style={{
        fill: "none",
        stroke: "#d2a839",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M37.33 166.93c-.75-2.47-1.57-4.68-2.45-6.63-3.79-8.4-9.37-9.54-17.62-11.23"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M19.89 131.42c-.08.21.92-.79.92-.79 0 5 0 10-2 15l1 1c1-7 4-14 3-21 0-1-3-4 .44-5.33"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M23.25 120.29c2.56 9.51 1.03 17.49-1.91 27.11-.11.35.1.71.45.79 3.24.75 6.16 2.14 8.77 4.19.35.27.63.21.84-.18 1.65-3.19 2.73-6.7 3.24-10.53"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M34.64 141.68c-.48-.19-.53-.65-.14-1.36"
      style={{
        fill: "none",
        stroke: "#d0a231",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M34.5 140.32c2.09-3.59 4.76-13.21 2.3-17.68a.405.405 0 0 0-.75.1c-.76 3.1-1.76 6.06-3.01 8.87-.19.43-.45.68-.78.74-.29.05-.39-.07-.3-.36l2.79-8.73c.14-.43-.38-.77-.72-.47-.43.37-.71.9-.84 1.59"
      style={{
        fill: "none",
        stroke: "#debc5a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M33.19 124.38c-.01-.37-.37-.57-1.06-.59"
      style={{
        fill: "none",
        stroke: "#d0a231",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M32.13 123.79c4.15-4.98 5.35-10.61 3.6-16.89"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M35.73 106.89c2.09.33 2.68.21 1.76-.37"
      style={{
        fill: "none",
        stroke: "#d0a231",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M37.49 106.53c.1-3.19.99-8.19-1.7-8.86-.41-.11-.55-.36-.4-.75.25-.65.31-1.13.19-1.43"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M35.58 95.49c.64-.07.95-.41.94-1.04"
      style={{
        fill: "none",
        stroke: "#d0a231",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M36.52 94.44c.11-.02.22-.04.34-.06.25-.05.38-.2.39-.45l.22-24.79a.67.67 0 0 0-.59-.67.659.659 0 0 0-.72.51c-.44 1.97-1.27 3.43-2.48 4.4"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M33.68 73.39c-.88.85-1.44 1.72-1.69 2.63-.19.68-1.16.67-1.33-.02a21.65 21.65 0 0 1-.01-10.4c.09-.37-.32-.66-.63-.45-1.87 1.25-3.92 1.82-6.15 1.7a1.243 1.243 0 0 1-1.01-1.86c.81-1.4 1.9-2.5 3.29-3.29.35-.2.26-.73-.14-.8-2.79-.45-5.37-1.45-7.75-3.02-1.02-.67-.61-2.25.61-2.33l3.7-.24a.46.46 0 0 0 .38-.68c-.97-1.85-1.45-3.83-1.42-5.93 0-.86 1.01-1.33 1.68-.79l3.04 2.43c.28.23.57.24.87.05.37-.23.62-.52.74-.89.08-.23.24-.43.45-.56 1.61-.94 3.16-.57 4.65 1.11"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m32.96 50.04-.59 2.44"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M32.37 52.49c-.21-1.35-.74-2.14-1.57-2.38-4.31-1.24-3.57 9.34 3.05 7.25"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M33.85 57.36c4.05-2.25 4.76-9.62 2.35-13.2-1.24-1.85-2.85-3.15-4.82-3.9"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M31.38 40.26c-5.85-1.44-10.93 1.7-13.14 6.9-3.27 7.73.11 17.88 3.75 25.14.89 1.78 1.01 3.36 3.76 2.68"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M25.75 74.97c-.13 1.05-.66 1.61-1.6 1.69"
      style={{
        fill: "none",
        stroke: "#d0a231",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M24.15 76.67c.96 1.75 2.38 3.15 4.27 4.2"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M28.42 80.86c-.19.55-.56.91-1.12 1.09-.25.07-.41.24-.47.49-.17.71-.03.83.4.36"
      style={{
        fill: "none",
        stroke: "#d0a231",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m27.23 82.81.12.48"
      style={{
        fill: "none",
        stroke: "#debc5a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M27.35 83.29c-.94.47-1.32 1.03-1.14 1.69a.48.48 0 0 1-.7.54c-.34-.19-.75-.69-1.22-1.52"
      style={{
        fill: "none",
        stroke: "#d0a231",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m24.29 84-.65-3.64c-.1-.57-.28-.6-.55-.08-.31.6-.39 1.3-.26 2.09"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m22.83 82.36-.42.44c-.62.66-1.7.02-1.42-.84.74-2.32.91-4.69.51-7.11-.03-.18-.11-.35-.22-.49-.73-.93-1.42-1.02-2.09-.28"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m19.19 74.08-1.57 4.34"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m17.62 78.43-1.11.16"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m16.51 78.58.85-4.27"
      style={{
        fill: "none",
        stroke: "#dfbf65",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m17.36 74.32 2.02-2.52c.23-.29.27-.6.12-.94-2.29-5.06-3.81-10.29-4.56-15.69"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M14.94 55.17c.03-.87-.26-1.5-.87-1.91"
      style={{
        fill: "none",
        stroke: "#cd9f2b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M14.07 53.25c.9-1.08 1.49-2.46 1.78-4.14"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M15.85 49.11c.84-.81.6-1.94-.54-2.28s-1.96.99-3.11 1.12"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M10.91 44.99c2.32.98 4.9.43 7.73-1.66.99-.73.22-2.3-.97-1.95-.37.11-1.02.07-1.95-.12"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M15.72 41.26c-.09-.37.02-.81.32-1.3"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m16.04 39.96 5.01-.37"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M21.05 39.58c1.13-.04 1.9-.46 2.31-1.26"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M23.36 38.33c.76.16 1.36.16 1.79-.01.43-.17.43-.34.02-.53l-4.44-2.01"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M20.73 35.78c.36-2.04.19-3.11-.51-3.21"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M20.22 32.56c-.48-.93-1.05-1.63-1.71-2.1"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M18.51 30.47c.19-.65.54-.95 1.04-.9"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M19.55 29.56c2.41 2.73 5.17 4.92 8.26 6.57"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M27.81 36.13c.67.77 1.55.97 2.64.59"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M30.45 36.72c.41 1 .87 1.47 1.37 1.4.39-.05.52-.26.4-.63-2.07-6.29-6.09-11.07-12.06-14.33"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M20.16 23.17c.75-.65 1.64-.75 2.69-.3"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M22.85 22.87c.83 1.33 1.67 1.93 2.52 1.8"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M25.37 24.67c-.31-.64.21-.99 1.54-1.06"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m26.91 23.6 2.48 6.09"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M29.39 29.69c.47.75 1.01 1.27 1.61 1.58.41.21.67.08.77-.37l.23-1.05"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m32 29.85.09-3.52"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M32.09 26.33c.64-1.1 1.63-2 2.98-2.71"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M35.07 23.62c1.37-.84 2.1-1.66 2.19-2.46"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M37.26 21.17c1.18-.69 2.43-.93 3.74-.72"
      style={{
        fill: "none",
        stroke: "#d5ae44",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M41 20.44c2.58-.45 4.67-1.48 6.28-3.1.29-.29.3-.63.02-1.04"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M94.52 24.81c1.49-.41 2.29-1.23 2.42-2.46.03-.31.33-.52.63-.45.99.25 1.81-.04 2.45-.88.19-.26.45-.39.78-.39h.5c.43 0 .57.58.18.77-1.77.87-3.19 2.01-4.24 3.43"
      style={{
        fill: "none",
        stroke: "#d9b34e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M97.24 24.83c1.55 1.89 1.48 3.17-.21 3.85"
      style={{
        fill: "none",
        stroke: "#d2a839",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M97.03 28.67c-.27-.55-.66-.93-1.15-1.15a.88.88 0 0 0-.86.05l-7.52 4.45"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m87.5 32.03-3.43 1.58"
      style={{
        fill: "none",
        stroke: "#dfbf65",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m84.07 33.6-5.95 1.38c-.47.11-.65-.08-.56-.55.27-1.29.11-1.95-.47-1.98"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M77.09 32.46c-1.99-1.35-4.26-2.1-6.82-2.23"
      style={{
        fill: "none",
        stroke: "#ddb957",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M70.27 30.22c-.43-.31-.54-.66-.34-1.03.14-.27.35-.5.62-.67.31-.2.3-.38-.03-.55-2.67-1.35-5.5-1.72-8.49-1.13-.34.07-.39.23-.16.49.96 1.05 2.05 1.88 3.27 2.48.27.13.48.32.64.57.45.72 1.08 1.14 1.87 1.27.35.06.63.23.84.52l.8 1.1c.19.27.45.42.78.47 2.86.45 4.11 2.54 5.88 3.53 2.27 1.27 4.39 1.82 6.36 1.64"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M82.31 38.92c.79-.17 1.31.12 1.57.87.11.31.33.5.64.57.23.05.5.04.79-.03"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M85.31 40.33c.17.05.25.15.24.29"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M85.55 40.62c1.03 1.47 2.27 2.09 3.7 1.86"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m89.25 42.47 5.52.7"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M94.77 43.17c1.85.08 3.29-.4 4.33-1.44"
      style={{
        fill: "none",
        stroke: "#ddb957",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M99.1 41.74c.9.71 1.61 1.09 2.12 1.14"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M101.22 42.88c1.82-.87 2.61-1.06 2.37-.56"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M103.59 42.31c3.27-.08 6.49-.69 9.67-1.84 4.22-1.52 5.54-6.93 5.97-11.03"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M119.23 29.44c1.08-3.11 3.16-5.52 6.25-7.23"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M125.48 22.22c3.45.21 5.42-1.32 5.92-4.61"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m131.4 17.6 1.3-4.19c.23-.73.09-.8-.41-.23-7.18 8.28-16.09 13.06-26.74 14.33"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M105.55 27.51c-1.09-.68-2.17-.81-3.23-.4"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M102.32 27.12c-.32-.17-.12-.62.59-1.34"
      style={{
        fill: "none",
        stroke: "#d2a839",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M102.91 25.78c1.49-.26 2.76-1.08 3.82-2.47"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M259.2 189.2c.58-.39.73-.69.46-.89-6.31-4.65-12.37-9.6-18.16-14.86-.93-.85-1.59-.97-1.98-.36"
      style={{
        fill: "none",
        stroke: "#ebd382",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M239.52 173.09c-.1 0-.23-.07-.4-.23"
      style={{
        fill: "none",
        stroke: "#d5ad4b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m239.87 170.24 17.27 14.25c.49.41.65.3.49-.31-.35-1.33-.91-2.48-1.68-3.45M257.89 178.8l7.51 4.01c.26.14.59.06.77-.18.17-.24.14-.58-.08-.78l-7.76-7.2M258.83 173.37l5.42 4.78c.39.35.55.26.49-.26-.48-3.92-4.29-6.04-7.54-7.38M256.85 167.93c3.73-1.07 6.41-3.41 8.04-7.04a.778.778 0 0 0-.46-1.06c-.13-.05-.31 0-.53.15M264.02 158.74l2.13-1.78c.3-.25.37-.69.17-1.03a.808.808 0 0 0-.99-.31l-1.27.54"
      style={{
        fill: "none",
        stroke: "#ebd382",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M260.34 152.15c-2.67-.3-8.1 5.46-10.15 7.12-3.55 2.88-7.01 5.87-10.37 8.97"
      style={{
        fill: "none",
        stroke: "#e3c469",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="m239.1 166.7 20.36-16.4c.57-.46.14-1.38-.58-1.23l-4.32.92"
      style={{
        fill: "none",
        stroke: "#e3c469",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M37.1 172.65c0-.35-.2-.54-.57-.55-.14 0-.28.04-.39.14-6.19 5.76-12.73 11.1-19.61 16.01-.44.32-.39.53.14.62l.89.16"
      style={{
        fill: "none",
        stroke: "#e8cd77",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M17.38 185.73c2.49-1.75 19.21-13.59 17.83-15.49"
      style={{
        fill: "none",
        stroke: "#e8cd77",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M17.26 149.07c-.33.07-.56.18-.7.34-.21.23-.2.44.04.64l20.73 16.88"
      style={{
        fill: "none",
        stroke: "#e8cd77",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M35.03 168.02c-5.22-7.4-12.22-11.4-19.02-16.16"
      style={{
        fill: "none",
        stroke: "#e8cd77",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="m229.07 16.83-.12.42"
      style={{
        fill: "none",
        stroke: "#e1c163",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M212.09 18.24c-10.28 1.39-17.77 7.34-27.61 9.52-.24.05-.29.37-.07.49l7.57 4.05"
      style={{
        fill: "none",
        stroke: "#debb57",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m191.98 32.29 4.28 1.08c.28.07.58-.05.73-.3.91-1.45 2.23-2.29 3.96-2.51.44-.05.69-.3.76-.74l.15-1c.05-.29.19-.51.42-.68a12.06 12.06 0 0 1 4.52-1.98c.33-.07.54-.27.61-.6l.5-2.15"
      style={{
        fill: "none",
        stroke: "#d9af45",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M207.91 23.42c4.4-2.38 8.16-2.95 11.29-1.71"
      style={{
        fill: "none",
        stroke: "#debb57",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M218.31 23.08c-1.86-.57-3.76-.68-5.71-.34-.32.06-.35.51-.04.61l.96.3c.11.03.2.1.26.21l.22.36c.13.21-.04.48-.29.46l-2.94-.29a.334.334 0 0 0-.28.56c.19.21.47.33.83.38 2.01.26 3.65.35 4.94.26M215.1 27.03c-4.25-.85-8.31-.18-12.18 2.03-.13.07-.14.16-.04.27l.24.23c.09.09.18.1.28.03.75-.48 1.67-.73 2.75-.76.4-.01.65.29.56.68-.08.39-.47.72-.87.74-2.87.14-5.39 1.09-7.56 2.85a.708.708 0 0 0 .36 1.25l3.9.5"
      style={{
        fill: "none",
        stroke: "#dcb753",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m202.2 35.81-11.47-2.72"
      style={{
        fill: "none",
        stroke: "#d9af45",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M169.48 28.88c.11.32.49.57 1.16.75.3.08.58.04.84-.13 1.67-1.05 3.33-1.01 4.97.13.57.4 1.36 0 1.36-.7v-.51c0-.37-.18-.55-.55-.52-1.01.07-1.93-.18-2.75-.74"
      style={{
        fill: "none",
        stroke: "#e4c367",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m174.57 25.87 2.6.5c.23.05.46-.09.53-.32a.455.455 0 0 0-.26-.56l-6.74-2.82c-.29-.12-.54-.06-.75.19a.75.75 0 0 0-.18.55"
      style={{
        fill: "none",
        stroke: "#e5c56b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M170.51 20.18c-.46 2.13 3.74 2.94 5.22 3.53 2.19.88 3.52.99 1.44-.93-.48-.44-4.22-3.01-1.47-2.38.84.19 1.9 2.37 2.25.44.22-1.19-1.78-2.49-2.65-2.92"
      style={{
        fill: "none",
        stroke: "#e1c163",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M177.96 18.15a8.538 8.538 0 0 0 2.66 5.72"
      style={{
        fill: "none",
        stroke: "#dcb753",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M23.83 301.11c0-.11.02-.22 0-.31-.02-.29-.17-.42-.46-.41l-6.24.31c-.28.02-.53.12-.76.29-1.87 1.45-3.32.32-5.31.93-.3.09-.31.21-.02.34 3.17 1.47 6.2 1.57 9.09.31"
      style={{
        fill: "none",
        stroke: "#e7cd77",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M46.63 320.08c1.42.62 1.37 2.08.28 2.99"
      style={{
        fill: "none",
        stroke: "#d8b34d",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M11.99 299.23c1.28.35 2.25.28 2.9-.21"
      style={{
        fill: "none",
        stroke: "#bcae64",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M30.28 15.08c1.53 3.55 1.53 7.55 1.81 11.26"
      style={{
        fill: "none",
        stroke: "#ebd382",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M250.57 320.14c-.48-.88-.96-1.76-1.49-2.61-.04.83-.33.29-.84.46"
      style={{
        fill: "none",
        stroke: "#dfc165",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M70.27 30.22a.77.77 0 0 0-.19.37c-.08.31.02.56.29.74 1.95 1.25 4.19 1.63 6.72 1.12"
      style={{
        fill: "none",
        stroke: "#ebd27d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m84.07 33.6 13.34 3.62"
      style={{
        fill: "none",
        stroke: "#eed78b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M97.41 37.22c-5.69-.68-10.73-.12-15.1 1.69"
      style={{
        fill: "none",
        stroke: "#dfbe5c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M15.85 49.11c-.06-.13-.17-.21-.34-.24-.33-.07-.57.04-.74.33l-3.36 5.87c-.16.28-.08.46.24.55l.42.11"
      style={{
        fill: "none",
        stroke: "#eed585",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M250.05 19.69c.19-1.32-.07-2.24-.76-2.77-.34-.25-.57-.18-.7.22-1.35 4.09-2.1 8.47-2.27 13.15M244.08 28.87c.64-.21 1.07-.76 1.3-1.67.75-3 1.43-5.97 1.65-9.07.1-1.44 1.48-3.4.91-4.65-.19-.41-.39-.42-.6-.02-2.13 4.01-3.24 8.33-3.33 12.96M241.74 23.67 240.69 18c-.05-.31-.24-.43-.55-.37-.49.09-.74.52-.77 1.28"
      style={{
        fill: "none",
        stroke: "#ebd382",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M234.81 20.35c-1.19-1.82-3.11-3-5.74-3.53"
      style={{
        fill: "none",
        stroke: "#e8ce7a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m189.52 297.48-6.39 1.36c-.23.05-.38.27-.33.51.04.23.27.38.5.34l9.02-1.58"
      style={{
        fill: "none",
        stroke: "#e2c468",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M192.83 299.95c-4.27 1.88-8.52 2.13-12.73.75-.33-.11-.66-.11-.99-.02-1.69.48-3.93 1.65-5.52.4-.31-.24-.6-.22-.87.05-1.34 1.35-2.96 2.08-4.87 2.19-.95.05-1.53-1.04-.94-1.79l4.37-5.62"
      style={{
        fill: "none",
        stroke: "#dfbe5c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m173.61 295.95-4.77 4.36c-.25.23-.21.41.1.54.2.08.42 0 .65-.2 1.63-1.51 3.44-2.79 5.42-3.82"
      style={{
        fill: "none",
        stroke: "#e2c468",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m176.5 297.76 4.94-1.79c.15-.05.23-.21.19-.36a.3.3 0 0 0-.34-.23c-.25.04-.5-.01-.73-.15"
      style={{
        fill: "none",
        stroke: "#dfbe5c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M257.44 116.34c.63 2.75 2.17 4.6 4.64 5.55.29.11.62 0 .77-.29a.63.63 0 0 0-.21-.8c-1.86-1.26-3.3-2.88-4.31-4.86-.1-.2-.31-.33-.54-.32-.25 0-.46.09-.64.28"
      style={{
        fill: "none",
        stroke: "#eacd75",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M258.35 113.99c1.37 2.95 3.23 5.42 5.57 7.39.17.14.34.22.49.23.22.03.38-.03.49-.18.22-.29.18-.53-.11-.74a6.167 6.167 0 0 1-2.27-2.96"
      style={{
        fill: "none",
        stroke: "#e8ca71",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M256.47 123.44c-2.66-1.82-3.66-5.82-1.66-8.82l-1-1c-3 11-2 23 .7 33.81"
      style={{
        fill: "none",
        stroke: "#d7ae42",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M22.83 82.36c.03 3.05-.4 6.04-1.31 8.99-.11.33.02.51.37.52.33.01.54-.1.64-.31.85-1.79 1.31-3.66 1.37-5.6"
      style={{
        fill: "none",
        stroke: "#e9cf7b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M23.9 85.96c1.67.38 2.2 1.58 1.58 3.61-.1.33-.1.69.02 1.02.68 1.96 1.23 3.38.5 5.5-.72 2.11-1.49 4.45-2.31 7.01"
      style={{
        fill: "none",
        stroke: "#d8b34d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M17.62 78.43c-.61 2.07-.76 4.21-.47 6.4.06.42.61.55.84.19.77-1.17 1.03-2.46.79-3.87-.07-.36-.04-.74.07-1.09.56-1.79.89-3.6 1-5.43.01-.22-.04-.37-.14-.44-.11-.08-.29-.11-.52-.1"
      style={{
        fill: "none",
        stroke: "#ead17f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M33.85 57.36c-.31-1.55-.43-2.96-.35-4.23.04-.71-.34-.92-1.13-.64"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M256.71 24.78c.47-.24.78-.51.92-.81.16-.33.07-.55-.28-.65-1.03-.31-1.82-.18-2.38.41"
      style={{
        fill: "none",
        stroke: "#f1db8c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M249.59 22.92c-.35-1.38-.2-2.46.46-3.23"
      style={{
        fill: "none",
        stroke: "#f0d989",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M105.39 20.17c2.03 1.37-7.17 4.27-8.14 4.66"
      style={{
        fill: "none",
        stroke: "#dfbe5f",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M136.22 295.74a50.891 50.891 0 0 0-5.55 12.62c-.16.55-.33.55-.5.01l-.94-2.92M36.88 232.13a91.769 91.769 0 0 0-2.71 9.23c-.48 2-1.63 2.99-2.37 4.9-.17.45-.06.54.34.28 2.13-1.37 3.19-3.27 3.18-5.72 0-.31.15-.52.44-.63l.86-.33c.2-.07.34-.25.37-.46l.59-4.08M37.56 245.92l-.35-2c-.06-.32-.48-.41-.66-.14l-3.02 4.5c-.13.19-.13.45 0 .64.9 1.29-.71 3.38-1.22 4.74-.19.51-.03.83.5.96l.54.14c.31.08.46.28.45.59v.93"
      style={{
        fill: "none",
        stroke: "#d6ac3f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M33.79 256.27c-2.52 4.54-5.88 6.96-10.09 7.27-.35.02-.6.19-.75.51a231.39 231.39 0 0 0-3.42 7.76c-3 7.17-3.34 13.91-1.01 20.21"
      style={{
        fill: "none",
        stroke: "#dcb852",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m18.52 292.02 1.82 2.54"
      style={{
        fill: "none",
        stroke: "#d6ac3f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M19.44 296.17c-2.29-2.85-5.62-4.44-9.15-2.84M12.4 289.63c1.53 1.21 1.02 1.5 2.69 1.29.99-.12 1.9.35.89-1.02"
      style={{
        fill: "none",
        stroke: "#d7b24b",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M15.98 289.9c-.27-3.15-1.79-5.58-4.58-7.3"
      style={{
        fill: "none",
        stroke: "#e1c061",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M14.32 227.73c3.49-1.1 5.49-1.1 4.8-4.84"
      style={{
        fill: "none",
        stroke: "#d6b047",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M24.91 230.99c-.34.34-.7.47-1.09.4"
      style={{
        fill: "none",
        stroke: "#d3aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m23.82 231.38-3.73-4.51c-.27-.33-.5-.3-.7.08-1.64 3.14-2.89 7.53-3.8 9.88-5.64 14.64-7.78 29.94-2.51 44.54.99 2.73 1.71 2.66 2.18-.2.79-4.77 2.18-9.34 4.17-13.71.13-.29.08-.63-.13-.87-1.59-1.85-2.53-3.91-2.82-6.16"
      style={{
        fill: "none",
        stroke: "#dcb852",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m16.48 260.43 1.37-.65"
      style={{
        fill: "none",
        stroke: "#d3aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M17.85 259.79c.14 2.35.89 4.02 2.26 4.99"
      style={{
        fill: "none",
        stroke: "#e1c061",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M20.11 264.77c1.44-1.38 2.01-2.6 1.71-3.67-1.12-3.95-.81-5.91.93-5.88"
      style={{
        fill: "none",
        stroke: "#d3aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m22.75 255.23.41 2.87c.08.57.22.59.41.04.57-1.64.79-3.28.68-4.91"
      style={{
        fill: "none",
        stroke: "#e1c061",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m24.25 253.23.91-.84c.31-.28.49-.21.55.2l.15 1.1c.06.47.64.67.97.33.45-.46.68-1.09.68-1.9"
      style={{
        fill: "none",
        stroke: "#d3aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M252.72 109.96a64.44 64.44 0 0 0-3.03 19.45c-.01 3.41 2.64 15.74 4.82 18.03"
      style={{
        fill: "none",
        stroke: "#e5c466",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m254.51 147.43.25.25c.22.22.24.45.06.7-.13.18-.28.29-.46.34"
      style={{
        fill: "none",
        stroke: "#dcb852",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m241.32 141.62 4.01 2.17c.68.37 1.46-.27 1.25-1.01l-1.61-5.57c-.1-.35.27-.64.59-.47l.61.33c.43.23.95-.07.98-.55.17-2.97-.19-5.85-1.07-8.64-.19-.58.01-1.07.6-1.48.32-.21.46-.51.42-.9l-.83-9.19c-.04-.42.13-.53.5-.34l1.07.55c.44.22.97-.07 1.01-.56.55-6.83-1.13-12.87-5.04-18.12"
      style={{
        fill: "none",
        stroke: "#dfbe5c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M252.34 189.27c-4.49 13.33-4.52 26.59-.07 39.79"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M170.34 27.58c-.05.43-.34.87-.86 1.3"
      style={{
        fill: "none",
        stroke: "#efd785",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M169.48 28.88c-.87-.55-1.46-.4-1.75.44-.11.31.03.65.33.79 4.86 2.29 8.98 1.5 12.36-2.38.24-.28.52-.33.84-.14l9.47 5.51"
      style={{
        fill: "none",
        stroke: "#debb57",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M190.73 33.1c-3.45 2.03-7 3.57-10.66 4.61-.32.09-.67.05-.97-.1-1.82-.94-3.68-1.14-5.59-.59-.36.1-.69.04-.99-.17-1.46-1.03-3.1-1.61-4.93-1.74a.775.775 0 0 0-.81.92l.28 1.4c.06.32-.27.57-.56.42l-8.6-4.52"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M257.11 39.54c2 .57 3.98.49 5.95-.23.47-.17.46-.3-.04-.38-2.43-.37-4.87-.46-7.32-.26-.28.03-.46.11-.55.25-.11.17-.14.4-.09.69"
      style={{
        fill: "none",
        stroke: "#e7c96e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M252.79 37.21c2.33.35 4.66.46 6.99.33 2.87-.16 4.47-2.14 7.92-.92.31.11.48 0 .51-.33a.593.593 0 0 0-.15-.44c-.14-.15-.37-.23-.7-.23-1.6 0-3.15-.22-4.65-.71"
      style={{
        fill: "none",
        stroke: "#eacd76",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M243.98 197.85c-1.78 2.05-2.83 4.3-3.14 6.74-.06.5-.64.73-1.03.42-.14-.11-.26-.33-.37-.64"
      style={{
        fill: "none",
        stroke: "#efd785",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m109.11 35.13-6.31 1.6"
      style={{
        fill: "none",
        stroke: "#e8cc79",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M102.8 36.74c-1.95-.33-3.75-.16-5.39.49"
      style={{
        fill: "none",
        stroke: "#e4c772",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M99.65 39.1c.73-.34 1.11-.66 1.16-.97.06-.39-.1-.54-.49-.45-2.88.65-5.62 1.89-8.21 3.74"
      style={{
        fill: "none",
        stroke: "#e5c76c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M85.55 40.62c2.03.29 3.89.15 5.6-.41 2.65-.87 2.57-1.23-.23-1.08-1.05.05-2.8.27-5.27.65-.16.03-.27.11-.32.26-.03.09-.04.19-.02.29"
      style={{
        fill: "none",
        stroke: "#e6c970",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M262.97 296.84c-1.36-.1-2.74.38-4 .85"
      style={{
        fill: "none",
        stroke: "#e2c367",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M207.91 23.42c-5.54 2.31-10.85 5.27-15.93 8.88"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M157.69 298.58c-5.89-.43-9.51 2.16-10.88 7.79-.15.63.08 1.29.69 1.96"
      style={{
        fill: "none",
        stroke: "#dcb852",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M147.5 308.33c.23.58.63 1.05 1.2 1.42"
      style={{
        fill: "none",
        stroke: "#bda760",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M147.75 312.35c-.09.36-.24.69-.45.99-.85-.87-.15-1.98-.47-3.05-2.01-4.66-4.01-10.66-6.96-14.71"
      style={{
        fill: "none",
        stroke: "#dcb852",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="m35.58 95.49-3.57-4.13a.308.308 0 0 0-.41-.05c-.13.09-.17.27-.09.41l2.41 4.09c.15.25.24.52.29.81.49 3.49 1.58 6.8 3.28 9.91"
      style={{
        fill: "none",
        stroke: "#d9af45",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M35.73 106.89c-.57-.49-.87.34-.9 2.51-.05 4.75-.99 9.32-2.81 13.71-.08.19-.23.35-.42.44-.3.13-.49.33-.56.6-.08.27.02.39.3.34.39-.06.66-.3.79-.71"
      style={{
        fill: "none",
        stroke: "#e4c367",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M33.19 124.38c-1.51 3.13-2.33 6.38-2.46 9.73 0 .39.17.53.54.42 2.58-.74 3.92-4.92 4.6-7.22.03-.12.11-.18.24-.18h.4c.25 0 .35.12.3.36-1.01 5.45-1.7 9.16-5.01 13.83-.53.76-.4.9.39.41l2.31-1.41"
      style={{
        fill: "none",
        stroke: "#e1c163",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M34.64 141.68c-1.49 1.34-2.99 2-4.49 1.98a.57.57 0 0 1-.54-.74l1.76-5.89c.06-.19-.14-.37-.33-.3l-1.25.45c-.4.14-.8-.19-.75-.61.09-.73 0-1.33-.27-1.8"
      style={{
        fill: "none",
        stroke: "#debb57",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M28.77 134.76c.37-2.93 1-5.02.38-8.17-.66-3.35-.29-6.63 1.12-9.84.22-.49.06-.71-.47-.64-.51.07-.94.29-1.29.68a.45.45 0 0 1-.78-.23l-.47-2.84"
      style={{
        fill: "none",
        stroke: "#e3c46d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M27.26 113.73c.09-6.02 1.76-11.29 5.03-15.81.2-.28.23-.58.09-.9l-5.19-11.39a.371.371 0 0 0-.46-.2c-.19.06-.29.24-.25.43 1.03 4.58 2.18 17.29-1.12 20.85"
      style={{
        fill: "none",
        stroke: "#debb57",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m25.36 106.71-1.15-.65"
      style={{
        fill: "none",
        stroke: "#d9af45",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m23.9 85.96.39-1.97"
      style={{
        fill: "none",
        stroke: "#e4c367",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m27.35 83.29 3.94 5.14c.15.2.43.25.65.13.22-.13.3-.4.2-.63-1.01-2.23-2.64-3.94-4.91-5.12"
      style={{
        fill: "none",
        stroke: "#e1c163",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M28.42 80.86c.53.7 1.09.94 1.7.72.38-.14.4-.33.07-.56l-6.04-4.36"
      style={{
        fill: "none",
        stroke: "#debb57",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M35.61 231.82c.08.17-.01.26-.28.29-.15 0-.27-.1-.27-.25 0-4.96-.69-9.7-2.1-14.23"
      style={{
        fill: "none",
        stroke: "#e1c061",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M210.61 308.67c-2.14-.11-4.1.19-5.87.91-.39.16-.41.35-.04.56 2.94 1.67 6.05 1.97 9.34.9"
      style={{
        fill: "none",
        stroke: "#e2c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M217.89 317.05c-3.39.37-6.73-.49-10.03-2.58-.24-.15-.34-.37-.3-.66l.07-.51c.05-.41-.11-.69-.49-.86-1.69-.75-3.37-1.53-5.04-2.35-.42-.21-.6-.66-.54-1.35.04-.42-.15-.68-.56-.77-1.6-.38-2.92-1.21-3.95-2.5-.28-.35-.73-.5-1.16-.39-3.2.81-6.21 2.1-9.02 3.85-.32.2-.2.69.18.72 9.26.74 19.85 6.79 24.81 8.44 4.2 1.4 8.47 1.21 12.82-.56"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m178.92 313.23-6.13 3.11a.31.31 0 0 0-.15.39c.06.15.22.22.37.18.63-.19 1.2-.19 1.72-.01"
      style={{
        fill: "none",
        stroke: "#e8cc79",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M144.77 321.86c.01.16.03.26.04.31.16.38.69.42.99.08l5.9-6.72"
      style={{
        fill: "none",
        stroke: "#e2bf5f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M34.25 265.58c.34-3.01.19-6.12-.46-9.31"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m17.36 74.32-.63-7.36a.98.98 0 0 0-.49-.8c-1.07-.64-2.13-.61-3.19.09-.29.19-.47.46-.53.81-1.95 11.92 2.38 23.99 6.76 34.21"
      style={{
        fill: "none",
        stroke: "#eed78b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m19.28 101.26.43 4.01c.05.5.29.63.74.39 1.52-.83 2.6-1.69 3.24-2.56"
      style={{
        fill: "none",
        stroke: "#e4c76b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M23.69 103.11c2.38-3.21 2.55-2.23.52 2.95"
      style={{
        fill: "none",
        stroke: "#debb57",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M24.21 106.06c-.91 2.07-2.36 3.97-4.33 5.72"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m22.3 282.89.32.46c.18.25.2.58.05.85-.96 1.77-1.27 3.66-.93 5.68.13.73 1.01 1.05 1.57.56l3.27-2.81"
      style={{
        fill: "none",
        stroke: "#e7cb71",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M31.98 289.1c.49.15.63.36.42.63-3.6 4.49-8.23 5.26-13.88 2.3"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M47.3 16.31c-2.4.99-4.5 2.37-6.3 4.14"
      style={{
        fill: "none",
        stroke: "#e9cf7b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M37.26 21.17c-.33-.87-.48-1.78-.46-2.73 0-.05 0-.09-.01-.13-.1-.58-.33-.78-.7-.6-.26.13-.41.34-.44.63l-.58 5.29"
      style={{
        fill: "none",
        stroke: "#ead17f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M120.2 311.61c-3.51.37-7.21-.63-11.11-2.98-4.42-2.68-8.05-1.92-12.73-1.67-1.85.1-3.74.44-5.65 1.01"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M90.71 307.98c-3.56-2.19-7.74-3.78-12.53-4.77a.926.926 0 0 0-1.06.6c-.19.56-.13.92.19 1.08.31.16.36.38.17.67-.21.32-.39.44-.56.37"
      style={{
        fill: "none",
        stroke: "#debb57",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M76.92 305.92c-2.37-.76-3.85.72-6.04.71-.94 0-1.9-.02-2.88-.07"
      style={{
        fill: "none",
        stroke: "#e7cb71",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M34.55 281.79c-.01 3.99-.81 5.4-2.38 4.21"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m240.63 138.85 2.88 2.83c.23.23.47.24.72.03.34-.29.35-.64.02-1.07-1.8-2.36-2.93-4.62-3.4-6.78-.51-2.37-1.11-4.06-1.8-5.07"
      style={{
        fill: "none",
        stroke: "#e5c76c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M239.98 115.4c.99 3.25 2.51 6.25 4.54 8.99.34.45 1.06.22 1.07-.34.06-3.35-.36-6.66-1.27-9.91-.19-.69-.54-1.11-1.04-1.25-.59-.16-.81.06-.64.65l2.44 8.89c.04.15-.05.32-.2.36-.15.05-.29.04-.44-.03-.17-.08-.3-.26-.41-.55-1.63-4.48-2.66-9.47-3.11-14.98M243.8 101.97c.46 3.51 1.52 7.11 3.19 10.8.15.33.65.21.63-.15-.23-4.12-1.33-7.98-3.3-11.59-.14-.26-.5-.3-.69-.08-.13.14-.17.28-.14.41"
      style={{
        fill: "none",
        stroke: "#e6c970",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M31.38 40.26c1.98 3 2.51 6.26 1.58 9.79M33.68 73.39c.86 2.71.89 5.56.09 8.57"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M33.77 81.96c-2.33-3.79-5-6.11-8.02-6.98"
      style={{
        fill: "none",
        stroke: "#debb57",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M33.15 197.07c-.41.45-.51.87-.28 1.24 1.34 2.21 2.16 4.39 2.46 6.56"
      style={{
        fill: "none",
        stroke: "#e4c76b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M35.33 204.88c-.67-.11-1.12.06-1.36.51"
      style={{
        fill: "none",
        stroke: "#dfbe5c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m33.97 205.38-2.73-1.92a.574.574 0 0 0-.9.54c.49 3.71 1.48 7.28 2.99 10.71.16.35.48.6.87.66l.38.06"
      style={{
        fill: "none",
        stroke: "#f1db8c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M34.58 215.43c-.59.16-.95.41-1.09.76"
      style={{
        fill: "none",
        stroke: "#e4c76b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M33.49 216.2c-.53-1.29-1.13-2.11-1.81-2.47-.56-.3-.7-.16-.43.41l1.71 3.5"
      style={{
        fill: "none",
        stroke: "#efd785",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m32.96 217.63-1.3.06"
      style={{
        fill: "none",
        stroke: "#dcb852",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M31.66 217.7c-.01-.49-.13-.8-.34-.93-.18-.11-.42 0-.44.22-.19 1.81.03 3.58.67 5.33"
      style={{
        fill: "none",
        stroke: "#f1db8c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M31.55 222.32c-.93.62-1.87.49-2.82-.39a.427.427 0 0 0-.71.24c-1.25 6.74.17 12.77 4.25 18.08.23.29.26.61.11.94l-4.87 10.93"
      style={{
        fill: "none",
        stroke: "#dcb852",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M27.51 252.11c-.13.04-.26.05-.37.03a.479.479 0 0 1-.38-.54c1.13-7.03 1.31-14.07-1.85-20.62"
      style={{
        fill: "none",
        stroke: "#e1c160",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M24.91 230.99c-.79-1.8-2.01-3.39-3.67-4.77-.27-.23-.28-.46 0-.69 1.86-1.63 2.51-3.95 1.96-6.95"
      style={{
        fill: "none",
        stroke: "#dcb852",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M88.37 308.43c-10.91 3.79-21.06 9.17-32.27 11.65"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m54.5 319.39-.93-3.07"
      style={{
        fill: "none",
        stroke: "#e5c466",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M201.59 301.89c-.04.28-.18.54-.43.79-.18.19-.44.3-.77.33a36.96 36.96 0 0 0-15.32 5.28c-.3.18-.62.26-.97.24l-5.36-.34c-.25-.01-.5-.07-.73-.18-3.31-1.49-6.51-1.48-9.61 0-4.5 2.17-8.36 2.23-12.57 5.47-.28.21-.55.21-.82-.02-.2-.17-.26-.45-.17-.82"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M14.94 55.17c-.19-.37-.5-.35-.93.08-.17.17-.32.41-.45.72-7.43 18.26-2.13 38.05 6.01 55.79.04.09.11.13.2.12.34 0 .38-.05.11-.1"
      style={{
        fill: "none",
        stroke: "#dcb852",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M19.88 111.77c.39.15.69.31.9.48.2.16.3.45.3.86-.03 4.36-.7 5.68-1.99 3.97"
      style={{
        fill: "none",
        stroke: "#d6ac3f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M19.09 117.09c.05-.38.04-.69-.03-.94a.54.54 0 0 0-.83-.29l-1.15.81c-.19.13-.43-.09-.3-.28l1.13-1.67a.472.472 0 0 0-.69-.63l-2.88 2.37"
      style={{
        fill: "none",
        stroke: "#debb5a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M14.34 116.46c.59-2.08 2.11-3.1 3.5-4.55-.9-.23-1.89-.29-2.78-.7"
      style={{
        fill: "none",
        stroke: "#d6ac3f",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M22.32 218.65c.22 1.82.02 3.53-.6 5.12-.17.43-.81.34-.84-.12l-.36-4.54c-.05-.61-.24-.66-.58-.15-.76 1.15-1.03 2.46-.82 3.93"
      style={{
        fill: "none",
        stroke: "#dab551",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M19.12 222.88c-.36 3.01-3.74.12-4.8-.65"
      style={{
        fill: "none",
        stroke: "#e2c46b",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M131.4 17.6c-2.51.87-4.49 2.41-5.92 4.61M119.23 29.44c-2.81 3.63-6.03 6.22-9.66 7.78-.41.17-.56.04-.47-.39.13-.67.14-1.23 0-1.7"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M109.11 35.13c2.39-.62 8.44-2.34 6.34-6-.59-1.03-1.46-1.37-2.6-1.02-2.67.84-5.2 2.46-7.78 3.14-5.71 1.49-11.57 1.74-17.57.77"
      style={{
        fill: "none",
        stroke: "#eed78b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M97.03 28.67a5.94 5.94 0 0 0 1.8 1.6c.26.15.53.18.81.08l3.92-1.33"
      style={{
        fill: "none",
        stroke: "#e1c160",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m103.56 29.03 2.55.34c.61.08.73-.13.36-.62l-.92-1.23"
      style={{
        fill: "none",
        stroke: "#f0d989",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M148.7 309.76c-.08-1.36.35-2.41 1.28-3.16"
      style={{
        fill: "none",
        stroke: "#b0903c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m149.98 306.6 5.97-6.11c.23-.23.18-.36-.14-.39-4.16-.34-5.99 3.51-7.98 6.29-.12.17-.11.3.04.41.11.08.27.08.38 0l.91-.67"
      style={{
        fill: "none",
        stroke: "#e0c168",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m149.16 306.12-1.66 2.21"
      style={{
        fill: "none",
        stroke: "#b0903c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M159.23 300.52c-1.7 4.26-2.16 8.28-4.39 12.13"
      style={{
        fill: "none",
        stroke: "#dcb852",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M151.7 315.54c-4.23.21-6.81 1.89-6.93 6.33"
      style={{
        fill: "none",
        stroke: "#dab44e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m144.77 321.86-1.54 3.02c-.11.22-.07.4.14.54.25.17.46.13.63-.1.83-1.18 1.72-2.15 2.68-2.9 6.53-5.08 15.32-12.76 24.47-10.62.33.08.37.23.1.44l-3.41 2.68"
      style={{
        fill: "none",
        stroke: "#d6ac3f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M106.7 314.23c-.89-.6-.89-2.6-.89-2.6 9-1 17 4 23 11 1 1 3 1 4 2-1-4-2-8-5.57-8.67"
      style={{
        fill: "none",
        stroke: "#d6ac3f",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M128.6 308.85c-.28-4.19-3.34-9.08-8.13-8.92-.47.01-.54.19-.22.54l5.72 6.08"
      style={{
        fill: "none",
        stroke: "#d4b458",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m103.59 42.31 3.92-4.02c.09-.1.12-.22.07-.35-.03-.1-.06-.21-.09-.32a.236.236 0 0 0-.37-.12l-5.84 4.51c-.13.09-.19.25-.16.4l.1.46"
      style={{
        fill: "none",
        stroke: "#e9cb72",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M99.1 41.74c.21-.15.36-.34.44-.55.15-.4 0-.56-.4-.48-1.66.32-3.12 1.14-4.37 2.47"
      style={{
        fill: "none",
        stroke: "#e6c66b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M89.25 42.47c.39-1.09 1.34-1.44 2.86-1.06"
      style={{
        fill: "none",
        stroke: "#dab34a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M92.11 41.42c2.43.11 4.95-.67 7.54-2.32"
      style={{
        fill: "none",
        stroke: "#e9cb72",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M99.65 39.1c.57 1.29 1.55 1.14 2.96-.43.52-.59.58-1.23.19-1.93"
      style={{
        fill: "none",
        stroke: "#dab34a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M94.21 295.26c1.25 1.25 3.15 2.09 5.68 2.52"
      style={{
        fill: "none",
        stroke: "#dfbe5c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m101.4 296.45 5.79 4.28c.86.64 1 .51.43-.4-1.13-1.78-2.77-3.22-4.92-4.32"
      style={{
        fill: "none",
        stroke: "#e1c264",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M105.03 295.52s-.11.12-.17.23c-.11.18-.07.33.11.44 2.37 1.41 3.86 3.48 4.46 6.19.1.44-.08.68-.53.73-1.97.19-3.66-.36-5.09-1.65-.27-.25-.59-.32-.95-.21-1.91.58-3.75.35-5.52-.68a1.1 1.1 0 0 0-1.07-.02c-3.94 2.07-9.27.86-13.17-.99"
      style={{
        fill: "none",
        stroke: "#dfbe5c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M84.5 297.58c.29-.03.35.09.2.36-.08.15-.04.24.13.27l8.12 1.58c.25.05.5-.1.58-.34.08-.24-.03-.5-.26-.61-2.13-1.03-4.54-1.46-7.23-1.29"
      style={{
        fill: "none",
        stroke: "#e5c76c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M36.52 94.44c-.75-.77-1.32-1.75-1.69-2.93a.996.996 0 0 0-.61-.64c-.81-.31-.9-.86-.28-1.66a.91.91 0 0 0 .1-.95L32 84c-.15-.29-.06-.42.27-.39l1.26.12c.29.03.47-.1.52-.4.09-.54-.01-1-.28-1.38"
      style={{
        fill: "none",
        stroke: "#d9af45",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m25.37 24.67-1.78-4.06c-.16-.37-.37-.4-.63-.09-.45.53-.48 1.31-.11 2.35"
      style={{
        fill: "none",
        stroke: "#eacd76",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M20.16 23.17c-1.03-.34-1.98-.96-2.86-1.87-.19-.21-.4-.22-.62-.03-.24.21-.27.39-.08.56 5.29 4.85 9.9 9.82 13.85 14.9"
      style={{
        fill: "none",
        stroke: "#ebcf7a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M27.81 36.13c.13-.03.24-.1.33-.2.18-.19.17-.49 0-.67L16.58 23.85a.337.337 0 0 0-.45-.02c-.14.11-.16.3-.07.44l3.5 5.29"
      style={{
        fill: "none",
        stroke: "#eacd76",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M18.51 30.47c-.87-.73-1.7-1.07-2.47-1.02-.46.03-.54.22-.25.58 1.11 1.34 2.58 2.19 4.43 2.54"
      style={{
        fill: "none",
        stroke: "#e9cb72",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M20.73 35.78c-4.09-1.49-8.26-1.35-12.51.42-.43.18-.42.3.05.35 4.49.53 8.98.93 13.47 1.22.83.05 1.37.23 1.62.56"
      style={{
        fill: "none",
        stroke: "#eacd76",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M21.05 39.58c.03-.11.04-.21.03-.31-.03-.21-.15-.33-.36-.35L8.7 37.79c-.23-.02-.42.19-.36.41.05.23.2.37.43.4 2.64.36 4.51 1.25 7.27 1.35"
      style={{
        fill: "none",
        stroke: "#e9cb72",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m15.72 41.26-4.81 3.73"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m246.54 186.71-2.17 7.35c-.11.37.03.56.42.56h1.23c.37 0 .64.36.53.71l-1.78 5.89c-.11.37.02.5.4.39l1.12-.33c.46-.13.71.04.74.51.21 2.97-.13 5.87-1.02 8.71-.11.35-.04.66.23.92 1.9 1.84.44 8.27-.32 10.62-.13.41 0 .54.4.39l1.6-.62c.37-.14.77.1.82.49.79 6.5-.78 12.47-4.71 17.91"
      style={{
        fill: "none",
        stroke: "#dfbe5c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M243.35 239.24c2.56-4.29 3.98-8.72 4.26-13.28a.466.466 0 0 0-.91-.17l-3.35 10.92M240.21 230.4c1.1-.35 1.55-1.52 1.35-3.52-.27-2.67.52-6.15 2.35-10.46"
      style={{
        fill: "none",
        stroke: "#e6c970",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M243.91 216.41a.89.89 0 0 0 .16-.38c.06-.27.23-.4.5-.41.1 0 .21 0 .33-.02.22-.02.39.2.31.41a56.258 56.258 0 0 0-2.41 8.36c-.29 1.38.14 1.62 1.27.72.11-.09.29-.57.56-1.45.94-3.13 1.2-6.33.79-9.6-.08-.59-.29-.64-.63-.15l-1.38 1.96"
      style={{
        fill: "none",
        stroke: "#e2c468",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M243.41 215.85c-2.13 2.72-3.24 5.22-3.33 7.49"
      style={{
        fill: "none",
        stroke: "#e6c970",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M238.74 211.85c.55.26.78.73.67 1.41-.05.33-.06.56-.01.7.07.24.2.41.38.52.28.17.48.1.6-.2l3.17-8.15c.18-.47.41-.49.7-.08.14.21.15.47.03.78a53.386 53.386 0 0 0-2.6 8.03c-.11.44.03.54.41.29 2.4-1.55 3.42-8.74 3.57-11.44.03-.63-.2-.76-.71-.37l-1.51 1.19c-.3.23-.71-.1-.55-.44 1-2.14 1.36-4.22 1.09-6.25"
      style={{
        fill: "none",
        stroke: "#dfbe5c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M243.98 197.85c.23-.13.35-.38.34-.76-.01-.57-.24-.67-.67-.29l-2.61 2.27"
      style={{
        fill: "none",
        stroke: "#e5c76c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M26.91 23.6c.12-1.99.09-4.16-.79-6"
      style={{
        fill: "none",
        stroke: "#eacd76",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M24.64 108.42c-.98.91-1.57 1.71-1.77 2.4"
      style={{
        fill: "none",
        stroke: "#e8cc79",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M22.87 110.82c-.59.29-.98.59-1.17.9-.18.28-.09.69.26 1.22 1.47 2.23 1.9 4.68 1.29 7.36"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M14.34 116.46c.31.95-.35 2.11-1.96 3.5-.21.18-.32.41-.32.69v.56c0 .57.19.64.56.21.4-.47.75-.45 1.06.07.21.35.5.43.87.24 1.94-1.05 3.45-2.59 4.54-4.64"
      style={{
        fill: "none",
        stroke: "#e6c66b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m36.35 222.29-2.86-6.1"
      style={{
        fill: "none",
        stroke: "#e9cf7b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M34.58 215.43c-.37-3.14-1.24-6.04-2.63-8.71-.15-.28-.2-.51-.17-.7.06-.3.26-.48.59-.55.33-.07.49.07.48.4-.07 2.03.68 3.04 2.25 3.05"
      style={{
        fill: "none",
        stroke: "#ebd382",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M35.1 208.93c.45.85.71 1.86.77 3.03.01.17.09.22.24.14l.38-.21a.54.54 0 0 0 .31-.53c-.05-2.23-.54-4.39-1.47-6.48"
      style={{
        fill: "none",
        stroke: "#d9b652",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M106.73 23.31c.34-.17.41-.42.2-.76-.18-.3-.43-.38-.75-.24l-6.89 3.04c-.35.15-.27.66.1.72 1.05.17 2.23.07 3.52-.29M102.32 27.12c-1.17.19-2.25.61-3.23 1.25-.27.17-.36.4-.28.71.16.58.6.72 1.31.43.31-.13.6-.28.89-.46.65-.42 1.5-.43 2.55-.02"
      style={{
        fill: "none",
        stroke: "#e7cb73",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M192.52 39.42c-2.75.39-5.39.12-7.94-.81-.55-.2-1.06-.15-1.54.15-.28.17-.28.34 0 .51 2.52 1.46 5.26 1.81 8.23 1.05"
      style={{
        fill: "none",
        stroke: "#e9cb72",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M187.37 42.65c-.05-.34-.18-.56-.41-.66-3.45-1.51-6.97-2.96-10.56-4.35-.52-.2-.7-.03-.53.5.19.59.65 1.04 1.38 1.33 3.19 1.29 5.67 2.23 7.44 2.81"
      style={{
        fill: "none",
        stroke: "#e7c96e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m182.32 43.21-4.62-2.52a.568.568 0 0 0-.71.14l-.25.3"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m175.28 41.71-6.38-4.7c-.21-.16-.4-.13-.56.08-.12.15-.11.31.04.48 1.17 1.33 2.64 2.88 4.39 4.64"
      style={{
        fill: "none",
        stroke: "#e7c96e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M131.82 295.45c-.05 1.23-.44 2.28-1.17 3.15-.16.19-.26.41-.3.65l-1.12 6.2"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M129.23 305.45c-2.05-5.19-5.6-7.43-10.67-6.72"
      style={{
        fill: "none",
        stroke: "#dcb852",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M12.12 156.1c-.85-.39-1.48-.56-1.89-.49-.43.07-.5.27-.22.6 4.1 4.81 8.92 8.38 14.46 10.71M22.85 168.35l-.11-.32c-.13-.35-.36-.59-.69-.72-3.68-1.49-6.86-3.7-9.53-6.65a.522.522 0 0 0-.85.59c2.15 4.16 5.46 6.49 9.92 6.99M21.09 170.15c-4.57.79-7.73 3.17-9.47 7.15-.1.22-.02.48.19.61s.49.08.64-.11c1.93-2.37 4.29-4.2 7.07-5.48M19.8 173.66c-3.57 2.21-6.72 5.03-9.47 8.48-.16.21-.24.35-.24.42.02.3.36.48.63.33l8.33-4.51"
      style={{
        fill: "none",
        stroke: "#ebd382",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M20.75 180.15c-.82 1.43-1.46 3.39-3.06 4.12"
      style={{
        fill: "none",
        stroke: "#ebd382",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M16.51 78.58c-.64 2.66-.61 5.3.1 7.93.14.53.47.71 1 .55l.65-.21c.37-.12.74.2.67.58-.45 2.5-.49 4.99-.12 7.48.08.53.39.84.92.91l.64.08c.29.04.48.34.39.62l-1.48 4.74"
      style={{
        fill: "none",
        stroke: "#e8d081",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M29.81 13.43c-3.14-.86-.13 5.48.09 7.1s.15 9.22 2.11 9.32"
      style={{
        fill: "none",
        stroke: "#ebd382",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M29.39 29.69c.42-5.07.42-11.07-2.18-15.62"
      style={{
        fill: "none",
        stroke: "#ead17f",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="M256.66 215.59c-.22.65-.88 3.74-.05 4.17s1.71-2.1 1.8-2.62"
      style={{
        fill: "none",
        stroke: "#ddb95d",
        strokeWidth: ".3px",
      }}
    />
    <path
      d="m255.76 222.62-1.24-3.97c-.1-.32-.57-.29-.63.04-.31 1.72-.12 3.42.58 5.09.09.23.22.39.37.48.19.13.4.18.63.17"
      style={{
        fill: "none",
        stroke: "#dbb555",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M255.08 226.4c-2.56-3.86-2.08-7.31-2.68-10.82-1.49-8.69.04-16.04 2.66-24.98.1-.33-.01-.58-.32-.74-.75-.39-1.55-.58-2.4-.58"
      style={{
        fill: "none",
        stroke: "#d6aa43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m252.34 189.27-5.8-2.56"
      style={{
        fill: "none",
        stroke: "#dbb555",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M246.54 186.71c-.52-.99-.98-1.29-1.37-.9"
      style={{
        fill: "none",
        stroke: "#d1a53c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m243.81 184.7-5.51-9.57"
      style={{
        fill: "none",
        stroke: "#dbb555",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m100.71 312.89-1.38.97c-.17.13-.34.11-.49-.05-.41-.44-.8-.33-1.15.33"
      style={{
        fill: "none",
        stroke: "#e2bf5f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m90.71 307.98 4.29 3.1c.29.21.55.19.8-.06l.74-.74a.7.7 0 0 1 .82-.14c.93.45 1.24 1.33.93 2.64-.03.12-.09.21-.16.26-.11.08-.26.13-.45.14-.31.03-.43.19-.35.49.05.18.17.34.36.47"
      style={{
        fill: "none",
        stroke: "#d9af45",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M97.69 314.14c.66 1.06 1.53 1.86 2.62 2.4.27.14.51.09.72-.14.49-.55 1.08-.69 1.76-.4.09.04.1.08 0 .13l-2.33 1.29c-.21.12-.39.09-.55-.09-.34-.38-.76-.54-1.27-.48-.39.04-.73-.06-1.03-.3-.77-.62-1.12-1.42-1.07-2.4a.506.506 0 0 0-.66-.51l-.8.27"
      style={{
        fill: "none",
        stroke: "#dcb753",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M48.49 318.02c1.35 1.18 3.11 1.8 5.28 1.86.22 0 .44-.09.56-.27l.17-.23"
      style={{
        fill: "none",
        stroke: "#dab148",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M54.5 319.39c.33.28.87.51 1.6.7"
      style={{
        fill: "none",
        stroke: "#debb57",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M56.1 320.08c7.03.84 12.71-.15 19.39-3.49 5-2.49 10.24-4.46 15.73-5.91.41-.11.47-.31.17-.62-.77-.79-1.78-1.34-3.02-1.63"
      style={{
        fill: "none",
        stroke: "#d9af45",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M88.37 308.43c-2.53-1.71-5.28-2.82-8.25-3.31a.782.782 0 0 0-.79.33c-.89 1.33-2.13 2.14-3.7 2.45-.29.06-.44.23-.47.52-.19 2.01-4.12 3.09-6.23 4.16-.51.26-.58.61-.22 1.04.13.15.13.29.02.43-.3.36-.56.64-.61.66-3.44 1.4-6.19 3.34-10.01 2.3"
      style={{
        fill: "none",
        stroke: "#debb57",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m62.06 310.85 5.92.55c.32.03.63-.02.94-.13l2.47-.91c.58-.21.6-.46.06-.75l-1.37-.74c-.39-.21-.39-.41.01-.62 1.22-.63 2.44-.9 3.65-.83.32.02.62-.05.91-.21l2.27-1.28"
      style={{
        fill: "none",
        stroke: "#dcb753",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m14.07 53.25-2 2.48"
      style={{
        fill: "none",
        stroke: "#e2c265",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M259.2 189.2c-4.25-.95-8.31-.97-12.19-3.92-3.82-2.9-6.06-7.72-7.49-12.19"
      style={{
        fill: "none",
        stroke: "#e3c26c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m11.4 282.61 3.49 6.84c.13.27.35.41.65.43l.44.03"
      style={{
        fill: "none",
        stroke: "#ead17e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m31.66 217.7 2.14 8.07c.15.56.02.65-.41.26-1.03-.93-1.64-2.17-1.84-3.71"
      style={{
        fill: "none",
        stroke: "#e3c469",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m23.82 231.38 1.91 4.77c.15.37.09.7-.16 1.01l-.39.48c-.19.23-.25.5-.16.8l1.43 4.87c.07.25-.06.51-.31.6a.492.492 0 0 1-.61-.29c-.29-.75-.5-1.58-.62-2.47-.07-.51-.21-.82-.43-.94-.29-.17-.69-.17-1.22-.01"
      style={{
        fill: "none",
        stroke: "#e1c160",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M23.26 240.2c-.77-2.96-1.46-3.41-2.07-1.35"
      style={{
        fill: "none",
        stroke: "#f1db8c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M21.19 238.86c-.41-1.02-.51-2.01-.3-2.96.07-.27.3-.48.58-.5l.58-.05c.84-.06 1.03-.44.57-1.15-.55-.85-1.29-1.3-2.21-1.34-.47-.02-.73.2-.78.67-.35 2.96.16 5.72 1.53 8.28.16.31.08.69-.2.9a.7.7 0 0 1-.91-.05c-.27-.25-.56-.33-.87-.24-.43.13-.52.38-.29.76.33.53.39 1.01.19 1.44"
      style={{
        fill: "none",
        stroke: "#e1c160",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M19.08 244.61c-.13 0-.25 0-.36.01-.25.02-.43.14-.53.37a71.632 71.632 0 0 0-5.8 21.89c-.07.71.02 1.26.28 1.65.3.45.99.26 1.01-.28.12-3.78.82-7.16 2.11-10.14"
      style={{
        fill: "none",
        stroke: "#eed78b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M15.79 258.11c-.1.88.13 1.65.69 2.32"
      style={{
        fill: "none",
        stroke: "#e1c160",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M24.25 253.23c-.3-2.25-.8-4.35-1.49-6.28-.16-.45-.41-.77-.76-.94-.38-.19-.54-.07-.48.35l1.23 8.87M20.11 264.77l-1.48-10.4a.563.563 0 0 0-.63-.49c-.31.03-.54.3-.52.61l.37 5.29"
      style={{
        fill: "none",
        stroke: "#e6c96f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M15.79 258.11c-.02-2.25.43-4.4 1.36-6.45.09-.19.24-.29.45-.29h.44c.37 0 .57-.19.6-.56l.44-6.2"
      style={{
        fill: "none",
        stroke: "#e5ca76",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m21.19 238.86 3.34 9.84c.07.19.27.3.47.24.19-.06.31-.26.26-.46l-2-8.27"
      style={{
        fill: "none",
        stroke: "#e8cd77",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m28.77 134.76-2.74 8.51c-.12.39-.6.53-.92.27-.36-.3-.45-.65-.28-1.04 3.91-8.8 1.66-23.14-1.96-31.69M27.26 113.73c.07-1.97-.29-3.32-1.06-4.04-.15-.15-.26-.32-.31-.52-.2-.73-.62-.98-1.25-.75"
      style={{
        fill: "none",
        stroke: "#eed78b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m24.64 108.42.72-1.71"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m33.97 205.38 1.13 3.54"
      style={{
        fill: "none",
        stroke: "#e7cb73",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m149.98 306.6-.49-.61c-.07-.09-.16-.12-.27-.07-.31.13-.33.2-.06.21"
      style={{
        fill: "none",
        stroke: "#c2b076",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M243.91 216.41c-.09-.43-.25-.62-.5-.56"
      style={{
        fill: "none",
        stroke: "#f3df94",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m139.15 7.85-.34 32.74c-.01.91.2.96.63.16 2.56-4.81 6.14-12.86 4.86-18.37a93.62 93.62 0 0 0-4.68-14.62c-.1-.25-.47-.18-.47.09M136.64 8c-4.7 11.69-7.33 21.07.27 32.25.3.44.45.39.44-.14l-.1-31.99c0-.35-.48-.44-.61-.12"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M72.39 27.33c1.35.6 2.3 1.39 2.85 2.37.16.27.38.48.67.62 1.37.64 2.56 1.54 3.58 2.71.23.27.6.37.93.26l5.41-1.71"
      style={{
        fill: "none",
        stroke: "#dfbf65",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m85.83 31.58 6.1-3.37c.38-.21.36-.37-.07-.47-15.45-3.61-25.85-14.15-43.01-8.13-.25.09-.26.44-.02.54l5.44 2.29c.27.11.55.11.83 0 4.49-1.83 8.74-1.44 12.75 1.16.29.19.48.44.59.76.47 1.37 1.78 2.36 3.95 2.97"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M85.83 31.58c-4.39-1.72-8.4-3.54-12.01-5.47-.49-.26-.83-.28-1.04-.05-.22.24-.35.66-.39 1.27"
      style={{
        fill: "none",
        stroke: "#eed78b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M34.34 37.79c1.37 3.47 3.73 5.11 7.66 5.08 2.64 0 7.5 1.15 7.51-3"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M49.51 39.88c1.67-2.82-.44-6.92-3.79-6.92-5.57 0-1.7 8.58 1.39 3.99.26-.39.51-.39.76.01.33.53.13 1.1-.62 1.73"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M47.25 38.69c-1.44 1.01-2.96 1.13-4.57.37"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M42.68 39.06c-2.23-2.43-2.23-4.55.01-6.38.35-.28.25-.84-.17-.99a9.38 9.38 0 0 1-4.09-2.82c-.57-.66-.16-1.68.7-1.79 2.09-.25 4.06.14 5.91 1.18.58.32 1.24-.24 1.01-.86-.46-1.21-.52-2.47-.19-3.77a.49.49 0 0 1 .74-.3c2.12 1.31 3.45 3.18 3.99 5.6.03.16 0 .3-.12.42l-.33.32c-.14.15-.23.12-.27-.08a7.471 7.471 0 0 0-1.74-3.54.368.368 0 0 0-.48-.07c-.15.09-.22.28-.15.45l.89 2.25c.13.31.12.61 0 .92-1.35 3.16 2.77 4.93 4.23 1.69.12-.27.3-.48.54-.65l3.15-2.15c.99-.67 2.25.35 1.79 1.45l-2.34 5.67c-.2.48.25.98.75.83 2.99-.89 6.03-1.09 9.11-.62.57.09.84.75.5 1.21l-1.62 2.22"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M64.49 39.24c-1.17 1.27-2.67 2.28-4.52 3.02-.28.11-.2.53.1.53l23.5.36c.75.01.79-.15.1-.46l-8.38-3.84"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M75.29 38.85c-5.63-3.43-10.89-7.09-15.78-10.99-5.71-4.55-14.6-8.8-21.51-4.52-5.04 3.12-5.48 9.29-3.66 14.45"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M75.29 38.85c-3.52.73-7.12.86-10.8.39M42.68 39.06l-8.34-1.26M49.51 39.88c-1.24.02-1.99-.38-2.26-1.19"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M233.37 42.83c11.45 1.68 13.45-18.86 1.82-20.34"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M235.19 22.49c-6.21-3.02-14.48 2.17-19.45 6.23-7.15 5.85-14.96 10.49-23.45 13.93-.2.08-.14.38.08.38l24.22-.23c.3 0 .39-.42.11-.54a17.865 17.865 0 0 1-6.47-4.85c-.53-.63-.15-1.6.67-1.7 3.09-.39 6.13-.18 9.12.65.35.1.47-.03.36-.38l-2.04-6.27a.884.884 0 0 1 1.07-1.13c1.96.54 3.57 1.59 4.84 3.14.28.35.46.3.53-.14.55-3.23 2.04-5.92 4.48-8.07.42-.37 1.09-.06 1.07.5l-.11 3.72c-.02.52.55.84.99.57 1.6-.98 3.38-1.42 5.33-1.31 1.44.08 1.91 1.96.68 2.71l-3.37 2.05a.55.55 0 0 0-.12.86c3.85 4.01-.15 8.25-5.07 6.49-.93-.33-1.19-1.51-.5-2.21l.3-.3c.29-.29.51-.24.65.15.27.74.78 1.17 1.55 1.3 1.22.2 2.4-.53 2.75-1.71 1.01-3.33-3.9-4.42-5.6-2.43-2.3 2.69-2.26 5.56.11 8.61.17.23.41.35.7.35l4.75-.03"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M235.19 22.49c5.53 3.92 6.65 8.84 3.36 14.77-1.27 2.28-3.22 3.78-5.18 5.57"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m61.29 23.79 2.77-.38a.3.3 0 0 0 .26-.29c0-.14-.1-.27-.24-.3-2.13-.43-4.23-.33-6.29.29-.58.17-.69.95-.17 1.27 2.15 1.31 4.48 1.66 6.97 1.03.14-.04.24-.17.23-.32a.301.301 0 0 0-.28-.28l-3.22-.26a.405.405 0 0 1-.36-.37c0-.2.14-.36.33-.39"
      style={{
        fill: "none",
        stroke: "#d9b34e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M127.17 23.78c-5.36.96-7.23 8.16-7.87 12.84-.03.21.03.25.2.11 4.02-3.25 6.75-7.38 8.19-12.38.13-.46-.05-.65-.52-.57"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M129.1 23.99c-1.19 5.63-4.09 10.19-8.71 13.66-.45.34-.11 1.06.44.92 6.34-1.63 8.87-8.48 8.76-14.53 0-.13-.1-.23-.22-.24-.13-.02-.24.07-.27.19"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M148.79 24.24c.93 4.35 4.26 10.24 8.03 12.62.32.21.43.13.34-.24-1.36-5.28-2.14-11.34-7.96-12.77-.35-.09-.48.04-.41.39"
      style={{
        fill: "none",
        stroke: "#e2c266",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M226.19 32.69c1.9-.81 2.63-2.21 2.18-4.22-.05-.23-.04-.47.02-.7l.45-1.71a.51.51 0 0 0-.33-.61.5.5 0 0 0-.62.3l-2.39 6.29c-.29.75-.06.96.69.65"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M147.11 26.37c.16 4.2 3.07 12.55 8.53 11.88.51-.06.56-.25.17-.58-3.71-3.11-6.48-6.9-8.31-11.38-.09-.21-.4-.15-.39.08"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m40.36 29.13 4.82 2.34c.06.03.13.01.16-.05l.02-.05c.43-.87-.3-2.09-1.61-2.72l-.28-.14c-1.32-.64-2.72-.45-3.14.42l-.03.04c-.02.06 0 .13.06.16"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M235.81 28.28c-.2-.42-1.58-.18-3.09.55-1.51.72-2.56 1.65-2.36 2.06.2.42 1.58.18 3.09-.55 1.51-.72 2.56-1.65 2.36-2.06"
      style={{
        fill: "none",
        stroke: "#d9b34e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M129.35 32.85c-4.06 9.98-10.1 4.38-16.74 9.38-.28.21-.13.65.22.65h22.02c.37 0 .56-.18.59-.55.07-.83-.21-1.51-.82-2.02"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m134.62 40.31-4.05-10.68c-.17-.43-.31-.42-.42.03l-.8 3.19"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M134.62 40.31c-2.21-1.19-3.96-3.68-5.27-7.46"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M56.35 30.24c-3.27.6-5.84 4.45-5.07 7.56.09.37.48.59.85.47 2.39-.75 3.91-5.89 4.63-7.51.19-.43.05-.61-.41-.52"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m155.71 42.9 8.56.16c.49.01.54-.14.15-.43-3.28-2.49-6.79-3.39-10.54-2.7"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M153.88 39.94c-4.7-1.74-7.21-4.91-7.52-9.5-.02-.24-.34-.3-.44-.08l-5.59 12.03c-.11.23.06.5.32.5l15.06.02"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M153.88 39.94c.3.83 1.03 1.49 2.2 1.99.33.14.21.47-.37.98"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M224.06 36.26c.07.07.17.11.3.11.28 0 .51-.23.49-.51-.11-1.71-.87-3.06-2.26-4.07-.29-.21-.61-.3-.96-.26-.45.05-.83-.11-1.14-.5-.23-.29-.69-.06-.59.3.73 2.65 1.8 4.82 3.2 6.49.28.34.67.42 1.16.24.45-.16.48-.38.09-.65-.35-.25-.53-.59-.55-1.04 0-.25.07-.29.26-.11"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m62.6 38.22-9.75 3.76a.561.561 0 0 0 .29 1.08c3.67-.55 6.83-1.94 9.49-4.17.49-.41.71-.8.67-1.19-.07-.63-.41-.94-1.04-.95-4.29-.05-8 1.34-11.13 4.16-.31.28 0 .78.39.63l10.47-3.99c.16-.06.35-.02.47.1l.22.21c.16.16.13.28-.08.36M224.27 40.17c-3.19-2.5-6.85-3.62-10.96-3.36-.33.02-.48.42-.25.66.31.33.71.45 1.2.38.38-.06.75-.03 1.11.1l8.46 3.02c1.8.64 1.95.37.44-.8M223.84 42.15l-10.21-3.98c-.05-.02-.11 0-.13.06-.33.84 1.66 2.4 4.45 3.49l.31.12c2.79 1.09 5.31 1.29 5.64.44.02-.05-.01-.11-.06-.13"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M256.9 55.32c.76.45 1.48.52 2.16.23.29-.13.44-.35.45-.66.25-4.87-1.18-8.77-4.29-11.69"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M255.22 43.21c-5.51-5.47-12.08-4.03-16.05 2.31-.17.27-.26.56-.25.88.11 4.12-.86 9.5 4.08 11.25.31.11.61.12.92.04 3.52-.91 6.14-3.68 3.26-7.13-.21-.26-.51-.41-.83-.44-1.38-.13-2.1.5-2.17 1.87a.545.545 0 0 1-1.09.03c-.43-3.67 3.84-4.93 5.98-1.71.23.33.68.4.99.15l2.61-2.2c.62-.52 1.35-.69 1.77-.41.19.13.27.47.23 1.04-.13 1.93-.45 3.88-.97 5.85-.11.39.04.58.44.58h2.76"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M255.22 43.21c1.65 4.12 2.21 8.16 1.68 12.12"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m81.52 45.19-22.97.04"
      style={{
        fill: "none",
        stroke: "#d9b34e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m58.55 45.24-16.85-.71a.468.468 0 0 0-.32.83l7.72 6.37c.29.24.63.36 1.01.37l25.65.21"
      style={{
        fill: "none",
        stroke: "#d1a334",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M75.76 52.31c19.65.72 32 .96 37.05.73 9.1-.41 18.2-.45 27.29-.12.14.01.21.08.21.21 0 .11 0 .22.01.34 0 .16-.07.23-.22.21-1.62-.17-2.81.24-3.57 1.25"
      style={{
        fill: "none",
        stroke: "#cd9d2f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m136.53 54.93-85.78.03c-.41 0-.61.2-.62.61l-.22 13.38"
      style={{
        fill: "none",
        stroke: "#a6933f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M49.91 68.94 50 83.58"
      style={{
        fill: "none",
        stroke: "#b49e48",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m50 83.58.12 12.27"
      style={{
        fill: "none",
        stroke: "#a48e3d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m50.12 95.86-.07 28.61"
      style={{
        fill: "none",
        stroke: "#978135",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m50.05 124.46-.22 14.28"
      style={{
        fill: "none",
        stroke: "#896f2e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m49.83 138.74.03 1.35"
      style={{
        fill: "none",
        stroke: "#907b3d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m49.86 140.1.28 13.61"
      style={{
        fill: "none",
        stroke: "#978444",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m50.14 153.71-.08 4.07"
      style={{
        fill: "none",
        stroke: "#88662d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m50.06 157.77.02 20.64"
      style={{
        fill: "none",
        stroke: "#82602d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m50.08 178.41.07 5.09"
      style={{
        fill: "none",
        stroke: "#a1712a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M50.15 183.51c-.28.81-.34 1.34-.19 1.6"
      style={{
        fill: "none",
        stroke: "#916c2f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m49.96 185.1-.17 1.23c-.04.34-.12.35-.24.03-.11-.31-.34-.35-.69-.14a.746.746 0 0 1-1.12-.54c-.32-2.27-.29-4.94.1-8.01.98-7.83-.36-16.72-.23-23.99.23-12.9-.55-25.94.12-38.79.11-2-.57-3.92-.39-6.06 1.03-12.53-.07-25.55.27-38.15.13-4.73-.35-10.66.13-16.03.03-.34-.08-.63-.32-.87l-.87-.87"
      style={{
        fill: "none",
        stroke: "#cd9d2f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M46.55 52.92 39.4 45.7c-.35-.36-.52-.29-.5.22l.43 14"
      style={{
        fill: "none",
        stroke: "#d1a334",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m39.33 59.92.32 11.84"
      style={{
        fill: "none",
        stroke: "#d9b34e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M39.65 71.75c-.58 25.17-.69 41.21-.32 48.12.22 4.21.31 7.65.26 10.34-.32 18.68.02 37.4-.21 56.1-.09 7.25-.01 14.49.24 21.73.19 5.49-.37 11.42-.34 16.33.13 22.84-.02 45.7-.45 68.58 0 .16.19.25.3.14l8.19-7.79"
      style={{
        fill: "none",
        stroke: "#d1a334",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M47.32 285.3c.66-.62.87-1.2.63-1.73-.11-.23-.16-.48-.15-.74.18-7.08.84-14.71.34-21.74-.09-1.4.46-2.19 1.65-2.38"
      style={{
        fill: "none",
        stroke: "#cd9d2f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M49.79 258.71c.05-.28.19-.11.41.51"
      style={{
        fill: "none",
        stroke: "#82602d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M50.2 259.23c-.44 1.13-.47 2.54-.08 4.23"
      style={{
        fill: "none",
        stroke: "#664f14",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M50.12 263.45c-.07 5.81-.09 12.08-.06 18.81 0 1.17-.4 1.82.26 3.13"
      style={{
        fill: "none",
        stroke: "#6d5223",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m50.32 285.39-6.8 6.2"
      style={{
        fill: "none",
        stroke: "#d1a334",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M43.52 291.6c-.51.02-1.08.53-1.7 1.52-.19.32-.1.48.27.47 28.15-.17 56.3-.16 84.45.05 4.5.03 10.68.61 16.05.41 30.34-1.17 60.9-.58 91.15-.44.63 0 .92-.79.43-1.2l-6.57-5.47a.786.786 0 0 1-.28-.65c.03-.51-.05-.91-.24-1.21"
      style={{
        fill: "none",
        stroke: "#cd9d2f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.08 285.08.23-1.38"
      style={{
        fill: "none",
        stroke: "#7d5a26",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.31 283.7 2.44 2.27"
      style={{
        fill: "none",
        stroke: "#d1a334",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m229.75 285.96 6.63 6.77c.46.46 1.24.12 1.22-.53-1.57-42.98-.29-86.02-.72-129.01-.19-19.16.46-38.42-.31-57.56-.27-6.73-.31-12.07-.1-16.02.67-12.99.89-25.99.66-39.02"
      style={{
        fill: "none",
        stroke: "#cd9d2f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M237.13 50.6c-.24-1.76-.15-3.38.26-4.87.09-.31-.29-.53-.52-.31l-8.5 8.13c-.12.11-.22.23-.29.38l-.91 1.81"
      style={{
        fill: "none",
        stroke: "#d1a334",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M227.17 55.74c.22-.19.22-.4.01-.63a.5.5 0 0 0-.38-.17l-10.25-.04"
      style={{
        fill: "none",
        stroke: "#ac9944",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m216.55 54.89-71.23-.02"
      style={{
        fill: "none",
        stroke: "#a6933f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M145.32 54.88c-1.51-.61-1.4-1.37.35-2.28.23-.12.48-.18.73-.17 11.63.35 23.1.38 34.41.08 1.55-.04 2.96.64 4.35.61 13.03-.26 26.09-.33 39.2-.2"
      style={{
        fill: "none",
        stroke: "#cd9d2f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M224.36 52.92c1.94.45 3.51-.43 4.72-2.63.03-.06.07-.11.12-.15l5.52-4.63c.53-.45.45-.68-.25-.69-20.26-.34-41.77.17-66.14-.08-22.99-.24-43.85-.08-65.77-.13-7.01-.02-14.02.18-21.04.59"
      style={{
        fill: "none",
        stroke: "#d1a334",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M224.36 52.92c-.35-.63-.44-1.16-.27-1.6.15-.37.54-.57.93-.48.91.22 1.69.07 2.32-.45.57-.47.17-1.39-.56-1.28-2.66.39-5.26.78-8.01.77-16.2-.08-33.1.86-48.64 1.25-6.57.17-14.09-.73-21.25-.57-.36.01-.71.16-.95.43-1.57 1.66-3.12 1.75-4.64.28-.32-.3-.73-.48-1.17-.49-10.57-.19-20.8-.49-31.7-.33-7.24.1-14.52-.13-21.78.3-4.34.25-8.53 0-12.88 1.56"
      style={{
        fill: "none",
        stroke: "#d1a33b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M58.55 45.24c-2.67-.08-5.23.28-7.68 1.07-1.77.58-2.44 2.06-1 3.44.24.23.53.33.86.32 11.32-.59 22.62-.75 33.94-1.26 7.23-.32 14.72 1.36 21.37.82 3.2-.27 6.38-.71 9.54-1.33.31-.06.44-.24.39-.55-.03-.27-.17-.4-.4-.39-11.73.82-23.08.1-34.05-2.16"
      style={{
        fill: "none",
        stroke: "#deb95a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m145.32 54.88-8.79.05"
      style={{
        fill: "none",
        stroke: "#a79346",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m216.55 54.89 5.33.18c.89.03 1.57.82 1.46 1.71l-.75 6.18a.48.48 0 0 1-.67.38c-.83-.36-1.61-.27-2.33.27-.29.22-.61.26-.94.11-5.33-2.41-7.39-4.04-13.46-2.02-5.11 1.69-7.9 2.21-12.65 1.31-4.49-.85-7.69.16-11.42-.85-.32-.09-.64-.07-.95.05-1.82.73-3.7 1.14-5.65 1.21-2.29.08-4.3-1.15-6.67-1.64-4.9-1.02-8.93-3.21-13.8-3.68-2.56-.25-6.58-2.4-7.83 1.11-.12.33-.05.63.2.89l3.41 3.47c.25.26.56.37.93.33 2.06-.22 5.9.17 4.45 3.48"
      style={{
        fill: "none",
        stroke: "#868f5b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M155.21 67.39c-13.87-8.69-29.36-10.29-43.58-1.2-2.84 1.81-6.34 4.61-10.51 8.38"
      style={{
        fill: "none",
        stroke: "#40452b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M101.12 74.57c-4.59-.61-9.09-.42-13.52.57-3.81.86-6.15 2.67-10.75 1.63a83.255 83.255 0 0 0-15.8-2.03c-1.34-.04-2.42-1.73-3.38-2.36-2.33-1.55-4.92-2.69-7.76-3.43"
      style={{
        fill: "none",
        stroke: "#8e945f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M95.57 102.96c-2.77 1.81-5 1.8-6.69-.05"
      style={{
        fill: "none",
        stroke: "#706f4d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M88.88 102.92c-1.87-4.53-5.37-6.96-10.51-7.31"
      style={{
        fill: "none",
        stroke: "#8b8e5d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M78.37 95.61c-1.3.31-1.98-.26-2.05-1.7-.02-.34.09-.67.3-.93.54-.66.77-1.43.7-2.3a.637.637 0 0 0-.53-.58l-9.67-1.69"
      style={{
        fill: "none",
        stroke: "#939964",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M67.12 88.4c-3.46-1.6-5.04-.04-8.03-.27a.653.653 0 0 1-.41-.19l-3.5-3.59c-.25-.26-.55-.4-.91-.43L50 83.58"
      style={{
        fill: "none",
        stroke: "#8b8e5d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M160.15 71.11c8.56 7.32 12.11 12.4 14.65 23.37"
      style={{
        fill: "none",
        stroke: "#4c5138",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m174.8 94.49.79 4.85"
      style={{
        fill: "none",
        stroke: "#313c2d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m175.59 99.33 1.29 10.56"
      style={{
        fill: "none",
        stroke: "#283026",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m176.88 109.9.2 2.92"
      style={{
        fill: "none",
        stroke: "#4c5138",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m177.08 112.82.27 6.38"
      style={{
        fill: "none",
        stroke: "#20231c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m177.35 119.2 1.88 26.3"
      style={{
        fill: "none",
        stroke: "#262920",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m179.23 145.49-1.46 9.48"
      style={{
        fill: "none",
        stroke: "#1f2018",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m177.77 154.98 2.06 5.55"
      style={{
        fill: "none",
        stroke: "#41371d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M179.83 160.52c10.6 10.97 17.41 16.67 19.19 29.94"
      style={{
        fill: "none",
        stroke: "#2b1a1a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M199.02 190.46c2.1 6.08 5.42 11.15 7.06 17.35"
      style={{
        fill: "none",
        stroke: "#2b2021",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M206.08 207.82c.92 5.09 1.07 8.85-.67 14.08a68.967 68.967 0 0 0-2.38 9.16"
      style={{
        fill: "none",
        stroke: "#221819",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m203.03 231.05 1.45 8.96"
      style={{
        fill: "none",
        stroke: "#291a17",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m204.48 240.02 3 13.06"
      style={{
        fill: "none",
        stroke: "#1f1114",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m207.48 253.08 2.32 32.17"
      style={{
        fill: "none",
        stroke: "#170c12",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m209.8 285.24-3.47.11"
      style={{
        fill: "none",
        stroke: "#6b5520",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M206.33 285.36c-.35-10.35-.93-20.66-1.74-30.95-.4-5.05-1.29-9.33-2.73-13.9a.727.727 0 0 0-1.22-.28l-19.24 20.02c-.11.12-.25.2-.41.23-3.12.63-6.28 1.02-9.47 1.16-.35.02-.7-.12-.93-.39-3.78-4.3-7.11-3.66-13.53-3.46-3.73.11-7.49.2-11.26.26-.43 0-.63.23-.6.66.11 1.39.31 3.86.62 7.43.1 1.17-.38 1.79-1.45 1.86-1 .07-1.65.15-1.96.25-10.14 3.36-20.27 6.8-30.4 10.33-.31.11-.61.1-.91-.01a58.294 58.294 0 0 1-14.89-8c-.27-.2-.44-.52-.47-.86l-.67-10.61c-.03-.54.25-1.06.73-1.33l3.59-2.03c.35-.19.53-.49.56-.88.25-3.09 1.36-5.77 3.35-8.03.63-.72.69-1.4 1.29-2.22a.378.378 0 0 0-.33-.6c-4.11.24-8.11 1.23-11.05 4.45-7.09 7.74-20.06 15.13-29.87 7.22-.27-.22-.58-.26-.91-.13-4.25 1.76-8.35 4.4-12.31 7.91"
      style={{
        fill: "none",
        stroke: "#07030f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m50.2 259.23 8.93-5.24c.32-.19.38-.43.18-.74l-2.22-3.47"
      style={{
        fill: "none",
        stroke: "#1c1119",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M57.09 249.77c-.99-3.32-.61-6.88 1.14-10.67"
      style={{
        fill: "none",
        stroke: "#2b1d1b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M58.23 239.11c1.59-3.24 2.45-6.85 2.58-10.83.11-3.39.86-5.31 2.14-8.21"
      style={{
        fill: "none",
        stroke: "#1e1418",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m62.95 220.07 5.6-12.36"
      style={{
        fill: "none",
        stroke: "#31251f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m68.55 207.71 4.59-12.47"
      style={{
        fill: "none",
        stroke: "#402e1b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m73.14 195.24.68-1.52"
      style={{
        fill: "none",
        stroke: "#2b1d1b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m73.82 193.71 1.74-5.89"
      style={{
        fill: "none",
        stroke: "#3b2216",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m75.56 187.82 1.26-3.12"
      style={{
        fill: "none",
        stroke: "#4c3517",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M76.82 184.71c1.87-5.28 5.15-9.86 9.84-13.74"
      style={{
        fill: "none",
        stroke: "#3c1f0e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m86.66 170.96 8.62-6.28c.23-.17.29-.49.13-.72-2.67-3.92-3.34-8.2-2.01-12.84.11-.4-.04-.62-.46-.65-3.75-.31-7.08-1.37-10-3.2"
      style={{
        fill: "none",
        stroke: "#352512",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M82.94 147.27c-2.85-2.19-3-4.9-.44-8.12"
      style={{
        fill: "none",
        stroke: "#313530",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m82.5 139.15 1.43-2.51"
      style={{
        fill: "none",
        stroke: "#2a2c29",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M83.93 136.65c3.31-5.21 7.04-10.15 11.21-14.83.46-.52.57-1.26.28-1.88-2.16-4.76-.41-11.82.15-16.97"
      style={{
        fill: "none",
        stroke: "#23201a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m95.57 102.96-.02-3.99c0-.33-.11-.62-.33-.87-1.95-2.17-1.91-4.23.11-6.18.25-.25.35-.54.29-.89-.96-5.66.87-11.15 5.5-16.47"
      style={{
        fill: "none",
        stroke: "#4e4f34",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M227.1 62.81c-2.56-.43-4.22.55-4.97 2.94-.11.34-.46.53-.8.45-1.53-.39-2.65.04-3.35 1.27-.17.29-.41.5-.72.63-2 .83-3.55.28-4.65-1.63-.31-.53-.95-.77-1.53-.55-.57.22-.91.82-.8 1.42l.35 1.89c.08.4-.21.77-.61.81l-1.68.17c-.23.03-.44.14-.58.33-2.81 3.76-7.79 1.55-10.66 5.82-.2.29-.51.5-.86.57-2.68.55-5.12-1.07-7.17-1.5-2.03-.43-4.05-.96-6.04-1.6-.3-.1-.5-.37-.51-.69-.08-3.33-1.84-5.01-5.27-5.04-.3 0-.6-.1-.85-.29-4.09-3.06-8.62-3.86-13.57-2.4-.32.09-.51.3-.57.63-.34 1.81-1.04 3.51-2.11 5.08"
      style={{
        fill: "none",
        stroke: "#919b68",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m160.15 71.11-4.94-3.73"
      style={{
        fill: "none",
        stroke: "#464a30",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M67.12 88.4c.91 1.54.65 2.71-.78 3.5-.36.2-.48.5-.37.9l.98 3.36c.07.27.06.53-.03.79l-.1.25c-.6 1.61 1.05 3.15 2.62 2.44l8.93-4.04"
      style={{
        fill: "none",
        stroke: "#838959",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m88.88 102.92-3.32-1.99"
      style={{
        fill: "none",
        stroke: "#605f43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M85.56 100.93c-.99-1.6-2.21-2.11-3.68-1.52-.33.13-.7.11-1.02-.06-1.89-.98-3.82-1.14-5.78-.48-.3.1-.56.26-.78.48-5.54 5.41-8.72 1.63-14.29.15-3.27-.87-6.57-2.08-9.89-3.64"
      style={{
        fill: "none",
        stroke: "#6e714a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M83.93 136.65c-2.17-2.35-4.76-3.32-7.77-2.91-.33.05-.63.18-.89.41-1.39 1.22-3.06 1.36-4.99.43a.58.58 0 0 0-.57.02l-2.56 1.49c-.33.19-.68.29-1.07.29h-10.8c-.32 0-.61.1-.86.3-1.44 1.1-2.97 1.79-4.59 2.07"
      style={{
        fill: "none",
        stroke: "#4c4c42",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m56.13 124.85 4.4-3.94c.25-.22.57-.34.9-.31 2.77.24 7.15.82 13.14 1.73 3.53.54 6.94-.21 10.21-2.25.29-.18.6-.25.93-.22l2.16.19c.39.03.58-.47.26-.7-1.09-.8-2.31-.99-3.66-.56-6.25 1.99-12.24 1.52-17.97-1.39-1.37-.7-2.87-.66-4.35-.82-.26-.03-.44-.16-.53-.4-.23-.64-.07-.97.5-.99 5.27-.19 10.61.24 16.01 1.29 1.26.24 2.41-.75 2.34-2.03-.1-2.06-.68-5.46 2.11-6.49"
      style={{
        fill: "none",
        stroke: "#4c4937",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M225.53 285.15c.67.23 1.01.62 1.04 1.17 0 .35-.15.56-.48.64-1.83.45-4.09.75-6.78.92-37.75 2.35-74.44 2.94-110.07 1.77-17.84-.59-36.24-.83-50.93-.27-3.19.13-8.12.86-14.79 2.21"
      style={{
        fill: "none",
        stroke: "#d1a33b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M57.09 249.77c-2.4.39-4.63-1.68-6.27-1.14-.46.15-.81.49-1.06 1.04"
      style={{
        fill: "none",
        stroke: "#472e33",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M68.55 207.71c-6.58-1.41-10.3-6.58-18.78-2.82"
      style={{
        fill: "none",
        stroke: "#71523a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m189.03 110.09-12.15-.19"
      style={{
        fill: "none",
        stroke: "#73815e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M73.14 195.24c-5.7-1.37-9.35.59-14.08-.14-.68-.11-1.09-.53-1.22-1.28-.06-.34-.26-.53-.6-.57l-7.14-.88"
      style={{
        fill: "none",
        stroke: "#6b4b36",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M73.82 193.71c-4.3-1.63-9.16-1.51-13.05-2.01a.63.63 0 0 1-.55-.64c0-.33.27-.59.59-.61l1.97-.13c.21 0 .3-.27.15-.42a.906.906 0 0 0-.44-.21c-3.17-.68-6.37-1.2-9.59-1.56-.41-.05-.72-.16-.93-.34-.44-.4-.16-1.13.43-1.13 1.69 0 3.39-.04 5.09-.07.39 0 .67-.14.83-.39.24-.37.14-.53-.3-.46-2.97.43-5.59-.32-7.87-2.24"
      style={{
        fill: "none",
        stroke: "#663f30",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M201.34 114.99c-.8 4.27 6.48 3.62 9.13 3.75 3.41.15 5.83 2.1 8.75 3.6 2.28 1.16 4.45.98 6.93 1.18.37.03.56.23.58.59l.2 4.02"
      style={{
        fill: "none",
        stroke: "#475341",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M226.93 129.1c.08 1.24-.16 2.03-.72 2.37-.78.47-2.16-.49-3.37-.34-.32.04-.64-.06-.88-.26a4.636 4.636 0 0 1-1.39-2.04c-.12-.35-.35-.6-.7-.73l-2.24-.85"
      style={{
        fill: "none",
        stroke: "#505447",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M217.63 127.26c-2.37-1-4.65-2.11-6.86-3.34-1.78-.99-2.89-3.12-5.7-3.25-4.85-.24-9.68-.99-14.45-1-4.43 0-8.86-.17-13.27-.47"
      style={{
        fill: "none",
        stroke: "#454c3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m82.6 165.26-.04 3.49c-.01.33-.1.62-.29.89-1.89 2.64-3.53 4.3-6.83 5.36-3.25 1.05-7.67 2.08-8.82 5.79-.1.32-.05.67.13.95 2.14 3.34 6.52 2.14 10.07 2.96"
      style={{
        fill: "none",
        stroke: "#885325",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M75.56 187.82c-3.96.35-6.58 1.44-10.57.04-3.8-1.34-6.79-4.87-4.83-8.99"
      style={{
        fill: "none",
        stroke: "#87572c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m60.16 178.88 2.85-2.97"
      style={{
        fill: "none",
        stroke: "#67462f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m82.94 147.27-3.03.08a.94.94 0 0 1-.83-.4c-.91-1.24-2.13-2.1-3.65-2.58a.909.909 0 0 0-1.15.64c-1.25 4.94-3.47 8.29-6.64 10.04"
      style={{
        fill: "none",
        stroke: "#665a42",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m67.64 155.05-9.66-.4"
      style={{
        fill: "none",
        stroke: "#7d6a47",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M57.98 154.65c-.84.32-2.35.07-4.54-.74"
      style={{
        fill: "none",
        stroke: "#675947",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m53.44 153.91-3.3-.21"
      style={{
        fill: "none",
        stroke: "#534d49",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M196.75 108.36c.14.61.14 1.13.01 1.54a.7.7 0 0 1-.71.49l-7.02-.3"
      style={{
        fill: "none",
        stroke: "#7d8d65",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m189.03 110.09 4.12-.33c.9-.07 1.38-1.11.85-1.84-1.69-2.35-4-3.25-6.95-2.69a.834.834 0 0 1-.82-.3 11.05 11.05 0 0 0-2.95-2.64c-2.55-1.57-1.61-6.25-5.82-4.76-.29.1-.46.3-.51.59-.13.72-.59 1.13-1.36 1.22"
      style={{
        fill: "none",
        stroke: "#596c53",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m58.23 239.11-8.2-.5"
      style={{
        fill: "none",
        stroke: "#493133",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M227.38 189.88c-9.67-1.44-18.53-.57-28.36.58"
      style={{
        fill: "none",
        stroke: "#55393b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227 268.89-.31-11.09c-.04-1.49-1.56-2.49-2.95-1.94-.85.33-1.73.32-2.62-.03a.835.835 0 0 1-.54-.66 1.7 1.7 0 0 1-.02-.4.473.473 0 0 0-.43-.49l-12.65-1.2"
      style={{
        fill: "none",
        stroke: "#351d26",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.08 285.08-1.55.08"
      style={{
        fill: "none",
        stroke: "#7d5a2d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m225.53 285.15-15.73.09"
      style={{
        fill: "none",
        stroke: "#816032",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.16 228.12-.1 2.24c-.01.29-.16.45-.45.48-7.89.66-15.75.73-23.58.22"
      style={{
        fill: "none",
        stroke: "#4b3230",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M227.21 243.05c-5.03-.16-9.95-1.4-14.9-.4-.33.06-.67 0-.95-.18-2.07-1.35-4.37-2.17-6.88-2.46"
      style={{
        fill: "none",
        stroke: "#482b2b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m187.13 147.74 21.68 4.1c.67.13.67.26 0 .39l-7.95 1.55"
      style={{
        fill: "none",
        stroke: "#68603d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m200.86 153.77-23.09 1.2"
      style={{
        fill: "none",
        stroke: "#605735",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m217.63 127.26-4.58.95c-.33.07-.62.22-.86.46-1.79 1.77-4.25 2.34-7.39 1.71-1.21-.24-1.77.32-1.7 1.67 0 .27.2.5.46.58 3.72 1.06 6.55-.77 9.52-.46 4.7.48 11.05 4.18 13.99 6.25"
      style={{
        fill: "none",
        stroke: "#565a4c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.05 143.15-3.91 2.31c-.28.17-.63.19-.93.06-3.03-1.32-6.17-1.66-9.42-1.02-1.19.23-2.21.09-3.07-.44a.813.813 0 0 1-.33-1.02c.15-.37.56-.58.95-.48 1.55.37 2.81-.01 3.8-1.15.09-.1.21-.18.34-.23l3.24-1.08c.23-.08.34-.24.34-.47 0-.09.02-.2.07-.32a.819.819 0 0 0-.97-1.07 26.4 26.4 0 0 1-10.02.58c-1.5-.2-2.91-.13-4.22.21-6.5 1.67-13.1 2.2-19.81 1.6-3.66-.33-4.72 1.8-2.96 4.96"
      style={{
        fill: "none",
        stroke: "#525941",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M180.15 145.6c-.64-.37-.95-.41-.92-.1"
      style={{
        fill: "none",
        stroke: "#454938",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m62.95 220.07-13.13-.37"
      style={{
        fill: "none",
        stroke: "#4f3937",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M227.3 115.29c-6 .81-11.84.15-17.51-1.99-.75-.28-2.44-.13-5.07.45-.47.11-.59.37-.34.79l.16.26a.34.34 0 0 1-.33.51l-2.87-.33"
      style={{
        fill: "none",
        stroke: "#73815e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M201.34 114.99c-8.29-.93-15.86-1.99-24.26-2.17"
      style={{
        fill: "none",
        stroke: "#6b7454",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.9 200.35-.78 7.66"
      style={{
        fill: "none",
        stroke: "#8b692e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.12 208.01-21.04-.2"
      style={{
        fill: "none",
        stroke: "#4c373a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M227.02 85.89c-.07-.68-.44-1.05-1.11-1.1-.32-.02-.61-.19-.79-.46-1.64-2.52-4.75-2.96-7.11-4.85-.58-.46-1.43-.22-1.68.47l-2.71 7.5"
      style={{
        fill: "none",
        stroke: "#9ba577",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m213.62 87.44 1.21-4.52c.07-.27.01-.55-.18-.76l-1.19-1.32a.622.622 0 0 1-.13-.65c.36-1.03.27-2.02-.28-2.97a.886.886 0 0 0-.97-.42c-1.97.48-3.35 1.62-4.13 3.43-.12.28-.29.53-.51.75l-2.97 3.01c-.23.23-.5.37-.81.43-3.04.53-5.8 1.69-8.29 3.49-.31.23-.68.37-1.07.41-1.02.09-1.96.49-2.81 1.18-.85.7-.49 2.07.59 2.25 1.79.31 3.42 1.01 4.9 2.12.27.2.57.29.9.26l5.68-.39c.09-.01.18-.03.26-.08l5.49-3.06"
      style={{
        fill: "none",
        stroke: "#919b68",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M209.31 90.61c-1.07 1.67-2.42 2.97-4.07 3.92-.25.14-.48.31-.69.51-.61.58-.86 1.23-.75 1.95.06.4-.1.67-.49.8-2.44.81-4.94 1.03-7.51.66-.33-.05-.61-.23-.8-.5-1.81-2.61-3.46-3.57-4.95-2.88"
      style={{
        fill: "none",
        stroke: "#a3a76d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M190.05 95.07c-.68-.6-1.54-.52-2.58.23-.27.2-.63.2-.9 0l-3.44-2.53a.83.83 0 0 0-.65-.15c-1.22.23-1.83-.29-1.84-1.54 0-.92-1.26-1.2-1.65-.36-.79 1.69-2.18 2.94-4.19 3.77"
      style={{
        fill: "none",
        stroke: "#7d8d65",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m207.34 163.6-27.51-3.07"
      style={{
        fill: "none",
        stroke: "#6c5037",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m206.33 285.36-156.01.04"
      style={{
        fill: "none",
        stroke: "#72582f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M82.5 139.15c-.41-.57-1-.9-1.79-.99-.38-.04-.7.08-.96.37l-3.82 4.18c-.23.26-.52.37-.87.32-5.23-.78-10.46-.71-15.68.2-1.25.22-2.1 0-3.31-.15-.32-.04-.64 0-.93.14-1.37.62-2.81.83-4.33.62a.765.765 0 0 1-.65-.68l-.3-3.07"
      style={{
        fill: "none",
        stroke: "#5b6159",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M86.66 170.96c-.06-.88-.28-1.61-.67-2.18-.14-.21-.32-.25-.53-.12l-.3.18a.304.304 0 0 1-.46-.28c.14-2.07-.56-3.17-2.1-3.3"
      style={{
        fill: "none",
        stroke: "#714420",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M82.6 165.26c-3.36-1.67-6.98-2.7-10.85-3.09-1.18-.12-1.32-1.78-.18-2.09l1.72-.48c.09-.03.17-.08.21-.16l.26-.43a.23.23 0 0 0-.18-.35c-2.89-.19-4.67-.58-5.34-1.17-1.71-1.49-1.91-2.3-.6-2.44"
      style={{
        fill: "none",
        stroke: "#805a29",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M237.13 50.6c-.99 4.01-1.57 8.04-1.73 12.1-.51 12.65-.36 25.3.45 37.93.02.29-.15.64-.5 1.06-.21.25-.32.57-.33.89-.25 23.58-.53 47.16-.82 70.74-.14 11.35-.55 21.07-1.23 29.17-.51 6.07-.09 11.71.15 17.64.35 8.63-.02 30.1-1.13 64.43-.03.97-.78 1.44-2.24 1.41"
      style={{
        fill: "none",
        stroke: "#d1a33b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.31 283.7-.02-5.82"
      style={{
        fill: "none",
        stroke: "#816032",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M227.29 277.88c.66-.21.99-.46.99-.75.24-25.59.11-51.18-.38-76.77"
      style={{
        fill: "none",
        stroke: "#cb9e2e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M227.9 200.35c-.73-3.37-.9-6.86-.52-10.47"
      style={{
        fill: "none",
        stroke: "#957441",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.38 189.88-.07-14.63"
      style={{
        fill: "none",
        stroke: "#956e3a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.31 175.26.03-27.16"
      style={{
        fill: "none",
        stroke: "#b39445",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.34 148.1-.29-4.94"
      style={{
        fill: "none",
        stroke: "#978541",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.05 143.15.02-4.74"
      style={{
        fill: "none",
        stroke: "#907e40",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.07 138.41-.14-9.31"
      style={{
        fill: "none",
        stroke: "#9b864c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M226.93 129.1c.21-.28.21-.61 0-.98"
      style={{
        fill: "none",
        stroke: "#8a783c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m226.93 128.12.37-12.83"
      style={{
        fill: "none",
        stroke: "#928546",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.3 115.29-.07-4.89"
      style={{
        fill: "none",
        stroke: "#b6a558",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.23 110.4-.12-15.75"
      style={{
        fill: "none",
        stroke: "#aa9c53",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.11 94.65-.09-8.77"
      style={{
        fill: "none",
        stroke: "#baa95f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.02 85.89.08-23.08"
      style={{
        fill: "none",
        stroke: "#b6a558",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.1 62.81.07-7.07"
      style={{
        fill: "none",
        stroke: "#b09f50",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M85.56 100.93c-1.37-.55-2.31-.49-2.82.19-.18.24-.15.58.06.79a8.22 8.22 0 0 0 3.84 2.13c.34.08.64.23.91.46l1.73 1.46c.65.55.29 1.61-.56 1.66l-6.14.35"
      style={{
        fill: "none",
        stroke: "#53523b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M82.58 107.96c-2.69-.25-2.96 1.39-2.77 3.69.37 4.78-9.75 2.2-12.23 1.18-3.15-1.31-6.4-2.21-9.76-2.72-3.59-.54-2.9 3.68-6.91 4.39-.34.06-.59.36-.59.7l-.02 4.36c0 .27.12.49.35.64 2.03 1.35 4 1.31 5.91-.11.78-.58 1.87.11 1.67 1.06-.25 1.18-.95 2.41-2.1 3.7"
      style={{
        fill: "none",
        stroke: "#5a5b3e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M56.13 124.85c-1.76 1.03-3.79.9-6.08-.39"
      style={{
        fill: "none",
        stroke: "#53523b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m49.96 185.1.14 7.26"
      style={{
        fill: "none",
        stroke: "#926b35",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m50.1 192.37-.33 12.52"
      style={{
        fill: "none",
        stroke: "#a77c36",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m49.77 204.88.05 14.81"
      style={{
        fill: "none",
        stroke: "#97733a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m49.82 219.7.21 18.91"
      style={{
        fill: "none",
        stroke: "#856233",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m50.03 238.61-.27 11.07"
      style={{
        fill: "none",
        stroke: "#926b35",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m49.76 249.67.03 9.04"
      style={{
        fill: "none",
        stroke: "#825f33",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M60.16 178.88c-2.98.9-6.34.75-10.08-.46"
      style={{
        fill: "none",
        stroke: "#57332e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M57.98 154.65c-.75 3.44 3.73 3.63 5.77 3.81.95.08 1.47 1.15.94 1.95l-.61.92a.87.87 0 0 0-.09.88c2.51 6.08 14.81.18 14.83 5.67 0 4.05-5.49 5.35-9.01 5.52-1.63.08-3.89.91-6.8 2.5"
      style={{
        fill: "none",
        stroke: "#81592e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M63.01 175.9c1.09-1.19 1.49-2.14 1.21-2.87"
      style={{
        fill: "none",
        stroke: "#513530",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M53.44 153.91c2.41 3.36 4.15 6.65 5.22 9.87.11.32.29.58.55.78 2.95 2.24 4.62 5.06 5.01 8.47"
      style={{
        fill: "none",
        stroke: "#573c30",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M64.22 173.04c-.55.08-1.03 0-1.43-.22-.28-.15-.48-.4-.58-.7-.69-2.15-1.85-3.99-3.5-5.52-1.12-1.03-2.74-1.22-3.97-2.39-.26-.24-.41-.57-.44-.92-.28-3.89-1.69-5.73-4.24-5.51"
      style={{
        fill: "none",
        stroke: "#3d2932",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M206.81 108.54c-2.12-.77-3.72-2.32-4.8-4.66a.488.488 0 0 0-.73-.19c-2.16 1.52-1.73 5.2-4.53 4.66"
      style={{
        fill: "none",
        stroke: "#a3a76d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M196.75 108.36c-.61-3.61-1.34-7.38-3.93-10.18-.87-.95-1.8-1.99-2.77-3.11"
      style={{
        fill: "none",
        stroke: "#889262",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M227.31 175.26c-9.95-.35-19.84-1.03-29.67-2.03-.93-.09-1.72-.24-2.38-.45-.17-.05-.27-.22-.24-.4s.18-.3.36-.3c3.03.05 5.55.22 7.57.49 1.7.22 2.86-.55 4.4-1.15a.49.49 0 0 0 .16-.81l-5.3-5.22c-.23-.23-.19-.37.13-.42 2.05-.31 4.46-.4 7.22-.29.44.02.71-.18.8-.61.06-.28-.06-.42-.35-.43l-2.67-.04"
      style={{
        fill: "none",
        stroke: "#73593f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M207.34 163.6c-.13-1.63.33-3.27 1.38-4.9.57-.89-.06-2.07-1.12-2.08-.94-.01-1.61-.43-2-1.25a.902.902 0 0 0-.91-.51c-1.79.19-3.07-.17-3.83-1.08"
      style={{
        fill: "none",
        stroke: "#8a7642",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.29 277.88-.29-8.99"
      style={{
        fill: "none",
        stroke: "#775520",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227 268.89.21-25.83"
      style={{
        fill: "none",
        stroke: "#7f5a22",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.21 243.05-.05-14.94"
      style={{
        fill: "none",
        stroke: "#8a6324",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m227.16 228.12-.04-20.1"
      style={{
        fill: "none",
        stroke: "#826127",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M227.34 148.1c-.5.5-.67 1.08-.51 1.74.15.6-.45 1.11-1.01.87-1.63-.68-3.22-.76-4.77-.24-5.53 1.89-8.42-.31-13.27-1.44-6.77-1.57-13.65-2-20.65-1.29"
      style={{
        fill: "none",
        stroke: "#757046",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M187.13 147.74c-2.93-.14-5.25-.85-6.98-2.14"
      style={{
        fill: "none",
        stroke: "#4c5039",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M227.23 110.4c-3.92-.64-7.23.34-10.94.16-2.21-.11-4.39.1-6.56.62-.31.08-.64.06-.94-.06-1.55-.61-2.21-1.47-1.98-2.58"
      style={{
        fill: "none",
        stroke: "#8b986b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M206.81 108.54c2.53-3.89 2.44-5.36 6.63-8.13.97-.64.82-2.11-.26-2.55-2.5-1 .56-5.62 1.5-6.77"
      style={{
        fill: "none",
        stroke: "#979e67",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M227.11 94.65c-1.03.05-1.85-.74-2.47-2.39a.946.946 0 0 0-.4-.46l-3.47-1.98a.961.961 0 0 1-.47-.82c.01-1.27-.3-2.42-.94-3.47-.32-.52-1.11-.42-1.28.17-.63 2.22-1.77 4.02-3.4 5.39"
      style={{
        fill: "none",
        stroke: "#8f9c72",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m214.68 91.1-1.91-2.78"
      style={{
        fill: "none",
        stroke: "#a6aa74",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M213.62 87.44c-.21.37-.5.66-.85.87"
      style={{
        fill: "none",
        stroke: "#959e6f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m212.77 88.32-3.46 2.29"
      style={{
        fill: "none",
        stroke: "#9da065",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M46.55 52.92c1.16 7.04-.62 12.53-.73 18.9-.38 23.25-.4 39.37-.07 48.37.48 13.28 1.77 27.04.27 40.26-.32 2.77.81 5.03.83 7.68.05 7.63-.95 16.41-1.11 23.69-.27 12.79-.55 25.58-.83 38.38-.01.37.17.6.54.69l2.04.48c.34.08.57.4.55.75l-.31 4.83c-.02.41-.23.68-.62.8-1.73.51-2.26 1.51-2.23 3.36.2 14.16.43 28.33.68 42.51 0 .34.18.55.51.63.87.21 1.29.56 1.25 1.06"
      style={{
        fill: "none",
        stroke: "#d1a33b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M39.65 71.75c.84 14.15 1.47 28.26 1.9 42.31.03.75.35 1.5.5 2.23.05.22.25.36.47.34a.45.45 0 0 0 .39-.44 929.6 929.6 0 0 1 1.31-59.28c.08-1.52-.61-2.94-2.27-2.69-2.27.33-2.8 3.89-2.62 5.69"
      style={{
        fill: "none",
        stroke: "#deb95a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m265.29 55.12-3.67-6.17a.734.734 0 0 0-.93-.29c-.34.16-.5.55-.38.9.84 2.44 2.22 4.52 4.13 6.25.2.18.51.19.72.02.22-.17.27-.47.13-.71"
      style={{
        fill: "none",
        stroke: "#debc5a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M253.08 49.92c-2.83.75-4.58 2.83-2.25 5.42.19.22.53.21.71-.01a9.205 9.205 0 0 0 2.06-4.97c.05-.4-.13-.55-.52-.44"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M24.59 50.22c-1.38-.75-1.97-.35-1.76 1.21.25 1.86 1.06 3.22 2.45 4.09.27.17.48.11.64-.17 1.27-2.24.83-3.95-1.33-5.13"
      style={{
        fill: "none",
        stroke: "#d9b34e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m259.66 63.61-2.66 8"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M257 71.61c-.04.99-.35 1.63-.93 1.94"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M256.07 73.54c.02.25 0 .44-.06.58"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M256.01 74.12c-.57.35-.88.85-.94 1.5"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M255.07 75.62a4.99 4.99 0 0 0-.57 2.37"
      style={{
        fill: "none",
        stroke: "#debc5a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m254.5 78-1.63 1.74"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M252.87 79.74c-.83 2.39-1.15 4.65-.97 6.78"
      style={{
        fill: "none",
        stroke: "#ddb957",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M251.9 86.51c-.71.18-.99.8-.82 1.87"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M251.08 88.39c-.31.65-.39 1.48-.24 2.48"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M250.84 90.86c-2.47 4.33.15 7.46 1.9 11.34.54 1.2 2.2 1.32 2.9.2.17-.27.07-.62-.32-1.04"
      style={{
        fill: "none",
        stroke: "#d6ac3f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m255.32 101.36-1.31-7.42"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M254.01 93.94c.9-.82 1.99-.85 3.27-.08"
      style={{
        fill: "none",
        stroke: "#d1a636",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M257.28 93.86c-1.16 2.91-1.23 6.53-.21 10.84.16.67-.55 1.21-1.16.89-2.1-1.11-3.72-2.68-4.87-4.71-.12-.21-.44-.1-.4.14.69 4.15 2.55 7.62 5.59 10.43.31.28.8.18.97-.2 7.38-16.6 13.09-37.9 5.43-55.44-.32-.72-1.37-.6-1.52.17l-1.45 7.62"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M257.28 93.86c.65-1.97.68-4.02.11-6.14-.2-.74.07-.99.8-.76l.56.18c.44.14.72-.02.83-.47l.6-2.48"
      style={{
        fill: "none",
        stroke: "#dab34a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M260.18 84.19c.29 1.36.77 1.21 1.44-.45 1.34-3.33 2.23-20.14-1.96-20.14"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M254.01 93.94c-1.07-1.66-1.87-3.54-2.41-5.63-.05-.19-.22-.16-.52.07"
      style={{
        fill: "none",
        stroke: "#e6c970",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m251.9 86.51 2.2 5.73c.13.33.32.38.58.13.19-.19.25-.44.16-.75-.89-3.01-1.19-5.9-.88-8.67.13-1.15-.24-2.22-1.09-3.22"
      style={{
        fill: "none",
        stroke: "#e1c264",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M254.5 78c2.06 4.75-.86 8.29 1.72 13.44.28.57.41.53.38-.1-.13-2.62-1.65-5.58-.2-8.32.15-.27.2-.56.17-.87l-.72-6.15c-.03-.25-.17-.38-.42-.37h-.36"
      style={{
        fill: "none",
        stroke: "#e2c468",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M256.01 74.12c.37.37.58.81.65 1.32.38 2.96.73 5.84 1.05 8.63.02.21.2.37.42.38.21 0 .4-.15.44-.36.34-1.84.29-10.18-2.5-10.55"
      style={{
        fill: "none",
        stroke: "#e6c970",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M260.18 84.19c.76-4.68-.3-8.88-3.18-12.59"
      style={{
        fill: "none",
        stroke: "#dfbe5c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M255.32 101.36c.03.35-.14.52-.49.53-.14 0-.27-.09-.31-.22l-3.68-10.81"
      style={{
        fill: "none",
        stroke: "#ebcf79",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M28.33 57.99c-.8-1.65-2.07-1.61-3.7-1.62-.6 0-.97.32-1.11.95-.07.28-.24.38-.51.31l-2.73-.71a.35.35 0 0 0-.42.21c-.08.16-.01.36.14.45 2.91 1.77 6.08 2.43 9.51 1.96.42-.06.48-.65.07-.78l-.57-.18c-.31-.1-.54-.3-.68-.59"
      style={{
        fill: "none",
        stroke: "#ddb957",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M252.81 57.29v-.43c-.01-.33-.18-.49-.51-.49l-2.64.03c-.21 0-.42.08-.58.23l-2.52 2.4c-.24.23-.2.36.13.41 3.49.49 6.76-.17 9.8-1.97.11-.06.14-.15.1-.26-.03-.09-.06-.19-.09-.28-.03-.09-.14-.14-.23-.11l-2.83.92c-.41.13-.62-.02-.63-.45M255.22 59.76l-4.73.98c-.47.1-.53.32-.19.65l3.1 3.07"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M253.4 64.46c.42.66.53 1.24.32 1.73-.1.23-.31.41-.62.54-.34.13-.61.2-.82.2"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M252.28 66.93c-2.36-.21-4.5-.86-6.42-1.97-.5-.29-.66-.15-.48.4 1.1 3.39 1.21 6.8.32 10.23-.29 1.15-.76 1.23-1.4.23l-4.57-7.13c-.18-.28-.61-.16-.61.17l.08 29.31"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M239.2 98.18c-.48 2.79-.47 5.73.04 8.82.02.11.11.19.22.18.11 0 .2-.08.21-.19.31-3.07 1.17-6.25 2.56-9.52"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M242.23 97.46c.28-.42.36-.91.25-1.47a.99.99 0 0 1 .26-.88c.86-.91 1.46-1.99 1.79-3.23.19-.71.04-.79-.45-.25l-3.61 3.94a.4.4 0 0 1-.54.05.395.395 0 0 1-.11-.53l2.77-4.71"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m242.59 90.39 1.52-1.96"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M244.11 88.43c2.15-.67 3.64-2.29 4.45-4.86"
      style={{
        fill: "none",
        stroke: "#debc5a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M248.56 83.57c.71-.2 1.02-.57.95-1.1a.637.637 0 0 0-.52-.53c-.61-.09-.86-.47-.75-1.13"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m248.24 80.81 3.39-3.12"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m251.63 77.68.22-.22c.22-.22.21-.43-.03-.63l-1.46-1.23c-.55-.46-.47-.7.25-.71l1.97-.03c.31 0 .55-.15.7-.42a56.921 56.921 0 0 0 5.99-16.29c.13-.61-.64-1-1.06-.54-.93 1.01-1.93 1.72-2.99 2.15"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M251.63 77.68a.888.888 0 0 0-.1-.38c-.17-.31-.39-.35-.67-.14l-5.26 3.97c-.16.12-.2.33-.1.5.1.17.31.24.49.16l2.25-.99"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M248.56 83.57a.69.69 0 0 0 0-.45c-.14-.37-.32-.39-.55-.07l-3.9 5.38"
      style={{
        fill: "none",
        stroke: "#e7c96e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M242.59 90.39c-.44-1.97.06-3.94 1.49-5.92.21-.29.04-.7-.31-.77l-.99-.18a.669.669 0 0 1-.47-.96c1.41-2.75 3.4-4.97 5.97-6.66.29-.19.52-.46.66-.79l3.34-8.17M253.4 64.46c.92-1.33 1.53-2.9 1.82-4.7"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M242.23 97.46c-.47-.33-1.48-.1-3.03.71"
      style={{
        fill: "none",
        stroke: "#e7cb71",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M239.75 61.89c.07 4.29 1.55 7.89 4.42 10.8"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M244.17 72.69c.83-5.73-.32-10.39-3.46-13.97-.23-.26-.42-.24-.59.06-.69 1.2-.81 2.24-.37 3.11"
      style={{
        fill: "none",
        stroke: "#d6b048",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M244.17 72.69c-1.32-3.4-2.27-6.22-2.85-8.46-.51-1.94-1.03-2.72-1.57-2.34"
      style={{
        fill: "none",
        stroke: "#ead17e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M33.27 71.53c2.41-3.48 3.48-7.29 3.21-11.43"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M36.48 60.1c-.39-.13-.61-.43-.67-.89-.05-.39-.58-.5-.77-.15a31.325 31.325 0 0 0-3.86 11.69c-.07.57.14 1.13.55 1.51.75.69 1.27.44 1.54-.73"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M36.48 60.1c-1.73 3.67-2.8 7.48-3.21 11.43"
      style={{
        fill: "none",
        stroke: "#edd381",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M251.27 64.96c-.86-.29-1.3-.72-1.31-1.29 0-.34-.12-.63-.35-.88-1.1-1.21-2.49-2.08-4.17-2.61-1.15-.36-2.02 1.04-1.2 1.91 1.84 1.95 4.12 3.14 6.85 3.58.19.03.37-.09.42-.27a.376.376 0 0 0-.24-.44"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M30.26 60.82c-.18-.28-.98-.1-1.78.42-.79.52-1.29 1.17-1.1 1.46.18.28.98.1 1.78-.42.79-.52 1.29-1.17 1.1-1.46M31.2 62.15l-6.11 2.83c-.06.03-.09.11-.06.17.27.57 1.83.4 3.5-.37l.29-.14c1.67-.77 2.81-1.86 2.55-2.42-.03-.07-.1-.1-.16-.07M238.6 139.91l-.4 23.29c0 .14.1.27.25.29.14.02.28-.06.32-.2 1.03-3.24 2.61-6.19 4.76-8.84.14-.18.18-.38.11-.59l-4.7-14.01c-.03-.08-.11-.13-.19-.11-.09.01-.15.08-.15.17"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m37.81 162.09-.02-21.58c0-.13-.09-.24-.22-.26a.276.276 0 0 0-.3.18l-3.99 11.51c-.34.98-.26 2.05.22 2.96l3.8 7.31c.34.67.51.63.51-.12M37.09 175.71c-.89 2.98-2.29 5.68-4.2 8.1-.22.27-.27.57-.16.9l4.7 13.64s.05.06.08.05c.04 0 .07-.03.07-.07.2-7.52 1.06-15.22-.08-22.59-.04-.22-.35-.24-.41-.03"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M257.48 243.57c-.25.67-.61 1.11-1.08 1.33-.32.14-.62.11-.89-.1-.7-.55-1.05-1.28-1.04-2.2"
      style={{
        fill: "none",
        stroke: "#d2a839",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m254.47 242.6.94-5.94"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M255.41 236.65c.3-.57.36-.95.19-1.13-.8-.8-2.14-.59-2.67.41-1.75 3.3-4.3 6.72-2.19 10.65.16.3.21.61.15.94-.36 1.85-.02 3.49 1.01 4.93"
      style={{
        fill: "none",
        stroke: "#d2a839",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m251.9 252.45.74 5.2c.07.49.24.52.49.1.44-.72.66-1.69.66-2.91"
      style={{
        fill: "none",
        stroke: "#ddb957",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m253.79 254.85 1.76.16"
      style={{
        fill: "none",
        stroke: "#d2a839",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m255.55 255.01-.69 7.87"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M254.86 262.88c.94 1.09 1.6 2.47 1.97 4.15"
      style={{
        fill: "none",
        stroke: "#d2a839",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M256.83 267.02c2.31 5.24 3.73 10.29 4.26 15.15.23 2.04.78 2.13 1.65.27 1.8-3.81 2.75-7.51 2.86-11.09"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M265.6 271.36c2.51-14.55-2.6-30.6-8.32-43.98-.3-.7-.73-.79-1.28-.27-2.79 2.63-4.57 5.83-5.35 9.61-.07.32.33.53.55.28l3.26-3.73c.79-.9 2.27-.4 2.36.79.19 2.55-.17 4.97-1.09 7.26-.12.31.04.66.36.75 1.05.3 1.51.8 1.39 1.5"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M265.6 271.36c-1.83-8.97-4.14-17.44-6.93-25.39-.11-.3-.3-.38-.59-.24l-.34.17"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m257.74 245.89-.26-2.33"
      style={{
        fill: "none",
        stroke: "#dbb54d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M255.41 236.65a.756.756 0 0 0-.16-.41c-.21-.25-.39-.22-.54.07a34.061 34.061 0 0 0-3.19 9.74c-.06.37.16.72.52.82.35.11.73-.08.87-.42l1.56-3.86"
      style={{
        fill: "none",
        stroke: "#e6c96f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m257.74 245.89-.22 5.1c0 .42.18.56.57.41l.62-.22c.44-.17.73-.03.86.42 1.72 5.73.81 10.87-2.74 15.42"
      style={{
        fill: "none",
        stroke: "#e1c160",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m254.86 262.88 1.75-6.53c.08-.31.04-.61-.12-.9-1.7-3.04.09-4.73.1-7.49 0-.46-.62-.6-.82-.19-1.2 2.51-1.27 4.93-.22 7.24"
      style={{
        fill: "none",
        stroke: "#e6c96f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m253.79 254.85 1.01-8.51c.04-.35-.11-.5-.46-.46-.28.03-.46.2-.53.5-.51 2.04-1.14 4.07-1.91 6.08"
      style={{
        fill: "none",
        stroke: "#e3c468",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M238.99 233.04c-.27 2.13-.28 4.25 0 6.38.04.35.22.6.55.75l.68.32c.35.16.55.43.6.82.27 2.07 1.28 3.67 3.04 4.81.14.09.32.07.43-.06.11-.12.12-.3.02-.43-2.34-2.99-3.75-9.34-4.64-12.63-.3-1.11-.52-1.1-.67.04"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M253.56 271.88c.2.31.28.55.24.72"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M253.8 272.6a9.481 9.481 0 0 1-3.58 4.14c-.32.21-.24.69.13.78l5.25 1.25"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m255.6 278.77 2.89 2.13c.35.26.83-.05.75-.47a55.276 55.276 0 0 0-5.84-16.17c-.19-.35-.48-.54-.87-.57-.85-.07-1.26-.59-1.21-1.55 0-.25.14-.41.39-.48.4-.1.5-.21.29-.34"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M252 261.32c-1.29-1.83-2.87-3.3-4.73-4.41"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M247.27 256.9c.28-.71.63-1.08 1.04-1.1"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m248.31 255.8.59.49c.41.35.53.26.36-.25-.93-2.71-2.49-4.81-4.68-6.32"
      style={{
        fill: "none",
        stroke: "#debc5a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M244.58 249.73c-.56-.01-1.18-.54-1.85-1.57"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m242.73 248.15-3.18-4.48c-.18-.25-.57-.12-.57.19l.12 25.81c0 .36.48.47.64.16l2.31-4.44c.06-.12.15-.21.27-.28 1.02-.59 1.62-1.48 1.79-2.66.06-.4.4-.7.8-.71.41-.01.76.27.84.67.69 3.49.62 6.98-.21 10.45-.07.29.23.54.5.41 2.39-1.1 4.73-2.91 7.52-1.4"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M242.73 248.15c-.56 2.13-.02 4.16 1.61 6.11.33.41.24.61-.29.61h-1.26c-.41 0-.68.43-.5.8 1.92 3.93 4.93 6.63 9.02 8.09.32.11.52.33.6.66a33.39 33.39 0 0 0 1.99 5.75c.15.33.22.62.21.89 0 .65-.19.92-.55.81"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M244.58 249.73c-.39.74-.16 1.56.67 2.46 1.41 1.54 2.43 2.75 3.06 3.62"
      style={{
        fill: "none",
        stroke: "#e7c96e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m247.27 256.9-.94-.02c-.41-.01-.48.13-.2.44 1.54 1.69 3.5 3.02 5.87 3.99M255.6 278.77l-1.01-5.73c-.05-.25-.19-.39-.44-.42-.11 0-.22-.02-.35-.02"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M36.45 277.89c.23-4.19-.84-7.93-3.2-11.21"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M33.25 266.67c-.08-1.17-.59-1.39-1.54-.68-.35.27-.54.71-.5 1.16.43 4.31 1.68 8.36 3.76 12.16.21.37.46.41.76.1.47-.47.71-.98.72-1.53"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M33.25 266.67c.35 3.87 1.42 7.61 3.2 11.21"
      style={{
        fill: "none",
        stroke: "#edd381",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M242.73 267.32c-1.87 2.45-2.8 5.34-2.81 8.69"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M239.92 276.01c-.85.92-.76 2.17.27 3.75.22.33.44.34.67.01 2.83-3.95 4.01-8.35 3.56-13.18-.07-.7-1.02-.85-1.3-.2l-.39.93"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M239.92 276.01c2.05-2.07 2.99-4.97 2.81-8.69"
      style={{
        fill: "none",
        stroke: "#edd381",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M25.73 274.3c.11 1.94 4.35 3.71 5.98 4.13a.73.73 0 0 0 .83-1.05c-1.55-2.83-3.98-4.38-7.3-4.66-.52-.04-.6.12-.23.49l.41.41c.19.19.3.41.31.68M250.5 273.89l.76-.56c.17-.13.23-.36.13-.55a.44.44 0 0 0-.52-.23c-2.61.76-6.93 2.12-7.02 5.39-.01.33.16.47.49.41 2.18-.43 4.05-1.4 5.6-2.91.25-.23.37-.52.37-.87v-.3c0-.16.06-.29.19-.38"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M246.37 279.14c1.48 1.68 2.63 2.62 3.46 2.82.26.07.42.23.47.49l.14.7"
      style={{
        fill: "none",
        stroke: "#d6ac3f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M250.44 283.15c-.75 1.62-.78 2.86-.1 3.73"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M250.34 286.89c-.3.41-.73.78-1.3 1.11"
      style={{
        fill: "none",
        stroke: "#d6ac3f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M249.04 287.99c-1.61 3.13-5.76 2.19-6.01-1.11-.03-.43.15-.69.54-.8.27-.08.45.02.54.29l.25.82c.45 1.43 2.35 1.69 3.16.44 4.86-7.5-11.1-10.99-8.31 2.08"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M239.21 289.71c-1.62 4.67 4.57 8.76 8.62 8.73 8.24-.04 11.88-8.31 11.53-15.54 0-.28-.16-.41-.45-.38l-3.94.42c-.38.04-.72-.06-1.01-.31-.67-.57-.64-1.12.08-1.66"
      style={{
        fill: "none",
        stroke: "#d6ac3f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m254.04 280.98 2.03.63c.2.06.41-.03.5-.22.09-.18.03-.4-.14-.52-2.85-1.95-6.2-2.53-10.06-1.72"
      style={{
        fill: "none",
        stroke: "#debc5a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m254.04 280.98-7.67-1.83"
      style={{
        fill: "none",
        stroke: "#e8ca71",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M239.21 289.71c3.36 4.94 7.37 5.99 12.04 3.15.91-.55 1.25-1.35 1.02-2.39-.3-1.35-1.38-2.18-3.23-2.48"
      style={{
        fill: "none",
        stroke: "#e5c466",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m250.34 286.89 2.45 1.77c.68.49 1.56-.26 1.19-1.01l-2.17-4.45a.485.485 0 0 0-.26-.23c-.55-.2-.92-.14-1.11.19"
      style={{
        fill: "none",
        stroke: "#e3c162",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m233.6 295.46-5.05-.03c-.36 0-.64.15-.85.44-1.99 2.85-2 10.4 3.37 9.42 5.23-.97.94-8.1-2.18-3.6-.18.27-.59.23-.71-.07-.22-.53-.12-1.06.3-1.58 3.22-4 9.22.79 5.18 5.62-.25.31-.21.56.13.76l2.79 1.71"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m236.58 308.14 1.28 1.46c.79.91-.04 2.3-1.22 2.04l-2.94-.65"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m233.7 310.98-3.28-1.31c-.42-.17-.61-.03-.56.42l.47 4.09"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M230.33 314.18c-.25 0-.56.26-.93.79"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M229.4 314.98c-2.25-2.14-3.81-4.82-4.67-8.05a.473.473 0 0 0-.84-.16c-1.16 1.61-2.71 2.66-4.65 3.15a.64.64 0 0 1-.8-.67c.21-2.46.9-4.76 2.08-6.9.37-.66.21-.82-.46-.48l-1.08.56c-.23.12-.48.2-.74.23-2.53.32-5.06.27-7.59-.15-.6-.1-.87-.8-.49-1.27 1.73-2.15 3.85-3.81 6.37-4.97.45-.21.3-.89-.2-.89h-23.51c-.37 0-.46.51-.11.64 10.22 3.79 17.57 9.24 27.01 16.7 1.97 1.57 5.16 2.91 9.57 4.03"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M229.29 316.74c4.03.48 7.5-.42 10.4-2.71 5.98-4.72 3.62-20.33-6.09-18.57"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M229.29 316.74c.74-.26.78-.85.11-1.77M230.33 314.18c2.17-.28 3.29-1.35 3.37-3.2M236.58 308.14c2.35-4.81 1.36-9.03-2.98-12.67"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M38.36 315.07c10.23 5.63 20.52-4.07 28.29-9.82a73.48 73.48 0 0 1 16.76-9.32c.28-.11.2-.53-.1-.53h-3.26"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M80.05 295.39H59c-.14 0-.27.09-.29.24-.02.14.06.28.2.32 2.64.85 4.91 2.43 6.81 4.75"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m65.72 300.7.42.94c.19.42.06.66-.4.71l-3.83.46"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m61.91 302.82-6.15-.98c-.41-.07-.52.09-.35.46l2.17 4.64"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M57.58 306.93c.61 1.21.64 2.15.07 2.81-.25.29-.54.34-.87.16l-2.14-1.11"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m54.64 308.8-2.85-2.09"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M51.79 306.7c.21-.68-.21-1.14-1.24-1.38-1.4-.33-2.7.82-2.54 2.24a9.12 9.12 0 0 1-.76 4.81c-.03.07 0 .15.07.17l.27.09c.25.09.53-.03.64-.27.59-1.24 1.38-2.26 2.37-3.07"
      style={{
        fill: "none",
        stroke: "#d6ac3f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m50.6 309.3-1.25 2.85"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M49.35 312.14c-.81 1.56-1.77 2.44-2.88 2.63-.27.05-.47-.05-.62-.28-.09-.15-.11-.27-.05-.38"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m45.8 314.11.28-3.52c.05-.54-.53-.9-1-.63-2.09 1.21-4.34 1.6-6.74 1.19a.527.527 0 0 1-.36-.8c1.04-1.67 2.47-2.86 4.3-3.57.61-.23.72-1.06.19-1.45-4.17-3.11 1.25-9.07 5.25-5.66.61.52.62 1.16.03 1.93-.23.31-.44.3-.65-.02-.9-1.37-2.03-1.62-3.38-.75-.29.19-.48.45-.56.78-1.74 7.66 11.79 2.75 5.28-5.83a.916.916 0 0 0-.79-.4c-3.02-.03-7.56-.68-10.08 1.05-4.93 3.39-4.95 11.12-2.55 16.07.09.18.21.33.37.44l2.97 2.12"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m45.8 314.11-7.44.95M49.35 312.14c1.83-.11 3.59-1.22 5.29-3.35M57.58 306.93c2.49-1.27 3.93-2.65 4.33-4.12M80.05 295.39c.17.21.26.41.27.6 0 .35-.16.54-.51.55-4.98.18-9.68 1.57-14.09 4.16"
      style={{
        fill: "none",
        stroke: "#e4c363",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m51.79 306.7-1.19 2.59"
      style={{
        fill: "none",
        stroke: "#e5c466",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M52.28 298.33c3.1 2.47 6.69 3.5 10.76 3.08"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m63.04 301.42.5-.7c.2-.27.19-.54-.03-.79-.17-.2-.33-.29-.48-.26"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M63.03 299.67c-3.23-2.79-6.78-4.17-10.66-4.12"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M52.37 295.55c-.43-.04-.87.33-1.33 1.12-.19.32-.15.62.1.89.31.33.69.59 1.14.78"
      style={{
        fill: "none",
        stroke: "#d5aa3c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M52.37 295.55c3.1 2.1 6.65 3.47 10.66 4.12"
      style={{
        fill: "none",
        stroke: "#e9cb72",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m63.04 301.42-9.75-3.61c-.29-.11-.54-.04-.74.2l-.27.33"
      style={{
        fill: "none",
        stroke: "#eacd76",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m213.75 300.14 10.46-4s.01 0 0-.01v-.05c-.35-.88-2.86-.75-5.62.3l-.5.19c-2.75 1.06-4.71 2.63-4.37 3.52v.04s.02.01.03.01"
      style={{
        fill: "none",
        stroke: "#e0be5e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M215.22 300.51c-.23.08-.78.05-1.65-.1-.15-.03-.35-.04-.59-.03-.32.01-.46.25-.3.54.16.3.55.55.89.57 4.41.31 8.19-1.03 11.34-4 .22-.21-.01-.58-.3-.47l-9.39 3.49"
      style={{
        fill: "none",
        stroke: "#e1c062",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M55.6 307.8c.18.27.44.38.78.34.49-.07.63-.33.42-.78l-3.15-6.74c-.5-1.07-2.08-.97-2.67.17-.89 1.71 1.96 5.36 3.08 6.4.12.12.27.18.44.19.09 0 .19 0 .29-.01.35 0 .62.13.81.43"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m223.08 300.12-3.71 6.91c-.04.08-.01.17.07.21h.03c1.44.78 3.43-.13 4.44-2.03l.16-.3c1.02-1.9.68-4.06-.75-4.83l-.04-.02c-.07-.04-.16-.01-.2.06"
      style={{
        fill: "none",
        stroke: "#dbb64f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m228.38 310.43.33-.11c.17-.06.26-.18.27-.36.04-2.16-.85-3.68-2.67-4.56a.581.581 0 0 0-.8.71l2.18 6.43c.25.73.52.74.82.03.29-.69.24-1.37-.16-2.06-.02-.04-.01-.07.03-.08M45.39 306.96l-5.2 2.19c-.07.03-.1.1-.07.17l.02.05c.38.9 1.83 1.16 3.23.57l.36-.15c1.4-.59 2.23-1.8 1.85-2.71l-.02-.05a.143.143 0 0 0-.17-.07M236.23 309.12l-5.39-2.35c-.09-.04-.19 0-.23.09l-.05.12c-.39.89.43 2.1 1.83 2.71l.64.28c1.4.61 2.84.39 3.23-.5l.05-.12c.04-.09 0-.19-.08-.23"
      style={{
        fill: "none",
        stroke: "#d9b24b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m13.42 30.17-.68 1.06c-.05.09-.03.2.06.26l2.22 1.42c1.54.98 2.95 1.54 3.15 1.23l.17-.27c.2-.31-.89-1.36-2.44-2.35l-2.21-1.41a.195.195 0 0 0-.27.06"
      style={{
        fill: "none",
        stroke: "#eacd76",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m258.81 41.83 5.11 2.74c.07.04.14.01.18-.05.35-.67-.48-1.81-1.88-2.56l-.3-.16c-1.39-.75-2.81-.81-3.16-.15-.04.07-.01.15.05.18"
      style={{
        fill: "none",
        stroke: "#e9cb72",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M145.97 70.28c5.09 3.47 8.89 7.87 11.39 13.19"
      style={{
        fill: "none",
        stroke: "#23110d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M157.36 83.46c.65 2.83 1.17 5.65 2.88 8.09.85 1.23.68 2.21-.52 2.96"
      style={{
        fill: "none",
        stroke: "#160b0d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M159.72 94.51c-1.97 4.93-3.31 10.33-4.04 16.18-.73 5.95.39 11.36 3.36 16.21.18.29.22.65.11.98l-1.87 5.56"
      style={{
        fill: "none",
        stroke: "#25120b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M157.28 133.45c-1.04 1.93-1.81 3.75-2.32 5.45-.72 2.45-.06 5.36-.14 8.08-.03 1.26-.72 2.17-.8 3.53-.11 1.92 1.83 4.61 2.57 6.51.12.3.11.64-.04.93a14.35 14.35 0 0 0-1.38 4.29c-.78 5.31 4.74 8.17 1.27 13.62-.17.28-.25.61-.2.94.13.87.62 1.79 1.45 2.75"
      style={{
        fill: "none",
        stroke: "#32180b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m157.69 179.54 3.07 3.18c.44.45 1.18-.04.93-.62-1.51-3.46-.75-6.43 2.29-8.91"
      style={{
        fill: "none",
        stroke: "#25120b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M163.98 173.2c.83-.65.98-1.56.43-2.75-.87-1.91-.9-3.77 1.2-4.52 5.06-1.8 1.99-5.05 3.98-8.54"
      style={{
        fill: "none",
        stroke: "#160b0d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m169.59 157.38 4.43-2.79c.26-.16.4-.47.36-.78-.35-2.75-.05-5.37.9-7.87.53-1.39.77-2.65.72-3.77-.83-17.33-1.49-34.66-5.95-51.79-1.57-6.02-4.75-10.85-9.55-14.49"
      style={{
        fill: "none",
        stroke: "#0f0910",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M160.5 75.89c-5.73-5.91-13.44-9.73-23.13-11.48"
      style={{
        fill: "none",
        stroke: "#23110d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m137.37 64.42-7.16-1.53c-.29-.06-.6.03-.82.25-.93.95-1.39 2.08-1.4 3.39 0 .4.19.59.59.56 4.74-.32 9 .26 12.79 1.75 2.1.82 3.63 1.3 4.6 1.44"
      style={{
        fill: "none",
        stroke: "#100b10",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M137.37 64.42c4.12 1.92 6.99 3.87 8.6 5.86"
      style={{
        fill: "none",
        stroke: "#321b1d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M160.5 75.89c1.13 3.1 2.69 6 4.69 8.7.19.26.28.59.24.92-.48 3.93-.08 7.71 1.19 11.34"
      style={{
        fill: "none",
        stroke: "#31191d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M166.62 96.86c-.27 1.08-.6 1.4-.98.95-3.18-3.71-4.8-7.22-5.36-12.09-.25-2.19-1.22-2.94-2.92-2.25"
      style={{
        fill: "none",
        stroke: "#381c1a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M169.59 157.38c.45-.86.33-1.48-.36-1.87a1.84 1.84 0 0 1-.65-.65 5.58 5.58 0 0 1-.78-2.67c0-.3-.1-.57-.28-.8-.61-.79-.88-1.64-.82-2.54.03-.4.24-.62.64-.65l2.19-.2c.45-.04.68-.29.68-.75-.04-3.76 1.7-7.46 1.7-10.52 0-3.73-1.29-7.15-3.86-10.26-.34-.41-1-.1-.9.42l1.47 7.49c.04.19.01.4-.08.57-.73 1.41-1.9 1.91-3.49 1.52-.44-.11-.63-.39-.58-.84l.4-3.43c.03-.29.03-.58-.02-.87-.96-5.62.52-10.47 2.48-15.93 2.49-6.94 2.46-12.21-.71-18.55"
      style={{
        fill: "none",
        stroke: "#24141c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M163.98 173.2c-2.61-4.95-2.07-7.96 1.62-9.01.33-.1.55-.32.66-.65 2.13-7.09-1.34-8.88-3.51-14.32-1.24-3.12-1.17-6.4.2-9.83 1.81-4.54.93-8.35-1.44-12.43-3.72-6.42-.75-11.58 2.19-17.36 2.45-4.81-.74-11.05-3.98-15.08"
      style={{
        fill: "none",
        stroke: "#3b1d18",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M157.69 179.54c1-.19 1.52-1.3 1.56-3.35.01-.38.14-.7.41-.96 5.03-4.97-1.83-7.09-2.05-11.33-.06-1.09.04-2.24.31-3.44.26-1.18 1.75-1.55 2.54-.64.53.61.72 1.3.57 2.05-.06.29.11.57.38.66.27.1.58-.02.71-.28.88-1.73.51-3.2-1.12-4.42-4.64-3.47-5.55-6.42-4.18-12.14.97-4.05 1.13-8.13.46-12.25"
      style={{
        fill: "none",
        stroke: "#572916",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M99.91 89.6c3.34-9.61 13.73-24.36 25.65-23.41.37.03.61-.13.74-.48l.26-.69c.57-1.56.07-2.09-1.52-1.59-10.73 3.42-27.89 12.91-26.69 25.98.08.86 1.28 1.01 1.56.19"
      style={{
        fill: "none",
        stroke: "#23110d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M114.21 95.39c-1.68 4.53-6.71 6.08-11.27 6.26-.37.02-.54.21-.5.58l.81 8.04c.04.38.51.53.77.25 4.53-5.08 7.98-8.29 10.34-9.62 8.76-4.93 15.67 2.17 23.64 8.09"
      style={{
        fill: "none",
        stroke: "#6e5b31",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M138 108.99c3.29 1.37 11.24 6.11 5.88 10.44-.27.22-.28.45-.04.7l3.41 3.47"
      style={{
        fill: "none",
        stroke: "#675226",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m147.25 123.6 4.21 7.39"
      style={{
        fill: "none",
        stroke: "#513d18",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m151.46 130.99.97 4.01c.13.51.83.59 1.06.11l3.35-6.88c.12-.24.12-.53-.01-.76-4.96-9.22-5.59-17.35-1.96-27.88.15-.43 0-.64-.45-.64-1.34.01-2.36.22-3.05.61"
      style={{
        fill: "none",
        stroke: "#32210f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m151.37 99.56-4.01.04"
      style={{
        fill: "none",
        stroke: "#513d18",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m147.36 99.6-6.38-1.52"
      style={{
        fill: "none",
        stroke: "#675226",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M140.98 98.07c-2.5-1.66-3.91-3.72-1.4-6.28 2.88-2.94 6.48-4.1 10.79-3.48"
      style={{
        fill: "none",
        stroke: "#5c4926",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m150.37 88.32 6.14 1.02c.4.07.57-.1.5-.5-1.77-10.22-10.32-17.79-20.49-19.24"
      style={{
        fill: "none",
        stroke: "#32210f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M136.52 69.6c-1.53-.59-3.45-.85-5.78-.78-2.66.08-7.1-1.35-9.17-.46-9.31 4-15.71 10.78-19.2 20.35-.14.37-.01.57.38.62 5.38.69 9.86.82 11.46 6.06"
      style={{
        fill: "none",
        stroke: "#5c4926",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m136.52 69.6 9.37 8.09c.25.22.42.49.51.82.65 2.4 2.66 3.3 3.45 5 .72 1.55.89 3.16.52 4.81"
      style={{
        fill: "none",
        stroke: "#8e6a35",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M140.98 98.07c-.14.03-.28.06-.43.09"
      style={{
        fill: "none",
        stroke: "#c39b4c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m140.55 98.17-1.08-.04c-.32-.01-.62-.15-.83-.39l-3.06-3.46c-.21-.24-.31-.52-.29-.84.22-4.3 4.5-5.29 7.11-7.07.06-.05.13-.08.2-.09l3.93-.67c.5-.09.55-.79.06-.94-.81-.26-1.23-.86-1.24-1.79-.01-.31-.1-.6-.29-.85a43.3 43.3 0 0 0-6.72-7.08c-3.1-2.62-11.54-4.28-15.36-3.08-4.38 1.39-13.71 9.42-14.18 14.61-.03.35.12.59.45.72 2.96 1.15 4.9 2.78 5.82 4.88.81 1.84.53 2.94-.86 3.31"
      style={{
        fill: "none",
        stroke: "#c9a456",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m147.36 99.6-.65 12.51c0 .33.05.64.18.93.69 1.45.93 2.96.74 4.53-.04.31.02.61.17.9 1.05 1.99.86 3.7-.55 5.13"
      style={{
        fill: "none",
        stroke: "#b88f3e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m140.55 98.17.33.41c.11.13.1.26-.02.37l-.24.24c-.19.19-.26.41-.21.67.37 2.18-.17 4.1-1.64 5.75-.35.4-.07 1.02.46 1.02h.57c.18 0 .24.23.09.32-.43.25-.6.59-.51 1.04.07.35-.07.57-.4.68l-.98.32"
      style={{
        fill: "none",
        stroke: "#d5ad57",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M151.46 130.99c1.52-6.23-2.33-11.31-1.98-16.92.29-4.77.92-9.61 1.89-14.51"
      style={{
        fill: "none",
        stroke: "#835e27",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M155.79 93.58c-.02-.92-3.03-1.61-6.72-1.53-3.7.08-6.68.89-6.65 1.81.02.92 3.03 1.61 6.72 1.53 3.69-.08 6.67-.89 6.65-1.81"
      style={{
        fill: "none",
        stroke: "#786d46",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M109.47 95.32c0-.93-2.46-1.67-5.48-1.65-3.02.02-5.46.78-5.46 1.71 0 .93 2.46 1.67 5.48 1.65 3.02-.02 5.46-.78 5.46-1.71"
      style={{
        fill: "none",
        stroke: "#776b43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M115.33 104.92c-3.97 1.96-8.54 6.3-11.25 9.74-5.88 7.49-11.06 14.46-15.53 20.93-1.67 2.41-2.9 5.13-3.69 8.16-.08.3.03.4.32.29 9.91-3.7 23-3.02 32.71-.32 1.9.52 3.62.19 5.49-.05.33-.04.62-.21.83-.46a152.89 152.89 0 0 0 16.78-24.51c1.16-2.1.95-3.91-1.13-5.13a322.57 322.57 0 0 1-13.17-8.11 3.865 3.865 0 0 0-4.92.58 18.185 18.185 0 0 1-5 3.74.995.995 0 0 1-1.43-1.08l.63-3.29c.12-.6-.09-.76-.64-.49"
      style={{
        fill: "none",
        stroke: "#786d46",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M110.35 164.49c-1.07 3.02-4.5 7.11-.54 9.77 8.72 5.88 28.86 4.63 35.96-3.42 1.81-2.05 3.72-4 5.72-5.85.25-.22.37-.56.32-.89-.23-1.7-.05-3.42.56-5.17"
      style={{
        fill: "none",
        stroke: "#776b43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M152.37 158.93c-.17-1.07-.48-2.27-.92-3.58-.97-2.88-.18-5.06.73-7.73.11-.31.12-.63.04-.95-1.54-6.19-2.03-20.69-9.66-24.02-.35-.15-.62-.07-.82.26L127.06 147c-.1.17-.26.31-.45.37a46.937 46.937 0 0 1-15.1 2.77c-.28 0-.5.26-.47.54.27 2.59-.43 4.87-2.1 6.82-.18.2-.3.45-.35.72-.21 1.03.11 1.86.95 2.47.25.18.42.46.45.77l.36 3.03"
      style={{
        fill: "none",
        stroke: "#73653c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M152.37 158.93c-2.16.29-3.85 1.16-5.08 2.63-.21.25-.48.4-.8.45-1.83.29-3.64.32-5.43.11-2.56-.3-10.13 1.49-12.49 3.31-.27.21-.62.28-.96.2-2.05-.52-3.37.98-4.86 1.3-2.05.45-4.12.62-6.2.53-.33-.02-.63-.18-.83-.44-1.49-1.96-3.28-2.8-5.37-2.53"
      style={{
        fill: "none",
        stroke: "#e9cf7f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M113.8 145.32a81.777 81.777 0 0 0-22.75.12.323.323 0 0 0 0 .64c3.37.46 6.74.6 10.11.43 3.85-.2 8.5.49 12.67-.39a.407.407 0 0 0-.03-.8"
      style={{
        fill: "none",
        stroke: "#6d6341",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M103 150.9c-2.17-.37-4.38-.63-5.76 1.36-4.49 6.47 8.05 9.47.32 16.62-.22.2-.27.54-.1.79 1.3 2.01 3.27 3.18 5.92 3.51"
      style={{
        fill: "none",
        stroke: "#1f1114",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M103.38 173.18c.77 1.3 1.07 2.72.92 4.25-.02.19.23.27.32.1 2.25-4.33-1-7.96 2.87-11.8.23-.23.35-.52.36-.85.04-1.8-.51-3.4-1.64-4.81-.21-.25-.3-.54-.27-.87.17-2.27 1.08-4.17 2.71-5.68 1.13-1.05.33-2.93-1.21-2.85l-4.44.23"
      style={{
        fill: "none",
        stroke: "#37221a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M103.38 173.18c-.2-2.91.13-5.73.98-8.46.11-.36.06-.69-.17-1-1.27-1.67-1.51-3.54-.73-5.61.07-.2-.05-.41-.26-.44l-.38-.05a.678.678 0 0 0-.76.55l-.5 2.48c-.13.64-1.04.66-1.2.03-.91-3.51-.03-6.77 2.64-9.78"
      style={{
        fill: "none",
        stroke: "#56332e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M171.14 162.7c-.41 2.83-1.82 4.6-4.25 5.29-.34.1-.46.32-.36.65l.89 2.98"
      style={{
        fill: "none",
        stroke: "#321e10",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M167.42 171.62c-.86 2.35-2.24 4.47-4.14 6.38-.53.53-.18 1.44.57 1.47 7.33.35 14.16 2.39 20.49 6.14 1.53.91 4.3 3.88 8.3 8.91"
      style={{
        fill: "none",
        stroke: "#1f110f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M192.64 194.51c6.67 8.57 7.35 16.69 8.45 27.12.04.37.15.4.34.08 3.76-6.22 2.3-15.1-1.13-21.05-3.97-6.9-3.88-14.71-7.66-20.99-1.45-2.41-3.2-4.6-5.25-6.57"
      style={{
        fill: "none",
        stroke: "#0b0611",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M187.39 173.1c-4.65-5.08-9.11-9.82-13.46-15.15-.22-.27-.5-.35-.83-.23-1.92.68-2.57 2.34-1.96 4.97"
      style={{
        fill: "none",
        stroke: "#191111",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m187.39 173.1-.72 2.58"
      style={{
        fill: "none",
        stroke: "#231722",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M186.67 175.68c-3.41-7.05-7.97-9.32-15.53-12.99"
      style={{
        fill: "none",
        stroke: "#4a2f21",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m186.67 175.68 5.29 11.25c.1.21.02.45-.18.56s-.45.05-.58-.14l-1.72-2.62"
      style={{
        fill: "none",
        stroke: "#3c2321",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M189.48 184.74c-3.47-6.78-10.06-12.78-17.8-12.8-1.5 0-2.92-.11-4.26-.32"
      style={{
        fill: "none",
        stroke: "#512f1f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m189.48 184.74-3.09-.91c-.67-.2-.76-.05-.27.45 2.87 2.93 5.05 6.35 6.52 10.24"
      style={{
        fill: "none",
        stroke: "#2a1720",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m140.59 180.99-5.41 6.32"
      style={{
        fill: "none",
        stroke: "#412d12",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M135.18 187.32c-7.8 10.69-13.95 22.38-18.45 35.08-.11.33.07.7.41.8.74.23 1.35-.1 1.83-.99 3.5-6.53 6.77-13.61 11.21-19.55 1.21-1.61 2.3-3.23 3.28-4.85"
      style={{
        fill: "none",
        stroke: "#291e13",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M133.46 197.8a97.66 97.66 0 0 1 20.11-15.3"
      style={{
        fill: "none",
        stroke: "#4c3517",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M153.57 182.51c.64.14 1.2-.03 1.68-.51.25-.25.25-.5-.02-.74-1.63-1.47-2.07-3.37-1.33-5.68"
      style={{
        fill: "none",
        stroke: "#291e13",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M153.9 175.57c1.95-2.44 1.91-4.58-.13-6.43"
      style={{
        fill: "none",
        stroke: "#412d12",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m153.77 169.15-1.08-1.39c-.21-.27-.44-.29-.7-.07-4.17 3.55-7.97 7.99-11.4 13.31"
      style={{
        fill: "none",
        stroke: "#513d18",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M153.77 169.15c-3.09 5.73-7.49 9.68-13.18 11.85"
      style={{
        fill: "none",
        stroke: "#91692a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M153.9 175.57a32.97 32.97 0 0 1-7.74 8.71c-5.37 4.25-8.13 6.63-12.06 10.25-.3.27-.78.18-.95-.18a1.24 1.24 0 0 1-.11-.78c.03-.2.17-.41.4-.63 2.35-2.25 2.93-4.12 1.74-5.63"
      style={{
        fill: "none",
        stroke: "#694b25",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M153.57 182.51c-2.05-.33-4.23.27-6.56 1.82-5.75 3.84-10.27 8.33-13.55 13.48"
      style={{
        fill: "none",
        stroke: "#74532a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M89.29 172.93c-5.02 4.71-8.43 10.17-10.22 16.39"
      style={{
        fill: "none",
        stroke: "#211513",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M79.07 189.32c-3.56 10.76-7.86 20.96-12.9 30.61-1.07 2.05-1.59 4.24-2.35 6.43"
      style={{
        fill: "none",
        stroke: "#1e1418",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M63.82 226.35c.23 3.94-.34 7.65-1.71 11.12-1.17 2.97-1.79 4.95-1.88 5.94-.33 3.85.86 6.91 3.57 9.2 6.13 5.15 15.33 2.68 21.16-1.98"
      style={{
        fill: "none",
        stroke: "#0f0b15",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M84.96 250.64c1.86-.89 3.69-2.01 5.5-3.37.63-.47.89-.98.78-1.54"
      style={{
        fill: "none",
        stroke: "#29110c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M91.24 245.73c.27-.04.46-.13.56-.27.07-.11.06-.29-.03-.53-1.53-3.94-2.22-8.13-2.08-12.57"
      style={{
        fill: "none",
        stroke: "#604b2a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M89.69 232.35c.48-5.19.22-6.41 3.65-10.54.09-.11.09-.27-.01-.37a.278.278 0 0 0-.37-.05c-4.55 3.06-7.84 7.24-9.87 12.53"
      style={{
        fill: "none",
        stroke: "#29110c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m83.09 233.93-.23 7.72"
      style={{
        fill: "none",
        stroke: "#402e1b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M82.86 241.64c-.21.98-.06 2.04.43 3.18.13.3 0 .65-.28.81-1.03.55-1.96-.32-2.17-1.35-.69-3.52-.57-7.05.37-10.6"
      style={{
        fill: "none",
        stroke: "#29110c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M81.21 233.68c1.09-2.09 2.2-4.16 3.34-6.21 1.66-2.99 4.25-4.72 6.67-7.15.88-.88 2.1-1.1 2.83-.51.36.29.79.26 1.3-.07.46-.31.61-.91.36-1.4-7.55-14.51-5.22-28.89.87-43.5.14-.34.14-.68 0-1.01l-1.74-4.01c-.14-.32-.36-.38-.65-.19l-4.89 3.29"
      style={{
        fill: "none",
        stroke: "#0f0b15",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M81.21 233.68c-.12-.52-.26-.81-.42-.86"
      style={{
        fill: "none",
        stroke: "#381c21",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M80.79 232.82c-.01-1.87.7-3.56 2.12-5.07.2-.22.22-.55.04-.79l-.72-.97c-.23-.3-.21-.59.05-.87l4.32-4.67"
      style={{
        fill: "none",
        stroke: "#452f2c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m86.6 220.46 5.21-2.66c.31-.16.32-.61.01-.78-.47-.27-1.08-.23-1.82.1-4.93 2.24-8.78 4.99-11.54 8.25"
      style={{
        fill: "none",
        stroke: "#0f0b15",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M78.46 225.37c-3.26 1.77-5.4 4.83-6.42 9.17-.09.38-.59.47-.81.14-.43-.64-.56-1.35-.39-2.12.04-.18-.03-.28-.21-.3-.1-.01-.2 0-.29.06-.11.06-.2.19-.26.38-.9 2.88-1.94 5.16-1.54 8.32.29 2.33.48 4.69.56 7.06 0 .29.09.56.25.81l2.12 3.36c.17.27.4.33.68.18.32-.17.52-.43.61-.8.08-.34-.03-.78-.34-1.32a14.03 14.03 0 0 1-1.35-3.4c-.18-.72-.03-.8.46-.24 3.74 4.3 7.28 4.19 13.43 3.97"
      style={{
        fill: "none",
        stroke: "#381c21",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M63.82 226.35c.23.54.31 1.03.24 1.46-.03.17.08.33.24.38.17.04.34-.05.4-.21 3.88-10.65 11.47-11.63 22.47-12.29.33-.02.44-.45.17-.63-3.47-2.33-5.86-5.47-7.19-9.44-.28-.84.66-1.56 1.4-1.07l.84.57"
      style={{
        fill: "none",
        stroke: "#2d1f2d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M82.39 205.12c1.79 2.69 4.14 5.15 7.05 7.4.29.22.7-.02.65-.38-.12-.91-.44-1.79-.95-2.64a26.79 26.79 0 0 1-3.57-9.89c-.05-.36.09-.56.42-.6.23-.03.4.06.5.28l1.66 3.43c.34.7.52.66.54-.12.11-5.05.75-10.02 1.92-14.93.81-3.4 1.91-12.54-1.32-14.75"
      style={{
        fill: "none",
        stroke: "#302028",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M89.69 232.35c-.02-.55-.08-.96-.17-1.22-.27-.7-.43-.62-.5.24l-.59 7.46c-.03.35-.18.41-.45.2-2.24-1.68-.37-5.04-.41-7.38 0-.29-.4-.37-.52-.1-1.88 4.3-1.97 8.64-.27 13.03.21.55 1.03.4 1.03-.19v-2.47c0-.3.38-.42.56-.18l2.87 3.98"
      style={{
        fill: "none",
        stroke: "#885c36",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M82.86 241.64c.46.65.71 1.34.76 2.08.01.1.06.15.16.15s.19 0 .28.01c.27 0 .37-.12.3-.37-.72-2.91-.87-5.85-.44-8.84.05-.31-.07-.54-.35-.68-.22-.11-.38-.13-.48-.07"
      style={{
        fill: "none",
        stroke: "#693f27",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M86.6 220.46c-5.28 3.07-8.93 7.65-10.96 13.73"
      style={{
        fill: "none",
        stroke: "#362417",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M75.64 234.18c-.63.93-1.14 2.21-1.53 3.83-.05.23-.15.42-.29.55-.19.17-.37.27-.56.3-.46.07-.84-.37-.72-.82 1.14-4.25 3.11-8.47 5.92-12.68"
      style={{
        fill: "none",
        stroke: "#29110c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M82.39 205.12c-.15-2.83-.89-5.49-2.22-7.99-.15-.28-.21-.6-.18-.92.29-2.54-.02-4.84-.92-6.9"
      style={{
        fill: "none",
        stroke: "#3f292b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M80.79 232.82c.06.73-.05 1.4-.34 2.01-.18.38-.63.56-1.02.42a.834.834 0 0 1-.52-.98l1.51-5.92c.08-.31-.04-.47-.36-.47s-.55.18-.73.54c-1.2 2.41-2.43 4.33-3.69 5.76"
      style={{
        fill: "none",
        stroke: "#5e3523",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M106.4 183.37c-4.94.85-7.33-1.99-6.46-6.75a.78.78 0 0 0-.31-.81c-.24-.19-.5-.25-.79-.16-.28.09-.52.35-.72.79-.23.53-.42.9-.57 1.11"
      style={{
        fill: "none",
        stroke: "#1e1513",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M97.55 177.54c-4.18 10.03-5.45 20.23-3.8 30.58.6 3.78 2.88 6.82 4.51 10.35.16.34.42.55.79.62l15.41 3.06c.34.07.56-.07.66-.4 1.62-5.32 3.59-10.18 5.9-14.58"
      style={{
        fill: "none",
        stroke: "#130c13",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M121.02 207.18c4.38-8.47 9.17-16.32 14.37-23.53"
      style={{
        fill: "none",
        stroke: "#2d1f14",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M135.39 183.65c.78-.56 1.17-1.17 1.17-1.84-.01-.26.1-.47.31-.62a13.63 13.63 0 0 0 3.45-3.77c.21-.35.13-.46-.26-.34-5.4 1.64-10.89 2.6-16.48 2.88"
      style={{
        fill: "none",
        stroke: "#402e1b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m123.58 179.96-4.08-.5"
      style={{
        fill: "none",
        stroke: "#2d1f14",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m119.5 179.46-4.46-1.11c-.36-.09-.55.05-.58.43-.08 1.39-.6 2.29-1.57 2.69"
      style={{
        fill: "none",
        stroke: "#41371d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M112.89 181.46c-1.17-.73-1.11-1.76.18-3.08.25-.25.22-.47-.09-.64l-4.18-2.38c-.33-.19-.55-.1-.66.26-.46 1.49-.86 3-1.21 4.53-.13.57-.03.86.28.87 1.04.01 1.31 1.44.35 1.85l-1.16.49"
      style={{
        fill: "none",
        stroke: "#2d1f14",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M112.89 181.46c-.16.39.04.71.61.97.91.42 1.55.43 1.93.03"
      style={{
        fill: "none",
        stroke: "#6e5530",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M115.43 182.46c1.16 1.03 1.86.24 2.11-2.39"
      style={{
        fill: "none",
        stroke: "#2d1f14",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M117.54 180.07c.45.69.93 1.17 1.43 1.46.35.2.6.12.75-.25.23-.55.15-1.16-.22-1.83"
      style={{
        fill: "none",
        stroke: "#6e5530",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M123.58 179.96c-.18.4-.28.79-.29 1.17"
      style={{
        fill: "none",
        stroke: "#6d4c2f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m123.29 181.12-.43-.2c-.35-.17-.59-.07-.74.28-1.1 2.65-.57 3.25 1.6 1.79"
      style={{
        fill: "none",
        stroke: "#2d1f14",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m123.72 182.99 1.27 1.42c.22.24.57.32.87.18.33-.15.62-.39.88-.74"
      style={{
        fill: "none",
        stroke: "#6d4c2f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M126.74 183.85c.77.6 1.36.59 1.76-.02.32-.49.41-1.06.28-1.69"
      style={{
        fill: "none",
        stroke: "#2d1f14",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M128.78 182.15c.97.97 1.99 1.34 3.05 1.12.26-.05.36-.38.17-.57l-.3-.31c-.25-.25-.2-.42.13-.51l.72-.21"
      style={{
        fill: "none",
        stroke: "#6d4c2f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M132.55 181.66c-.25.94.26 1.44 1.54 1.49.23 0 .41-.09.53-.29l.14-.24"
      style={{
        fill: "none",
        stroke: "#2d1f14",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M134.76 182.62c-.06.41.15.75.63 1.02"
      style={{
        fill: "none",
        stroke: "#6d4c2f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M121.02 207.18c-.46-1.63.08-3.66 1.63-6.09a.698.698 0 0 0-.57-1.07c-.55-.02-1.06.27-1.53.88-2.01 2.59-3.58 5.4-4.72 8.43-.25.65-.75.95-1.51.9-.33-.02-.44-.18-.35-.49 1.53-5.02 1.46-10.01-.19-14.98-.28-.84-1.5-.76-1.67.11l-1.26 6.36c-.07.33-.24.59-.53.76-.72.45-1.17 1.07-1.35 1.88a.4.4 0 0 1-.45.31.404.404 0 0 1-.35-.42l.53-10.17c.02-.38-.49-.52-.67-.18-2.68 5.11-3.81 10.62-3.4 16.53 0 .15-.01.27-.07.36-.07.11-.16.18-.25.23-.33.17-.53.08-.59-.29-.67-3.91-.74-7.85-.22-11.81"
      style={{
        fill: "none",
        stroke: "#3f2a27",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M103.5 198.43c-.22-5.27.75-10.29 2.9-15.06"
      style={{
        fill: "none",
        stroke: "#4b3326",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M117.54 180.07c-.52-.3-.98-.3-1.37 0-.15.11-.25.27-.29.44l-.45 1.96"
      style={{
        fill: "none",
        stroke: "#41371d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M134.76 182.62c-.04-1.55-.54-2.32-1.5-2.29-.34 0-.61.27-.64.61l-.07.72M128.78 182.15c.08-.29.06-.53-.06-.73-.1-.17-.28-.26-.55-.29-.64-.05-1.16.14-1.57.59-.23.25-.26.52-.08.81.27.45.34.89.22 1.33M123.72 182.99l-.43-1.87"
      style={{
        fill: "none",
        stroke: "#402e1b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M103.5 198.43c-.39-.64-.53-1.66-.43-3.05.04-.62-.31-.85-1.06-.69-.33.07-.51.27-.55.6l-1.35 10.1c-.05.34-.15.36-.31.05-1.87-3.64-2.72-6.58-2.55-8.82.47-6.11.57-12.46.3-19.07"
      style={{
        fill: "none",
        stroke: "#312026",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M161.98 186.76c-1.48 1.27-3.31 1.79-5.49 1.57-.89-.09-1.32-1.13-.77-1.83l2.11-2.66c.4-.5-.18-1.19-.74-.89l-5.3 2.85"
      style={{
        fill: "none",
        stroke: "#191111",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M151.79 185.8a68.11 68.11 0 0 0-18.74 15.55c-1.32 1.57-2.1 2.93-2.34 4.1"
      style={{
        fill: "none",
        stroke: "#100b10",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M130.71 205.46c-1.86 2.22-3.4 4.55-4.63 6.99-1.95 3.86-4.36 7.28-6.03 11.23-.15.35-.07.63.24.85l3.23 2.35"
      style={{
        fill: "none",
        stroke: "#1e1513",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m123.52 226.88 1.84 1.67"
      style={{
        fill: "none",
        stroke: "#100b10",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m125.36 228.54 2.62 3.91c.17.25.53.29.74.07 3.52-3.56 7.94-4.22 13.27-1.99"
      style={{
        fill: "none",
        stroke: "#191111",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M141.99 230.54c2.23-1.18 3.03-3.22 2.38-6.11-.51-2.31 1.94-4.43 2.57-6.12 1.37-3.62 2.29-7.47 2.77-11.54"
      style={{
        fill: "none",
        stroke: "#100b10",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M149.71 206.76c2.42-7.65 7-14.01 13.73-19.06"
      style={{
        fill: "none",
        stroke: "#191111",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m163.44 187.71 6.77-5.02c.47-.35.41-.57-.16-.68l-5.93-1.1c-.39-.07-.55.08-.5.47.31 2.19-.24 3.98-1.64 5.39"
      style={{
        fill: "none",
        stroke: "#211513",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m163.44 187.71-.94.1c-.38.03-.56-.14-.55-.52l.03-.52"
      style={{
        fill: "none",
        stroke: "#3a2624",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m149.71 206.76-1.13 1.53c-.06.09-.13.09-.21 0l-.34-.33c-.23-.24-.39-.2-.48.13-.05.2-.06.42-.03.65.01.04 0 .06-.06.05h-.07c-.11 0-.17-.07-.16-.19.22-5.71 1.71-11.03 4.48-15.96.42-.75-.34-1.62-1.14-1.29l-1.71.71c-.35.14-.75.01-.94-.32a.76.76 0 0 1 .21-.97c2.13-1.57 3.35-3.23 3.66-4.98M141.99 230.54c-.94-1.76-1.4-3.73-1.37-5.92.01-.71-.31-1.12-.97-1.23a.704.704 0 0 0-.75.39l-1.28 2.74c-.19.42-.46.48-.8.17-2.71-2.44-3.95-5.12-3.7-8.04.34-3.99 1.83-8.47 4.46-13.46.37-.71.52-1.35.46-1.93a.452.452 0 0 0-.83-.19c-3.55 5.66-6.11 11.49-7.67 17.5-.37 1.41-1.76 4.07-4.18 7.98"
      style={{
        fill: "none",
        stroke: "#281c21",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m123.52 226.88 7.19-21.42"
      style={{
        fill: "none",
        stroke: "#2e1f23",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M165.57 188.18c-9.57 6.69-14.77 15.59-15.59 26.68"
      style={{
        fill: "none",
        stroke: "#23110d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M149.98 214.85c-.43 2.61-1.64 5-3.65 7.16-.26.27-.39.63-.37 1l.27 5.67c.02.3.17.49.46.58 2.26.65 4.81 2.2 6.68-.32.21-.28.24-.65.06-.95-1.3-2.19-3.96-5.65-2.61-8.33 1.77-3.53 3.3-6.85 4.6-9.97"
      style={{
        fill: "none",
        stroke: "#160b0d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M155.42 209.7c3.47-5.8 7.91-10.45 13.3-13.94"
      style={{
        fill: "none",
        stroke: "#23110d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M168.72 195.76c4.65-3.03 9.69-5.42 15.12-7.19.38-.13.42-.32.11-.58-2.35-2.01-4.95-3.38-7.8-4.1-3.63-.92-8.17 2.07-10.58 4.29"
      style={{
        fill: "none",
        stroke: "#2d1c0d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M168.72 195.76c-.09-1.33 0-2.37.29-3.14.42-1.11.16-1.3-.77-.57a39.854 39.854 0 0 0-9.78 11.21c-.18.31-.64.26-.75-.08l-.56-1.67c-.09-.26-.25-.32-.49-.19l-.61.32c-.31.16-.62-.21-.41-.48l9.93-12.98"
      style={{
        fill: "none",
        stroke: "#502d1a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M155.42 209.7c-.42-2.06.1-4.16 1.55-6.31.23-.33.18-.61-.15-.85l-.24-.17c-.25-.19-.46-.15-.65.1-2.37 3.35-3.85 7.07-4.44 11.15-.05.3-.19.55-.42.74-.37.29-.73.46-1.09.5"
      style={{
        fill: "none",
        stroke: "#381c1a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m182.56 191.09-5.76 2.56"
      style={{
        fill: "none",
        stroke: "#0b0611",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M176.8 193.65c-10.3 4.88-19.25 15.24-23.01 25.69"
      style={{
        fill: "none",
        stroke: "#0f0b15",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m153.79 219.34-.48 2.3c-.07.32.01.65.22.91 1.92 2.39 3.09 5.09 3.52 8.1.05.33.22.58.52.74 7.88 4.26 16.74 14.87 12.49 24.41-.17.37-.11.7.17 1l1.97 2.06c.25.27.56.37.93.32l6.1-.95c.33-.05.61-.21.84-.46l17.97-20.25c.2-.23.33-.49.38-.79l.95-5.72c.27-1.61-.36-2.7-1.9-3.26l-5.92-2.17a.75.75 0 0 1-.49-.78l.06-.49"
      style={{
        fill: "none",
        stroke: "#0b0611",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m191.12 224.3 3.67.29"
      style={{
        fill: "none",
        stroke: "#130f19",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m194.79 224.6 4.11 1.93c.33.16.49.06.48-.31-.32-14.3-1.74-25.85-12.9-35.55-.23-.2-.53-.31-.83-.31-1.05 0-2.08.23-3.09.73"
      style={{
        fill: "none",
        stroke: "#29232d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M194.79 224.6c.26-.53.24-1.01-.07-1.44-.15-.21-.52-.43-1.1-.68-1.09-.46-1.53-1.22-1.3-2.27"
      style={{
        fill: "none",
        stroke: "#3c3246",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M192.32 220.21c.79-.17 1.11-.53.95-1.07-.13-.41-.91-.67-2.34-.76"
      style={{
        fill: "none",
        stroke: "#29232d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M190.93 218.38c7.52-4.98 3.61-12.62.81-18.65"
      style={{
        fill: "none",
        stroke: "#3c3246",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M191.74 199.73c-1.71-4.39-4.77-7.27-9.18-8.64"
      style={{
        fill: "none",
        stroke: "#34293e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M191.74 199.73c-1.51.17-2.87-.33-4.06-1.51-.14-.14-.31-.16-.5-.05-.25.13-.29.32-.11.55 3.54 4.56 6.75 7.37 5.26 13.84-.08.35-.27.63-.57.82-5.51 3.67-11.56 5.84-18.17 6.51a.42.42 0 0 0-.38.4c0 .22.13.4.34.44 3.21.62 6.56 1.05 10.03 1.28 1.47.09 3.52-.98 4.61 1.08.15.28.37.46.67.55l2.26.67"
      style={{
        fill: "none",
        stroke: "#1d142a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m153.79 219.34.08 2.75c.03.79.19.82.48.09 1.04-2.6 2.57-4.89 4.58-6.88.25-.25.63-.31.94-.15l1.62.8c.56.28 1.15-.31.88-.87-1.89-3.88 2.3-6.25 5.28-7.02 2.43-.62 4.65-1.89 6.98-2.21 2.35-.33 4.68-.49 7-.48.61 0 .97-.7.6-1.19s-.9-.71-1.58-.64c-2.65.26-5.58.04-8.2-.02-.83-.02-1.33-.94-.88-1.65l5.23-8.22"
      style={{
        fill: "none",
        stroke: "#1a1126",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m190.93 218.38-5.8 1.01c-.3.05-.51.33-.48.64.03.31.3.54.61.52l7.06-.34"
      style={{
        fill: "none",
        stroke: "#130f19",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M92.71 227.45c-.85 2.89-.96 6.13-.32 9.7"
      style={{
        fill: "none",
        stroke: "#604b2a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m92.39 237.15 1.11 5.69c.07.37.43.63.81.57l2.24-.34c.27-.04.42-.33.29-.57-.75-1.35-1.12-2.72-1.09-4.11"
      style={{
        fill: "none",
        stroke: "#402e1b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m95.75 238.39 1.09-8.51"
      style={{
        fill: "none",
        stroke: "#604b2a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m96.84 229.88 2.98-6.56c.15-.33.06-.58-.25-.76-3.89-2.22-6.14 1.7-6.86 4.89"
      style={{
        fill: "none",
        stroke: "#211513",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m96.84 229.88-.1-4.15c-.03-1.1-1.55-1.36-1.95-.33-.36.93-1.05 1.62-2.08 2.05"
      style={{
        fill: "none",
        stroke: "#81603d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M95.75 238.39c-.17.44-.5.58-.97.42-.28-.1-.5-.3-.63-.56-.42-.87-1.01-1.24-1.76-1.1"
      style={{
        fill: "none",
        stroke: "#a07945",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M98.97 229.65c-.93 3.49-1.29 7.15-1.1 10.99.06 1.16.62 1.51 1.69 1.06 6.08-2.55 18.31 1.19 24.56 3.16"
      style={{
        fill: "none",
        stroke: "#675226",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m124.12 244.86 4.44 1.35c.98.3 1.91-.57 1.69-1.56-.78-3.48-2.04-6.83-3.78-10.06-3.92-7.22-13.41-10.67-21.15-11.31-2.72-.23-3.44-.86-4.57 1.77-.63 1.48-1.23 3.01-1.78 4.6"
      style={{
        fill: "none",
        stroke: "#6b582e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M124.12 244.86c-.83-1.97-2.1-3.7-3.79-5.19-.1-.09-.21-.1-.33-.03l-.26.15c-.18.11-.31.07-.39-.12-2.19-5.12-12.54-6.48-17.58-6.74-.37-.02-.59-.21-.66-.58-.26-1.41-.97-2.31-2.14-2.7"
      style={{
        fill: "none",
        stroke: "#d2aa54",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m142.88 248.61-.48 4.57c-.06.57.33 1.09.89 1.2 7.3 1.45 14.88-.38 22.31-.26 1.07.02 1.72.34 2.64.82.33.17.56.09.71-.26 2.13-5.05-1.23-11.52-4.91-15.63"
      style={{
        fill: "none",
        stroke: "#1b0a0d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M164.04 239.05c-1.5-2.39-3.74-4.28-6.73-5.67-2.41-1.11-4.61-.76-6.62 1.06-.24.22-.58.28-.88.15l-3.61-1.48"
      style={{
        fill: "none",
        stroke: "#361d0f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M146.2 233.1c-.55-.87-1.73-.82-3.56.16-.29.15-.6.2-.93.13-3.8-.82-6.99-3.55-10.37.41-.24.28-.18.47.17.58 6.96 2.15 10.75 6.89 11.37 14.22"
      style={{
        fill: "none",
        stroke: "#29110c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M146.2 233.1c3.98 4.17 5.89 6.63 8.17 11.96"
      style={{
        fill: "none",
        stroke: "#5f2e1b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m154.37 245.07.29 4.73c.03.41-.16.66-.55.75-1.54.37-2.59-.13-3.15-1.51a.612.612 0 0 0-.72-.36c-.3.08-.49.37-.45.67.15 1.1-.07 2.17-.66 3.21-1.05 1.86-3.87 1.24-4.04-.89l-.04-.5a.573.573 0 0 0-.38-.52c-.89-.35-1.48-1.03-1.79-2.04"
      style={{
        fill: "none",
        stroke: "#441b19",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M164.04 239.05c1.31 6.41.82 10.71-1.47 12.9-.25.24-.65-.02-.53-.34.51-1.4.41-2.74-.3-4.01a.58.58 0 0 0-1.06.11l-1.16 3.68c-.22.73-1.21.83-1.58.16l-3.57-6.48"
      style={{
        fill: "none",
        stroke: "#51261c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M105.09 249.86c-1.17 2.46-2.56 6.67-.1 8.77.27.23.58.32.93.25l27.99-5.21"
      style={{
        fill: "none",
        stroke: "#6b582e",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m133.91 253.67 6.2-.38c.28-.02.46-.16.53-.43 1.45-5.33.16-9.86-3.85-13.61"
      style={{
        fill: "none",
        stroke: "#5a431f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M136.79 239.24c-1.57-1.83-3.68-3.04-6.31-3.61a.448.448 0 0 0-.5.63c1.23 2.59 5.46 13.58-1.43 12.36-4.13-.73-7.87-2.95-12.05-3.71-1.81-.33-3.62-.71-5.45-1.12-.32-.07-.65 0-.91.19-2.17 1.6-3.86 3.56-5.05 5.87"
      style={{
        fill: "none",
        stroke: "#4e351c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m136.79 239.24-1.48 8.48c-.06.33-.22.63-.46.86-1.79 1.7-4.19 2.48-7.22 2.34"
      style={{
        fill: "none",
        stroke: "#a8783a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M127.63 250.92c-2.03-.48-3.96-.62-6.01-1.33-3.68-1.28-10.24-3.18-13.87-1.34-.28.14-.47.36-.58.65-.29.8-.99 1.12-2.08.95"
      style={{
        fill: "none",
        stroke: "#b98d4a",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M133.91 253.67c-1.43-1.39-3.52-2.31-6.28-2.74"
      style={{
        fill: "none",
        stroke: "#c59a4d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m118.7 261.52 7.01 2.46c.37.13.74.12 1.11-.03l14.76-5.98c.35-.15.38-.63.05-.82-1.84-1.03-3.04-.38-4.86-.09-6.07.97-12.08 2.2-18.03 3.69-.87.22-.89.48-.04.77"
      style={{
        fill: "none",
        stroke: "#07030f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M97.3 259.3c3.04 3.04 7.81 5.51 11.05 7.46 3.73 2.24 10.23.15 13.85-1.68.29-.15.27-.58-.04-.7l-6.82-2.64c-.25-.09-.5-.12-.77-.08-5.25.86-12.45 3.66-14.81-3.46a.601.601 0 0 0-.84-.35l-1.51.74c-.37.19-.4.42-.11.71"
      style={{
        fill: "none",
        stroke: "#060509",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m144.07 265.21-.48-5.78a.46.46 0 0 0-.62-.39c-5.31 2.08-10.59 4.24-15.82 6.47-3.4 1.44-6.13 5.8-8.53 8.5-.25.29.04.72.4.6l24.26-8.2c.57-.19.84-.59.79-1.2M104.12 272.89c1.3.89 2.73 1.75 4.28 2.56a.785.785 0 0 0 1.13-.53c.61-2.67-.24-4.69-2.57-6.08-1.14-.68-2.57-.62-3.65-2.11-.21-.3-.5-.5-.87-.59-1.35-.33-2.46-1.01-3.32-2.06a.694.694 0 0 0-1.2.22c-2.03 6.26 2.64 6.14 6.2 8.59"
      style={{
        fill: "none",
        stroke: "#0c0719",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M112.53 276.48c3.18-.54 6.96-5.49 8.53-8.16.23-.37.12-.52-.31-.44l-8.38 1.65c-.42.08-.72.46-.71.89l.21 5.51c.01.35.32.6.66.55"
      style={{
        fill: "none",
        stroke: "#060509",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m20.44 83.96-.67 6.9c-.02.25.14.47.39.52.24.05.48-.09.55-.33.69-2.27 1.03-4.62 1.03-7.03a.65.65 0 0 0-.62-.65.644.644 0 0 0-.68.59"
      style={{
        fill: "none",
        stroke: "#e6ca73",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m21.88 103.47 3.28-12.58c.02-.07-.03-.14-.09-.16-.93-.25-2.42 2.38-3.33 5.87l-.06.21c-.91 3.48-.89 6.51.04 6.75h.01c.07.02.14-.02.16-.09"
      style={{
        fill: "none",
        stroke: "#ead17f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M28.84 112.68c.03.39 0 .7-.1.91-.16.35.21.7.55.52 5.24-2.82 5.18-9.24 3.41-14.1"
      style={{
        fill: "none",
        stroke: "#ddb857",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M32.7 100c-2.63 4.14-3.92 8.36-3.86 12.67"
      style={{
        fill: "none",
        stroke: "#e4c367",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M32.7 100c-.68 4.76-1.67 8.82-2.98 12.17-.08.22-.19.36-.32.41-.15.06-.33.09-.56.09"
      style={{
        fill: "none",
        stroke: "#edd484",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M30.95 121.27c.39.11 1.27-1.9 1.97-4.48.71-2.58.96-4.75.56-4.86-.39-.11-1.27 1.9-1.97 4.48-.71 2.58-.96 4.75-.56 4.86"
      style={{
        fill: "none",
        stroke: "#e5c56b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M242.85 105.6c-.22 2.88.53 5.44 2.25 7.69.15.2.43.25.65.12a.49.49 0 0 0 .17-.63l-1.4-2.73a.475.475 0 0 1-.06-.24c.03-1.46-.24-2.9-.81-4.33-.44-1.11-.71-1.07-.8.12"
      style={{
        fill: "none",
        stroke: "#e5c76c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m243.13 131.46-2.41-6.58c-.11-.31-.32-.4-.62-.27-.23.09-.32.26-.27.51.56 2.78 2.11 8.19 5.28 9.63.38.17.56.05.53-.37-.26-3.45-1.23-9.59-3.91-11.8-.38-.31-.49-.24-.34.23l2.64 8.34c.08.25-.05.51-.3.6a.485.485 0 0 1-.6-.29"
      style={{
        fill: "none",
        stroke: "#e1c264",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M19.26 118.77c-.53.75-.63 1.54-.29 2.39.22.54.42.54.61 0 .25-.73.33-1.47.22-2.24-.04-.27-.38-.36-.54-.14"
      style={{
        fill: "none",
        stroke: "#eacd76",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M212.74 158.1c1.68 5.45 9.02 5.09 13.87 4.96.25-.01.45-.21.45-.46v-5.76c0-.45-.22-.71-.66-.8-2.12-.44-4.2-.42-6.25.06-2.46.58-5.97-1.39-7.32 1.05-.17.31-.2.62-.09.95"
      style={{
        fill: "none",
        stroke: "#7d6b43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M259.39 223.82c2.25-1.01 3.62-4.52 5.42-6.39.18-.19.2-.39.07-.61-.21-.35-.71-.2-1.49.45-.23.19-.43.41-.62.64l-4.04 5.05c-.37.46.13 1.1.66.86"
      style={{
        fill: "none",
        stroke: "#debb61",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M261.69 216.87c-2.15.42-4.2 3-3.99 5.21.04.36.51.46.69.15.97-1.69 2.24-3.1 3.79-4.25.53-.39.16-1.24-.49-1.11"
      style={{
        fill: "none",
        stroke: "#e1be65",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M108.35 180.32c.4.22 1.14-.34 1.62-1.26.49-.91.55-1.83.13-2.05-.4-.22-1.14.34-1.62 1.26-.49.91-.55 1.83-.13 2.05"
      style={{
        fill: "none",
        stroke: "#2d1f14",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M115.06 184.12v-.3c0-.15-.15-.26-.3-.22l-.54.17c-.26.08-.33.41-.14.6l1.07 1.08c.12.12.17.3.11.47l-.26.8c-.2.61.56 1.08 1.02.63 1.63-1.59 1.63-2.84 0-3.75-.45-.25-.61-.13-.48.37.07.26 0 .39-.22.4-.14 0-.25-.11-.25-.25"
      style={{
        fill: "none",
        stroke: "#6e5530",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M245.33 224.88c-2.03 1.26-2.68 6.08-2.48 8.18.04.37.56.42.66.06l2.28-7.9c.08-.27-.22-.49-.46-.34"
      style={{
        fill: "none",
        stroke: "#e2c468",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M174.45 227.12c-4.04-1.69-10.75-3.71-14.64-1.75-.21.1-.31.34-.24.56.07.22.29.36.52.33 3.83-.55 7.47-.02 10.94 1.57.91.42 2.44.62 3.3.45.59-.12.67-.93.12-1.16M160.53 230.12c5.2 1.73 10.47 5.33 12.77 10.46.12.26.43.36.68.22l.41-.24c.4-.24.49-.56.27-.97-3.2-5.91-8.05-9.62-14.54-11.14-.7-.16-1.73.05-2.3.47-.58.43-.48.91.21 1.08.67.16 1.23.19 1.68.08.27-.07.56-.05.82.04"
      style={{
        fill: "none",
        stroke: "#0b0611",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M240.25 207.32c-.5 1.11-.6 2.15-.31 3.1.17.53.36.54.57.02l1.35-3.23c.12-.29.03-.47-.26-.56-.61-.19-1.06.03-1.35.67"
      style={{
        fill: "none",
        stroke: "#debb57",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M32.66 236.24c1.59-1.45 1.92-2.33.98-2.62"
      style={{
        fill: "none",
        stroke: "#d6b047",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M33.64 233.62c.39-3.17-.49-5.93-2.64-8.27"
      style={{
        fill: "none",
        stroke: "#e1c061",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M31 225.35c.64.2.34-.13-.89-.99"
      style={{
        fill: "none",
        stroke: "#d6b047",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M30.11 224.37c-.17-.25-.41-.33-.73-.24-.33.09-.5.32-.51.67-.03 4.63 1.06 8.98 3.27 13.03.21.39.42.39.63 0 .19-.36.15-.89-.11-1.58"
      style={{
        fill: "none",
        stroke: "#e2c265",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M30.11 224.37c-.83 2.62 1.75 8.95 2.55 11.88"
      style={{
        fill: "none",
        stroke: "#ead17f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M31 225.35c.25 2.98 1.13 5.74 2.64 8.27"
      style={{
        fill: "none",
        stroke: "#e9cf7b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M28.09 253.88c-.47 1.14-.22 1.32.75.55 1.41-1.13 2.55-2.5 3.41-4.11.17-.32-.18-.67-.5-.5-1.71.91-2.93 2.26-3.66 4.06"
      style={{
        fill: "none",
        stroke: "#dfbe5d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m30.81 257.02-.51-.69a.224.224 0 0 0-.31-.05l-.15.11c-3.25 2.4-5.74 4.54-5.56 4.78l.14.19c.17.24 2.95-1.52 6.2-3.93l.14-.1c.1-.07.12-.21.05-.31"
      style={{
        fill: "none",
        stroke: "#dcb852",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M21.57 254.62c.95-1.87-.39-5.75-.95-7.57-.13-.42-.75-.35-.78.09-.18 2.57.16 5.05 1.01 7.44.11.32.56.35.72.04"
      style={{
        fill: "none",
        stroke: "#e1c160",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M140.57 236.77c2.25 2.35 4.29 4.91 6.13 7.68.21.31.18.6-.08.87-1.26 1.3-1.4 2.82-.41 4.57.17.31.35.31.54.02 3.6-5.56-3.48-13.39-7.78-16.18-.53-.35-1.16.28-.81.81.62.92 1.78 1.57 2.41 2.23M148.65 241.26c1.75 2.43 3.1 5.07 4.04 7.91.09.27.34.46.63.46h.47c.36 0 .62-.34.52-.68-.96-3.51-2.83-6.43-5.6-8.74-.19-.16-.48.03-.41.27.11.34.22.6.35.78"
      style={{
        fill: "none",
        stroke: "#774628",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m257.88 253.65-1.44 10c-.01.08.04.15.12.16h.05c.79.12 1.75-2.01 2.15-4.75l.05-.34c.39-2.75.07-5.06-.72-5.18h-.05c-.08-.01-.15.04-.16.11"
      style={{
        fill: "none",
        stroke: "#e7cb73",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M153.94 280.01c.02-.9.81-1.58 1.69-1.46 3.16.42 5.78-.52 7.87-2.81.25-.28.25-.56-.01-.84-.45-.48-1.02-.66-1.71-.54-.33.05-.65.02-.97-.09-1.89-.66-3.66-.51-5.31.44-1.3.76-2.97.31-3.72-.99-.72-1.25-1.16-2.57-1.32-3.96-.05-.41-.62-.47-.75-.07l-1.47 4.56c-.13.4-.2.81-.21 1.24-.04 1.25-.5 2.29-1.39 3.13-.81.77-.33 2.13.78 2.22l1.49.11a1 1 0 0 1 .82.5c1.3 2.1 4.17.4 4.21-1.44"
      style={{
        fill: "none",
        stroke: "#07030f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m91.63 297.24 8.52 3.62c.24.1.52.01.65-.22s.06-.52-.15-.67a17.834 17.834 0 0 0-8.84-3.34c-.17-.01-.25.06-.25.23v.28c0 .05.02.08.07.1M175.43 299.79l.39 1c.05.14.2.2.34.15l.12-.05c4.84-1.88 8.65-3.71 8.51-4.08l-.07-.16c-.14-.37-4.18.87-9.02 2.75l-.12.05c-.14.05-.2.2-.15.34"
      style={{
        fill: "none",
        stroke: "#e2c468",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m138.94 297.88.19 32.25c0 .35.48.44.61.12 1.93-4.83 3.49-9.71 4.69-14.66 1.2-4.9-2.75-13.71-4.95-17.85-.37-.69-.55-.64-.54.14M136.45 298.48c-.68 1.55-1.38 3.07-2.11 4.55-4.75 9.68-1.4 18.03 2.15 27.01.16.41.78.3.78-.14l.06-31.24c0-1.47-.29-1.53-.88-.18"
      style={{
        fill: "none",
        stroke: "#e3c469",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m154.31 307.38.48 1.16c.23.56.43.55.59-.03l1.73-6.11c.12-.43-.4-.74-.72-.44l-4.27 3.91c-.39.36-.13 1.01.4 1.01h1.04c.37 0 .62.17.75.5"
      style={{
        fill: "none",
        stroke: "#e0c168",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m207.47 306.83-8.35-1.69c-.11-.02-.21.05-.24.16v.07c-.16.76 1.62 1.77 3.98 2.24l.21.05c2.36.47 4.39.24 4.54-.53l.02-.07a.2.2 0 0 0-.16-.23"
      style={{
        fill: "none",
        stroke: "#e6c66b",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M131.4 17.6c-2.51.87-4.49 2.41-5.92 4.61-3.09 1.71-5.17 4.12-6.25 7.23-2.81 3.63-6.03 6.22-9.66 7.78-.41.17-.56.04-.47-.39.13-.67.14-1.23 0-1.7 2.39-.62 8.44-2.34 6.34-6-.59-1.03-1.46-1.37-2.6-1.02-2.67.84-5.2 2.46-7.78 3.14-5.71 1.49-11.57 1.74-17.57.77l7.52-4.45a.88.88 0 0 1 .86-.05c.49.22.88.6 1.15 1.15a5.94 5.94 0 0 0 1.8 1.6c.26.15.53.18.81.08l3.92-1.33 2.55.34c.61.08.73-.13.36-.62l-.92-1.23c10.65-1.27 19.56-6.05 26.74-14.33.5-.57.64-.5.41.23l-1.3 4.19ZM170.34 27.58c-.05.43-.34.87-.86 1.3-.87-.55-1.46-.4-1.75.44-.11.31.03.65.33.79 4.86 2.29 8.98 1.5 12.36-2.38.24-.28.52-.33.84-.14l9.47 5.51c-3.45 2.03-7 3.57-10.66 4.61-.32.09-.67.05-.97-.1-1.82-.94-3.68-1.14-5.59-.59-.36.1-.69.04-.99-.17-1.46-1.03-3.1-1.61-4.93-1.74a.775.775 0 0 0-.81.92l.28 1.4c.06.32-.27.57-.56.42l-8.6-4.52c-.55-1.94-1.26-4.04-2.15-6.29-1.34-3.43-6.6-4.49-9.5-6.31-.29-.18-.49-.43-.6-.74l-2.42-6.7a.38.38 0 0 1 .18-.48c.17-.1.38-.06.5.09 6.9 8.42 15.71 13.31 26.43 14.68ZM260.22 27.12c-.19.15-.47.25-.85.28-.33.03-.6.16-.81.41-2.99 3.51-6.5 6.39-10.51 8.63-.14.08-.32.04-.42-.09a.333.333 0 0 1 .03-.42l9.8-9.96a.666.666 0 0 0-.38-1.13l-.37-.05c.47-.24.78-.51.92-.81.16-.33.07-.55-.28-.65-1.03-.31-1.82-.18-2.38.41-.67-1.05-1.74-.62-3.21 1.3a.463.463 0 0 1-.79-.47l.85-1.97a.537.537 0 0 0-.52-.74c-.53.02-1.1.37-1.71 1.06-.35-1.38-.2-2.46.46-3.23.59-.71.96-1.38 1.1-2.03l2.18-2.39a.816.816 0 0 1 1.41.45l.76 5.47c.04.3.36.48.64.35l6.68-3.14c.4-.19.84.14.78.58-.41 2.93-1.53 5.65-3.38 8.14ZM85.83 31.58c-4.39-1.72-8.4-3.54-12.01-5.47-.49-.26-.83-.28-1.04-.05-.22.24-.35.66-.39 1.27-2.17-.61-3.48-1.6-3.95-2.97-.11-.32-.3-.57-.59-.76-4.01-2.6-8.26-2.99-12.75-1.16-.28.11-.56.11-.83 0l-5.44-2.29c-.24-.1-.23-.45.02-.54 17.16-6.02 27.56 4.52 43.01 8.13.43.1.45.26.07.47l-6.1 3.37ZM219.2 21.71c-3.13-1.24-6.89-.67-11.29 1.71-5.54 2.31-10.85 5.27-15.93 8.88l-7.57-4.05a.263.263 0 0 1 .07-.49c9.84-2.18 17.33-8.13 27.61-9.52 5.25-.77 10.44-.25 15.59 1.56.36.13.28.66-.1.68-1.71.09-3.24.67-4.6 1.73-.28.21-.64.29-.98.21l-2.8-.71ZM75.29 38.85c-3.52.73-7.12.86-10.8.39l1.62-2.22a.766.766 0 0 0-.5-1.21c-3.08-.47-6.12-.27-9.11.62a.62.62 0 0 1-.75-.83l2.34-5.67c.46-1.1-.8-2.12-1.79-1.45l-3.15 2.15c-.24.17-.42.38-.54.65-1.46 3.24-5.58 1.47-4.23-1.69.13-.31.14-.61 0-.92l-.89-2.25c-.07-.17 0-.36.15-.45.16-.1.36-.07.48.07.9 1.03 1.48 2.21 1.74 3.54.04.2.13.23.27.08l.33-.32c.11-.12.15-.26.12-.42-.54-2.42-1.87-4.29-3.99-5.6a.49.49 0 0 0-.74.3c-.33 1.3-.27 2.56.19 3.77.23.62-.43 1.18-1.01.86-1.85-1.04-3.82-1.43-5.91-1.18-.86.11-1.27 1.13-.7 1.79a9.38 9.38 0 0 0 4.09 2.82c.42.15.52.71.17.99-2.24 1.83-2.24 3.95-.01 6.38l-8.34-1.26c-1.82-5.16-1.38-11.33 3.66-14.45 6.91-4.28 15.8-.03 21.51 4.52 4.89 3.9 10.15 7.56 15.78 10.99ZM235.19 22.49c5.53 3.92 6.65 8.84 3.36 14.77-1.27 2.28-3.22 3.78-5.18 5.57l-4.75.03c-.29 0-.53-.12-.7-.35-2.37-3.05-2.41-5.92-.11-8.61 1.7-1.99 6.61-.9 5.6 2.43a2.449 2.449 0 0 1-2.75 1.71c-.77-.13-1.28-.56-1.55-1.3-.14-.39-.36-.44-.65-.15l-.3.3c-.69.7-.43 1.88.5 2.21 4.92 1.76 8.92-2.48 5.07-6.49a.55.55 0 0 1 .12-.86l3.37-2.05c1.23-.75.76-2.63-.68-2.71-1.95-.11-3.73.33-5.33 1.31-.44.27-1.01-.05-.99-.57l.11-3.72c.02-.56-.65-.87-1.07-.5-2.44 2.15-3.93 4.84-4.48 8.07-.07.44-.25.49-.53.14-1.27-1.55-2.88-2.6-4.84-3.14a.884.884 0 0 0-1.07 1.13l2.04 6.27c.11.35-.01.48-.36.38-2.99-.83-6.03-1.04-9.12-.65-.82.1-1.2 1.07-.67 1.7 1.79 2.11 3.94 3.73 6.47 4.85.28.12.19.54-.11.54l-24.22.23c-.22 0-.28-.3-.08-.38 8.49-3.44 16.3-8.08 23.45-13.93 4.97-4.06 13.24-9.25 19.45-6.23ZM70.27 30.22a.77.77 0 0 0-.19.37c-.08.31.02.56.29.74 1.95 1.25 4.19 1.63 6.72 1.12.58.03.74.69.47 1.98-.09.47.09.66.56.55l5.95-1.38 13.34 3.62c-5.69-.68-10.73-.12-15.1 1.69-1.97.18-4.09-.37-6.36-1.64-1.77-.99-3.02-3.08-5.88-3.53-.33-.05-.59-.2-.78-.47l-.8-1.1c-.21-.29-.49-.46-.84-.52-.79-.13-1.42-.55-1.87-1.27-.16-.25-.37-.44-.64-.57-1.22-.6-2.31-1.43-3.27-2.48-.23-.26-.18-.42.16-.49 2.99-.59 5.82-.22 8.49 1.13.33.17.34.35.03.55-.27.17-.48.4-.62.67-.2.37-.09.72.34 1.03ZM153.88 39.94c.3.83 1.03 1.49 2.2 1.99.33.14.21.47-.37.98l-15.06-.02c-.26 0-.43-.27-.32-.5l5.59-12.03c.1-.22.42-.16.44.08.31 4.59 2.82 7.76 7.52 9.5Z"
      style={{
        fill: "#e9ce75",
      }}
    />
    <path
      d="M223.8 36.38c.02.45.2.79.55 1.04.39.27.36.49-.09.65-.49.18-.88.1-1.16-.24-1.4-1.67-2.47-3.84-3.2-6.49-.1-.36.36-.59.59-.3.31.39.69.55 1.14.5.35-.04.67.05.96.26 1.39 1.01 2.15 2.36 2.26 4.07.02.28-.21.52-.49.51-.13 0-.23-.04-.3-.11-.19-.18-.27-.14-.26.11ZM49.51 39.88c-1.24.02-1.99-.38-2.26-1.19.75-.63.95-1.2.62-1.73-.25-.4-.5-.4-.76-.01-3.09 4.59-6.96-3.98-1.39-3.99 3.35 0 5.46 4.1 3.79 6.92ZM129.35 32.85c1.31 3.78 3.06 6.27 5.27 7.46.61.51.89 1.19.82 2.02-.03.37-.22.55-.59.55h-22.02c-.35 0-.5-.44-.22-.65 6.64-5 12.68.6 16.74-9.38ZM31.38 40.26c1.98 3 2.51 6.26 1.58 9.79-1.49-1.68-3.04-2.05-4.65-1.11-.21.13-.37.33-.45.56-.12.37-.37.66-.74.89-.3.19-.59.18-.87-.05l-3.04-2.43c-.67-.54-1.67-.07-1.68.79-.03 2.1.45 4.08 1.42 5.93.16.3-.04.66-.38.68l-3.7.24c-1.22.08-1.63 1.66-.61 2.33 2.38 1.57 4.96 2.57 7.75 3.02.4.07.49.6.14.8-1.39.79-2.48 1.89-3.29 3.29-.46.81.09 1.81 1.01 1.86 2.23.12 4.28-.45 6.15-1.7.31-.21.72.08.63.45-.84 3.47-.84 6.93.01 10.4.17.69 1.14.7 1.33.02.25-.91.81-1.78 1.69-2.63.86 2.71.89 5.56.09 8.57-2.33-3.79-5-6.11-8.02-6.98-2.75.68-2.87-.9-3.76-2.68-3.64-7.26-7.02-17.41-3.75-25.14 2.21-5.2 7.29-8.34 13.14-6.9ZM255.22 43.21c1.65 4.12 2.21 8.16 1.68 12.12h-2.76c-.4 0-.55-.2-.44-.59.52-1.97.84-3.92.97-5.85.04-.57-.04-.91-.23-1.04-.42-.28-1.15-.11-1.77.41l-2.61 2.2a.68.68 0 0 1-.99-.15c-2.14-3.22-6.41-1.96-5.98 1.71.03.28.28.5.56.49.29 0 .52-.24.53-.52.07-1.37.79-2 2.17-1.87.32.03.62.18.83.44 2.88 3.45.26 6.22-3.26 7.13-.31.08-.61.07-.92-.04-4.94-1.75-3.97-7.13-4.08-11.25 0-.32.08-.61.25-.88 3.97-6.34 10.54-7.78 16.05-2.31ZM182.32 43.21c-2.43.27-4.29-.43-5.58-2.08l.25-.3c.17-.21.47-.27.71-.14l4.62 2.52ZM10.91 44.99l4.81-3.73c.93.19 1.58.23 1.95.12 1.19-.35 1.96 1.22.97 1.95-2.83 2.09-5.41 2.64-7.73 1.66Z"
      style={{
        fill: "#e9ce75",
      }}
    />
    <path
      d="M250.83 55.33c-2.33-2.59-.58-4.67 2.25-5.42.39-.11.57.04.52.44a9.205 9.205 0 0 1-2.06 4.97c-.18.22-.52.23-.71.01ZM32.37 52.49c.79-.28 1.17-.07 1.13.64-.08 1.27.04 2.68.35 4.23-6.62 2.09-7.36-8.49-3.05-7.25.83.24 1.36 1.03 1.57 2.38ZM14.94 55.17c.75 5.4 2.27 10.63 4.56 15.69.15.34.11.65-.12.94l-2.02 2.52-.63-7.36a.98.98 0 0 0-.49-.8c-1.07-.64-2.13-.61-3.19.09-.29.19-.47.46-.53.81-1.95 11.92 2.38 23.99 6.76 34.21l.43 4.01c.05.5.29.63.74.39 1.52-.83 2.6-1.69 3.24-2.56 2.38-3.21 2.55-2.23.52 2.95-.91 2.07-2.36 3.97-4.33 5.72.27.05.23.09-.11.1-.09 0-.16-.03-.2-.12-8.14-17.74-13.44-37.53-6.01-55.79.13-.31.28-.55.45-.72.43-.43.74-.45.93-.08ZM253.44 57.74l2.83-.92c.09-.03.2.02.23.11s.06.19.09.28c.04.11.01.2-.1.26-3.04 1.8-6.31 2.46-9.8 1.97-.33-.05-.37-.18-.13-.41l2.52-2.4c.16-.15.37-.23.58-.23l2.64-.03c.33 0 .5.16.51.49v.43c.01.43.22.58.63.45ZM255.22 59.76c-.29 1.8-.9 3.37-1.82 4.7l-3.1-3.07c-.34-.33-.28-.55.19-.65l4.73-.98Z"
      style={{
        fill: "#e9ce75",
      }}
    />
    <ellipse
      cx={28.81}
      cy={61.75}
      rx={1.72}
      ry={0.62}
      style={{
        fill: "#e9ce75",
      }}
      transform="rotate(-33 28.818 61.764)"
    />
    <path
      d="M31.2 62.15c.06-.03.13 0 .16.06.26.57-.88 1.66-2.55 2.43l-.29.14c-1.67.77-3.23.94-3.5.38-.03-.07 0-.15.06-.18l6.11-2.83ZM259.66 63.61c4.19 0 3.3 16.81 1.96 20.14-.67 1.66-1.15 1.81-1.44.45.76-4.68-.3-8.88-3.18-12.59l2.66-8ZM252.28 66.93l-3.34 8.17c-.14.33-.37.6-.66.79a17.265 17.265 0 0 0-5.97 6.66c-.2.39.03.88.47.96l.99.18c.35.07.52.48.31.77-1.43 1.98-1.93 3.95-1.49 5.92l-2.77 4.71c-.11.18-.06.41.11.53.17.13.4.1.54-.05l3.61-3.94c.49-.54.64-.46.45.25a7.407 7.407 0 0 1-1.79 3.23.99.99 0 0 0-.26.88c.11.56.03 1.05-.25 1.47-.47-.33-1.48-.1-3.03.71l-.08-29.31c0-.33.43-.45.61-.17l4.57 7.13c.64 1 1.11.92 1.4-.23.89-3.43.78-6.84-.32-10.23-.18-.55-.02-.69.48-.4 1.92 1.11 4.06 1.76 6.42 1.97ZM24.15 76.67l6.04 4.36c.33.23.31.42-.07.56-.61.22-1.17-.02-1.7-.72-1.89-1.05-3.31-2.45-4.27-4.2Z"
      style={{
        fill: "#e9ce75",
      }}
    />
    <path
      d="m251.63 77.68-3.39 3.12-2.25.99c-.18.08-.39.01-.49-.16-.1-.17-.06-.38.1-.5l5.26-3.97c.28-.21.5-.17.67.14.06.11.09.23.1.38ZM252.72 109.96a64.44 64.44 0 0 0-3.03 19.45c-.01 3.41 2.64 15.74 4.82 18.03l.25.25c.22.22.24.45.06.7-.13.18-.28.29-.46.34-3.2.57-6.1 1.75-8.7 3.54-.39.26-.65.17-.8-.27l-3.54-10.37 4.01 2.17c.68.37 1.46-.27 1.25-1.01l-1.61-5.57c-.1-.35.27-.64.59-.47l.61.33c.43.23.95-.07.98-.55.17-2.97-.19-5.85-1.07-8.64-.19-.58.01-1.07.6-1.48.32-.21.46-.51.42-.9l-.83-9.19c-.04-.42.13-.53.5-.34l1.07.55c.44.22.97-.07 1.01-.56.55-6.83-1.13-12.87-5.04-18.12 1.35-4.16 3.26-8.38 5.74-12.65.11-.19.41-.08.37.14-1.36 8.03-2.16 17.44 2.8 24.62ZM27.26 113.73c.07-1.97-.29-3.32-1.06-4.04-.15-.15-.26-.32-.31-.52-.2-.73-.62-.98-1.25-.75l.72-1.71c3.3-3.56 2.15-16.27 1.12-20.85-.04-.19.06-.37.25-.43.18-.06.38.02.46.2l5.19 11.39c.14.32.11.62-.09.9-3.27 4.52-4.94 9.79-5.03 15.81ZM22.87 110.82c3.62 8.55 5.87 22.89 1.96 31.69-.17.39-.08.74.28 1.04.32.26.8.12.92-.27l2.74-8.51c.27.47.36 1.07.27 1.8-.05.42.35.75.75.61l1.25-.45c.19-.07.39.11.33.3l-1.76 5.89c-.11.37.16.73.54.74 1.5.02 3-.64 4.49-1.98-.51 3.83-1.59 7.34-3.24 10.53-.21.39-.49.45-.84.18a22.07 22.07 0 0 0-8.77-4.19.617.617 0 0 1-.45-.79c2.94-9.62 4.47-17.6 1.91-27.11.61-2.68.18-5.13-1.29-7.36-.35-.53-.44-.94-.26-1.22.19-.31.58-.61 1.17-.9ZM238.2 163.21l.4-23.29c0-.09.06-.16.15-.17.08-.02.16.03.19.11l4.7 14.01c.07.21.03.41-.11.59-2.15 2.65-3.73 5.6-4.76 8.84-.04.14-.18.22-.32.2a.29.29 0 0 1-.25-.29ZM238.3 175.12l5.51 9.57-4.87 14.53a.27.27 0 0 1-.28.18.256.256 0 0 1-.22-.25l-.14-24.03ZM33.15 197.07c-.41.45-.51.87-.28 1.24 1.34 2.21 2.16 4.39 2.46 6.56-.67-.11-1.12.06-1.36.51l-2.73-1.92a.574.574 0 0 0-.9.54c.49 3.71 1.48 7.28 2.99 10.71.16.35.48.6.87.66l.38.06c-.59.16-.95.41-1.09.76-.53-1.29-1.13-2.11-1.81-2.47-.56-.3-.7-.16-.43.41l1.71 3.5-1.3.06c-.01-.49-.13-.8-.34-.93-.18-.11-.42 0-.44.22-.19 1.81.03 3.58.67 5.33-.93.62-1.87.49-2.82-.39a.427.427 0 0 0-.71.24c-1.25 6.74.17 12.77 4.25 18.08.23.29.26.61.11.94l-4.87 10.93c-.13.04-.26.05-.37.03a.479.479 0 0 1-.38-.54c1.13-7.03 1.31-14.07-1.85-20.62-.79-1.8-2.01-3.39-3.67-4.77-.27-.23-.28-.46 0-.69 1.86-1.63 2.51-3.95 1.96-6.95 2.76-9.75 1.02-18.69-2.07-28.48-.13-.43.02-.65.47-.67 3.45-.17 6.47-1.34 9.07-3.52.32-.27.82-.13.96.27l3.19 9.51c.19.56 0 .72-.53.47l-3.58-1.61a.64.64 0 0 0-.91.56c-.04.99.27 1.88.92 2.67.49.59.76.5.81-.25l.06-.73c.03-.34.21-.48.55-.43.37.05.71.29 1.02.71ZM246.54 186.71l5.8 2.56c-4.49 13.33-4.52 26.59-.07 39.79-4.22 6.63-3.88 15.33-2.41 22.72.03.17-.06.34-.22.4s-.34 0-.43-.15c-2.35-3.91-4.07-7.85-5.18-11.82 3.93-5.44 5.5-11.41 4.71-17.91a.607.607 0 0 0-.82-.49l-1.6.62c-.4.15-.53.02-.4-.39.76-2.35 2.22-8.78.32-10.62-.27-.26-.34-.57-.23-.92.89-2.84 1.23-5.74 1.02-8.71-.03-.47-.28-.64-.74-.51l-1.12.33c-.38.11-.51-.02-.4-.39l1.78-5.89a.552.552 0 0 0-.53-.71h-1.23c-.39 0-.53-.19-.42-.56l2.17-7.35Z"
      style={{
        fill: "#e9ce75",
      }}
    />
    <path
      d="M243.98 197.85c.27 2.03-.09 4.11-1.09 6.25-.16.34.25.67.55.44l1.51-1.19c.51-.39.74-.26.71.37-.15 2.7-1.17 9.89-3.57 11.44-.38.25-.52.15-.41-.29.66-2.77 1.53-5.44 2.6-8.03.12-.31.11-.57-.03-.78-.29-.41-.52-.39-.7.08l-3.17 8.15c-.12.3-.32.37-.6.2a.865.865 0 0 1-.38-.52c-.05-.14-.04-.37.01-.7.11-.68-.12-1.15-.67-1.41l.7-7.49c.11.31.23.53.37.64.39.31.97.08 1.03-.42.31-2.44 1.36-4.69 3.14-6.74Zm-3.73 9.47c-.5 1.11-.6 2.15-.31 3.1.17.53.36.54.57.02l1.35-3.23c.12-.29.03-.47-.26-.56-.61-.19-1.06.03-1.35.67ZM255.76 222.62c.2 1 .1 1.6-.29 1.81-.23 0-.44-.04-.63-.17-.15-.09-.28-.25-.37-.48-.7-1.67-.89-3.37-.58-5.09.06-.33.53-.36.63-.04l1.24 3.97ZM23.82 231.38l1.91 4.77c.15.37.09.7-.16 1.01l-.39.48c-.19.23-.25.5-.16.8l1.43 4.87c.07.25-.06.51-.31.6a.492.492 0 0 1-.61-.29c-.29-.75-.5-1.58-.62-2.47-.07-.51-.21-.82-.43-.94-.29-.17-.69-.17-1.22-.01-.77-2.96-1.46-3.41-2.07-1.35-.41-1.02-.51-2.01-.3-2.96.07-.27.3-.48.58-.5l.58-.05c.84-.06 1.03-.44.57-1.15-.55-.85-1.29-1.3-2.21-1.34-.47-.02-.73.2-.78.67-.35 2.96.16 5.72 1.53 8.28.16.31.08.69-.2.9a.7.7 0 0 1-.91-.05c-.27-.25-.56-.33-.87-.24-.43.13-.52.38-.29.76.33.53.39 1.01.19 1.44-.13 0-.25 0-.36.01-.25.02-.43.14-.53.37a71.632 71.632 0 0 0-5.8 21.89c-.07.71.02 1.26.28 1.65.3.45.99.26 1.01-.28.12-3.78.82-7.16 2.11-10.14-.1.88.13 1.65.69 2.32.29 2.25 1.23 4.31 2.82 6.16.21.24.26.58.13.87a54.371 54.371 0 0 0-4.17 13.71c-.47 2.86-1.19 2.93-2.18.2-5.27-14.6-3.13-29.9 2.51-44.54.91-2.35 2.16-6.74 3.8-9.88.2-.38.43-.41.7-.08l3.73 4.51ZM242.73 248.15c-.56 2.13-.02 4.16 1.61 6.11.33.41.24.61-.29.61h-1.26c-.41 0-.68.43-.5.8 1.92 3.93 4.93 6.63 9.02 8.09.32.11.52.33.6.66a33.39 33.39 0 0 0 1.99 5.75c.15.33.22.62.21.89 0 .65-.19.92-.55.81-2.79-1.51-5.13.3-7.52 1.4-.27.13-.57-.12-.5-.41.83-3.47.9-6.96.21-10.45a.83.83 0 0 0-.84-.67c-.4.01-.74.31-.8.71-.17 1.18-.77 2.07-1.79 2.66-.12.07-.21.16-.27.28l-2.31 4.44c-.16.31-.64.2-.64-.16l-.12-25.81c0-.31.39-.44.57-.19l3.18 4.48ZM265.6 271.36c-.11 3.58-1.06 7.28-2.86 11.09-.87 1.86-1.42 1.77-1.65-.27-.53-4.86-1.95-9.91-4.26-15.15 3.55-4.55 4.46-9.69 2.74-15.42-.13-.45-.42-.59-.86-.42l-.62.22c-.39.15-.58.01-.57-.41l.22-5.1.34-.17c.29-.14.48-.06.59.24 2.79 7.95 5.1 16.42 6.93 25.39Z"
      style={{
        fill: "#e9ce75",
      }}
    />
    <path
      d="M20.62 247.05c.56 1.82 1.9 5.7.95 7.57-.16.31-.61.28-.72-.04a18.18 18.18 0 0 1-1.01-7.44c.03-.44.65-.51.78-.09ZM30.81 257.02c.07.1.05.24-.05.31l-.14.1c-3.25 2.41-6.03 4.17-6.2 3.93l-.14-.19c-.18-.24 2.31-2.38 5.56-4.78l.15-.11c.1-.07.23-.05.31.05l.51.69ZM33.79 256.27c.65 3.19.8 6.3.46 9.31-1.24-.99-1.99-2.09-2.26-3.3-.15-.69-1.12-.71-1.3-.03-.9 3.57-.85 7.13.15 10.67.1.34-.29.61-.58.41-1.91-1.3-4.03-1.95-6.34-1.96-1.16 0-1.76 1.39-.95 2.23l3.04 3.16c.31.33.11.86-.34.9-2.84.23-5.36 1.28-7.57 3.14-.71.6-.33 1.76.6 1.83l3.6.25.32.46c.18.25.2.58.05.85-.96 1.77-1.27 3.66-.93 5.68.13.73 1.01 1.05 1.57.56l3.27-2.81c2 2.39 3.8 2.88 5.4 1.47.49.15.63.36.42.63-3.6 4.49-8.23 5.26-13.88 2.3-2.33-6.3-1.99-13.04 1.01-20.21 1.09-2.6 2.23-5.19 3.42-7.76.15-.32.4-.49.75-.51 4.21-.31 7.57-2.73 10.09-7.27ZM247.27 256.9c1.86 1.11 3.44 2.58 4.73 4.41-2.37-.97-4.33-2.3-5.87-3.99-.28-.31-.21-.45.2-.44l.94.02ZM253.8 272.6c.13 0 .24.01.35.02.25.03.39.17.44.42l1.01 5.73-5.25-1.25a.429.429 0 0 1-.13-.78 9.481 9.481 0 0 0 3.58-4.14Z"
      style={{
        fill: "#e9ce75",
      }}
    />
    <path
      d="M34.55 281.79c-.01 3.99-.81 5.4-2.38 4.21-.06 1.23-.37 1.92-.94 2.05-4.78 1.16-4.14-6.8 1.45-7.53.25-.03.51 0 .74.13.72.37 1.1.75 1.13 1.14ZM249.04 287.99c1.85.3 2.93 1.13 3.23 2.48.23 1.04-.11 1.84-1.02 2.39-4.67 2.84-8.68 1.79-12.04-3.15-2.79-13.07 13.17-9.58 8.31-2.08-.81 1.25-2.71.99-3.16-.44l-.25-.82c-.09-.27-.27-.37-.54-.29-.39.11-.57.37-.54.8.25 3.3 4.4 4.24 6.01 1.11ZM266.57 283.26c.15 2.36-.51 4.72-1.99 7.08l-3.69 1.47a.661.661 0 0 1-.9-.67c.33-3.64 1.88-6.61 4.67-8.9.23-.19.57-.1.69.17.45.99.86 1.27 1.22.85ZM94.21 295.26c2.44-.53 4.33.31 5.68 2.52-2.53-.43-4.43-1.27-5.68-2.52ZM131.82 295.45c-.05 1.23-.44 2.28-1.17 3.15-.16.19-.26.41-.3.65l-1.12 6.2c-2.05-5.19-5.6-7.43-10.67-6.72l-7.35-3.03c-.67-.27-.64-.41.08-.4l20.53.15ZM157.69 298.58c-5.89-.43-9.51 2.16-10.88 7.79-.15.63.08 1.29.69 1.96.23.58.63 1.05 1.2 1.42l-1.24 3.38c-.1.26-.22.27-.36.03l-.15-.25a.996.996 0 0 1-.12-.75c.33-1.38 0-2.51-1.04-3.39-.23-.2-.38-.45-.44-.75-.92-4.17-2.75-8.32-5.49-12.45l25.12-.21c.73 0 .75.12.07.38l-7.36 2.84ZM45.8 314.11l-7.44.95-2.97-2.12c-.16-.11-.28-.26-.37-.44-2.4-4.95-2.38-12.68 2.55-16.07 2.52-1.73 7.06-1.08 10.08-1.05.33 0 .6.13.79.4 6.51 8.58-7.02 13.49-5.28 5.83.08-.33.27-.59.56-.78 1.35-.87 2.48-.62 3.38.75.21.32.42.33.65.02.59-.77.58-1.41-.03-1.93-4-3.41-9.42 2.55-5.25 5.66.53.39.42 1.22-.19 1.45-1.83.71-3.26 1.9-4.3 3.57-.2.32 0 .74.36.8 2.4.41 4.65.02 6.74-1.19.47-.27 1.05.09 1 .63l-.28 3.52ZM80.05 295.39c.17.21.26.41.27.6 0 .35-.16.54-.51.55-4.98.18-9.68 1.57-14.09 4.16-1.9-2.32-4.17-3.9-6.81-4.75a.287.287 0 0 1-.2-.32.29.29 0 0 1 .29-.25h21.05ZM180.56 295.23c.23.14.48.19.73.15a.3.3 0 0 1 .34.23c.04.15-.04.31-.19.36l-4.94 1.79c.99-1.71 2.34-2.56 4.06-2.53ZM229.4 314.98c.67.92.63 1.51-.11 1.77-4.41-1.12-7.6-2.46-9.57-4.03-9.44-7.46-16.79-12.91-27.01-16.7-.35-.13-.26-.64.11-.64h23.51c.5 0 .65.68.2.89a17.418 17.418 0 0 0-6.37 4.97.786.786 0 0 0 .49 1.27c2.53.42 5.06.47 7.59.15.26-.03.51-.11.74-.23l1.08-.56c.67-.34.83-.18.46.48a17.146 17.146 0 0 0-2.08 6.9c-.03.44.37.78.8.67 1.94-.49 3.49-1.54 4.65-3.15.23-.32.74-.23.84.16.86 3.23 2.42 5.91 4.67 8.05ZM233.6 295.46c4.34 3.64 5.33 7.86 2.98 12.67l-2.79-1.71c-.34-.2-.38-.45-.13-.76 4.04-4.83-1.96-9.62-5.18-5.62-.42.52-.52 1.05-.3 1.58.12.3.53.34.71.07 3.12-4.5 7.41 2.63 2.18 3.6-5.37.98-5.36-6.57-3.37-9.42.21-.29.49-.44.85-.44l5.05.03Z"
      style={{
        fill: "#e9ce75",
      }}
    />
    <path
      d="M105.03 295.52c3.78 1.08 11.02 2.21 12.42 6.35.97 2.88 1.88 6.13 2.75 9.74-3.51.37-7.21-.63-11.11-2.98-4.42-2.68-8.05-1.92-12.73-1.67-1.85.1-3.74.44-5.65 1.01-3.56-2.19-7.74-3.78-12.53-4.77a.926.926 0 0 0-1.06.6c-.19.56-.13.92.19 1.08.31.16.36.38.17.67-.21.32-.39.44-.56.37-2.37-.76-3.85.72-6.04.71-.94 0-1.9-.02-2.88-.07.45-1.47 1.58-2.19 3.41-2.16.34.01.63-.11.87-.36 3.5-3.56 7.11-5.05 10.82-4.48 3.9 1.85 9.23 3.06 13.17.99a1.1 1.1 0 0 1 1.07.02c1.77 1.03 3.61 1.26 5.52.68.36-.11.68-.04.95.21 1.43 1.29 3.12 1.84 5.09 1.65.45-.05.63-.29.53-.73-.6-2.71-2.09-4.78-4.46-6.19-.18-.11-.22-.26-.11-.44.06-.11.12-.19.17-.23ZM171.28 295.92l-4.37 5.62c-.59.75-.01 1.84.94 1.79 1.91-.11 3.53-.84 4.87-2.19.27-.27.56-.29.87-.05 1.59 1.25 3.83.08 5.52-.4.33-.09.66-.09.99.02 4.21 1.38 8.46 1.13 12.73-.75l2.05-.95c.31-.15.63-.15.94.01l5.77 2.88c-.04.28-.18.54-.43.79-.18.19-.44.3-.77.33a36.96 36.96 0 0 0-15.32 5.28c-.3.18-.62.26-.97.24l-5.36-.34c-.25-.01-.5-.07-.73-.18-3.31-1.49-6.51-1.48-9.61 0-4.5 2.17-8.36 2.23-12.57 5.47-.28.21-.55.21-.82-.02-.2-.17-.26-.45-.17-.82 2.23-3.85 2.69-7.87 4.39-12.13 2.97-2.48 6.99-4.02 12.05-4.61ZM29.26 305.6c1.13-1.27 1.47-2.15 1.04-2.66l-.28-1.02c.56-1.01 1.16-1.58 1.8-1.72.45-.1.82.36.62.78l-2.15 4.53c-.1.21-.27.29-.5.23-.13-.03-.3-.08-.53-.14ZM223.08 300.12c.04-.07.13-.1.2-.06l.04.02c1.43.77 1.77 2.93.75 4.83l-.16.3c-1.01 1.9-3 2.81-4.44 2.04h-.03c-.08-.05-.11-.14-.07-.22l3.71-6.91ZM61.91 302.82c-.4 1.47-1.84 2.85-4.33 4.12l-2.17-4.64c-.17-.37-.06-.53.35-.46l6.15.98Z"
      style={{
        fill: "#e9ce75",
      }}
    />
    <path
      d="M88.37 308.43c-10.91 3.79-21.06 9.17-32.27 11.65-.73-.19-1.27-.42-1.6-.7l-.93-3.07c1.26-1.02 3.03.38 4.54.7 3.82 1.04 6.57-.9 10.01-2.3.05-.02.31-.3.61-.66.11-.14.11-.28-.02-.43-.36-.43-.29-.78.22-1.04 2.11-1.07 6.04-2.15 6.23-4.16.03-.29.18-.46.47-.52 1.57-.31 2.81-1.12 3.7-2.45.17-.26.48-.38.79-.33 2.97.49 5.72 1.6 8.25 3.31ZM217.89 317.05c1.23-.13 2.25-.51 3.05-1.15.27-.21.56-.27.89-.2.89.21 1.84.82 2.85 1.83-4.35 1.77-8.62 1.96-12.82.56-4.96-1.65-15.55-7.7-24.81-8.44a.39.39 0 0 1-.18-.72c2.81-1.75 5.82-3.04 9.02-3.85.43-.11.88.04 1.16.39 1.03 1.29 2.35 2.12 3.95 2.5.41.09.6.35.56.77-.06.69.12 1.14.54 1.35 1.67.82 3.35 1.6 5.04 2.35.38.17.54.45.49.86l-.07.51c-.04.29.06.51.3.66 3.3 2.09 6.64 2.95 10.03 2.58ZM51.79 306.7l2.85 2.09c-1.7 2.13-3.46 3.24-5.29 3.35l1.25-2.85 1.19-2.59ZM233.7 310.98c-.08 1.85-1.2 2.92-3.37 3.2l-.47-4.09c-.05-.45.14-.59.56-.42l3.28 1.31Z"
      style={{
        fill: "#e9ce75",
      }}
    />
    <path
      d="m206.33 285.36-156.01.04c-.66-1.31-.26-1.96-.26-3.13-.03-6.73 0-13 .06-18.81 3.96-3.51 8.06-6.15 12.31-7.91.33-.13.64-.09.91.13 9.81 7.91 22.78.52 29.87-7.22 2.94-3.22 6.94-4.21 11.05-4.45.32-.02.52.34.33.6-.6.82-.66 1.5-1.29 2.22-1.99 2.26-3.1 4.94-3.35 8.03-.03.39-.21.69-.56.88l-3.59 2.03c-.48.27-.76.79-.73 1.33l.67 10.61c.03.34.2.66.47.86 4.57 3.39 9.53 6.05 14.89 8 .3.11.6.12.91.01 10.13-3.53 20.26-6.97 30.4-10.33.31-.1.96-.18 1.96-.25 1.07-.07 1.55-.69 1.45-1.86-.31-3.57-.51-6.04-.62-7.43-.03-.43.17-.65.6-.66 3.77-.06 7.53-.15 11.26-.26 6.42-.2 9.75-.84 13.53 3.46.23.27.58.41.93.39 3.19-.14 6.35-.53 9.47-1.16.16-.03.3-.11.41-.23l19.24-20.02a.727.727 0 0 1 1.22.28c1.44 4.57 2.33 8.85 2.73 13.9.81 10.29 1.39 20.6 1.74 30.95Zm-52.39-5.35c.02-.9.81-1.58 1.69-1.46 3.16.42 5.78-.52 7.87-2.81.25-.28.25-.56-.01-.84-.45-.48-1.02-.66-1.71-.54-.33.05-.65.02-.97-.09-1.89-.66-3.66-.51-5.31.44-1.3.76-2.97.31-3.72-.99-.72-1.25-1.16-2.57-1.32-3.96-.05-.41-.62-.47-.75-.07l-1.47 4.56c-.13.4-.2.81-.21 1.24-.04 1.25-.5 2.29-1.39 3.13-.81.77-.33 2.13.78 2.22l1.49.11a1 1 0 0 1 .82.5c1.3 2.1 4.17.4 4.21-1.44Z"
      style={{
        fill: "#0e061d",
      }}
    />
    <path
      d="M118.74 260.74a211.72 211.72 0 0 1 18.03-3.69c1.82-.29 3.02-.94 4.86.09.33.19.3.67-.05.82l-14.76 5.98c-.37.15-.74.16-1.11.03l-7.01-2.46c-.85-.29-.83-.55.04-.77Z"
      style={{
        fill: "#0e061d",
      }}
    />
    <path
      d="m136.53 54.93 8.79-.05 71.23.02 5.33.18c.89.03 1.57.82 1.46 1.71l-.75 6.18a.48.48 0 0 1-.67.38c-.83-.36-1.61-.27-2.33.27-.29.22-.61.26-.94.11-5.33-2.41-7.39-4.04-13.46-2.02-5.11 1.69-7.9 2.21-12.65 1.31-4.49-.85-7.69.16-11.42-.85-.32-.09-.64-.07-.95.05-1.82.73-3.7 1.14-5.65 1.21-2.29.08-4.3-1.15-6.67-1.64-4.9-1.02-8.93-3.21-13.8-3.68-2.56-.25-6.58-2.4-7.83 1.11-.12.33-.05.63.2.89l3.41 3.47c.25.26.56.37.93.33 2.06-.22 5.9.17 4.45 3.48-13.87-8.69-29.36-10.29-43.58-1.2-2.84 1.81-6.34 4.61-10.51 8.38-4.59-.61-9.09-.42-13.52.57-3.81.86-6.15 2.67-10.75 1.63a83.255 83.255 0 0 0-15.8-2.03c-1.34-.04-2.42-1.73-3.38-2.36-2.33-1.55-4.92-2.69-7.76-3.43l.22-13.38c0-.41.21-.61.62-.61l85.78-.03Z"
      style={{
        fill: "#808956",
      }}
    />
    <path
      d="m179.83 160.52 27.51 3.07 2.67.04c.29.01.41.15.35.43-.09.43-.36.63-.8.61-2.76-.11-5.17-.02-7.22.29-.32.05-.36.19-.13.42l5.3 5.22c.26.25.17.68-.16.81-1.54.6-2.7 1.37-4.4 1.15-2.02-.27-4.54-.44-7.57-.49-.18 0-.33.12-.36.3s.07.35.24.4c.66.21 1.45.36 2.38.45 9.83 1 19.72 1.68 29.67 2.03l.07 14.63c-9.67-1.44-18.53-.57-28.36.58-1.78-13.27-8.59-18.97-19.19-29.94Z"
      style={{
        fill: "#553334",
      }}
    />
    <path
      d="m167.96 23.44 1.81-.04c1.12 1.48 2.72 2.3 4.8 2.46l-.06 1.29c-1.35-.39-2.74-.25-4.17.42-10.72-1.37-19.53-6.26-26.43-14.68a.385.385 0 0 0-.5-.09.39.39 0 0 0-.18.48l2.42 6.7c.11.31.31.56.6.74 2.9 1.82 8.16 2.88 9.5 6.31.89 2.25 1.6 4.35 2.15 6.29.38 3.03 1.44 5.05 3.17 6.06 3.64 2.11 7.54 3.05 11.7 2.82 2.5.85 3.34.69 2.51-.5.62-.77 1.11-.97 1.46-.58 1.29 1.65 3.15 2.35 5.58 2.08.77.45 1.56.14 2.37-.93.7.32 1.59.44 2.68.37 1.27-.21 2.57-.98 3.91-2.33.53.27.94-.03 1.24-.9.21-.85.97-.93 2.27-.24.31.17.62.17.93.01l6.48-3.37c.25-.42.36-.74.34-.97 3.01-.53 5.27-1.75 6.77-3.68.81-1.03 1.67-1.65 2.58-1.84.32-.07.58-.22.79-.47.65-.75 1.45-1.36 2.42-1.83l1.16-1.44c1.63-.49 2.53-1.24 2.72-2.23.04-.19-.18-.29-.67-.28-.09-.51.21-.96.89-1.37l2.8.71c.34.08.7 0 .98-.21 1.36-1.06 2.89-1.64 4.6-1.73.38-.02.46-.55.1-.68-5.15-1.81-10.34-2.33-15.59-1.56l-.5-.08c-.43-.07-.48-.25-.15-.54.31-.27.68-.43 1.11-.49 2.96-.41 5.92-.43 8.87-.04 2.8.36 4.86.19 7.53.16 1.31 1.73 3.27 2.76 5.86 3.11l2.22-.16c.32-.03.53-.19.64-.49.47-1.33 1.04-1.59 1.7-.8-.81 2.43-.02 4.01 2.37 4.76-.35.54.12.76 1.39.66.37-.03.58.13.63.49l.25 1.6.07 2.45c.05.87.27 1.64.67 2.29.19.29.4.31.64.07l.93-.94c1.63-2.23 2.72-4.69 3.27-7.37.61-.69 1.18-1.04 1.71-1.06.39-.02.67.38.52.74l-.85 1.97a.463.463 0 0 0 .79.47c1.47-1.92 2.54-2.35 3.21-1.3-5.07 3.43-8.76 7.94-11.07 13.53-.11.26-.01.55.23.7.23.15.54.11.73-.1l11.85-13.08.37.05c.54.07.77.74.38 1.13l-9.8 9.96c-.11.11-.12.3-.03.42.1.13.28.17.42.09 4.01-2.24 7.52-5.12 10.51-8.63.21-.25.48-.38.81-.41.38-.03.66-.13.85-.28.1 0 .12.22.07.67l-4.61 4.92c-.51.55-.51 1.39.01 1.93a1.4 1.4 0 0 0 1.93.11c1.37-1.16 3.17-1.62 5.42-1.38.14.33.34.39.59.19-.13.49-.44.94-.92 1.35-3.23-.39-6.53.38-9.92 2.3l-1.96.66c-.29.09-.29.19 0 .29l4.23 1.46 2.05-.07c-.29 3.62 1.41 5.62 5.11 6 .65.06 1.3-.28 2.1-.15 1.23.2 2.48.26 2.82-1.04.47.41.81.95 1.02 1.61.13.43-.02.69-.45.78l-2.49.55c-.42.09-.54.34-.37.73 1.89 4.33 1.52 8.2 3.12 12.41 3.53 9.27.66 23.79-1.07 32.79-1.02 5.34-3.14 11.32-4.74 17.02-.31.97-1.36 1.4-3.13 1.29-.16-.01-.3.04-.41.15l-.26.26c-.18.18-.06.48.19.5 1.13.09 1.9.6 2.32 1.54.12.27.3.49.55.66l1.84 1.21-.24.69-.5 1.18c-.76-1.64-2.15-2.89-4.17-3.74-.91-.09-1.31.54-1.2 1.91.07-.08.17.07.29.44-.28 1.08-.83 1.17-1.66.26-.2-.22-.31-.52-.3-.83.15-2.83-.77-4.76-2.76-5.81-4.96-7.18-4.16-16.59-2.8-24.62.04-.22-.26-.33-.37-.14-2.48 4.27-4.39 8.49-5.74 12.65-.81 1.57-.91 2.74-.32 3.52.11.21.21.41.31.61-2.84 1.71-3.8 3.46-2.88 5.25-1.33 2.39-1.64 5.11-.94 8.17-2.02 4.21-2.33 8.68-.93 13.4 0 3.63.51 6.99 1.58 10.06.07 1.36.3 2.28.69 2.77l3.54 10.37c.15.44.41.53.8.27 2.6-1.79 5.5-2.97 8.7-3.54-.27.93-.2 1.35.2 1.26-8.97 1.5-13.2 8.27-15.46 16.71l.71 1.54c6.69-1.45 12.04-4.88 16.04-10.31.15-.2.33-.24.56-.13.11.06.22.12.32.18.26.15.49.2.68.17.34-.07.52-.27.54-.62l5.33-2.45c.62.03.88.39.78 1.08-6.13 3.14-11.82 7-17.09 11.59-.38.33-.32.46.17.37 6.6-1.09 12.23-4.21 16.88-9.38l-.12 1.24c-2.48 3.41-5.94 5.89-10.37 7.46-.46.16-.47.82-.01.99.87.31 1.98.15 3.33-.5-.17.82-.06 1.68.35 2.58-1.38-.42-2.66-.55-3.85-.38-.37.05-.39.17-.06.34l5.54 2.9c.07.72-.1 1.15-.5 1.29-3.41-2.16-6.91-3.62-10.51-4.39-1.49-.31-1.62-.02-.39.88l10.46 7.66-1.94 1.92c-4.29-5.91-9.65-9.41-16.08-10.49-.71.87-.96 1.75-.75 2.62-.74 1.29-1.01 2.04-.82 2.27l.14 24.03c0 .12.09.23.22.25.12 0 .24-.06.28-.18l4.87-14.53c.39-.93.85-.56 1.36 1.12-2.21 4.2-3.58 8.62-4.13 13.25-.78 1.27-1.31 3.04-1.6 5.3l-.7 7.49c-1 3.6-.55 7.43 1.34 11.49-.47 2.52-.43 4.87.13 7.05.39 2.47 1.43 4.57 3.14 6.32-.33.99-.33 1.83 0 2.53.18.08.41.4.68.97 1.11 3.97 2.83 7.91 5.18 11.82.09.15.27.21.43.15.16-.06.25-.23.22-.4-1.47-7.39-1.81-16.09 2.41-22.72l2.81-2.67c.45.47.58-.18.39-1.97.39-.21.49-.81.29-1.81l.05-.39c.03-.23.24-.39.47-.37.75.07.99.53.73 1.38-.12.38.07.79.43.95l1.51.66c.38.17.37.71-.02.85l-.65.24c-.32.12-.28.58.05.64l2.56.46c.25.05.46.16.64.33l.71.69c.08.55.06 1.17.24 1.67 4.43 12.38 6.79 25.13 7.06 38.24.05 2.45-.27 5.02-.98 7.71-.67 2.55-1.34 5.08-1.99 7.58-.36.42-.77.14-1.22-.85a.445.445 0 0 0-.69-.17c-2.79 2.29-4.34 5.26-4.67 8.9-.04.49.45.85.9.67l3.69-1.47c.51.62 1.61 1.03 3.28 1.24.41.05.63.5.42.85-.3.5-.69.93-1.18 1.28.03-.15.06-.27.07-.38.03-.29-.09-.45-.37-.48-3.48-.4-8.03-.34-9.64 3.41-.16.37-.09.68.2.94.37.33.91.49 1.61.49.11.25.15.53.12.84-.04.31-.21.44-.52.41-2.64-.29-5.23.03-7.78.96-.3.11-.33.26-.09.47 1.11.93 2.21 1.11 3.29.53l.3.73c-.54.18-.69.55-.44 1.1.49 1.08-.68 2.17-1.72 1.59l-7.47-4.17c-.31-.17-.52-.09-.63.24-.45 1.27-.07 1.69 1.13 1.26.17 1.66.94 3.38 2.33 5.17-.58.26-1.01.56-1.29.91-.3-.46-.61-.71-.93-.76-.31-.05-.58.14-.8.56-.83 1.56-.5 3.2.98 4.92-.54.17-.84.65-.89 1.45l-.27-1.5c-.07-.38-.16-.38-.27 0-.13.46-.24.93-.34 1.41-.07.37-.29.5-.65.41-1.09-.27-1.5.11-1.22 1.12-2.47-.55-2.85 2.41-2.15 4.25-2.36-2.14-4.41-2.53-6.16-1.16l-2.06 1.02c-2.83.91-3.42 2.25-1.79 4.02-.92.27-1.92.03-3.01-.72-.28-.19-.58-.24-.9-.15-13.13 3.76-21.75-.13-34.13-6.05-2.87-1.37-5.55-1.96-8.56-2.6-.91-.19-1.48-.04-1.71.45-2.56 2.01-3.67 4.07-3.34 6.16-.74 1.2-1.66 1.81-2.76 1.82-.45.01-.65-.21-.6-.66l.25-2.32c.14.29.45.5.92.65s.8 0 1-.44l1.03-2.26c.25-.55-.44-1.04-.88-.62l-2.09 2c-.31-.23-.66-.39-1.05-.47.64-.03.94-.48.91-1.34 2.5-.75 3.9-1.97 4.19-3.67-1.22-.79-1.23-1.8-.04-3.03.17-.17.35-.2.56-.07l1.23.77c.41.25.74.18 1.01-.22.51-.77 1.22-1.13 2.12-1.07.15.01.23.09.25.23l.04.32c.05.32.23.52.54.59 4.45 1.07 10 3.2 16.63 6.39 8.16 3.93 16.95 4.41 26.36 1.42.29-.09.28-.18-.01-.26l-2.93-.78c-1.01-1.01-1.96-1.62-2.85-1.83-.33-.07-.62-.01-.89.2-.8.64-1.82 1.02-3.05 1.15 1.13-1.47 1.34-2.41.64-2.81-1.79-1.03-3.29-2.09-4.49-3.2-.82-1.51-1.96-2.3-3.43-2.37-1.44-2.37-3.35-3.82-5.74-4.33-.33-.07-.63-.22-.88-.43l-2.4-2.01-5.77-2.88c-.31-.16-.63-.16-.94-.01l-2.05.95c-.43.06-.6-.56-.51-1.85-1.01-.69-1.94-.9-2.8-.63.19-.98-.03-1.53-.65-1.66-3.03-.61-5.8-.81-8.31-.59-1.72-.03-3.07.82-4.06 2.53.02-.21-.28-.2-.89.01-.39.13-.58 0-.59-.41v-.52a2 2 0 0 0 .49-.87c.1-.37-.04-.51-.41-.41l-1.49.4c-1.94-.31-2.72-.33-2.33-.04-5.06.59-9.08 2.13-12.05 4.61-.71 1.23-1.52 1.08-2.43-.46-.22-.37-.26-.68-.13-.93.16-.3.5-.48 1.02-.55l7.36-2.84c.68-.26.66-.39-.07-.38l-25.12.21c-1.13 1.44-2.34 1.5-3.64.17l-4.4-.29-20.53-.15c-.72 0-.75.13-.08.4l7.35 3.03c1.09.33 1.21 1.47.35 3.43-.03.06-.03.13 0 .19.28.48.62.62 1.03.41.32 3.29 1.19 6.24 2.6 8.86.14.27.33.48.58.65l3.63 2.44c.28.19.64-.05.58-.37-.57-3.19-1.91-6.13-4.02-8.83 1.82 1.64 2.7 1.98 2.65 1.03l1.44 2.59c.12.23.3.3.55.22.23-.07.44-.24.64-.51 1.01 1.71 1.29 3.63.84 5.76-.03.13-.11.19-.25.17l-.67-.12c-.39-.07-.67.08-.84.43l-.44.87c-3.25-.65-5.6-2.09-7.04-4.34-.87-3.61-1.78-6.86-2.75-9.74-1.4-4.14-8.64-5.27-12.42-6.35l-2.33.49c-.53-.41-1.15-.63-1.86-.64-.26 0-.42.28-.29.5.15.25.43.44.85.58-.27.87-.78 1.31-1.51 1.32-1.35-2.21-3.24-3.05-5.68-2.52-.73-.67-1.63-.56-2.71.33-.25.2-.52.26-.83.19-2.13-.54-3.67.05-4.63 1.78-.11-.14-.63-.13-1.54.03l-1.4 1.98c-3.71-.57-7.32.92-10.82 4.48-.24.25-.53.37-.87.36-1.83-.03-2.96.69-3.41 2.16-1.15.25-1.82.8-2.01 1.66-.06.3.15.59.46.62l.6.04c.17 0 .22.25.07.33-1.94 1.08-3.18-2.05-5.06 1.63l-4.65 3.41c-.33.24-.37.52-.12.83.47.61.74 1.26.82 1.93-1.51-.32-3.28-1.72-4.54-.7l-5.08 1.71c-.45.59-1.02.98-1.72 1.18-.33.09-.62.03-.87-.19-.5-.45-1.21-.56-2.13-.31l-.68-.13c-.15-.65-.66-.99-1.53-1.02-1.55-.04-3.15.15-4.78.58.24-1.49-.31-2.26-1.64-2.31.21-.81-.04-1.41-.75-1.8-2.64-1.44-1-4.09-2.79-6.64-.32-.46-.65-.47-1-.03l-1.04 1.31c-.07.08-.13.08-.19 0-.15-.21-.19-.39-.1-.55.43-.79.41-1.42-.04-1.91.45-.57.46-.77.03-.61.23.06.4.11.53.14.23.06.4-.02.5-.23l2.15-4.53c.2-.42-.17-.88-.62-.78-.64.14-1.24.71-1.8 1.72-1.57-.12-3.04.39-4.41 1.52-.31.25-.26.41.13.46.25.03.45-.02.59-.16.07-.07.17-.07.24 0 .08.06.09.16.04.24-.14.21-.3.31-.47.31-.54-.16-1.37.19-2.48 1.06.07-.61-.43-.64-1.49-.09-.33.17-.58.09-.75-.24l-1.28-2.43c1.41-.11 2.64-.59 3.69-1.46.84-.13 1.44-.39 1.81-.77.25-.26-.03-.68-.37-.54-.88.36-1.6.29-2.17-.2-.29-.25-.62-.42-.99-.5-2.46-.54-4.87-.57-7.22-.09l-2.9.21c-4.19.07-5.78 1.41-4.78 4.02-1.49-.05-2.64-.37-3.44-.95a.488.488 0 0 1-.05-.75c2.36-2.23 5.15-3.54 8.38-3.95.37-.05.5-.25.4-.61l-.1-.37c.15-.05.31-.18.5-.37.25-.27.54-.31.87-.13 1.43.82 2.98 1.23 4.67 1.24.35 0 .6-.16.73-.49l.27-.69c.04-.81.34-1.34.9-1.61 3.59 3.91 7.75 4.83 12.46 2.74 1.75-.77 2.76-2.71 4.08-4.1.21-.22.34-.48.39-.78.61-3.48.18-6.77-1.29-9.88-.15-.32-.44-.55-.79-.63l-.64-.13c-.03-.39-.41-.77-1.13-1.14-.23-.12-.49-.16-.74-.13-5.59.73-6.23 8.69-1.45 7.53.57-.13.88-.82.94-2.05.63 1.24.57 2.27-.19 3.1-1.6 1.41-3.4.92-5.4-1.47-.53-.05-.53-.67 0-1.88.06-.14.07-.28.04-.42l-.65-2.81c-.12-.52.08-.8.61-.83 1.05-.07 1.7-.6 1.95-1.58.09-.34.43-.55.77-.48.25.05.43-.02.56-.19.21-.29.14-.47-.21-.53-3.98-.68-5.75.39-9.3 1.61-.33.11-.52.37-.57.76-.04.32.3.54.57.38.83-.48 1.58-.42 2.23.17.25.22.27.59.06.85-.09.11-.21.18-.35.21l-3.6-.25c-.93-.07-1.31-1.23-.6-1.83 2.21-1.86 4.73-2.91 7.57-3.14.45-.04.65-.57.34-.9l-3.04-3.16c-.81-.84-.21-2.23.95-2.23 2.31.01 4.43.66 6.34 1.96.29.2.68-.07.58-.41-1-3.54-1.05-7.1-.15-10.67.18-.68 1.15-.66 1.3.03.27 1.21 1.02 2.31 2.26 3.3l1.87 3.57c.31.58 1.18.37 1.19-.29l.25-22.95.02-10.59-.04-3.58c0-.37-.17-.45-.48-.26-.2.12-.26.34-.18.65l-.71.13c-.17.03-.28-.03-.33-.19a.363.363 0 0 0-.23-.25c.83-3.56 1.08-6.74.74-9.53 1.11-3.11 1.55-6.68 1.33-10.73-.23-4.34-.64-12.12-4.53-14.49-.31-.42-.65-.66-1.02-.71-.34-.05-.52.09-.55.43l-.06.73c-.05.75-.32.84-.81.25-.65-.79-.96-1.68-.92-2.67a.64.64 0 0 1 .91-.56l3.58 1.61c.54.25.72.09.53-.47l-3.19-9.51a.608.608 0 0 0-.96-.27c-2.6 2.18-5.62 3.35-9.07 3.52-.45.02-.6.24-.47.67 3.09 9.79 4.83 18.73 2.07 28.48l-.87.07-.97-2.67c-.11-.31-.33-.5-.65-.59-.77-.21-1.15-.64-1.16-1.3.45-.95.54-2.61.27-4.96-1.03-8.93-1.98-15.21-2.83-18.82.17-.07.37-.49.58-1.28 3.23-.61 6.7-.87 9.48-2.4 6.44-3.53 7.17-8.05 10.06-13.98.21-.32.35-.62.42-.91.24-1-.66-1.9-1.66-1.66l-.65.16c-5.79 1.69-10.61 4.99-14.46 9.91-1.11.12-1.67-.47-1.7-1.76l10.17-7.68c.47-.36.41-.5-.18-.43-3.18.39-6.26 1.52-9.24 3.39l-.34-.29c-.21-.17-.25-.38-.14-.62l.2-.43 3.5-1.94c.28-.16.28-.31-.01-.46-.39-.21-1.03-.13-1.92.23-.48-.27-.61-.7-.39-1.27.09-.25.19-.41.29-.46.13-.07.33-.14.6-.19.27.17.69.21 1.26.11.41.21.95-.26 1.62-1.42l4.87 1.32c.54.15.6.04.17-.33a87.166 87.166 0 0 0-17.39-11.81c-.03-.51-.14-.98-.35-1.4 1.35.28 5.94 2.75 6.31 2.7.44-.06.53-.27.28-.63l-.28-.4 1.26.31c.32.07.57.25.76.52 3.71 5.26 8.69 8.87 14.93 10.82 1.22.59 1.99.22 2.3-1.09-.75-2.47-1.57-4.68-2.45-6.63-3.79-8.4-9.37-9.54-17.62-11.23l.13-2.56 2.13-14.74 1.43-1.37c.37-.35.53-.27.48.24-.5 5.35-1.34 10.64-2.52 15.89-.03.14.02.23.16.27.09.03.19.05.28.08.19.06.32 0 .39-.2 2.48-6.59 4.47-16.91 2.25-23.73-.63-1.93-.21-2.81 1.26-2.66 2.56 9.51 1.03 17.49-1.91 27.11-.11.35.1.71.45.79 3.24.75 6.16 2.14 8.77 4.19.35.27.63.21.84-.18 1.65-3.19 2.73-6.7 3.24-10.53-.48-.19-.53-.65-.14-1.36 2.09-3.59 4.76-13.21 2.3-17.68a.405.405 0 0 0-.75.1c-.76 3.1-1.76 6.06-3.01 8.87-.19.43-.45.68-.78.74-.29.05-.39-.07-.3-.36l2.79-8.73c.14-.43-.38-.77-.72-.47-.43.37-.71.9-.84 1.59-.01-.37-.37-.57-1.06-.59 4.15-4.98 5.35-10.61 3.6-16.89 2.09.33 2.68.21 1.76-.37.1-3.19.99-8.19-1.7-8.86-.41-.11-.55-.36-.4-.75.25-.65.31-1.13.19-1.43.64-.07.95-.41.94-1.04.11-.02.22-.04.34-.06.25-.05.38-.2.39-.45l.22-24.79a.67.67 0 0 0-.59-.67.659.659 0 0 0-.72.51c-.44 1.97-1.27 3.43-2.48 4.4-.88.85-1.44 1.72-1.69 2.63-.19.68-1.16.67-1.33-.02a21.65 21.65 0 0 1-.01-10.4c.09-.37-.32-.66-.63-.45-1.87 1.25-3.92 1.82-6.15 1.7A1.243 1.243 0 0 1 22.84 65c.81-1.4 1.9-2.5 3.29-3.29.35-.2.26-.73-.14-.8-2.79-.45-5.37-1.45-7.75-3.02-1.02-.67-.61-2.25.61-2.33l3.7-.24a.46.46 0 0 0 .38-.68c-.97-1.85-1.45-3.83-1.42-5.93 0-.86 1.01-1.33 1.68-.79l3.04 2.43c.28.23.57.24.87.05.37-.23.62-.52.74-.89.08-.23.24-.43.45-.56 1.61-.94 3.16-.57 4.65 1.11l-.59 2.44c-.21-1.35-.74-2.14-1.57-2.38-4.31-1.24-3.57 9.34 3.05 7.25 4.05-2.25 4.76-9.62 2.35-13.2-1.24-1.85-2.85-3.15-4.82-3.9-5.85-1.44-10.93 1.7-13.14 6.9-3.27 7.73.11 17.88 3.75 25.14.89 1.78 1.01 3.36 3.76 2.68-.13 1.05-.66 1.61-1.6 1.69.96 1.75 2.38 3.15 4.27 4.2-.19.55-.56.91-1.12 1.09-.25.07-.41.24-.47.49-.17.71-.03.83.4.36l.12.48c-.94.47-1.32 1.03-1.14 1.69a.48.48 0 0 1-.7.54c-.34-.19-.75-.69-1.22-1.52l-.65-3.64c-.1-.57-.28-.6-.55-.08-.31.6-.39 1.3-.26 2.09l-.42.44c-.62.66-1.7.02-1.42-.84.74-2.32.91-4.69.51-7.11-.03-.18-.11-.35-.22-.49-.73-.93-1.42-1.02-2.09-.28l-1.57 4.34-1.11.16.85-4.27 2.02-2.52c.23-.29.27-.6.12-.94-2.29-5.06-3.81-10.29-4.56-15.69.03-.87-.26-1.5-.87-1.91.9-1.08 1.49-2.46 1.78-4.14.41-.59.6-.97.57-1.12-.27-1.22-1.8-1.65-2.66-.73-.48.51-1.17.74-2.08.7-.51-.69-1.49-1.07-2.94-1.16a.713.713 0 0 1-.67-.67c-.03-.39.19-.86.64-1.41.91.31 1.64.4 2.2.26 2.32.98 4.9.43 7.73-1.66.99-.73.22-2.3-.97-1.95-.37.11-1.02.07-1.95-.12-.09-.37.02-.81.32-1.3l5.01-.37c1.13-.04 1.9-.46 2.31-1.26.76.16 1.36.16 1.79-.01.43-.17.43-.34.02-.53l-4.44-2.01c.36-2.04.19-3.11-.51-3.21-.48-.93-1.05-1.63-1.71-2.1.19-.65.54-.95 1.04-.9 2.41 2.73 5.17 4.92 8.26 6.57.67.77 1.55.97 2.64.59.41 1 .87 1.47 1.37 1.4.39-.05.52-.26.4-.63-2.07-6.29-6.09-11.07-12.06-14.33.75-.65 1.64-.75 2.69-.3.83 1.33 1.67 1.93 2.52 1.8-.31-.64.21-.99 1.54-1.06l2.48 6.09c.47.75 1.01 1.27 1.61 1.58.41.21.67.08.77-.37l.23-1.05.09-3.52c.64-1.1 1.63-2 2.98-2.71 1.37-.84 2.1-1.66 2.19-2.46 1.18-.69 2.43-.93 3.74-.72 2.58-.45 4.67-1.48 6.28-3.1.29-.29.3-.63.02-1.04-.07-.49.04-1.06.33-1.7.63.05 1.3.31 2.01.76.27.17.55.21.86.14 8.72-2.15 16.53-1.69 24.74 2.13 6.33 2.95 12.76 5.34 19.28 7.17 1.49-.41 2.29-1.23 2.42-2.46.03-.31.33-.52.63-.45.99.25 1.81-.04 2.45-.88.19-.26.45-.39.78-.39h.5c.43 0 .57.58.18.77-1.77.87-3.19 2.01-4.24 3.43 1.55 1.89 1.48 3.17-.21 3.85-.27-.55-.66-.93-1.15-1.15a.88.88 0 0 0-.86.05l-7.52 4.45-3.43 1.58L78.1 35c-.47.11-.65-.08-.56-.55.27-1.29.11-1.95-.47-1.98-1.99-1.35-4.26-2.1-6.82-2.23-.43-.31-.54-.66-.34-1.03.14-.27.35-.5.62-.67.31-.2.3-.38-.03-.55-2.67-1.35-5.5-1.72-8.49-1.13-.34.07-.39.23-.16.49.96 1.05 2.05 1.88 3.27 2.48.27.13.48.32.64.57.45.72 1.08 1.14 1.87 1.27.35.06.63.23.84.52l.8 1.1c.19.27.45.42.78.47 2.86.45 4.11 2.54 5.88 3.53 2.27 1.27 4.39 1.82 6.36 1.64.79-.17 1.31.12 1.57.87.11.31.33.5.64.57.23.05.5.04.79-.03.17.05.25.15.24.29 1.03 1.47 2.27 2.09 3.7 1.86l5.52.7c1.85.08 3.29-.4 4.33-1.44.9.71 1.61 1.09 2.12 1.14 1.82-.87 2.61-1.06 2.37-.56 3.27-.08 6.49-.69 9.67-1.84 4.22-1.52 5.54-6.93 5.97-11.03 1.08-3.11 3.16-5.52 6.25-7.23 3.45.21 5.42-1.32 5.92-4.61l1.3-4.19c.23-.73.09-.8-.41-.23-7.18 8.28-16.09 13.06-26.74 14.33-1.09-.68-2.17-.81-3.23-.4-.32-.17-.12-.62.59-1.34 1.49-.26 2.76-1.08 3.82-2.47l1.49-.15c.03.07.07.16.1.25.04.11.12.15.23.12 11.96-3.38 20.15-8.77 27.7-18.63a2.267 2.267 0 0 1 3.23-.37c1.1.91 2.24 2.09 3.43 3.55 6.42 7.88 14.77 13 25.05 15.37ZM139.15 7.85l-.34 32.74c-.01.91.2.96.63.16 2.56-4.81 6.14-12.86 4.86-18.37a93.62 93.62 0 0 0-4.68-14.62c-.1-.25-.47-.18-.47.09Zm-2.51.15c-4.7 11.69-7.33 21.07.27 32.25.3.44.45.39.44-.14l-.1-31.99c0-.35-.48-.44-.61-.12ZM72.39 27.33c1.35.6 2.3 1.39 2.85 2.37.16.27.38.48.67.62 1.37.64 2.56 1.54 3.58 2.71.23.27.6.37.93.26l5.41-1.71 6.1-3.37c.38-.21.36-.37-.07-.47-15.45-3.61-25.85-14.15-43.01-8.13-.25.09-.26.44-.02.54l5.44 2.29c.27.11.55.11.83 0 4.49-1.83 8.74-1.44 12.75 1.16.29.19.48.44.59.76.47 1.37 1.78 2.36 3.95 2.97ZM34.34 37.79c1.37 3.47 3.73 5.11 7.66 5.08 2.64 0 7.5 1.15 7.51-3 1.67-2.82-.44-6.92-3.79-6.92-5.57 0-1.7 8.58 1.39 3.99.26-.39.51-.39.76.01.33.53.13 1.1-.62 1.73-1.44 1.01-2.96 1.13-4.57.37-2.23-2.43-2.23-4.55.01-6.38.35-.28.25-.84-.17-.99a9.38 9.38 0 0 1-4.09-2.82c-.57-.66-.16-1.68.7-1.79 2.09-.25 4.06.14 5.91 1.18.58.32 1.24-.24 1.01-.86-.46-1.21-.52-2.47-.19-3.77a.49.49 0 0 1 .74-.3c2.12 1.31 3.45 3.18 3.99 5.6.03.16 0 .3-.12.42l-.33.32c-.14.15-.23.12-.27-.08a7.471 7.471 0 0 0-1.74-3.54.368.368 0 0 0-.48-.07c-.15.09-.22.28-.15.45l.89 2.25c.13.31.12.61 0 .92-1.35 3.16 2.77 4.93 4.23 1.69.12-.27.3-.48.54-.65l3.15-2.15c.99-.67 2.25.35 1.79 1.45l-2.34 5.67c-.2.48.25.98.75.83 2.99-.89 6.03-1.09 9.11-.62.57.09.84.75.5 1.21l-1.62 2.22c-1.17 1.27-2.67 2.28-4.52 3.02-.28.11-.2.53.1.53l23.5.36c.75.01.79-.15.1-.46l-8.38-3.84c-5.63-3.43-10.89-7.09-15.78-10.99-5.71-4.55-14.6-8.8-21.51-4.52-5.04 3.12-5.48 9.29-3.66 14.45Zm199.03 5.04c11.45 1.68 13.45-18.86 1.82-20.34-6.21-3.02-14.48 2.17-19.45 6.23-7.15 5.85-14.96 10.49-23.45 13.93-.2.08-.14.38.08.38l24.22-.23c.3 0 .39-.42.11-.54a17.865 17.865 0 0 1-6.47-4.85c-.53-.63-.15-1.6.67-1.7 3.09-.39 6.13-.18 9.12.65.35.1.47-.03.36-.38l-2.04-6.27a.884.884 0 0 1 1.07-1.13c1.96.54 3.57 1.59 4.84 3.14.28.35.46.3.53-.14.55-3.23 2.04-5.92 4.48-8.07.42-.37 1.09-.06 1.07.5l-.11 3.72c-.02.52.55.84.99.57 1.6-.98 3.38-1.42 5.33-1.31 1.44.08 1.91 1.96.68 2.71l-3.37 2.05a.55.55 0 0 0-.12.86c3.85 4.01-.15 8.25-5.07 6.49-.93-.33-1.19-1.51-.5-2.21l.3-.3c.29-.29.51-.24.65.15.27.74.78 1.17 1.55 1.3 1.22.2 2.4-.53 2.75-1.71 1.01-3.33-3.9-4.42-5.6-2.43-2.3 2.69-2.26 5.56.11 8.61.17.23.41.35.7.35l4.75-.03ZM61.29 23.79l2.77-.38a.3.3 0 0 0 .26-.29c0-.14-.1-.27-.24-.3-2.13-.43-4.23-.33-6.29.29-.58.17-.69.95-.17 1.27 2.15 1.31 4.48 1.66 6.97 1.03.14-.04.24-.17.23-.32a.301.301 0 0 0-.28-.28l-3.22-.26a.405.405 0 0 1-.36-.37c0-.2.14-.36.33-.39Zm65.88 0c-5.36.96-7.23 8.16-7.87 12.84-.03.21.03.25.2.11 4.02-3.25 6.75-7.38 8.19-12.38.13-.46-.05-.65-.52-.57Zm1.93.2c-1.19 5.63-4.09 10.19-8.71 13.66-.45.34-.11 1.06.44.92 6.34-1.63 8.87-8.48 8.76-14.53 0-.13-.1-.23-.22-.24-.13-.02-.24.07-.27.19Zm19.69.26c.93 4.35 4.26 10.24 8.03 12.62.32.21.43.13.34-.24-1.36-5.28-2.14-11.34-7.96-12.77-.35-.09-.48.04-.41.39Zm77.4 8.45c1.9-.81 2.63-2.21 2.18-4.22-.05-.23-.04-.47.02-.7l.45-1.71a.51.51 0 0 0-.33-.61.5.5 0 0 0-.62.3l-2.39 6.29c-.29.75-.06.96.69.65Zm-79.08-6.33c.16 4.2 3.07 12.55 8.53 11.88.51-.06.56-.25.17-.58-3.71-3.11-6.48-6.9-8.31-11.38-.09-.21-.4-.15-.39.08ZM40.36 29.14l4.82 2.34c.06.03.13.01.16-.05l.02-.05c.43-.87-.3-2.09-1.61-2.72l-.28-.14c-1.32-.64-2.72-.45-3.14.42l-.03.04c-.02.06 0 .13.06.16Zm195.44-.85c-.2-.42-1.58-.18-3.09.55-1.51.72-2.56 1.65-2.36 2.06.2.42 1.58.18 3.09-.55 1.51-.72 2.56-1.65 2.36-2.06Zm-106.45 4.56c-4.06 9.98-10.1 4.38-16.74 9.38-.28.21-.13.65.22.65h22.02c.37 0 .56-.18.59-.55.07-.83-.21-1.51-.82-2.02l-4.05-10.68c-.17-.43-.31-.42-.42.03l-.8 3.19Zm-73-2.61c-3.27.6-5.84 4.45-5.07 7.56.09.37.48.59.85.47 2.39-.75 3.91-5.89 4.63-7.51.19-.43.05-.61-.41-.52Zm99.36 12.67 8.56.16c.49.01.54-.14.15-.43-3.28-2.49-6.79-3.39-10.54-2.7-4.7-1.74-7.21-4.91-7.52-9.5-.02-.24-.34-.3-.44-.08l-5.59 12.03c-.11.23.06.5.32.5l15.06.02Zm68.35-6.64c.07.07.17.11.3.11.28 0 .51-.23.49-.51-.11-1.71-.87-3.06-2.26-4.07-.29-.21-.61-.3-.96-.26-.45.05-.83-.11-1.14-.5-.23-.29-.69-.06-.59.3.73 2.65 1.8 4.82 3.2 6.49.28.34.67.42 1.16.24.45-.16.48-.38.09-.65-.35-.25-.53-.59-.55-1.04 0-.25.07-.29.26-.11ZM62.6 38.23l-9.75 3.76a.561.561 0 0 0 .29 1.08c3.67-.55 6.83-1.94 9.49-4.17.49-.41.71-.8.67-1.19-.07-.63-.41-.94-1.04-.95-4.29-.05-8 1.34-11.13 4.16-.31.28 0 .78.39.63l10.47-3.99c.16-.06.35-.02.47.1l.22.21c.16.16.13.28-.08.36Zm161.67 1.95c-3.19-2.5-6.85-3.62-10.96-3.36-.33.02-.48.42-.25.66.31.33.71.45 1.2.38.38-.06.75-.03 1.11.1l8.46 3.02c1.8.64 1.95.37.44-.8Zm-.43 1.97-10.21-3.98c-.05-.02-.11 0-.13.06-.33.84 1.66 2.4 4.45 3.49l.31.12c2.79 1.09 5.31 1.29 5.64.44.02-.05-.01-.11-.06-.13Zm33.06 13.18c.76.45 1.48.52 2.16.23.29-.13.44-.35.45-.66.25-4.87-1.18-8.77-4.29-11.69-5.51-5.47-12.08-4.03-16.05 2.31-.17.27-.26.56-.25.88.11 4.12-.86 9.5 4.08 11.25.31.11.61.12.92.04 3.52-.91 6.14-3.68 3.26-7.13-.21-.26-.51-.41-.83-.44-1.38-.13-2.1.5-2.17 1.87a.545.545 0 0 1-1.09.03c-.43-3.67 3.84-4.93 5.98-1.71.23.33.68.4.99.15l2.61-2.2c.62-.52 1.35-.69 1.77-.41.19.13.27.47.23 1.04-.13 1.93-.45 3.88-.97 5.85-.11.39.04.58.44.58h2.76ZM81.52 45.21l-22.97.04-16.85-.71a.468.468 0 0 0-.32.83l7.72 6.37c.29.24.63.36 1.01.37l25.65.21c19.65.72 32 .96 37.05.73 9.1-.41 18.2-.45 27.29-.12.14.01.21.08.21.21 0 .11 0 .22.01.34 0 .16-.07.23-.22.21-1.62-.17-2.81.24-3.57 1.25l-85.78.03c-.41 0-.61.2-.62.61l-.22 13.38L50 83.6l.12 12.27-.07 28.61-.22 14.28.03 1.35.28 13.61-.08 4.07.02 20.64.07 5.09c-.28.81-.34 1.34-.19 1.6l-.17 1.23c-.04.34-.12.35-.24.03-.11-.31-.34-.35-.69-.14a.746.746 0 0 1-1.12-.54c-.32-2.27-.29-4.94.1-8.01.98-7.83-.36-16.72-.23-23.99.23-12.9-.55-25.94.12-38.79.11-2-.57-3.92-.39-6.06 1.03-12.53-.07-25.55.27-38.15.13-4.73-.35-10.66.13-16.03.03-.34-.08-.63-.32-.87l-.87-.87-7.15-7.22c-.35-.36-.52-.29-.5.22l.43 14 .32 11.84c-.58 25.17-.69 41.21-.32 48.12.22 4.21.31 7.65.26 10.34-.32 18.68.02 37.4-.21 56.1-.09 7.25-.01 14.49.24 21.73.19 5.49-.37 11.42-.34 16.33.13 22.84-.02 45.7-.45 68.58 0 .16.19.25.3.14l8.19-7.79c.66-.62.87-1.2.63-1.73-.11-.23-.16-.48-.15-.74.18-7.08.84-14.71.34-21.74-.09-1.4.46-2.19 1.65-2.38.05-.28.19-.11.41.51-.44 1.13-.47 2.54-.08 4.23-.07 5.81-.09 12.08-.06 18.81 0 1.17-.4 1.82.26 3.13l-6.8 6.2c-.51.02-1.08.53-1.7 1.52-.19.32-.1.48.27.47 28.15-.17 56.3-.16 84.45.05 4.5.03 10.68.61 16.05.41 30.34-1.17 60.9-.58 91.15-.44.63 0 .92-.79.43-1.2l-6.57-5.47a.786.786 0 0 1-.28-.65c.03-.51-.05-.91-.24-1.21l.23-1.38 2.44 2.27 6.63 6.77c.46.46 1.24.12 1.22-.53-1.57-42.98-.29-86.02-.72-129.01-.19-19.16.46-38.42-.31-57.56-.27-6.73-.31-12.07-.1-16.02.67-12.99.89-25.99.66-39.02-.24-1.76-.15-3.38.26-4.87.09-.31-.29-.53-.52-.31l-8.5 8.13c-.12.11-.22.23-.29.38l-.91 1.81c.22-.19.22-.4.01-.63a.5.5 0 0 0-.38-.17l-10.25-.04-71.23-.02c-1.51-.61-1.4-1.37.35-2.28.23-.12.48-.18.73-.17 11.63.35 23.1.38 34.41.08 1.55-.04 2.96.64 4.35.61 13.03-.26 26.09-.33 39.2-.2 1.94.45 3.51-.43 4.72-2.63.03-.06.07-.11.12-.15l5.52-4.63c.53-.45.45-.68-.25-.69-20.26-.34-41.77.17-66.14-.08-22.99-.24-43.85-.08-65.77-.13-7.01-.02-14.02.18-21.04.59Zm183.77 9.93-3.67-6.17a.734.734 0 0 0-.93-.29c-.34.16-.5.55-.38.9.84 2.44 2.22 4.52 4.13 6.25.2.18.51.19.72.02.22-.17.27-.47.13-.71Zm-12.21-5.21c-2.83.75-4.58 2.83-2.25 5.42.19.22.53.21.71-.01a9.205 9.205 0 0 0 2.06-4.97c.05-.4-.13-.55-.52-.44Zm-228.49.31c-1.38-.75-1.97-.35-1.76 1.21.25 1.86 1.06 3.22 2.45 4.09.27.17.48.11.64-.17 1.27-2.24.83-3.95-1.33-5.13Zm235.07 13.38-2.66 8c-.04.99-.35 1.63-.93 1.94.02.25 0 .44-.06.58-.57.35-.88.85-.94 1.5a4.99 4.99 0 0 0-.57 2.37l-1.63 1.74c-.83 2.39-1.15 4.65-.97 6.78-.71.18-.99.8-.82 1.87-.31.65-.39 1.48-.24 2.48-2.47 4.33.15 7.46 1.9 11.34.54 1.2 2.2 1.32 2.9.2.17-.27.07-.62-.32-1.04l-1.31-7.42c.9-.82 1.99-.85 3.27-.08-1.16 2.91-1.23 6.53-.21 10.84.16.67-.55 1.21-1.16.89-2.1-1.11-3.72-2.68-4.87-4.71-.12-.21-.44-.1-.4.14.69 4.15 2.55 7.62 5.59 10.43.31.28.8.18.97-.2 7.38-16.6 13.09-37.9 5.43-55.44-.32-.72-1.37-.6-1.52.17l-1.45 7.62ZM28.33 58c-.8-1.65-2.07-1.61-3.7-1.62-.6 0-.97.32-1.11.95-.07.28-.24.38-.51.31l-2.73-.71a.35.35 0 0 0-.42.21c-.08.16-.01.36.14.45 2.91 1.77 6.08 2.43 9.51 1.96.42-.06.48-.65.07-.78l-.57-.18c-.31-.1-.54-.3-.68-.59Zm224.48-.7v-.43c-.01-.33-.18-.49-.51-.49l-2.64.03c-.21 0-.42.08-.58.23l-2.52 2.4c-.24.23-.2.36.13.41 3.49.49 6.76-.17 9.8-1.97.11-.06.14-.15.1-.26-.03-.09-.06-.19-.09-.28-.03-.09-.14-.14-.23-.11l-2.83.92c-.41.13-.62-.02-.63-.45Zm2.41 2.48-4.73.98c-.47.1-.53.32-.19.65l3.1 3.07c.42.66.53 1.24.32 1.73-.1.23-.31.41-.62.54-.34.13-.61.2-.82.2-2.36-.21-4.5-.86-6.42-1.97-.5-.29-.66-.15-.48.4 1.1 3.39 1.21 6.8.32 10.23-.29 1.15-.76 1.23-1.4.23l-4.57-7.13c-.18-.28-.61-.16-.61.17l.08 29.31c-.48 2.79-.47 5.73.04 8.82.02.11.11.19.22.18.11 0 .2-.08.21-.19.31-3.07 1.17-6.25 2.56-9.52.28-.42.36-.91.25-1.47a.99.99 0 0 1 .26-.88c.86-.91 1.46-1.99 1.79-3.23.19-.71.04-.79-.45-.25l-3.61 3.94a.4.4 0 0 1-.54.05.395.395 0 0 1-.11-.53l2.77-4.71 1.52-1.96c2.15-.67 3.64-2.29 4.45-4.86.71-.2 1.02-.57.95-1.1a.637.637 0 0 0-.52-.53c-.61-.09-.86-.47-.75-1.13l3.39-3.12.22-.22c.22-.22.21-.43-.03-.63l-1.46-1.23c-.55-.46-.47-.7.25-.71l1.97-.03c.31 0 .55-.15.7-.42a56.921 56.921 0 0 0 5.99-16.29c.13-.61-.64-1-1.06-.54-.93 1.01-1.93 1.72-2.99 2.15Zm-15.47 2.13c.07 4.29 1.55 7.89 4.42 10.8.83-5.73-.32-10.39-3.46-13.97-.23-.26-.42-.24-.59.06-.69 1.2-.81 2.24-.37 3.11ZM33.27 71.54c2.41-3.48 3.48-7.29 3.21-11.43-.39-.13-.61-.43-.67-.89-.05-.39-.58-.5-.77-.15a31.325 31.325 0 0 0-3.86 11.69c-.07.57.14 1.13.55 1.51.75.69 1.27.44 1.54-.73Zm218-6.57c-.86-.29-1.3-.72-1.31-1.29 0-.34-.12-.63-.35-.88-1.1-1.21-2.49-2.08-4.17-2.61-1.15-.36-2.02 1.04-1.2 1.91 1.84 1.95 4.12 3.14 6.85 3.58.19.03.37-.09.42-.27a.376.376 0 0 0-.24-.44ZM30.25 60.83c-.18-.28-.98-.1-1.78.42-.79.52-1.29 1.17-1.1 1.46.18.28.98.1 1.78-.42.79-.52 1.29-1.17 1.1-1.46Zm.95 1.34L25.09 65c-.06.03-.09.11-.06.17.27.57 1.83.4 3.5-.37l.29-.14c1.67-.77 2.81-1.86 2.55-2.42-.03-.07-.1-.1-.16-.07Zm207.4 77.76-.4 23.29c0 .14.1.27.25.29.14.02.28-.06.32-.2 1.03-3.24 2.61-6.19 4.76-8.84.14-.18.18-.38.11-.59l-4.7-14.01c-.03-.08-.11-.13-.19-.11-.09.01-.15.08-.15.17ZM37.81 162.1l-.02-21.58c0-.13-.09-.24-.22-.26a.276.276 0 0 0-.3.18l-3.99 11.51c-.34.98-.26 2.05.22 2.96l3.8 7.31c.34.67.51.63.51-.12Zm-.72 13.62c-.89 2.98-2.29 5.68-4.2 8.1-.22.27-.27.57-.16.9l4.7 13.64s.05.06.08.05c.04 0 .07-.03.07-.07.2-7.52 1.06-15.22-.08-22.59-.04-.22-.35-.24-.41-.03Zm220.39 67.86c-.25.67-.61 1.11-1.08 1.33-.32.14-.62.11-.89-.1-.7-.55-1.05-1.28-1.04-2.2l.94-5.94c.3-.57.36-.95.19-1.13-.8-.8-2.14-.59-2.67.41-1.75 3.3-4.3 6.72-2.19 10.65.16.3.21.61.15.94-.36 1.85-.02 3.49 1.01 4.93l.74 5.2c.07.49.24.52.49.1.44-.72.66-1.69.66-2.91l1.76.16-.69 7.87c.94 1.09 1.6 2.47 1.97 4.15 2.31 5.24 3.73 10.29 4.26 15.15.23 2.04.78 2.13 1.65.27 1.8-3.81 2.75-7.51 2.86-11.09 2.51-14.55-2.6-30.6-8.32-43.98-.3-.7-.73-.79-1.28-.27-2.79 2.63-4.57 5.83-5.35 9.61-.07.32.33.53.55.28l3.26-3.73c.79-.9 2.27-.4 2.36.79.19 2.55-.17 4.97-1.09 7.26-.12.31.04.66.36.75 1.05.3 1.51.8 1.39 1.5Zm-18.49-10.52c-.27 2.13-.28 4.25 0 6.38.04.35.22.6.55.75l.68.32c.35.16.55.43.6.82.27 2.07 1.28 3.67 3.04 4.81.14.09.32.07.43-.06.11-.12.12-.3.02-.43-2.34-2.99-3.75-9.34-4.64-12.63-.3-1.11-.52-1.1-.67.04Zm14.57 38.83c.2.31.28.55.24.72a9.481 9.481 0 0 1-3.58 4.14c-.32.21-.24.69.13.78l5.25 1.25 2.89 2.13c.35.26.83-.05.75-.47a55.276 55.276 0 0 0-5.84-16.17c-.19-.35-.48-.54-.87-.57-.85-.07-1.26-.59-1.21-1.55 0-.25.14-.41.39-.48.4-.1.5-.21.29-.34-1.29-1.83-2.87-3.3-4.73-4.41.28-.71.63-1.08 1.04-1.1l.59.49c.41.35.53.26.36-.25-.93-2.71-2.49-4.81-4.68-6.32-.56-.01-1.18-.54-1.85-1.57l-3.18-4.48c-.18-.25-.57-.12-.57.19l.12 25.81c0 .36.48.47.64.16l2.31-4.44c.06-.12.15-.21.27-.28 1.02-.59 1.62-1.48 1.79-2.66.06-.4.4-.7.8-.71.41-.01.76.27.84.67.69 3.49.62 6.98-.21 10.45-.07.29.23.54.5.41 2.39-1.1 4.73-2.91 7.52-1.4ZM36.45 277.9c.23-4.19-.84-7.93-3.2-11.21-.08-1.17-.59-1.39-1.54-.68-.35.27-.54.71-.5 1.16.43 4.31 1.68 8.36 3.76 12.16.21.37.46.41.76.1.47-.47.71-.98.72-1.53Zm206.28-10.57c-1.87 2.45-2.8 5.34-2.81 8.69-.85.92-.76 2.17.27 3.75.22.33.44.34.67.01 2.83-3.95 4.01-8.35 3.56-13.18-.07-.7-1.02-.85-1.3-.2l-.39.93Zm-217 6.98c.11 1.94 4.35 3.71 5.98 4.13a.73.73 0 0 0 .83-1.05c-1.55-2.83-3.98-4.38-7.3-4.66-.52-.04-.6.12-.23.49l.41.41c.19.19.3.41.31.68Zm224.77-.41.76-.56c.17-.13.23-.36.13-.55a.44.44 0 0 0-.52-.23c-2.61.76-6.93 2.12-7.02 5.39-.01.33.16.47.49.41 2.18-.43 4.05-1.4 5.6-2.91.25-.23.37-.52.37-.87v-.3c0-.16.06-.29.19-.38Zm-4.13 5.26c1.48 1.68 2.63 2.62 3.46 2.82.26.07.42.23.47.49l.14.7c-.75 1.62-.78 2.86-.1 3.73-.3.41-.73.78-1.3 1.11-1.61 3.13-5.76 2.19-6.01-1.11-.03-.43.15-.69.54-.8.27-.08.45.02.54.29l.25.82c.45 1.43 2.35 1.69 3.16.44 4.86-7.5-11.1-10.99-8.31 2.08-1.62 4.67 4.57 8.76 8.62 8.73 8.24-.04 11.88-8.31 11.53-15.54 0-.28-.16-.41-.45-.38l-3.94.42c-.38.04-.72-.06-1.01-.31-.67-.57-.64-1.12.08-1.66l2.03.63c.2.06.41-.03.5-.22.09-.18.03-.4-.14-.52-2.85-1.95-6.2-2.53-10.06-1.72Zm-12.77 16.32-5.05-.03c-.36 0-.64.15-.85.44-1.99 2.85-2 10.4 3.37 9.42 5.23-.97.94-8.1-2.18-3.6-.18.27-.59.23-.71-.07-.22-.53-.12-1.06.3-1.58 3.22-4 9.22.79 5.18 5.62-.25.31-.21.56.13.76l2.79 1.71 1.28 1.46c.79.91-.04 2.3-1.22 2.04l-2.94-.65-3.28-1.31c-.42-.17-.61-.03-.56.42l.47 4.09c-.25 0-.56.26-.93.79-2.25-2.14-3.81-4.82-4.67-8.05a.473.473 0 0 0-.84-.16c-1.16 1.61-2.71 2.66-4.65 3.15a.64.64 0 0 1-.8-.67c.21-2.46.9-4.76 2.08-6.9.37-.66.21-.82-.46-.48l-1.08.56c-.23.12-.48.2-.74.23-2.53.32-5.06.27-7.59-.15-.6-.1-.87-.8-.49-1.27 1.73-2.15 3.85-3.81 6.37-4.97.45-.21.3-.89-.2-.89h-23.51c-.37 0-.46.51-.11.64 10.22 3.79 17.57 9.24 27.01 16.7 1.97 1.57 5.16 2.91 9.57 4.03 4.03.48 7.5-.42 10.4-2.71 5.98-4.72 3.62-20.33-6.09-18.57Zm-195.24 19.6c10.23 5.63 20.52-4.07 28.29-9.82a73.48 73.48 0 0 1 16.76-9.32c.28-.11.2-.53-.1-.53H59c-.14 0-.27.09-.29.24-.02.14.06.28.2.32 2.64.85 4.91 2.43 6.81 4.75l.42.94c.19.42.06.66-.4.71l-3.83.46-6.15-.98c-.41-.07-.52.09-.35.46l2.17 4.64c.61 1.21.64 2.15.07 2.81-.25.29-.54.34-.87.16l-2.14-1.11-2.85-2.09c.21-.68-.21-1.14-1.24-1.38-1.4-.33-2.7.82-2.54 2.24a9.12 9.12 0 0 1-.76 4.81c-.03.07 0 .15.07.17l.27.09c.25.09.53-.03.64-.27.59-1.24 1.38-2.26 2.37-3.07l-1.25 2.85c-.81 1.56-1.77 2.44-2.88 2.63-.27.05-.47-.05-.62-.28-.09-.15-.11-.27-.05-.38l.28-3.52c.05-.54-.53-.9-1-.63-2.09 1.21-4.34 1.6-6.74 1.19a.527.527 0 0 1-.36-.8c1.04-1.67 2.47-2.86 4.3-3.57.61-.23.72-1.06.19-1.45-4.17-3.11 1.25-9.07 5.25-5.66.61.52.62 1.16.03 1.93-.23.31-.44.3-.65-.02-.9-1.37-2.03-1.62-3.38-.75-.29.19-.48.45-.56.78-1.74 7.66 11.79 2.75 5.28-5.83a.916.916 0 0 0-.79-.4c-3.02-.03-7.56-.68-10.08 1.05-4.93 3.39-4.95 11.12-2.55 16.07.09.18.21.33.37.44l2.97 2.12Zm13.92-16.73c3.1 2.47 6.69 3.5 10.76 3.08l.5-.7c.2-.27.19-.54-.03-.79-.17-.2-.33-.29-.48-.26-3.23-2.79-6.78-4.17-10.66-4.12-.43-.04-.87.33-1.33 1.12-.19.32-.15.62.1.89.31.33.69.59 1.14.78Zm161.47 1.8 10.46-4s.01 0 0-.01v-.05c-.35-.88-2.86-.75-5.62.3l-.5.19c-2.75 1.06-4.71 2.63-4.37 3.52v.04s.02.01.03.01Zm1.47.37c-.23.08-.78.05-1.65-.1-.15-.03-.35-.04-.59-.03-.32.01-.46.25-.3.54.16.3.55.55.89.57 4.41.31 8.19-1.03 11.34-4 .22-.21-.01-.58-.3-.47l-9.39 3.49ZM55.6 307.81c.18.27.44.38.78.34.49-.07.63-.33.42-.78l-3.15-6.74c-.5-1.07-2.08-.97-2.67.17-.89 1.71 1.96 5.36 3.08 6.4.12.12.27.18.44.19.09 0 .19 0 .29-.01.35 0 .62.13.81.43Zm167.48-7.67-3.71 6.91c-.04.08-.01.17.07.21h.03c1.44.78 3.43-.13 4.44-2.03l.16-.3c1.02-1.9.68-4.06-.75-4.83l-.04-.02c-.07-.04-.16-.01-.2.06Zm5.3 10.31.33-.11c.17-.06.26-.18.27-.36.04-2.16-.85-3.68-2.67-4.56a.581.581 0 0 0-.8.71l2.18 6.43c.25.73.52.74.82.03.29-.69.24-1.37-.16-2.06-.02-.04-.01-.07.03-.08Zm-182.99-3.47-5.2 2.19c-.07.03-.1.1-.07.17l.02.05c.38.9 1.83 1.16 3.23.57l.36-.15c1.4-.59 2.23-1.8 1.85-2.71l-.02-.05a.143.143 0 0 0-.17-.07Zm190.84 2.16-5.39-2.35c-.09-.04-.19 0-.23.09l-.05.12c-.39.89.43 2.1 1.83 2.71l.64.28c1.4.61 2.84.39 3.23-.5l.05-.12c.04-.09 0-.19-.08-.23Z"
      style={{
        fill: "#cc9d28",
      }}
    />
    <path
      d="M177.35 119.2c4.41.3 8.84.46 13.27.47 4.77.01 9.6.76 14.45 1 2.81.13 3.92 2.26 5.7 3.25 2.21 1.23 4.49 2.34 6.86 3.34l-4.58.95c-.33.07-.62.22-.86.46-1.79 1.77-4.25 2.34-7.39 1.71-1.21-.24-1.77.32-1.7 1.67 0 .27.2.5.46.58 3.72 1.06 6.55-.77 9.52-.46 4.7.48 11.05 4.18 13.99 6.25l-.02 4.74-3.91 2.31c-.28.17-.63.19-.93.06-3.03-1.32-6.17-1.66-9.42-1.02-1.19.23-2.21.09-3.07-.44a.813.813 0 0 1-.33-1.02c.15-.37.56-.58.95-.48 1.55.37 2.81-.01 3.8-1.15.09-.1.21-.18.34-.23l3.24-1.08c.23-.08.34-.24.34-.47 0-.09.02-.2.07-.32a.819.819 0 0 0-.97-1.07 26.4 26.4 0 0 1-10.02.58c-1.5-.2-2.91-.13-4.22.21-6.5 1.67-13.1 2.2-19.81 1.6-3.66-.33-4.72 1.8-2.96 4.96-.64-.37-.95-.41-.92-.1l-1.88-26.3Z"
      style={{
        fill: "#4b5240",
      }}
    />
    <path d="m155.21 67.39 4.94 3.73c8.56 7.32 12.11 12.4 14.65 23.37l.79 4.85 1.29 10.56.2 2.92.27 6.38 1.88 26.3-1.46 9.48 2.06 5.55c10.6 10.97 17.41 16.67 19.19 29.94 2.1 6.08 5.42 11.15 7.06 17.35.92 5.09 1.07 8.85-.67 14.08a68.967 68.967 0 0 0-2.38 9.16l1.45 8.96 3 13.06 2.32 32.17-3.47.11c-.35-10.35-.93-20.66-1.74-30.95-.4-5.05-1.29-9.33-2.73-13.9a.727.727 0 0 0-1.22-.28l-19.24 20.02c-.11.12-.25.2-.41.23-3.12.63-6.28 1.02-9.47 1.16-.35.02-.7-.12-.93-.39-3.78-4.3-7.11-3.66-13.53-3.46-3.73.11-7.49.2-11.26.26-.43 0-.63.23-.6.66.11 1.39.31 3.86.62 7.43.1 1.17-.38 1.79-1.45 1.86-1 .07-1.65.15-1.96.25-10.14 3.36-20.27 6.8-30.4 10.33-.31.11-.61.1-.91-.01a58.294 58.294 0 0 1-14.89-8c-.27-.2-.44-.52-.47-.86l-.67-10.61c-.03-.54.25-1.06.73-1.33l3.59-2.03c.35-.19.53-.49.56-.88.25-3.09 1.36-5.77 3.35-8.03.63-.72.69-1.4 1.29-2.22a.378.378 0 0 0-.33-.6c-4.11.24-8.11 1.23-11.05 4.45-7.09 7.74-20.06 15.13-29.87 7.22-.27-.22-.58-.26-.91-.13-4.25 1.76-8.35 4.4-12.31 7.91-.39-1.69-.36-3.1.08-4.23l8.93-5.24c.32-.19.38-.43.18-.74l-2.22-3.47c-.99-3.32-.61-6.88 1.14-10.67 1.59-3.24 2.45-6.85 2.58-10.83.11-3.39.86-5.31 2.14-8.21l5.6-12.36 4.59-12.47.68-1.52 1.74-5.89 1.26-3.12c1.87-5.28 5.15-9.86 9.84-13.74l8.62-6.28c.23-.17.29-.49.13-.72-2.67-3.92-3.34-8.2-2.01-12.84.11-.4-.04-.62-.46-.65-3.75-.31-7.08-1.37-10-3.2-2.85-2.19-3-4.9-.44-8.12l1.43-2.51c3.31-5.21 7.04-10.15 11.21-14.83.46-.52.57-1.26.28-1.88-2.16-4.76-.41-11.82.15-16.97l-.02-3.99c0-.33-.11-.62-.33-.87-1.95-2.17-1.91-4.23.11-6.18.25-.25.35-.54.29-.89-.96-5.66.87-11.15 5.5-16.47 4.17-3.77 7.67-6.57 10.51-8.38 14.22-9.09 29.71-7.49 43.58 1.2Zm-9.24 2.89c5.09 3.47 8.89 7.87 11.39 13.19.65 2.83 1.17 5.65 2.88 8.09.85 1.23.68 2.21-.52 2.96-1.97 4.93-3.31 10.33-4.04 16.18-.73 5.95.39 11.36 3.36 16.21.18.29.22.65.11.98l-1.87 5.56c-1.04 1.93-1.81 3.75-2.32 5.45-.72 2.45-.06 5.36-.14 8.08-.03 1.26-.72 2.17-.8 3.53-.11 1.92 1.83 4.61 2.57 6.51.12.3.11.64-.04.93a14.35 14.35 0 0 0-1.38 4.29c-.78 5.31 4.74 8.17 1.27 13.62-.17.28-.25.61-.2.94.13.87.62 1.79 1.45 2.75l3.07 3.18c.44.45 1.18-.04.93-.62-1.51-3.46-.75-6.43 2.29-8.91.83-.65.98-1.56.43-2.75-.87-1.91-.9-3.77 1.2-4.52 5.06-1.8 1.99-5.05 3.98-8.54l4.43-2.79c.26-.16.4-.47.36-.78-.35-2.75-.05-5.37.9-7.87.53-1.39.77-2.65.72-3.77-.83-17.33-1.49-34.66-5.95-51.79-1.57-6.02-4.75-10.85-9.55-14.49-5.73-5.91-13.44-9.73-23.13-11.48l-7.16-1.53c-.29-.06-.6.03-.82.25-.93.95-1.39 2.08-1.4 3.39 0 .4.19.59.59.56 4.74-.32 9 .26 12.79 1.75 2.1.82 3.63 1.3 4.6 1.44ZM99.91 89.6c3.34-9.61 13.73-24.36 25.65-23.41.37.03.61-.13.74-.48l.26-.69c.57-1.56.07-2.09-1.52-1.59-10.73 3.42-27.89 12.91-26.69 25.98.08.86 1.28 1.01 1.56.19Zm14.3 5.79c-1.68 4.53-6.71 6.08-11.27 6.26-.37.02-.54.21-.5.58l.81 8.04c.04.38.51.53.77.25 4.53-5.08 7.98-8.29 10.34-9.62 8.76-4.93 15.67 2.17 23.64 8.09 3.29 1.37 11.24 6.11 5.88 10.44-.27.22-.28.45-.04.7l3.41 3.47 4.21 7.39.97 4.01c.13.51.83.59 1.06.11l3.35-6.88c.12-.24.12-.53-.01-.76-4.96-9.22-5.59-17.35-1.96-27.88.15-.43 0-.64-.45-.64-1.34.01-2.36.22-3.05.61l-4.01.04-6.38-1.52c-2.5-1.66-3.91-3.72-1.4-6.28 2.88-2.94 6.48-4.1 10.79-3.48l6.14 1.02c.4.07.57-.1.5-.5-1.77-10.22-10.32-17.79-20.49-19.24-1.53-.59-3.45-.85-5.78-.78-2.66.08-7.1-1.35-9.17-.46-9.31 4-15.71 10.78-19.2 20.35-.14.37-.01.57.38.62 5.38.69 9.86.82 11.46 6.06Zm41.58-1.8c-.02-.92-3.03-1.61-6.72-1.53-3.7.08-6.68.89-6.65 1.81.02.92 3.03 1.61 6.72 1.53 3.69-.08 6.67-.89 6.65-1.81Zm-46.32 1.73c0-.93-2.46-1.67-5.48-1.65-3.02.02-5.46.78-5.46 1.71 0 .93 2.46 1.67 5.48 1.65 3.02-.02 5.46-.78 5.46-1.71Zm5.86 9.6c-3.97 1.96-8.54 6.3-11.25 9.74-5.88 7.49-11.06 14.46-15.53 20.93-1.67 2.41-2.9 5.13-3.69 8.16-.08.3.03.4.32.29 9.91-3.7 23-3.02 32.71-.32 1.9.52 3.62.19 5.49-.05.33-.04.62-.21.83-.46a152.89 152.89 0 0 0 16.78-24.51c1.16-2.1.95-3.91-1.13-5.13a322.57 322.57 0 0 1-13.17-8.11 3.865 3.865 0 0 0-4.92.58 18.185 18.185 0 0 1-5 3.74.995.995 0 0 1-1.43-1.08l.63-3.29c.12-.6-.09-.76-.64-.49Zm-4.98 59.58c-1.07 3.02-4.5 7.11-.54 9.77 8.72 5.88 28.86 4.63 35.96-3.42 1.81-2.05 3.72-4 5.72-5.85.25-.22.37-.56.32-.89-.23-1.7-.05-3.42.56-5.17-.17-1.07-.48-2.27-.92-3.58-.97-2.88-.18-5.06.73-7.73.11-.31.12-.63.04-.95-1.54-6.19-2.03-20.69-9.66-24.02-.35-.15-.62-.07-.82.26l-14.68 24.09c-.1.17-.26.31-.45.37a46.937 46.937 0 0 1-15.1 2.77c-.28 0-.5.26-.47.54.27 2.59-.43 4.87-2.1 6.82-.18.2-.3.45-.35.72-.21 1.03.11 1.86.95 2.47.25.18.42.46.45.77l.36 3.03Zm3.45-19.17a81.777 81.777 0 0 0-22.75.12.323.323 0 0 0 0 .64c3.37.46 6.74.6 10.11.43 3.85-.2 8.5.49 12.67-.39a.407.407 0 0 0-.03-.8ZM103 150.9c-2.17-.37-4.38-.63-5.76 1.36-4.49 6.47 8.05 9.47.32 16.62-.22.2-.27.54-.1.79 1.3 2.01 3.27 3.18 5.92 3.51.77 1.3 1.07 2.72.92 4.25-.02.19.23.27.32.1 2.25-4.33-1-7.96 2.87-11.8.23-.23.35-.52.36-.85.04-1.8-.51-3.4-1.64-4.81-.21-.25-.3-.54-.27-.87.17-2.27 1.08-4.17 2.71-5.68 1.13-1.05.33-2.93-1.21-2.85l-4.44.23Zm68.14 11.8c-.41 2.83-1.82 4.6-4.25 5.29-.34.1-.46.32-.36.65l.89 2.98c-.86 2.35-2.24 4.47-4.14 6.38-.53.53-.18 1.44.57 1.47 7.33.35 14.16 2.39 20.49 6.14 1.53.91 4.3 3.88 8.3 8.91 6.67 8.57 7.35 16.69 8.45 27.12.04.37.15.4.34.08 3.76-6.22 2.3-15.1-1.13-21.05-3.97-6.9-3.88-14.71-7.66-20.99-1.45-2.41-3.2-4.6-5.25-6.57-4.65-5.08-9.11-9.82-13.46-15.15-.22-.27-.5-.35-.83-.23-1.92.68-2.57 2.34-1.96 4.97ZM140.59 181l-5.41 6.32c-7.8 10.69-13.95 22.38-18.45 35.08-.11.33.07.7.41.8.74.23 1.35-.1 1.83-.99 3.5-6.53 6.77-13.61 11.21-19.55 1.21-1.61 2.3-3.23 3.28-4.85a97.66 97.66 0 0 1 20.11-15.3c.64.14 1.2-.03 1.68-.51.25-.25.25-.5-.02-.74-1.63-1.47-2.07-3.37-1.33-5.68 1.95-2.44 1.91-4.58-.13-6.43l-1.08-1.39c-.21-.27-.44-.29-.7-.07-4.17 3.55-7.97 7.99-11.4 13.31Zm-51.3-8.07c-5.02 4.71-8.43 10.17-10.22 16.39-3.56 10.76-7.86 20.96-12.9 30.61-1.07 2.05-1.59 4.24-2.35 6.43.23 3.94-.34 7.65-1.71 11.12-1.17 2.97-1.79 4.95-1.88 5.94-.33 3.85.86 6.91 3.57 9.2 6.13 5.15 15.33 2.68 21.16-1.98 1.86-.89 3.69-2.01 5.5-3.37.63-.47.89-.98.78-1.54.27-.04.46-.13.56-.27.07-.11.06-.29-.03-.53-1.53-3.94-2.22-8.13-2.08-12.57.48-5.19.22-6.41 3.65-10.54.09-.11.09-.27-.01-.37a.278.278 0 0 0-.37-.05c-4.55 3.06-7.84 7.24-9.87 12.53l-.23 7.72c-.21.98-.06 2.04.43 3.18.13.3 0 .65-.28.81-1.03.55-1.96-.32-2.17-1.35-.69-3.52-.57-7.05.37-10.6 1.09-2.09 2.2-4.16 3.34-6.21 1.66-2.99 4.25-4.72 6.67-7.15.88-.88 2.1-1.1 2.83-.51.36.29.79.26 1.3-.07.46-.31.61-.91.36-1.4-7.55-14.51-5.22-28.89.87-43.5.14-.34.14-.68 0-1.01l-1.74-4.01c-.14-.32-.36-.38-.65-.19l-4.89 3.29Zm17.11 10.44c-4.94.85-7.33-1.99-6.46-6.75a.78.78 0 0 0-.31-.81c-.24-.19-.5-.25-.79-.16-.28.09-.52.35-.72.79-.23.53-.42.9-.57 1.11-4.18 10.03-5.45 20.23-3.8 30.58.6 3.78 2.88 6.82 4.51 10.35.16.34.42.55.79.62l15.41 3.06c.34.07.56-.07.66-.4 1.62-5.32 3.59-10.18 5.9-14.58 4.38-8.47 9.17-16.32 14.37-23.53.78-.56 1.17-1.17 1.17-1.84-.01-.26.1-.47.31-.62a13.63 13.63 0 0 0 3.45-3.77c.21-.35.13-.46-.26-.34-5.4 1.64-10.89 2.6-16.48 2.88l-4.08-.5-4.46-1.11c-.36-.09-.55.05-.58.43-.08 1.39-.6 2.29-1.57 2.69-1.17-.73-1.11-1.76.18-3.08.25-.25.22-.47-.09-.64l-4.18-2.38c-.33-.19-.55-.1-.66.26-.46 1.49-.86 3-1.21 4.53-.13.57-.03.86.28.87 1.04.01 1.31 1.44.35 1.85l-1.16.49Zm55.58 3.4c-1.48 1.27-3.31 1.79-5.49 1.57-.89-.09-1.32-1.13-.77-1.83l2.11-2.66c.4-.5-.18-1.19-.74-.89l-5.3 2.85a68.11 68.11 0 0 0-18.74 15.55c-1.32 1.57-2.1 2.93-2.34 4.1-1.86 2.22-3.4 4.55-4.63 6.99-1.95 3.86-4.36 7.28-6.03 11.23-.15.35-.07.63.24.85l3.23 2.35 1.84 1.67 2.62 3.91c.17.25.53.29.74.07 3.52-3.56 7.94-4.22 13.27-1.99 2.23-1.18 3.03-3.22 2.38-6.11-.51-2.31 1.94-4.43 2.57-6.12 1.37-3.62 2.29-7.47 2.77-11.54 2.42-7.65 7-14.01 13.73-19.06l6.77-5.02c.47-.35.41-.57-.16-.68l-5.93-1.1c-.39-.07-.55.08-.5.47.31 2.19-.24 3.98-1.64 5.39Zm3.59 1.41c-9.57 6.69-14.77 15.59-15.59 26.68-.43 2.61-1.64 5-3.65 7.16-.26.27-.39.63-.37 1l.27 5.67c.02.3.17.49.46.58 2.26.65 4.81 2.2 6.68-.32.21-.28.24-.65.06-.95-1.3-2.19-3.96-5.65-2.61-8.33 1.77-3.53 3.3-6.85 4.6-9.97 3.47-5.8 7.91-10.45 13.3-13.94 4.65-3.03 9.69-5.42 15.12-7.19.38-.13.42-.32.11-.58-2.35-2.01-4.95-3.38-7.8-4.1-3.63-.92-8.17 2.07-10.58 4.29Zm16.99 2.91-5.76 2.56c-10.3 4.88-19.25 15.24-23.01 25.69l-.48 2.3c-.07.32.01.65.22.91 1.92 2.39 3.09 5.09 3.52 8.1.05.33.22.58.52.74 7.88 4.26 16.74 14.87 12.49 24.41-.17.37-.11.7.17 1l1.97 2.06c.25.27.56.37.93.32l6.1-.95c.33-.05.61-.21.84-.46l17.97-20.25c.2-.23.33-.49.38-.79l.95-5.72c.27-1.61-.36-2.7-1.9-3.26l-5.92-2.17a.75.75 0 0 1-.49-.78l.06-.49 3.67.29 4.11 1.93c.33.16.49.06.48-.31-.32-14.3-1.74-25.85-12.9-35.55-.23-.2-.53-.31-.83-.31-1.05 0-2.08.23-3.09.73Zm-89.85 36.36c-.85 2.89-.96 6.13-.32 9.7l1.11 5.69c.07.37.43.63.81.57l2.24-.34c.27-.04.42-.33.29-.57-.75-1.35-1.12-2.72-1.09-4.11l1.09-8.51 2.98-6.56c.15-.33.06-.58-.25-.76-3.89-2.22-6.14 1.7-6.86 4.89Zm6.26 2.21c-.93 3.49-1.29 7.15-1.1 10.99.06 1.16.62 1.51 1.69 1.06 6.08-2.55 18.31 1.19 24.56 3.16l4.44 1.35c.98.3 1.91-.57 1.69-1.56-.78-3.48-2.04-6.83-3.78-10.06-3.92-7.22-13.41-10.67-21.15-11.31-2.72-.23-3.44-.86-4.57 1.77-.63 1.48-1.23 3.01-1.78 4.6Zm43.91 18.95-.48 4.57c-.06.57.33 1.09.89 1.2 7.3 1.45 14.88-.38 22.31-.26 1.07.02 1.72.34 2.64.82.33.17.56.09.71-.26 2.13-5.05-1.23-11.52-4.91-15.63-1.5-2.39-3.74-4.28-6.73-5.67-2.41-1.11-4.61-.76-6.62 1.06-.24.22-.58.28-.88.15l-3.61-1.48c-.55-.87-1.73-.82-3.56.16-.29.15-.6.2-.93.13-3.8-.82-6.99-3.55-10.37.41-.24.28-.18.47.17.58 6.96 2.15 10.75 6.89 11.37 14.22Zm-37.79 1.25c-1.17 2.46-2.56 6.67-.1 8.77.27.23.58.32.93.25l27.99-5.21 6.2-.38c.28-.02.46-.16.53-.43 1.45-5.33.16-9.86-3.85-13.61-1.57-1.83-3.68-3.04-6.31-3.61a.448.448 0 0 0-.5.63c1.23 2.59 5.46 13.58-1.43 12.36-4.13-.73-7.87-2.95-12.05-3.71-1.81-.33-3.62-.71-5.45-1.12-.32-.07-.65 0-.91.19-2.17 1.6-3.86 3.56-5.05 5.87Zm13.61 11.66 7.01 2.46c.37.13.74.12 1.11-.03l14.76-5.98c.35-.15.38-.63.05-.82-1.84-1.03-3.04-.38-4.86-.09-6.07.97-12.08 2.2-18.03 3.69-.87.22-.89.48-.04.77Zm-21.4-2.22c3.04 3.04 7.81 5.51 11.05 7.46 3.73 2.24 10.23.15 13.85-1.68.29-.15.27-.58-.04-.7l-6.82-2.64c-.25-.09-.5-.12-.77-.08-5.25.86-12.45 3.66-14.81-3.46a.601.601 0 0 0-.84-.35l-1.51.74c-.37.19-.4.42-.11.71Zm46.77 5.92-.48-5.78a.46.46 0 0 0-.62-.39c-5.31 2.08-10.59 4.24-15.82 6.47-3.4 1.44-6.13 5.8-8.53 8.5-.25.29.04.72.4.6l24.26-8.2c.57-.19.84-.59.79-1.2Zm-39.95 7.67c1.3.89 2.73 1.75 4.28 2.56a.785.785 0 0 0 1.13-.53c.61-2.67-.24-4.69-2.57-6.08-1.14-.68-2.57-.62-3.65-2.11-.21-.3-.5-.5-.87-.59-1.35-.33-2.46-1.01-3.32-2.06a.694.694 0 0 0-1.2.22c-2.03 6.26 2.64 6.14 6.2 8.59Zm8.41 3.59c3.18-.54 6.96-5.49 8.53-8.16.23-.37.12-.52-.31-.44l-8.38 1.65c-.42.08-.72.46-.71.89l.21 5.51c.01.35.32.6.66.55Z" />
    <ellipse
      cx={109.22}
      cy={178.66}
      rx={1.87}
      ry={0.84}
      transform="rotate(-62.1 109.225 178.662)"
    />
    <path d="M117.54 180.07c-.25 2.63-.95 3.42-2.11 2.39l.45-1.96c.04-.17.14-.33.29-.44.39-.29.85-.29 1.37 0ZM134.76 182.62l-.14.24c-.12.2-.3.3-.53.29-1.28-.05-1.79-.55-1.54-1.49l.07-.72c.03-.34.3-.6.64-.61.96-.03 1.46.74 1.5 2.29ZM123.29 181.12l.43 1.87c-2.17 1.46-2.7.86-1.6-1.79.15-.35.39-.45.74-.28l.43.2ZM128.78 182.15c.13.63.04 1.2-.28 1.69-.4.61-.99.62-1.76.02.12-.44.05-.88-.22-1.33-.18-.29-.15-.56.08-.81.41-.45.93-.64 1.57-.59.27.03.45.12.55.29.12.2.14.44.06.73ZM86.6 220.46c-5.28 3.07-8.93 7.65-10.96 13.73-.63.93-1.14 2.21-1.53 3.83-.05.23-.15.42-.29.55-.19.17-.37.27-.56.3-.46.07-.84-.37-.72-.82 1.14-4.25 3.11-8.47 5.92-12.68 2.76-3.26 6.61-6.01 11.54-8.25.74-.33 1.35-.37 1.82-.1.31.17.3.62-.01.78l-5.21 2.66ZM190.93 218.38c1.43.09 2.21.35 2.34.76.16.54-.16.9-.95 1.07l-7.06.34a.576.576 0 0 1-.61-.52c-.03-.31.18-.59.48-.64l5.8-1.01ZM174.45 227.12c.55.23.47 1.04-.12 1.16-.86.17-2.39-.03-3.3-.45-3.47-1.59-7.11-2.12-10.94-1.57a.482.482 0 0 1-.52-.33c-.07-.22.03-.46.24-.56 3.89-1.96 10.6.06 14.64 1.75ZM173.3 240.58c-2.3-5.13-7.57-8.73-12.77-10.46-.26-.09-.55-.11-.82-.04-.45.11-1.01.08-1.68-.08-.69-.17-.79-.65-.21-1.08.57-.42 1.6-.63 2.3-.47 6.49 1.52 11.34 5.23 14.54 11.14.22.41.13.73-.27.97l-.41.24c-.25.14-.56.04-.68-.22ZM153.94 280.01c-.04 1.84-2.91 3.54-4.21 1.44a1 1 0 0 0-.82-.5l-1.49-.11c-1.11-.09-1.59-1.45-.78-2.22.89-.84 1.35-1.88 1.39-3.13.01-.43.08-.84.21-1.24l1.47-4.56c.13-.4.7-.34.75.07.16 1.39.6 2.71 1.32 3.96.75 1.3 2.42 1.75 3.72.99 1.65-.95 3.42-1.1 5.31-.44.32.11.64.14.97.09.69-.12 1.26.06 1.71.54.26.28.26.56.01.84-2.09 2.29-4.71 3.23-7.87 2.81-.88-.12-1.67.56-1.69 1.46Z" />
    <path
      d="M112.89 181.46c-.16.39.04.71.61.97.91.42 1.55.43 1.93.03 1.16 1.03 1.86.24 2.11-2.39.45.69.93 1.17 1.43 1.46.35.2.6.12.75-.25.23-.55.15-1.16-.22-1.83l4.08.5c-.18.4-.28.79-.29 1.17l-.43-.2c-.35-.17-.59-.07-.74.28-1.1 2.65-.57 3.25 1.6 1.79l1.27 1.42c.22.24.57.32.87.18.33-.15.62-.39.88-.74.77.6 1.36.59 1.76-.02.32-.49.41-1.06.28-1.69.97.97 1.99 1.34 3.05 1.12.26-.05.36-.38.17-.57l-.3-.31c-.25-.25-.2-.42.13-.51l.72-.21c-.25.94.26 1.44 1.54 1.49.23 0 .41-.09.53-.29l.14-.24c-.06.41.15.75.63 1.02-5.2 7.21-9.99 15.06-14.37 23.53-.46-1.63.08-3.66 1.63-6.09a.698.698 0 0 0-.57-1.07c-.55-.02-1.06.27-1.53.88-2.01 2.59-3.58 5.4-4.72 8.43-.25.65-.75.95-1.51.9-.33-.02-.44-.18-.35-.49 1.53-5.02 1.46-10.01-.19-14.98-.28-.84-1.5-.76-1.67.11l-1.26 6.36c-.07.33-.24.59-.53.76-.72.45-1.17 1.07-1.35 1.88a.4.4 0 0 1-.45.31.404.404 0 0 1-.35-.42l.53-10.17c.02-.38-.49-.52-.67-.18-2.68 5.11-3.81 10.62-3.4 16.53 0 .15-.01.27-.07.36-.07.11-.16.18-.25.23-.33.17-.53.08-.59-.29-.67-3.91-.74-7.85-.22-11.81-.22-5.27.75-10.29 2.9-15.06l1.16-.49c.96-.41.69-1.84-.35-1.85-.31 0-.41-.3-.28-.87.35-1.53.75-3.04 1.21-4.53.11-.36.33-.45.66-.26l4.18 2.38c.31.17.34.39.09.64-1.29 1.32-1.35 2.35-.18 3.08Zm-4.54-1.15c.4.22 1.14-.34 1.62-1.26.49-.91.55-1.83.13-2.05-.4-.22-1.14.34-1.62 1.26-.49.91-.55 1.83-.13 2.05Zm6.71 3.81v-.3c0-.15-.15-.26-.3-.22l-.54.17c-.26.08-.33.41-.14.6l1.07 1.08c.12.12.17.3.11.47l-.26.8c-.2.61.56 1.08 1.02.63 1.63-1.59 1.63-2.84 0-3.75-.45-.25-.61-.13-.48.37.07.26 0 .39-.22.4-.14 0-.25-.11-.25-.25Z"
      style={{
        fill: "#593d27",
      }}
    />
    <path
      d="m57.98 154.65 9.66.4c-1.31.14-1.11.95.6 2.44.67.59 2.45.98 5.34 1.17.17.01.27.2.18.35l-.26.43c-.04.08-.12.13-.21.16l-1.72.48c-1.14.31-1 1.97.18 2.09 3.87.39 7.49 1.42 10.85 3.09l-.04 3.49c-.01.33-.1.62-.29.89-1.89 2.64-3.53 4.3-6.83 5.36-3.25 1.05-7.67 2.08-8.82 5.79-.1.32-.05.67.13.95 2.14 3.34 6.52 2.14 10.07 2.96l-1.26 3.12c-3.96.35-6.58 1.44-10.57.04-3.8-1.34-6.79-4.87-4.83-8.99l2.85-2.97c2.91-1.59 5.17-2.42 6.8-2.5 3.52-.17 9.02-1.47 9.01-5.52-.02-5.49-12.32.41-14.83-5.67a.87.87 0 0 1 .09-.88l.61-.92c.53-.8.01-1.87-.94-1.95-2.04-.18-6.52-.37-5.77-3.81ZM153.57 182.51a97.66 97.66 0 0 0-20.11 15.3c3.28-5.15 7.8-9.64 13.55-13.48 2.33-1.55 4.51-2.15 6.56-1.82Z"
      style={{
        fill: "#97692d",
      }}
    />
    <path
      d="M25.94 17.28c.81 1.33 1.14 3.44.97 6.32-1.33.07-1.85.42-1.54 1.06l-1.78-4.06c-.16-.37-.37-.4-.63-.09-.45.53-.48 1.31-.11 2.35-1.05-.45-1.94-.35-2.69.3-1.03-.34-1.98-.96-2.86-1.87-.19-.21-.4-.22-.62-.03-.24.21-.27.39-.08.56 5.29 4.85 9.9 9.82 13.85 14.9-1.09.38-1.97.18-2.64-.59.13-.03.24-.1.33-.2.18-.19.17-.49 0-.67L16.58 23.85a.337.337 0 0 0-.45-.02c-.14.11-.16.3-.07.44l3.5 5.29c-.5-.05-.85.25-1.04.9-.87-.73-1.7-1.07-2.47-1.02-.46.03-.54.22-.25.58 1.11 1.34 2.58 2.19 4.43 2.54.7.1.87 1.17.51 3.21-4.09-1.49-8.26-1.35-12.51.42-.43.18-.42.3.05.35 4.49.53 8.98.93 13.47 1.22.83.05 1.37.23 1.62.56-.41.8-1.18 1.22-2.31 1.26.03-.11.04-.21.03-.31-.03-.21-.15-.33-.36-.35L8.71 37.79c-.23-.02-.42.19-.36.41.05.23.2.37.43.4 2.64.36 4.51 1.25 7.27 1.35-.3.49-.41.93-.32 1.3l-4.81 3.73c-.56.14-1.29.05-2.2-.26 1.45-.91 2.6-1.99 3.44-3.25.24-.36.15-.58-.28-.67a17.23 17.23 0 0 1-8.06-3.96.62.62 0 0 1 .24-1.07l8.24-2.24c.4-.11.49-.33.26-.68l-2.99-4.49c-.41-.62-.25-.93.5-.92l5.11.08c.54 0 .86-.6.55-1.04-1.58-2.22-2.59-4.7-3.04-7.44-.07-.44.38-.78.79-.6l6.29 2.86c.51.23 1.09-.1 1.16-.65l.66-5.11c.09-.71 1.03-.9 1.39-.28.73 1.23 1.72 1.9 2.97 2.02ZM13.42 30.16l-.68 1.06c-.05.09-.03.2.06.26l2.22 1.42c1.54.98 2.95 1.54 3.15 1.23l.17-.27c.2-.31-.89-1.36-2.44-2.35l-2.21-1.41a.195.195 0 0 0-.27.06ZM131.4 17.6c-.5 3.29-2.47 4.82-5.92 4.61 1.43-2.2 3.41-3.74 5.92-4.61ZM235.19 22.49c11.63 1.48 9.63 22.02-1.82 20.34 1.96-1.79 3.91-3.29 5.18-5.57 3.29-5.93 2.17-10.85-3.36-14.77ZM207.91 23.42l-.5 2.15c-.07.33-.28.53-.61.6a12.06 12.06 0 0 0-4.52 1.98c-.23.17-.37.39-.42.68l-.15 1c-.07.44-.32.69-.76.74-1.73.22-3.05 1.06-3.96 2.51-.15.25-.45.37-.73.3l-4.28-1.08c5.08-3.61 10.39-6.57 15.93-8.88ZM134.62 40.31c-2.21-1.19-3.96-3.68-5.27-7.46l.8-3.19c.11-.45.25-.46.42-.03l4.05 10.68ZM119.23 29.44c-.43 4.1-1.75 9.51-5.97 11.03-3.18 1.15-6.4 1.76-9.67 1.84l3.92-4.02c.09-.1.12-.22.07-.35-.03-.1-.06-.21-.09-.32a.236.236 0 0 0-.37-.12l-5.84 4.51c-.13.09-.19.25-.16.4l.1.46c-.51-.05-1.22-.43-2.12-1.14.21-.15.36-.34.44-.55.15-.4 0-.56-.4-.48-1.66.32-3.12 1.14-4.37 2.47l-5.52-.7c.39-1.09 1.34-1.44 2.86-1.06 2.43.11 4.95-.67 7.54-2.32.57 1.29 1.55 1.14 2.96-.43.52-.59.58-1.23.19-1.93l6.31-1.6c.13.47.12 1.03 0 1.7-.09.43.06.56.47.39 3.63-1.56 6.85-4.15 9.66-7.78ZM190.73 33.1l11.47 2.72-6.48 3.37c-.31.16-.62.16-.93-.01-1.3-.69-2.06-.61-2.27.24-2.75.39-5.39.12-7.94-.81-.55-.2-1.06-.15-1.54.15-.28.17-.28.34 0 .51 2.52 1.46 5.26 1.81 8.23 1.05-1.34 1.35-2.64 2.12-3.91 2.33-.05-.34-.18-.56-.41-.66-3.45-1.51-6.97-2.96-10.56-4.35-.52-.2-.7-.03-.53.5.19.59.65 1.04 1.38 1.33 3.19 1.29 5.67 2.23 7.44 2.81-.81 1.07-1.6 1.38-2.37.93l-4.62-2.52a.568.568 0 0 0-.71.14l-.25.3c-.35-.39-.84-.19-1.46.58l-6.38-4.7c-.21-.16-.4-.13-.56.08-.12.15-.11.31.04.48 1.17 1.33 2.64 2.88 4.39 4.64-4.16.23-8.06-.71-11.7-2.82-1.73-1.01-2.79-3.03-3.17-6.06l8.6 4.52c.29.15.62-.1.56-.42l-.28-1.4c-.1-.49.3-.95.81-.92 1.83.13 3.47.71 4.93 1.74.3.21.63.27.99.17 1.91-.55 3.77-.35 5.59.59.3.15.65.19.97.1 3.66-1.04 7.21-2.58 10.66-4.61ZM263.63 33.56l8.66 2.2c.49.12.64.74.26 1.08-2.25 2.04-4.88 3.33-7.87 3.88-.75.14-.97 1.1-.36 1.55l2.82 2.09c-.34 1.3-1.59 1.24-2.82 1.04-.8-.13-1.45.21-2.1.15-3.7-.38-5.4-2.38-5.11-6 2 .57 3.98.49 5.95-.23.47-.17.46-.3-.04-.38-2.43-.37-4.87-.46-7.32-.26-.28.03-.46.11-.55.25-.11.17-.14.4-.09.69l-4.23-1.46c-.29-.1-.29-.2 0-.29l1.96-.66c2.33.35 4.66.46 6.99.33 2.87-.16 4.47-2.14 7.92-.92.31.11.48 0 .51-.33a.593.593 0 0 0-.15-.44c-.14-.15-.37-.23-.7-.23-1.6 0-3.15-.22-4.65-.71.48-.41.79-.86.92-1.35Zm-4.82 8.27 5.11 2.74c.07.04.14.01.18-.05.35-.67-.48-1.81-1.88-2.56l-.3-.16c-1.39-.75-2.81-.81-3.16-.15-.04.07-.01.15.05.18ZM34.34 37.79l8.34 1.26c1.61.76 3.13.64 4.57-.37.27.81 1.02 1.21 2.26 1.19 0 4.15-4.87 2.99-7.51 3-3.93.03-6.29-1.61-7.66-5.08ZM75.29 38.85l8.38 3.84c.69.31.65.47-.1.46l-23.5-.36c-.3 0-.38-.42-.1-.53 1.85-.74 3.35-1.75 4.52-3.02 3.68.47 7.28.34 10.8-.39ZM155.71 42.9c.58-.51.7-.84.37-.98-1.17-.5-1.9-1.16-2.2-1.99 3.75-.69 7.26.21 10.54 2.7.39.29.34.44-.15.43l-8.56-.16ZM31.38 40.26c1.97.75 3.58 2.05 4.82 3.9 2.41 3.58 1.7 10.95-2.35 13.2-.31-1.55-.43-2.96-.35-4.23.04-.71-.34-.92-1.13-.64l.59-2.44c.93-3.53.4-6.79-1.58-9.79ZM255.22 43.21c3.11 2.92 4.54 6.82 4.29 11.69-.01.31-.16.53-.45.66-.68.29-1.4.22-2.16-.23.53-3.96-.03-8-1.68-12.12ZM257.28 93.86c.65-1.97.68-4.02.11-6.14-.2-.74.07-.99.8-.76l.56.18c.44.14.72-.02.83-.47l.6-2.48c.29 1.36.77 1.21 1.44-.45 1.34-3.33 2.23-20.14-1.96-20.14l1.45-7.62c.15-.77 1.2-.89 1.52-.17 7.66 17.54 1.95 38.84-5.43 55.44-.17.38-.66.48-.97.2-3.04-2.81-4.9-6.28-5.59-10.43-.04-.24.28-.35.4-.14 1.15 2.03 2.77 3.6 4.87 4.71.61.32 1.32-.22 1.16-.89-1.02-4.31-.95-7.93.21-10.84ZM251.63 77.68a.888.888 0 0 0-.1-.38c-.17-.31-.39-.35-.67-.14l-5.26 3.97c-.16.12-.2.33-.1.5.1.17.31.24.49.16l2.25-.99c-.11.66.14 1.04.75 1.13.27.05.48.26.52.53.07.53-.24.9-.95 1.1a.69.69 0 0 0 0-.45c-.14-.37-.32-.39-.55-.07l-3.9 5.38-1.52 1.96c-.44-1.97.06-3.94 1.49-5.92.21-.29.04-.7-.31-.77l-.99-.18a.669.669 0 0 1-.47-.96c1.41-2.75 3.4-4.97 5.97-6.66.29-.19.52-.46.66-.79l3.34-8.17c.21 0 .48-.07.82-.2.31-.13.52-.31.62-.54.21-.49.1-1.07-.32-1.73.92-1.33 1.53-2.9 1.82-4.7 1.06-.43 2.06-1.14 2.99-2.15.42-.46 1.19-.07 1.06.54a56.921 56.921 0 0 1-5.99 16.29c-.15.27-.39.41-.7.42l-1.97.03c-.72.01-.8.25-.25.71l1.46 1.23c.24.2.25.41.03.63l-.22.22ZM36.52 94.44c-.75-.77-1.32-1.75-1.69-2.93a.996.996 0 0 0-.61-.64c-.81-.31-.9-.86-.28-1.66a.91.91 0 0 0 .1-.95L32 84c-.15-.29-.06-.42.27-.39l1.26.12c.29.03.47-.1.52-.4.09-.54-.01-1-.28-1.38.8-3.01.77-5.86-.09-8.57 1.21-.97 2.04-2.43 2.48-4.4.07-.33.39-.55.72-.51.34.04.59.33.59.67l-.22 24.79c-.01.25-.14.4-.39.45-.12.02-.23.04-.34.06ZM35.58 95.49c.12.3.06.78-.19 1.43-.15.39 0 .64.4.75 2.69.67 1.8 5.67 1.7 8.86a28.88 28.88 0 0 1-3.28-9.91c-.05-.29-.14-.56-.29-.81l-2.41-4.09a.313.313 0 0 1 .09-.41c.13-.09.31-.07.41.05l3.57 4.13ZM24.21 106.06l1.15.65-.72 1.71c-.98.91-1.57 1.71-1.77 2.4-.59.29-.98.59-1.17.9-.18.28-.09.69.26 1.22 1.47 2.23 1.9 4.68 1.29 7.36-1.47-.15-1.89.73-1.26 2.66 2.22 6.82.23 17.14-2.25 23.73-.07.19-.2.26-.39.2-.09-.03-.19-.05-.28-.08-.14-.04-.19-.13-.16-.27a125.67 125.67 0 0 0 2.52-15.89c.05-.51-.11-.59-.48-.24l-1.43 1.37.59-6.13c.03-.28-.05-.55-.22-.77l-2.22-2.96a.552.552 0 0 0-.76-.12c-2.32 1.59-4.78 1.79-7.38.62a.868.868 0 0 1-.13-1.51c1.55-1.06 2.74-2.43 3.57-4.1.19-.39.09-.67-.31-.85l-4.1-1.79c-.85-.37-.83-1.58.03-1.93l5.63-2.28c.09 1.08 1.13 1.67 3.12 1.78.62.04.67.23.16.58-1.65 1.12-2.7 2.5-3.16 4.14.31.95-.35 2.11-1.96 3.5-.21.18-.32.41-.32.69v.56c0 .57.19.64.56.21.4-.47.75-.45 1.06.07.21.35.5.43.87.24 1.94-1.05 3.45-2.59 4.54-4.64 1.29 1.71 1.96.39 1.99-3.97 0-.41-.1-.7-.3-.86-.21-.17-.51-.33-.9-.48 1.97-1.75 3.42-3.65 4.33-5.72Zm-4.95 12.72c-.53.75-.63 1.54-.29 2.39.22.54.42.54.61 0 .25-.73.33-1.47.22-2.24-.04-.27-.38-.36-.54-.14ZM37.79 140.51l.02 21.58c0 .75-.17.79-.51.12l-3.8-7.31c-.48-.91-.56-1.98-.22-2.96l3.99-11.51c.04-.12.17-.2.3-.18.13.02.22.13.22.26ZM37.09 175.71c.06-.21.37-.19.41.03 1.14 7.37.28 15.07.08 22.59 0 .04-.03.07-.07.07-.03 0-.07-.01-.08-.05l-4.7-13.64a.893.893 0 0 1 .16-.9c1.91-2.42 3.31-5.12 4.2-8.1ZM252.34 189.27c.85 0 1.65.19 2.4.58.31.16.42.41.32.74-2.62 8.94-4.15 16.29-2.66 24.98.6 3.51.12 6.96 2.68 10.82l-2.81 2.67c-4.45-13.2-4.42-26.46.07-39.79ZM265.6 271.36c-1.83-8.97-4.14-17.44-6.93-25.39-.11-.3-.3-.38-.59-.24l-.34.17-.26-2.33c.12-.7-.34-1.2-1.39-1.5a.561.561 0 0 1-.36-.75c.92-2.29 1.28-4.71 1.09-7.26-.09-1.19-1.57-1.69-2.36-.79L251.2 237c-.22.25-.62.04-.55-.28.78-3.78 2.56-6.98 5.35-9.61.55-.52.98-.43 1.28.27 5.72 13.38 10.83 29.43 8.32 43.98ZM37.58 235.32l-.59 4.08c-.03.21-.17.39-.37.46l-.86.33c-.29.11-.44.32-.44.63.01 2.45-1.05 4.35-3.18 5.72-.4.26-.51.17-.34-.28.74-1.91 1.89-2.9 2.37-4.9.74-3.11 1.64-6.19 2.71-9.23-.08-.31-.02-.53.18-.65.31-.19.47-.11.48.26l.04 3.58ZM37.56 245.92l-.25 22.95c0 .66-.88.87-1.19.29l-1.87-3.57c.34-3.01.19-6.12-.46-9.31v-.93c.02-.31-.13-.51-.44-.59l-.54-.14c-.53-.13-.69-.45-.5-.96.51-1.36 2.12-3.45 1.22-4.74a.574.574 0 0 1 0-.64l3.02-4.5c.18-.27.6-.18.66.14l.35 2ZM242.73 248.15c.67 1.03 1.29 1.56 1.85 1.57-.39.74-.16 1.56.67 2.46 1.41 1.54 2.43 2.75 3.06 3.62-.41.02-.76.39-1.04 1.1l-.94-.02c-.41-.01-.48.13-.2.44 1.54 1.69 3.5 3.02 5.87 3.99.21.13.11.24-.29.34-.25.07-.38.23-.39.48-.05.96.36 1.48 1.21 1.55.39.03.68.22.87.57a55.276 55.276 0 0 1 5.84 16.17c.08.42-.4.73-.75.47l-2.89-2.13-1.01-5.73c-.05-.25-.19-.39-.44-.42-.11 0-.22-.02-.35-.02.04-.17-.04-.41-.24-.72.36.11.54-.16.55-.81.01-.27-.06-.56-.21-.89a33.39 33.39 0 0 1-1.99-5.75.876.876 0 0 0-.6-.66c-4.09-1.46-7.1-4.16-9.02-8.09-.18-.37.09-.8.5-.8h1.26c.53 0 .62-.2.29-.61-1.63-1.95-2.17-3.98-1.61-6.11ZM34.55 281.79l.64.13c.35.08.64.31.79.63 1.47 3.11 1.9 6.4 1.29 9.88-.05.3-.18.56-.39.78-1.32 1.39-2.33 3.33-4.08 4.1-4.71 2.09-8.87 1.17-12.46-2.74l-1.82-2.54c5.65 2.96 10.28 2.19 13.88-2.3.21-.27.07-.48-.42-.63.76-.83.82-1.86.19-3.1 1.57 1.19 2.37-.22 2.38-4.21ZM229.29 316.74c.74-.26.78-.85.11-1.77.37-.53.68-.79.93-.79 2.17-.28 3.29-1.35 3.37-3.2l2.94.65c1.18.26 2.01-1.13 1.22-2.04l-1.28-1.46c2.35-4.81 1.36-9.03-2.98-12.67 9.71-1.76 12.07 13.85 6.09 18.57-2.9 2.29-6.37 3.19-10.4 2.71ZM52.37 295.55c3.1 2.1 6.65 3.47 10.66 4.12.15-.03.31.06.48.26.22.25.23.52.03.79l-.5.7-9.75-3.61c-.29-.11-.54-.04-.74.2l-.27.33c-.45-.19-.83-.45-1.14-.78-.25-.27-.29-.57-.1-.89.46-.79.9-1.16 1.33-1.12ZM80.05 295.39h3.26c.3 0 .38.42.1.53a73.48 73.48 0 0 0-16.76 9.32c-7.77 5.75-18.06 15.45-28.29 9.82l7.44-.95c-.06.11-.04.23.05.38.15.23.35.33.62.28 1.11-.19 2.07-1.07 2.88-2.63 1.83-.11 3.59-1.22 5.29-3.35l2.14 1.11c.33.18.62.13.87-.16.57-.66.54-1.6-.07-2.81 2.49-1.27 3.93-2.65 4.33-4.12l3.83-.46c.46-.05.59-.29.4-.71l-.42-.94c4.41-2.59 9.11-3.98 14.09-4.16.35-.01.52-.2.51-.55-.01-.19-.1-.39-.27-.6ZM136.22 295.74a50.891 50.891 0 0 0-5.55 12.62c-.16.55-.33.55-.5.01l-.94-2.92 1.12-6.2c.04-.24.14-.46.3-.65.73-.87 1.12-1.92 1.17-3.15l4.4.29ZM201.59 301.89l2.4 2.01c.25.21.55.36.88.43 2.39.51 4.3 1.96 5.74 4.33-2.14-.11-4.1.19-5.87.91-.39.16-.41.35-.04.56 2.94 1.67 6.05 1.97 9.34.9 1.2 1.11 2.7 2.17 4.49 3.2.7.4.49 1.34-.64 2.81-3.39.37-6.73-.49-10.03-2.58-.24-.15-.34-.37-.3-.66l.07-.51c.05-.41-.11-.69-.49-.86-1.69-.75-3.37-1.53-5.04-2.35-.42-.21-.6-.66-.54-1.35.04-.42-.15-.68-.56-.77-1.6-.38-2.92-1.21-3.95-2.5-.28-.35-.73-.5-1.16-.39-3.2.81-6.21 2.1-9.02 3.85-.32.2-.2.69.18.72 9.26.74 19.85 6.79 24.81 8.44 4.2 1.4 8.47 1.21 12.82-.56l2.93.78c.29.08.3.17.01.26-9.41 2.99-18.2 2.51-26.36-1.42-6.63-3.19-12.18-5.32-16.63-6.39-.31-.07-.49-.27-.54-.59l-.04-.32c-.02-.14-.1-.22-.25-.23-.9-.06-1.61.3-2.12 1.07-.27.4-.6.47-1.01.22l-1.23-.77c-.21-.13-.39-.1-.56.07-1.19 1.23-1.18 2.24.04 3.03l-6.13 3.11a.31.31 0 0 0-.15.39c.06.15.22.22.37.18.63-.19 1.2-.19 1.72-.01.03.86-.27 1.31-.91 1.34-2.21.56-4.32.63-6.32.2-.39-.08-.53-.31-.43-.69l.77-2.83 3.41-2.68c.27-.21.23-.36-.1-.44-9.15-2.14-17.94 5.54-24.47 10.62-.96.75-1.85 1.72-2.68 2.9-.17.23-.38.27-.63.1-.21-.14-.25-.32-.14-.54l1.54-3.02c.01.16.03.26.04.31.16.38.69.42.99.08l5.9-6.72c.47-.87 1.52-1.83 3.14-2.88-.09.37-.03.65.17.82.27.23.54.23.82.02 4.21-3.24 8.07-3.3 12.57-5.47 3.1-1.49 6.3-1.5 9.61 0 .23.11.48.17.73.18l5.36.34c.35.02.67-.06.97-.24a36.96 36.96 0 0 1 15.32-5.28c.33-.03.59-.14.77-.33.25-.25.39-.51.43-.79Zm5.88 4.94-8.35-1.69c-.11-.02-.21.05-.24.16v.07c-.16.76 1.62 1.77 3.98 2.24l.21.05c2.36.47 4.39.24 4.54-.53l.02-.07a.2.2 0 0 0-.16-.23Zm-33.03 3.09-4.1-.88a.192.192 0 0 0-.24.15l-.02.11c-.17.76.65 1.58 1.82 1.83l.26.06c1.17.25 2.25-.16 2.41-.92l.03-.11c.02-.11-.05-.21-.16-.24Zm-3.9 5.47 4.51-2.22c.45-.22.43-.33-.07-.34-1.91 0-3.53.64-4.87 1.95a.38.38 0 0 0-.04.49c.1.15.3.2.47.12ZM120.2 311.61c1.44 2.25 3.79 3.69 7.04 4.34l3.34 2.09c.3.19.49.46.58.81l1.38 5.5c.11.44-.46.73-.75.38-5.51-6.49-12.39-10.84-20.65-13.04-1.93-.51-3.6.06-5.6.11-.62.01-.7.23-.25.65l1.33 1.23c.24.23.15.62-.15.73l-.5.18c-1.5-1.23-3.25-1.8-5.26-1.71l-1.38.97c-.17.13-.34.11-.49-.05-.41-.44-.8-.33-1.15.33a.85.85 0 0 1-.36-.47c-.08-.3.04-.46.35-.49.19 0 .34-.06.45-.14.07-.05.13-.14.16-.26.31-1.31 0-2.19-.93-2.64a.7.7 0 0 0-.82.14l-.74.74c-.25.25-.51.27-.8.06l-4.29-3.1c1.91-.57 3.8-.91 5.65-1.01 4.68-.25 8.31-1.01 12.73 1.67 3.9 2.35 7.6 3.35 11.11 2.98Zm-17.92-.81c1.46.71 2.73.41 3.82-.91.43-.53.31-.73-.36-.61l-3.34.6c-.46.09-.54.71-.12.92ZM88.37 308.43c1.24.29 2.25.84 3.02 1.63.3.31.24.51-.17.62a82.35 82.35 0 0 0-15.73 5.91c-6.68 3.34-12.36 4.33-19.39 3.49 11.21-2.48 21.36-7.86 32.27-11.65Z"
      style={{
        fill: "#deb750",
      }}
    />
    <path
      d="m227.1 62.81-.08 23.08c-.07-.68-.44-1.05-1.11-1.1-.32-.02-.61-.19-.79-.46-1.64-2.52-4.75-2.96-7.11-4.85-.58-.46-1.43-.22-1.68.47l-2.71 7.5 1.21-4.52c.07-.27.01-.55-.18-.76l-1.19-1.32a.622.622 0 0 1-.13-.65c.36-1.03.27-2.02-.28-2.97a.886.886 0 0 0-.97-.42c-1.97.48-3.35 1.62-4.13 3.43-.12.28-.29.53-.51.75L204.47 84c-.23.23-.5.37-.81.43-3.04.53-5.8 1.69-8.29 3.49-.31.23-.68.37-1.07.41-1.02.09-1.96.49-2.81 1.18-.85.7-.49 2.07.59 2.25 1.79.31 3.42 1.01 4.9 2.12.27.2.57.29.9.26l5.68-.39c.09-.01.18-.03.26-.08l5.49-3.06c-1.07 1.67-2.42 2.97-4.07 3.92-.25.14-.48.31-.69.51-.61.58-.86 1.23-.75 1.95.06.4-.1.67-.49.8-2.44.81-4.94 1.03-7.51.66-.33-.05-.61-.23-.8-.5-1.81-2.61-3.46-3.57-4.95-2.88-.68-.6-1.54-.52-2.58.23-.27.2-.63.2-.9 0l-3.44-2.53a.83.83 0 0 0-.65-.15c-1.22.23-1.83-.29-1.84-1.54 0-.92-1.26-1.2-1.65-.36-.79 1.69-2.18 2.94-4.19 3.77-2.54-10.97-6.09-16.05-14.65-23.37 1.07-1.57 1.77-3.27 2.11-5.08.06-.33.25-.54.57-.63 4.95-1.46 9.48-.66 13.57 2.4.25.19.55.29.85.29 3.43.03 5.19 1.71 5.27 5.04.01.32.21.59.51.69 1.99.64 4.01 1.17 6.04 1.6 2.05.43 4.49 2.05 7.17 1.5.35-.07.66-.28.86-.57 2.87-4.27 7.85-2.06 10.66-5.82.14-.19.35-.3.58-.33l1.68-.17c.4-.04.69-.41.61-.81l-.35-1.89c-.11-.6.23-1.2.8-1.42.58-.22 1.22.02 1.53.55 1.1 1.91 2.65 2.46 4.65 1.63.31-.13.55-.34.72-.63.7-1.23 1.82-1.66 3.35-1.27.34.08.69-.11.8-.45.75-2.39 2.41-3.37 4.97-2.94ZM206.81 108.54c-.23 1.11.43 1.97 1.98 2.58.3.12.63.14.94.06 2.17-.52 4.35-.73 6.56-.62 3.71.18 7.02-.8 10.94-.16l.07 4.89c-6 .81-11.84.15-17.51-1.99-.75-.28-2.44-.13-5.07.45-.47.11-.59.37-.34.79l.16.26a.34.34 0 0 1-.33.51l-2.87-.33c-8.29-.93-15.86-1.99-24.26-2.17l-.2-2.92 12.15.19 7.02.3a.7.7 0 0 0 .71-.49c.13-.41.13-.93-.01-1.54 2.8.54 2.37-3.14 4.53-4.66.25-.18.6-.09.73.19 1.08 2.34 2.68 3.89 4.8 4.66Z"
      style={{
        fill: "#97a170",
      }}
    />
    <path
      d="m82.39 205.12-.84-.57c-.74-.49-1.68.23-1.4 1.07 1.33 3.97 3.72 7.11 7.19 9.44.27.18.16.61-.17.63-11 .66-18.59 1.64-22.47 12.29a.34.34 0 0 1-.4.21.342.342 0 0 1-.24-.38c.07-.43-.01-.92-.24-1.46.76-2.19 1.28-4.38 2.35-6.43 5.04-9.65 9.34-19.85 12.9-30.61.9 2.06 1.21 4.36.92 6.9-.03.32.03.64.18.92 1.33 2.5 2.07 5.16 2.22 7.99ZM62.95 220.07c-1.28 2.9-2.03 4.82-2.14 8.21-.13 3.98-.99 7.59-2.58 10.83l-8.2-.5-.21-18.91 13.13.37Z"
      style={{
        fill: "#3c2830",
      }}
    />
    <path
      d="M137.37 64.42c4.12 1.92 6.99 3.87 8.6 5.86-.97-.14-2.5-.62-4.6-1.44-3.79-1.49-8.05-2.07-12.79-1.75-.4.03-.6-.16-.59-.56.01-1.31.47-2.44 1.4-3.39.22-.22.53-.31.82-.25l7.16 1.53ZM151.79 185.8c-.31 1.75-1.53 3.41-3.66 4.98a.76.76 0 0 0-.21.97c.19.33.59.46.94.32l1.71-.71c.8-.33 1.56.54 1.14 1.29-2.77 4.93-4.26 10.25-4.48 15.96-.01.12.05.18.16.19h.07c.05.01.07 0 .06-.05-.03-.23-.02-.45.03-.65.09-.33.25-.37.48-.13l.34.33c.08.08.15.08.21 0l1.13-1.53c-.48 4.07-1.4 7.92-2.77 11.54-.63 1.69-3.08 3.81-2.57 6.12.65 2.89-.15 4.93-2.38 6.11-.94-1.76-1.4-3.73-1.37-5.92.01-.71-.31-1.12-.97-1.23a.704.704 0 0 0-.75.39l-1.28 2.74c-.19.42-.46.48-.8.17-2.71-2.44-3.95-5.12-3.7-8.04.34-3.99 1.83-8.47 4.46-13.46.37-.71.52-1.35.46-1.93a.452.452 0 0 0-.83-.19c-3.55 5.66-6.11 11.49-7.67 17.5-.37 1.41-1.76 4.07-4.18 7.98l-1.84-1.67 7.19-21.42c.24-1.17 1.02-2.53 2.34-4.1a68.11 68.11 0 0 1 18.74-15.55Z"
      style={{
        fill: "#1f1520",
      }}
    />
    <path
      d="M159.72 94.51c3.24 4.03 6.43 10.27 3.98 15.08-2.94 5.78-5.91 10.94-2.19 17.36 2.37 4.08 3.25 7.89 1.44 12.43-1.37 3.43-1.44 6.71-.2 9.83 2.17 5.44 5.64 7.23 3.51 14.32-.11.33-.33.55-.66.65-3.69 1.05-4.23 4.06-1.62 9.01-3.04 2.48-3.8 5.45-2.29 8.91.25.58-.49 1.07-.93.62l-3.07-3.18c1-.19 1.52-1.3 1.56-3.35.01-.38.14-.7.41-.96 5.03-4.97-1.83-7.09-2.05-11.33-.06-1.09.04-2.24.31-3.44.26-1.18 1.75-1.55 2.54-.64.53.61.72 1.3.57 2.05-.06.29.11.57.38.66.27.1.58-.02.71-.28.88-1.73.51-3.2-1.12-4.42-4.64-3.47-5.55-6.42-4.18-12.14.97-4.05 1.13-8.13.46-12.25l1.87-5.56c.11-.33.07-.69-.11-.98-2.97-4.85-4.09-10.26-3.36-16.21.73-5.85 2.07-11.25 4.04-16.18Z"
      style={{
        fill: "#4a2316",
      }}
    />
    <path
      d="m85.56 100.93 3.32 1.99c1.69 1.85 3.92 1.86 6.69.05-.56 5.15-2.31 12.21-.15 16.97.29.62.18 1.36-.28 1.88-4.17 4.68-7.9 9.62-11.21 14.83-2.17-2.35-4.76-3.32-7.77-2.91-.33.05-.63.18-.89.41-1.39 1.22-3.06 1.36-4.99.43a.58.58 0 0 0-.57.02l-2.56 1.49c-.33.19-.68.29-1.07.29h-10.8c-.32 0-.61.1-.86.3-1.44 1.1-2.97 1.79-4.59 2.07l.22-14.28c2.29 1.29 4.32 1.42 6.08.39l4.4-3.94c.25-.22.57-.34.9-.31 2.77.24 7.15.82 13.14 1.73 3.53.54 6.94-.21 10.21-2.25.29-.18.6-.25.93-.22l2.16.19c.39.03.58-.47.26-.7-1.09-.8-2.31-.99-3.66-.56-6.25 1.99-12.24 1.52-17.97-1.39-1.37-.7-2.87-.66-4.35-.82-.26-.03-.44-.16-.53-.4-.23-.64-.07-.97.5-.99 5.27-.19 10.61.24 16.01 1.29 1.26.24 2.41-.75 2.34-2.03-.1-2.06-.68-5.46 2.11-6.49l6.14-.35c.85-.05 1.21-1.11.56-1.66l-1.73-1.46c-.27-.23-.57-.38-.91-.46a8.22 8.22 0 0 1-3.84-2.13.608.608 0 0 1-.06-.79c.51-.68 1.45-.74 2.82-.19Z"
      style={{
        fill: "#454033",
      }}
    />
    <path
      d="M85.56 100.93c-1.37-.55-2.31-.49-2.82.19-.18.24-.15.58.06.79a8.22 8.22 0 0 0 3.84 2.13c.34.08.64.23.91.46l1.73 1.46c.65.55.29 1.61-.56 1.66l-6.14.35c-2.69-.25-2.96 1.39-2.77 3.69.37 4.78-9.75 2.2-12.23 1.18-3.15-1.31-6.4-2.21-9.76-2.72-3.59-.54-2.9 3.68-6.91 4.39-.34.06-.59.36-.59.7l-.02 4.36c0 .27.12.49.35.64 2.03 1.35 4 1.31 5.91-.11.78-.58 1.87.11 1.67 1.06-.25 1.18-.95 2.41-2.1 3.7-1.76 1.03-3.79.9-6.08-.39l.07-28.61c3.32 1.56 6.62 2.77 9.89 3.64 5.57 1.48 8.75 5.26 14.29-.15.22-.22.48-.38.78-.48 1.96-.66 3.89-.5 5.78.48.32.17.69.19 1.02.06 1.47-.59 2.69-.08 3.68 1.52Z"
      style={{
        fill: "#616442",
      }}
    />
    <path
      d="m227.34 148.1-.03 27.16c-9.95-.35-19.84-1.03-29.67-2.03-.93-.09-1.72-.24-2.38-.45-.17-.05-.27-.22-.24-.4s.18-.3.36-.3c3.03.05 5.55.22 7.57.49 1.7.22 2.86-.55 4.4-1.15a.49.49 0 0 0 .16-.81l-5.3-5.22c-.23-.23-.19-.37.13-.42 2.05-.31 4.46-.4 7.22-.29.44.02.71-.18.8-.61.06-.28-.06-.42-.35-.43l-2.67-.04c-.13-1.63.33-3.27 1.38-4.9.57-.89-.06-2.07-1.12-2.08-.94-.01-1.61-.43-2-1.25a.902.902 0 0 0-.91-.51c-1.79.19-3.07-.17-3.83-1.08l7.95-1.55c.67-.13.67-.26 0-.39l-21.68-4.1c7-.71 13.88-.28 20.65 1.29 4.85 1.13 7.74 3.33 13.27 1.44 1.55-.52 3.14-.44 4.77.24.56.24 1.16-.27 1.01-.87-.16-.66.01-1.24.51-1.74Zm-14.6 10.01c1.68 5.45 9.02 5.09 13.87 4.96.25-.01.45-.21.45-.46v-5.76c0-.45-.22-.71-.66-.8-2.12-.44-4.2-.42-6.25.06-2.46.58-5.97-1.39-7.32 1.05-.17.31-.2.62-.09.95ZM263.37 298.82c.33-.05.63.01.89.2.33.24.29.36-.12.36h-2.82c-.56 0-.6-.15-.12-.44.68-.42 1.4-.46 2.17-.12Z"
      style={{
        fill: "#917f4a",
      }}
    />
    <path
      d="M149.98 306.6c-.93.75-1.36 1.8-1.28 3.16-.57-.37-.97-.84-1.2-1.42l1.66-2.21c-.27-.01-.25-.08.06-.21.11-.05.2-.02.27.07l.49.61Z"
      style={{
        fill: "#cea12e",
      }}
    />
    <path
      d="M82.94 147.27c2.92 1.83 6.25 2.89 10 3.2.42.03.57.25.46.65-1.33 4.64-.66 8.92 2.01 12.84.16.23.1.55-.13.72l-8.62 6.28c-.06-.88-.28-1.61-.67-2.18-.14-.21-.32-.25-.53-.12l-.3.18a.304.304 0 0 1-.46-.28c.14-2.07-.56-3.17-2.1-3.3-3.36-1.67-6.98-2.7-10.85-3.09-1.18-.12-1.32-1.78-.18-2.09l1.72-.48c.09-.03.17-.08.21-.16l.26-.43a.23.23 0 0 0-.18-.35c-2.89-.19-4.67-.58-5.34-1.17-1.71-1.49-1.91-2.3-.6-2.44 3.17-1.75 5.39-5.1 6.64-10.04.13-.5.66-.8 1.15-.64 1.52.48 2.74 1.34 3.65 2.58.21.28.48.41.83.4l3.03-.08Z"
      style={{
        fill: "#694a24",
      }}
    />
    <path
      d="M224.36 52.92c-.35-.63-.44-1.16-.27-1.6.15-.37.54-.57.93-.48.91.22 1.69.07 2.32-.45.57-.47.17-1.39-.56-1.28-2.66.39-5.26.78-8.01.77-16.2-.08-33.1.86-48.64 1.25-6.57.17-14.09-.73-21.25-.57-.36.01-.71.16-.95.43-1.57 1.66-3.12 1.75-4.64.28-.32-.3-.73-.48-1.17-.49-10.57-.19-20.8-.49-31.7-.33-7.24.1-14.52-.13-21.78.3-4.34.25-8.53 0-12.88 1.56l-25.65-.21c-.38-.01-.72-.13-1.01-.37l-7.72-6.37a.468.468 0 0 1 .32-.83l16.85.71c-2.67-.08-5.23.28-7.68 1.07-1.77.58-2.44 2.06-1 3.44.24.23.53.33.86.32 11.32-.59 22.62-.75 33.94-1.26 7.23-.32 14.72 1.36 21.37.82 3.2-.27 6.38-.71 9.54-1.33.31-.06.44-.24.39-.55-.03-.27-.17-.4-.4-.39-11.73.82-23.08.1-34.05-2.16 7.02-.41 14.03-.61 21.04-.59 21.92.05 42.78-.11 65.77.13 24.37.25 45.88-.26 66.14.08.7.01.78.24.25.69l-5.52 4.63c-.05.04-.09.09-.12.15-1.21 2.2-2.78 3.08-4.72 2.63ZM46.55 52.92c1.16 7.04-.62 12.53-.73 18.9-.38 23.25-.4 39.37-.07 48.37.48 13.28 1.77 27.04.27 40.26-.32 2.77.81 5.03.83 7.68.05 7.63-.95 16.41-1.11 23.69-.27 12.79-.55 25.58-.83 38.38-.01.37.17.6.54.69l2.04.48c.34.08.57.4.55.75l-.31 4.83c-.02.41-.23.68-.62.8-1.73.51-2.26 1.51-2.23 3.36.2 14.16.43 28.33.68 42.51 0 .34.18.55.51.63.87.21 1.29.56 1.25 1.06l-8.19 7.79c-.11.11-.3.02-.3-.14.43-22.88.58-45.74.45-68.58-.03-4.91.53-10.84.34-16.33-.25-7.24-.33-14.48-.24-21.73.23-18.7-.11-37.42.21-56.1.05-2.69-.04-6.13-.26-10.34-.37-6.91-.26-22.95.32-48.12.84 14.15 1.47 28.26 1.9 42.31.03.75.35 1.5.5 2.23.05.22.25.36.47.34a.45.45 0 0 0 .39-.44 929.6 929.6 0 0 1 1.31-59.28c.08-1.52-.61-2.94-2.27-2.69-2.27.33-2.8 3.89-2.62 5.69l-.43-14c-.02-.51.15-.58.5-.22l7.15 7.22ZM237.13 50.6c-.99 4.01-1.57 8.04-1.73 12.1-.51 12.65-.36 25.3.45 37.93.02.29-.15.64-.5 1.06-.21.25-.32.57-.33.89-.25 23.58-.53 47.16-.82 70.74-.14 11.35-.55 21.07-1.23 29.17-.51 6.07-.09 11.71.15 17.64.35 8.63-.02 30.1-1.13 64.43-.03.97-.78 1.44-2.24 1.41l-2.44-2.27-.02-5.82c.66-.21.99-.46.99-.75.24-25.59.11-51.18-.38-76.77-.73-3.37-.9-6.86-.52-10.47l-.07-14.63.03-27.16-.29-4.94.02-4.74-.14-9.31c.21-.28.21-.61 0-.98l.37-12.83-.07-4.89-.12-15.75-.09-8.77.08-23.08.07-7.07.91-1.81c.07-.15.17-.27.29-.38l8.5-8.13c.23-.22.61 0 .52.31-.41 1.49-.5 3.11-.26 4.87ZM206.33 285.36l3.47-.11 15.73-.09c.67.23 1.01.62 1.04 1.17 0 .35-.15.56-.48.64-1.83.45-4.09.75-6.78.92-37.75 2.35-74.44 2.94-110.07 1.77-17.84-.59-36.24-.83-50.93-.27-3.19.13-8.12.86-14.79 2.21l6.8-6.2 156.01-.04Z"
      style={{
        fill: "#d5a940",
      }}
    />
    <path
      d="M82.6 165.26c1.54.13 2.24 1.23 2.1 3.3-.02.24.25.41.46.28l.3-.18c.21-.13.39-.09.53.12.39.57.61 1.3.67 2.18-4.69 3.88-7.97 8.46-9.84 13.74-3.55-.82-7.93.38-10.07-2.96-.18-.28-.23-.63-.13-.95 1.15-3.71 5.57-4.74 8.82-5.79 3.3-1.06 4.94-2.72 6.83-5.36.19-.27.28-.56.29-.89l.04-3.49Z"
      style={{
        fill: "#783d1c",
      }}
    />
    <path
      d="M229.07 16.83c2.63.53 4.55 1.71 5.74 3.53-2.59-.35-4.55-1.38-5.86-3.11l.12-.42ZM174.85 17.76c1.69.3 2.65 1.49 2.9 3.57.05.5-.12.6-.51.29l-1.71-1.32a.639.639 0 0 0-.83.06l-.19.18c-.18.18-.16.34.05.49l3.99 2.76c.21.15.28.43.15.65-.12.23-.39.32-.63.22l-7.24-3.07c-.37-.16-.52-.44-.44-.84l.23-1.15c1.23.16 2.46.14 3.68-.07.46-.08.64-.67.55-1.77ZM175.28 41.71c.83 1.19-.01 1.35-2.51.5-1.75-1.76-3.22-3.31-4.39-4.64-.15-.17-.16-.33-.04-.48.16-.21.35-.24.56-.08l6.38 4.7ZM187.37 42.65c-1.09.07-1.98-.05-2.68-.37-1.77-.58-4.25-1.52-7.44-2.81-.73-.29-1.19-.74-1.38-1.33-.17-.53.01-.7.53-.5 3.59 1.39 7.11 2.84 10.56 4.35.23.1.36.32.41.66ZM257.11 39.54l-2.05.07c-.05-.29-.02-.52.09-.69.09-.14.27-.22.55-.25 2.45-.2 4.89-.11 7.32.26.5.08.51.21.04.38-1.97.72-3.95.8-5.95.23ZM261.62 48.96l3.67 6.17c.14.24.09.54-.13.71a.56.56 0 0 1-.72-.02 14.808 14.808 0 0 1-4.13-6.25c-.12-.35.04-.74.38-.9.34-.15.74-.03.93.29ZM255.07 75.62h.36c.25-.01.39.12.42.37l.72 6.15c.03.31-.02.6-.17.87-1.45 2.74.07 5.7.2 8.32.03.63-.1.67-.38.1-2.58-5.15.34-8.69-1.72-13.44-.01-.82.18-1.61.57-2.37ZM27.35 83.29l-.12-.48c2.27 1.18 3.9 2.89 4.91 5.12.1.23.02.5-.2.63-.22.12-.5.07-.65-.13l-3.94-5.14ZM248.56 83.57c-.81 2.57-2.3 4.19-4.45 4.86l3.9-5.38c.23-.32.41-.3.55.07.05.13.05.28 0 .45Z"
      style={{
        fill: "#efda8c",
      }}
    />
    <ellipse
      cx={149.1}
      cy={93.72}
      rx={6.69}
      ry={1.67}
      style={{
        fill: "#efda8c",
      }}
      transform="rotate(-1.2 148.953 93.717)"
    />
    <path
      d="M104.08 114.65c2.71-3.44 7.28-7.78 11.25-9.74.55-.27.76-.11.64.49l-.63 3.29a.995.995 0 0 0 1.43 1.08c1.89-.96 3.55-2.21 5-3.74a3.865 3.865 0 0 1 4.92-.58c4.13 2.69 8.52 5.39 13.17 8.11 2.08 1.22 2.29 3.03 1.13 5.13a152.89 152.89 0 0 1-16.78 24.51c-.21.25-.5.42-.83.46-1.87.24-3.59.57-5.49.05-9.71-2.7-22.8-3.38-32.71.32-.29.11-.4 0-.32-.29.79-3.03 2.02-5.75 3.69-8.16 4.47-6.47 9.65-13.44 15.53-20.93ZM258.35 113.99c2.02.85 3.41 2.1 4.17 3.74a6.167 6.167 0 0 0 2.27 2.96c.29.21.33.45.11.74-.11.15-.27.21-.49.18-.15 0-.32-.09-.49-.23-2.34-1.97-4.2-4.44-5.57-7.39ZM34.5 140.32l-2.31 1.41c-.79.49-.92.35-.39-.41 3.31-4.67 4-8.38 5.01-13.83.05-.24-.05-.36-.3-.36h-.4c-.13 0-.21.06-.24.18-.68 2.3-2.02 6.48-4.6 7.22-.37.11-.55-.03-.54-.42.13-3.35.95-6.6 2.46-9.73.13-.69.41-1.22.84-1.59.34-.3.86.04.72.47l-2.79 8.73c-.09.29.01.41.3.36.33-.06.59-.31.78-.74 1.25-2.81 2.25-5.77 3.01-8.87.09-.36.57-.43.75-.1 2.46 4.47-.21 14.09-2.3 17.68ZM243.91 216.41c-.09-.43-.25-.62-.5-.56l1.38-1.96c.34-.49.55-.44.63.15.41 3.27.15 6.47-.79 9.6-.27.88-.45 1.36-.56 1.45-1.13.9-1.56.66-1.27-.72.59-2.85 1.39-5.64 2.41-8.36a.304.304 0 0 0-.31-.41c-.12.01-.23.02-.33.02-.27 0-.44.14-.5.41a.89.89 0 0 1-.16.38ZM264.81 217.43c-1.8 1.87-3.17 5.38-5.42 6.39-.53.24-1.03-.4-.66-.86l4.04-5.05c.19-.23.39-.45.62-.64.78-.65 1.28-.8 1.49-.45.13.22.11.42-.07.61ZM242.85 233.07c-.2-2.1.45-6.92 2.48-8.18.24-.15.54.07.46.34l-2.28 7.9c-.1.36-.62.31-.66-.06ZM28.09 253.88c.73-1.8 1.95-3.15 3.66-4.06.32-.17.67.18.5.5-.86 1.61-2 2.98-3.41 4.11-.97.77-1.22.59-.75-.55ZM244.58 249.73c2.19 1.51 3.75 3.61 4.68 6.32.17.51.05.6-.36.25l-.59-.49c-.63-.87-1.65-2.08-3.06-3.62-.83-.9-1.06-1.72-.67-2.46ZM254.04 280.98l-7.67-1.83c3.86-.81 7.21-.23 10.06 1.72.17.12.23.34.14.52-.09.19-.3.28-.5.22l-2.03-.63ZM175.01 296.83a24.786 24.786 0 0 0-5.42 3.82c-.23.21-.45.28-.65.2-.31-.13-.35-.31-.1-.54l4.77-4.36 1.49-.4c.37-.1.51.04.41.41-.08.32-.25.61-.5.87ZM100.15 300.86l-8.52-3.62c-.05-.02-.07-.05-.07-.1v-.28c0-.17.08-.24.25-.23 3.25.32 6.19 1.43 8.84 3.34.21.15.28.44.15.67-.13.23-.41.32-.65.22ZM175.43 299.79c-.05-.14.01-.29.15-.34l.12-.05c4.84-1.88 8.88-3.12 9.02-2.75l.07.16c.14.37-3.67 2.2-8.51 4.08l-.12.05c-.14.05-.29-.01-.34-.15l-.39-1ZM189.52 297.48c.86-.27 1.79-.06 2.8.63l-9.02 1.58a.431.431 0 0 1-.5-.34c-.05-.24.1-.46.33-.51l6.39-1.36ZM23.83 301.11c-1.05.87-2.28 1.35-3.69 1.46-2.89 1.26-5.92 1.16-9.09-.31-.29-.13-.28-.25.02-.34 1.99-.61 3.44.52 5.31-.93.23-.17.48-.27.76-.29l6.24-.31c.29 0 .44.12.46.41v.31ZM174.89 319.39c-.11-.25-.12-.48-.02-.67l2.09-2c.44-.42 1.13.07.88.62l-1.03 2.26c-.2.44-.53.59-1 .44s-.78-.36-.92-.65Z"
      style={{
        fill: "#efda8c",
      }}
    />
    <path
      d="m227 268.89.29 8.99.02 5.82-.23 1.38-1.55.08-15.73.09-2.32-32.17 12.65 1.2c.25.02.44.24.43.49-.01.15 0 .28.02.4.06.32.24.54.54.66.89.35 1.77.36 2.62.03 1.39-.55 2.91.45 2.95 1.94l.31 11.09Z"
      style={{
        fill: "#2d1724",
      }}
    />
    <path
      d="M82.5 139.15c-2.56 3.22-2.41 5.93.44 8.12l-3.03.08a.94.94 0 0 1-.83-.4c-.91-1.24-2.13-2.1-3.65-2.58a.909.909 0 0 0-1.15.64c-1.25 4.94-3.47 8.29-6.64 10.04l-9.66-.4c-.84.32-2.35.07-4.54-.74l-3.3-.21-.28-13.61.3 3.07c.04.35.3.63.65.68 1.52.21 2.96 0 4.33-.62.29-.13.61-.18.93-.14 1.21.16 2.06.37 3.31.15 5.22-.91 10.45-.98 15.68-.2.35.05.64-.06.87-.32l3.82-4.18c.26-.29.58-.41.96-.37.79.09 1.38.42 1.79.99Z"
      style={{
        fill: "#626a60",
      }}
    />
    <path
      d="m136.52 69.6 9.37 8.09c.25.22.42.49.51.82.65 2.4 2.66 3.3 3.45 5 .72 1.55.89 3.16.52 4.81-4.31-.62-7.91.54-10.79 3.48-2.51 2.56-1.1 4.62 1.4 6.28-.14.03-.28.06-.43.09l-1.08-.04c-.32-.01-.62-.15-.83-.39l-3.06-3.46c-.21-.24-.31-.52-.29-.84.22-4.3 4.5-5.29 7.11-7.07.06-.05.13-.08.2-.09l3.93-.67c.5-.09.55-.79.06-.94-.81-.26-1.23-.86-1.24-1.79-.01-.31-.1-.6-.29-.85a43.3 43.3 0 0 0-6.72-7.08c-3.1-2.62-11.54-4.28-15.36-3.08-4.38 1.39-13.71 9.42-14.18 14.61-.03.35.12.59.45.72 2.96 1.15 4.9 2.78 5.82 4.88.81 1.84.53 2.94-.86 3.31-1.6-5.24-6.08-5.37-11.46-6.06-.39-.05-.52-.25-.38-.62 3.49-9.57 9.89-16.35 19.2-20.35 2.07-.89 6.51.54 9.17.46 2.33-.07 4.25.19 5.78.78Z"
      style={{
        fill: "#b7914b",
      }}
    />
    <path
      d="M190.05 95.07c.97 1.12 1.9 2.16 2.77 3.11 2.59 2.8 3.32 6.57 3.93 10.18.14.61.14 1.13.01 1.54a.7.7 0 0 1-.71.49l-7.02-.3 4.12-.33c.9-.07 1.38-1.11.85-1.84-1.69-2.35-4-3.25-6.95-2.69a.834.834 0 0 1-.82-.3 11.05 11.05 0 0 0-2.95-2.64c-2.55-1.57-1.61-6.25-5.82-4.76-.29.1-.46.3-.51.59-.13.72-.59 1.13-1.36 1.22l-.79-4.85c2.01-.83 3.4-2.08 4.19-3.77.39-.84 1.64-.56 1.65.36.01 1.25.62 1.77 1.84 1.54.23-.04.47.01.65.15l3.44 2.53c.27.2.63.2.9 0 1.04-.75 1.9-.83 2.58-.23Z"
      style={{
        fill: "#62785a",
      }}
    />
    <path
      d="m138.81 40.6.34-32.74c0-.27.37-.34.47-.09a93.62 93.62 0 0 1 4.68 14.62c1.28 5.51-2.3 13.56-4.86 18.37-.43.8-.64.75-.63-.16ZM136.64 8c.13-.32.61-.23.61.12l.1 31.99c0 .53-.14.58-.44.14-7.6-11.18-4.97-20.56-.27-32.25ZM30.33 13.44l.59 1.26-.64.37c-.28.17-.41.52-.29.83 1.26 3.37 1.96 6.85 2.1 10.43L32 29.85c-.47.17-.76 0-.88-.54-.58-2.58-.99-5.51-1.23-8.78-.17-2.33-1.13-4.29-1.69-6.55-.1-.4.06-.59.47-.58l1.66.04ZM20.16 23.17c5.97 3.26 9.99 8.04 12.06 14.33.12.37-.01.58-.4.63-.5.07-.96-.4-1.37-1.4-3.95-5.08-8.56-10.05-13.85-14.9-.19-.17-.16-.35.08-.56.22-.19.43-.18.62.03.88.91 1.83 1.53 2.86 1.87ZM256.71 24.78l-11.85 13.08c-.19.21-.5.25-.73.1a.562.562 0 0 1-.23-.7c2.31-5.59 6-10.1 11.07-13.53.56-.59 1.35-.72 2.38-.41.35.1.44.32.28.65-.14.3-.45.57-.92.81ZM119.3 36.62c.64-4.68 2.51-11.88 7.87-12.84.47-.08.65.11.52.57-1.44 5-4.17 9.13-8.19 12.38-.17.14-.23.1-.2-.11ZM156.82 36.87c-3.77-2.38-7.1-8.27-8.03-12.62-.07-.35.06-.48.41-.39 5.82 1.43 6.6 7.49 7.96 12.77.09.37-.02.45-.34.24ZM17.26 149.07c8.25 1.69 13.83 2.83 17.62 11.23.88 1.95 1.7 4.16 2.45 6.63L16.6 150.05c-.24-.2-.25-.41-.04-.64.14-.16.37-.27.7-.34ZM239.1 166.7c2.26-8.44 6.49-15.21 15.46-16.71l4.32-.92c.72-.15 1.15.77.58 1.23l-20.36 16.4ZM15.49 151.95c.73-.14 1.28-.2 1.91.3 6.08 4.89 12.04 9.77 17.89 14.64.04.03.07.07.1.11.34.44.22.78-.36 1.03-6.24-1.95-11.22-5.56-14.93-10.82a1.23 1.23 0 0 0-.76-.52l-1.26-.31-2.59-4.43ZM260.63 152.62l-2.68 4.9c-.02.35-.2.55-.54.62-.19.03-.42-.02-.68-.17-.1-.06-.21-.12-.32-.18-.23-.11-.41-.07-.56.13-4 5.43-9.35 8.86-16.04 10.31 6.33-5.83 12.81-11.12 19.43-15.88.25-.18.48-.27.71-.27.46 0 .69.18.68.54ZM12.12 156.1c6.2 3.19 12 7.12 17.39 11.81.43.37.37.48-.17.33l-4.87-1.32c-5.54-2.33-10.36-5.9-14.46-10.71-.28-.33-.21-.53.22-.6.41-.07 1.04.1 1.89.49ZM264.02 158.74c-4.65 5.17-10.28 8.29-16.88 9.38-.49.09-.55-.04-.17-.37a84.778 84.778 0 0 1 17.09-11.59l1.27-.54c.36-.15.78-.02.99.31.2.34.13.78-.17 1.03l-2.13 1.78Z"
      style={{
        fill: "#f8e7a3",
      }}
    />
    <path
      d="M263.9 159.98c.22-.15.4-.2.53-.15.44.15.65.64.46 1.06-1.63 3.63-4.31 5.97-8.04 7.04-1.35.65-2.46.81-3.33.5-.46-.17-.45-.83.01-.99 4.43-1.57 7.89-4.05 10.37-7.46ZM22.85 168.35c-.57.1-.99.06-1.26-.11-4.46-.5-7.77-2.83-9.92-6.99a.522.522 0 0 1 .85-.59c2.67 2.95 5.85 5.16 9.53 6.65.33.13.56.37.69.72l.11.32ZM19.52 172.32a19.555 19.555 0 0 0-7.07 5.48c-.15.19-.43.24-.64.11a.482.482 0 0 1-.19-.61c1.74-3.98 4.9-6.36 9.47-7.15.89-.36 1.53-.44 1.92-.23.29.15.29.3.01.46l-3.5 1.94ZM257.2 170.51c3.25 1.34 7.06 3.46 7.54 7.38.06.52-.1.61-.49.26l-5.42-4.78-5.54-2.9c-.33-.17-.31-.29.06-.34 1.19-.17 2.47-.04 3.85.38ZM19.05 178.38l-8.33 4.51c-.27.15-.61-.03-.63-.33 0-.07.08-.21.24-.42 2.75-3.45 5.9-6.27 9.47-8.48 2.98-1.87 6.06-3 9.24-3.39.59-.07.65.07.18.43l-10.17 7.68ZM258.33 174.65l7.76 7.2c.22.2.25.54.08.78a.61.61 0 0 1-.77.18l-7.51-4.01-10.46-7.66c-1.23-.9-1.1-1.19.39-.88 3.6.77 7.1 2.23 10.51 4.39ZM35.21 170.24c.36.5.43.84.22 1.02-6.82 5.98-12.84 10.8-18.05 14.47-.31.22-.75.16-1.32-.18l.53-1.18c2.31.35 3.17-2.69 4.16-4.22 3.85-4.92 8.67-8.22 14.46-9.91ZM239.87 170.24c6.43 1.08 11.79 4.58 16.08 10.49.77.97 1.33 2.12 1.68 3.45.16.61 0 .72-.49.31l-17.27-14.25ZM37.1 172.65c-2.89 5.93-3.62 10.45-10.06 13.98-2.78 1.53-6.25 1.79-9.48 2.4l-.89-.16c-.53-.09-.58-.3-.14-.62 6.88-4.91 13.42-10.25 19.61-16.01.11-.1.25-.15.39-.14.37 0 .56.2.57.55ZM259.2 189.2c-4.25-.95-8.31-.97-12.19-3.92-3.82-2.9-6.06-7.72-7.49-12.19.39-.61 1.05-.49 1.98.36 5.79 5.26 11.85 10.21 18.16 14.86.27.2.12.5-.46.89ZM33.97 205.38l1.13 3.54c-1.57-.01-2.32-1.02-2.25-3.05.01-.33-.15-.47-.48-.4-.33.07-.53.25-.59.55-.03.19.02.42.17.7 1.39 2.67 2.26 5.57 2.63 8.71l-.38-.06c-.39-.06-.71-.31-.87-.66-1.51-3.43-2.5-7-2.99-10.71-.06-.49.49-.83.9-.54l2.73 1.92ZM31.66 217.7l2.14 8.07c.15.56.02.65-.41.26-1.03-.93-1.64-2.17-1.84-3.71a11.73 11.73 0 0 1-.67-5.33c.02-.21.26-.33.44-.22.21.13.33.44.34.93ZM23.26 240.2l2 8.27c.05.2-.07.4-.26.46-.2.06-.4-.05-.47-.24l-3.34-9.84c.61-2.06 1.3-1.61 2.07 1.35ZM139.13 330.12l-.19-32.25c-.01-.78.17-.83.54-.14 2.2 4.14 6.15 12.95 4.95 17.85-1.2 4.95-2.76 9.83-4.69 14.66-.13.32-.61.23-.61-.12ZM136.45 298.48c.59-1.35.88-1.29.88.18l-.06 31.24c0 .44-.62.55-.78.14-3.55-8.98-6.9-17.33-2.15-27.01.73-1.48 1.43-3 2.11-4.55Z"
      style={{
        fill: "#f8e7a3",
      }}
    />
    <path
      d="M89.29 172.93c3.23 2.21 2.13 11.35 1.32 14.75a70.843 70.843 0 0 0-1.92 14.93c-.02.78-.2.82-.54.12l-1.66-3.43c-.1-.22-.27-.31-.5-.28-.33.04-.47.24-.42.6a26.79 26.79 0 0 0 3.57 9.89c.51.85.83 1.73.95 2.64.05.36-.36.6-.65.38-2.91-2.25-5.26-4.71-7.05-7.4-.15-2.83-.89-5.49-2.22-7.99-.15-.28-.21-.6-.18-.92.29-2.54-.02-4.84-.92-6.9 1.79-6.22 5.2-11.68 10.22-16.39ZM163.44 187.71l-.94.1c-.38.03-.56-.14-.55-.52l.03-.52c1.4-1.41 1.95-3.2 1.64-5.39-.05-.39.11-.54.5-.47l5.93 1.1c.57.11.63.33.16.68l-6.77 5.02ZM96.84 229.88l-.1-4.15c-.03-1.1-1.55-1.36-1.95-.33-.36.93-1.05 1.62-2.08 2.05.72-3.19 2.97-7.11 6.86-4.89.31.18.4.43.25.76l-2.98 6.56Z"
      style={{
        fill: "#422926",
      }}
    />
    <path
      d="M166.62 96.86c3.17 6.34 3.2 11.61.71 18.55-1.96 5.46-3.44 10.31-2.48 15.93.05.29.05.58.02.87l-.4 3.43c-.05.45.14.73.58.84 1.59.39 2.76-.11 3.49-1.52.09-.17.12-.38.08-.57l-1.47-7.49c-.1-.52.56-.83.9-.42 2.57 3.11 3.86 6.53 3.86 10.26 0 3.06-1.74 6.76-1.7 10.52 0 .46-.23.71-.68.75l-2.19.2c-.4.03-.61.25-.64.65-.06.9.21 1.75.82 2.54.18.23.27.5.28.8.03.94.29 1.83.78 2.67.16.27.38.49.65.65.69.39.81 1.01.36 1.87-1.99 3.49 1.08 6.74-3.98 8.54-2.1.75-2.07 2.61-1.2 4.52.55 1.19.4 2.1-.43 2.75-2.61-4.95-2.07-7.96 1.62-9.01.33-.1.55-.32.66-.65 2.13-7.09-1.34-8.88-3.51-14.32-1.24-3.12-1.17-6.4.2-9.83 1.81-4.54.93-8.35-1.44-12.43-3.72-6.42-.75-11.58 2.19-17.36 2.45-4.81-.74-11.05-3.98-15.08 1.2-.75 1.37-1.73.52-2.96-1.71-2.44-2.23-5.26-2.88-8.09 1.7-.69 2.67.06 2.92 2.25.56 4.87 2.18 8.38 5.36 12.09.38.45.71.13.98-.95ZM155.42 209.7c-1.3 3.12-2.83 6.44-4.6 9.97-1.35 2.68 1.31 6.14 2.61 8.33.18.3.15.67-.06.95-1.87 2.52-4.42.97-6.68.32-.29-.09-.44-.28-.46-.58l-.27-5.67c-.02-.37.11-.73.37-1 2.01-2.16 3.22-4.55 3.65-7.16.36-.04.72-.21 1.09-.5.23-.19.37-.44.42-.74.59-4.08 2.07-7.8 4.44-11.15.19-.25.4-.29.65-.1l.24.17c.33.24.38.52.15.85-1.45 2.15-1.97 4.25-1.55 6.31Z"
      style={{
        fill: "#2b1619",
      }}
    />
    <path
      d="M135.39 183.65c-.48-.27-.69-.61-.63-1.02-.04-1.55-.54-2.32-1.5-2.29-.34 0-.61.27-.64.61l-.07.72-.72.21c-.33.09-.38.26-.13.51l.3.31c.19.19.09.52-.17.57-1.06.22-2.08-.15-3.05-1.12.08-.29.06-.53-.06-.73-.1-.17-.28-.26-.55-.29-.64-.05-1.16.14-1.57.59-.23.25-.26.52-.08.81.27.45.34.89.22 1.33-.26.35-.55.59-.88.74a.75.75 0 0 1-.87-.18l-1.27-1.42-.43-1.87c0-.38.11-.77.29-1.17 5.59-.28 11.08-1.24 16.48-2.88.39-.12.47 0 .26.34a13.63 13.63 0 0 1-3.45 3.77c-.21.15-.32.36-.31.62 0 .67-.39 1.28-1.17 1.84ZM50.1 192.37l7.14.88c.34.04.54.23.6.57.13.75.54 1.17 1.22 1.28 4.73.73 8.38-1.23 14.08.14l-4.59 12.47c-6.58-1.41-10.3-6.58-18.78-2.82l.33-12.52ZM83.09 233.93c.1-.06.26-.04.48.07.28.14.4.37.35.68-.43 2.99-.28 5.93.44 8.84.07.25-.03.38-.3.37-.09-.01-.18-.01-.28-.01s-.15-.05-.16-.15c-.05-.74-.3-1.43-.76-2.08l.23-7.72ZM92.39 237.15c.75-.14 1.34.23 1.76 1.1.13.26.35.46.63.56.47.16.8.02.97-.42-.03 1.39.34 2.76 1.09 4.11.13.24-.02.53-.29.57l-2.24.34c-.38.06-.74-.2-.81-.57l-1.11-5.69Z"
      style={{
        fill: "#805b36",
      }}
    />
    <path
      d="M144.07 265.21c.05.61-.22 1.01-.79 1.2l-24.26 8.2c-.36.12-.65-.31-.4-.6 2.4-2.7 5.13-7.06 8.53-8.5 5.23-2.23 10.51-4.39 15.82-6.47.28-.11.6.09.62.39l.48 5.78ZM104.12 272.89c-3.56-2.45-8.23-2.33-6.2-8.59.17-.52.85-.65 1.2-.22.86 1.05 1.97 1.73 3.32 2.06.37.09.66.29.87.59 1.08 1.49 2.51 1.43 3.65 2.11 2.33 1.39 3.18 3.41 2.57 6.08-.12.51-.67.77-1.13.53-1.55-.81-2.98-1.67-4.28-2.56Z"
      style={{
        fill: "#170d32",
      }}
    />
    <path
      d="M227.38 189.88c-.38 3.61-.21 7.1.52 10.47l-.78 7.66-21.04-.2c-1.64-6.2-4.96-11.27-7.06-17.35 9.83-1.15 18.69-2.02 28.36-.58Z"
      style={{
        fill: "#553f41",
      }}
    />
    <path
      d="M200.86 153.77c.76.91 2.04 1.27 3.83 1.08.38-.04.74.16.91.51.39.82 1.06 1.24 2 1.25 1.06 0 1.69 1.19 1.12 2.08-1.05 1.63-1.51 3.27-1.38 4.9l-27.51-3.07-2.06-5.55 23.09-1.2ZM119.5 179.46c.37.67.45 1.28.22 1.83-.15.37-.4.45-.75.25-.5-.29-.98-.77-1.43-1.46-.52-.3-.98-.3-1.37 0-.15.11-.25.27-.29.44l-.45 1.96c-.38.4-1.02.39-1.93-.03-.57-.26-.77-.58-.61-.97.97-.4 1.49-1.3 1.57-2.69.03-.38.22-.52.58-.43l4.46 1.11ZM115.31 184.38c.22 0 .29-.14.22-.4-.13-.5.03-.62.48-.37 1.64.91 1.64 2.16 0 3.75-.46.45-1.22-.02-1.02-.63l.26-.8c.06-.17 0-.35-.11-.47l-1.07-1.08c-.19-.19-.12-.52.14-.6l.54-.17c.15-.04.3.07.3.22v.3c0 .14.11.26.25.25Z"
      style={{
        fill: "#826d39",
      }}
    />
    <path
      d="m68.55 207.71-5.6 12.36-13.13-.37-.05-14.81c8.48-3.76 12.2 1.41 18.78 2.82Z"
      style={{
        fill: "#61493e",
      }}
    />
    <path
      d="m212.77 88.32 1.91 2.78c-.94 1.15-4 5.77-1.5 6.77 1.08.44 1.23 1.91.26 2.55-4.19 2.77-4.1 4.24-6.63 8.13-2.12-.77-3.72-2.32-4.8-4.66a.488.488 0 0 0-.73-.19c-2.16 1.52-1.73 5.2-4.53 4.66-.61-3.61-1.34-7.38-3.93-10.18-.87-.95-1.8-1.99-2.77-3.11 1.49-.69 3.14.27 4.95 2.88.19.27.47.45.8.5 2.57.37 5.07.15 7.51-.66.39-.13.55-.4.49-.8-.11-.72.14-1.37.75-1.95.21-.2.44-.37.69-.51 1.65-.95 3-2.25 4.07-3.92l3.46-2.29Z"
      style={{
        fill: "#aeac69",
      }}
    />
    <path
      d="m216.55 54.89 10.25.04a.5.5 0 0 1 .38.17c.21.23.21.44-.01.63l-.07 7.07c-2.56-.43-4.22.55-4.97 2.94-.11.34-.46.53-.8.45-1.53-.39-2.65.04-3.35 1.27-.17.29-.41.5-.72.63-2 .83-3.55.28-4.65-1.63-.31-.53-.95-.77-1.53-.55-.57.22-.91.82-.8 1.42l.35 1.89c.08.4-.21.77-.61.81l-1.68.17c-.23.03-.44.14-.58.33-2.81 3.76-7.79 1.55-10.66 5.82-.2.29-.51.5-.86.57-2.68.55-5.12-1.07-7.17-1.5-2.03-.43-4.05-.96-6.04-1.6-.3-.1-.5-.37-.51-.69-.08-3.33-1.84-5.01-5.27-5.04-.3 0-.6-.1-.85-.29-4.09-3.06-8.62-3.86-13.57-2.4-.32.09-.51.3-.57.63-.34 1.81-1.04 3.51-2.11 5.08l-4.94-3.73c1.45-3.31-2.39-3.7-4.45-3.48-.37.04-.68-.07-.93-.33l-3.41-3.47c-.25-.26-.32-.56-.2-.89 1.25-3.51 5.27-1.36 7.83-1.11 4.87.47 8.9 2.66 13.8 3.68 2.37.49 4.38 1.72 6.67 1.64 1.95-.07 3.83-.48 5.65-1.21.31-.12.63-.14.95-.05 3.73 1.01 6.93 0 11.42.85 4.75.9 7.54.38 12.65-1.31 6.07-2.02 8.13-.39 13.46 2.02.33.15.65.11.94-.11.72-.54 1.5-.63 2.33-.27.29.13.63-.06.67-.38l.75-6.18c.11-.89-.57-1.68-1.46-1.71l-5.33-.18ZM213.62 87.44c-.21.37-.5.66-.85.87l-3.46 2.29-5.49 3.06c-.08.05-.17.07-.26.08l-5.68.39c-.33.03-.63-.06-.9-.26a11.243 11.243 0 0 0-4.9-2.12c-1.08-.18-1.44-1.55-.59-2.25.85-.69 1.79-1.09 2.81-1.18.39-.04.76-.18 1.07-.41 2.49-1.8 5.25-2.96 8.29-3.49.31-.06.58-.2.81-.43l2.97-3.01c.22-.22.39-.47.51-.75.78-1.81 2.16-2.95 4.13-3.43.38-.09.77.08.97.42.55.95.64 1.94.28 2.97-.08.24-.04.46.13.65l1.19 1.32c.19.21.25.49.18.76l-1.21 4.52ZM67.12 88.4l9.67 1.69c.29.05.51.29.53.58.07.87-.16 1.64-.7 2.3-.21.26-.32.59-.3.93.07 1.44.75 2.01 2.05 1.7l-8.93 4.04c-1.57.71-3.22-.83-2.62-2.44l.1-.25c.09-.26.1-.52.03-.79l-.98-3.36c-.11-.4.01-.7.37-.9 1.43-.79 1.69-1.96.78-3.5Z"
      style={{
        fill: "#8b9460",
      }}
    />
    <path
      d="M194.79 224.6c.26-.53.24-1.01-.07-1.44-.15-.21-.52-.43-1.1-.68-1.09-.46-1.53-1.22-1.3-2.27.79-.17 1.11-.53.95-1.07-.13-.41-.91-.67-2.34-.76 7.52-4.98 3.61-12.62.81-18.65-1.71-4.39-4.77-7.27-9.18-8.64 1.01-.5 2.04-.74 3.09-.73.3 0 .6.11.83.31 11.16 9.7 12.58 21.25 12.9 35.55 0 .37-.15.47-.48.31l-4.11-1.93Z"
      style={{
        fill: "#524659",
      }}
    />
    <path
      d="m189.03 110.09-12.15-.19-1.29-10.56c.77-.09 1.23-.5 1.36-1.22a.72.72 0 0 1 .51-.59c4.21-1.49 3.27 3.19 5.82 4.76 1.13.69 2.11 1.57 2.95 2.64.2.25.51.36.82.3 2.95-.56 5.26.34 6.95 2.69.53.73.05 1.77-.85 1.84l-4.12.33ZM227.3 115.29l-.37 12.83-.2-4.02c-.02-.36-.21-.56-.58-.59-2.48-.2-4.65-.02-6.93-1.18-2.92-1.5-5.34-3.45-8.75-3.6-2.65-.13-9.93.52-9.13-3.75l2.87.33c.28.03.47-.27.33-.51l-.16-.26c-.25-.42-.13-.68.34-.79 2.63-.58 4.32-.73 5.07-.45 5.67 2.14 11.51 2.8 17.51 1.99Z"
      style={{
        fill: "#4f604b",
      }}
    />
    <path
      d="M187.39 173.1c2.05 1.97 3.8 4.16 5.25 6.57 3.78 6.28 3.69 14.09 7.66 20.99 3.43 5.95 4.89 14.83 1.13 21.05-.19.32-.3.29-.34-.08-1.1-10.43-1.78-18.55-8.45-27.12-1.47-3.89-3.65-7.31-6.52-10.24-.49-.5-.4-.65.27-.45l3.09.91 1.72 2.62c.13.19.38.25.58.14s.28-.35.18-.56l-5.29-11.25.72-2.58ZM182.56 191.09c4.41 1.37 7.47 4.25 9.18 8.64-1.51.17-2.87-.33-4.06-1.51-.14-.14-.31-.16-.5-.05-.25.13-.29.32-.11.55 3.54 4.56 6.75 7.37 5.26 13.84-.08.35-.27.63-.57.82-5.51 3.67-11.56 5.84-18.17 6.51a.42.42 0 0 0-.38.4c0 .22.13.4.34.44 3.21.62 6.56 1.05 10.03 1.28 1.47.09 3.52-.98 4.61 1.08.15.28.37.46.67.55l2.26.67-.06.49c-.04.34.17.66.49.78l5.92 2.17c1.54.56 2.17 1.65 1.9 3.26l-.95 5.72c-.05.3-.18.56-.38.79l-17.97 20.25c-.23.25-.51.41-.84.46l-6.1.95c-.37.05-.68-.05-.93-.32l-1.97-2.06c-.28-.3-.34-.63-.17-1 4.25-9.54-4.61-20.15-12.49-24.41a.959.959 0 0 1-.52-.74c-.43-3.01-1.6-5.71-3.52-8.1-.21-.26-.29-.59-.22-.91l.48-2.3.08 2.75c.03.79.19.82.48.09 1.04-2.6 2.57-4.89 4.58-6.88.25-.25.63-.31.94-.15l1.62.8c.56.28 1.15-.31.88-.87-1.89-3.88 2.3-6.25 5.28-7.02 2.43-.62 4.65-1.89 6.98-2.21 2.35-.33 4.68-.49 7-.48.61 0 .97-.7.6-1.19s-.9-.71-1.58-.64c-2.65.26-5.58.04-8.2-.02-.83-.02-1.33-.94-.88-1.65l5.23-8.22 5.76-2.56Zm-8.11 36.03c-4.04-1.69-10.75-3.71-14.64-1.75-.21.1-.31.34-.24.56.07.22.29.36.52.33 3.83-.55 7.47-.02 10.94 1.57.91.42 2.44.62 3.3.45.59-.12.67-.93.12-1.16Zm-13.92 3.01c5.2 1.73 10.47 5.33 12.77 10.46.12.26.43.36.68.22l.41-.24c.4-.24.49-.56.27-.97-3.2-5.91-8.05-9.62-14.54-11.14-.7-.16-1.73.05-2.3.47-.58.43-.48.91.21 1.08.67.16 1.23.19 1.68.08.27-.07.56-.05.82.04Z"
      style={{
        fill: "#150b22",
      }}
    />
    <path
      d="m227.16 228.12.05 14.94c-5.03-.16-9.95-1.4-14.9-.4-.33.06-.67 0-.95-.18-2.07-1.35-4.37-2.17-6.88-2.46l-1.45-8.96c7.83.51 15.69.44 23.58-.22.29-.03.44-.19.45-.48l.1-2.24Z"
      style={{
        fill: "#52342d",
      }}
    />
    <path
      d="M201.34 114.99c-.8 4.27 6.48 3.62 9.13 3.75 3.41.15 5.83 2.1 8.75 3.6 2.28 1.16 4.45.98 6.93 1.18.37.03.56.23.58.59l.2 4.02c.21.37.21.7 0 .98.08 1.24-.16 2.03-.72 2.37-.78.47-2.16-.49-3.37-.34-.32.04-.64-.06-.88-.26a4.636 4.636 0 0 1-1.39-2.04c-.12-.35-.35-.6-.7-.73l-2.24-.85c-2.37-1-4.65-2.11-6.86-3.34-1.78-.99-2.89-3.12-5.7-3.25-4.85-.24-9.68-.99-14.45-1-4.43 0-8.86-.17-13.27-.47l-.27-6.38c8.4.18 15.97 1.24 24.26 2.17Z"
      style={{
        fill: "#3f4637",
      }}
    />
    <path
      d="m187.39 173.1-.72 2.58c-3.41-7.05-7.97-9.32-15.53-12.99-.61-2.63.04-4.29 1.96-4.97.33-.12.61-.04.83.23 4.35 5.33 8.81 10.07 13.46 15.15ZM161.98 186.76l-.03.52c-.01.38.17.55.55.52l.94-.1c-6.73 5.05-11.31 11.41-13.73 19.06l-1.13 1.53c-.06.09-.13.09-.21 0l-.34-.33c-.23-.24-.39-.2-.48.13-.05.2-.06.42-.03.65.01.04 0 .06-.06.05h-.07c-.11 0-.17-.07-.16-.19.22-5.71 1.71-11.03 4.48-15.96.42-.75-.34-1.62-1.14-1.29l-1.71.71c-.35.14-.75.01-.94-.32a.76.76 0 0 1 .21-.97c2.13-1.57 3.35-3.23 3.66-4.98l5.3-2.85c.56-.3 1.14.39.74.89l-2.11 2.66c-.55.7-.12 1.74.77 1.83 2.18.22 4.01-.3 5.49-1.57ZM141.99 230.54c-5.33-2.23-9.75-1.57-13.27 1.99-.21.22-.57.18-.74-.07l-2.62-3.91c2.42-3.91 3.81-6.57 4.18-7.98 1.56-6.01 4.12-11.84 7.67-17.5.23-.36.78-.23.83.19.06.58-.09 1.22-.46 1.93-2.63 4.99-4.12 9.47-4.46 13.46-.25 2.92.99 5.6 3.7 8.04.34.31.61.25.8-.17l1.28-2.74c.13-.28.44-.44.75-.39.66.11.98.52.97 1.23-.03 2.19.43 4.16 1.37 5.92Z"
      style={{
        fill: "#312221",
      }}
    />
    <path
      d="m83.93 136.65-1.43 2.51c-.41-.57-1-.9-1.79-.99-.38-.04-.7.08-.96.37l-3.82 4.18c-.23.26-.52.37-.87.32-5.23-.78-10.46-.71-15.68.2-1.25.22-2.1 0-3.31-.15-.32-.04-.64 0-.93.14-1.37.62-2.81.83-4.33.62a.765.765 0 0 1-.65-.68l-.3-3.07-.03-1.35c1.62-.28 3.15-.97 4.59-2.07.25-.2.54-.3.86-.3h10.8c.39 0 .74-.1 1.07-.29l2.56-1.49a.58.58 0 0 1 .57-.02c1.93.93 3.6.79 4.99-.43.26-.23.56-.36.89-.41 3.01-.41 5.6.56 7.77 2.91Z"
      style={{
        fill: "#535851",
      }}
    />
    <path
      d="M53.44 153.91c2.19.81 3.7 1.06 4.54.74-.75 3.44 3.73 3.63 5.77 3.81.95.08 1.47 1.15.94 1.95l-.61.92a.87.87 0 0 0-.09.88c2.51 6.08 14.81.18 14.83 5.67 0 4.05-5.49 5.35-9.01 5.52-1.63.08-3.89.91-6.8 2.5 1.09-1.19 1.49-2.14 1.21-2.87-.39-3.41-2.06-6.23-5.01-8.47-.26-.2-.44-.46-.55-.78-1.07-3.22-2.81-6.51-5.22-9.87ZM86.6 220.46l-4.32 4.67c-.26.28-.28.57-.05.87l.72.97c.18.24.16.57-.04.79-1.42 1.51-2.13 3.2-2.12 5.07.06.73-.05 1.4-.34 2.01-.18.38-.63.56-1.02.42a.834.834 0 0 1-.52-.98l1.51-5.92c.08-.31-.04-.47-.36-.47s-.55.18-.73.54c-1.2 2.41-2.43 4.33-3.69 5.76 2.03-6.08 5.68-10.66 10.96-13.73Z"
      style={{
        fill: "#6b482e",
      }}
    />
    <path
      d="m140.55 98.17.33.41c.11.13.1.26-.02.37l-.24.24c-.19.19-.26.41-.21.67.37 2.18-.17 4.1-1.64 5.75-.35.4-.07 1.02.46 1.02h.57c.18 0 .24.23.09.32-.43.25-.6.59-.51 1.04.07.35-.07.57-.4.68l-.98.32c-7.97-5.92-14.88-13.02-23.64-8.09-2.36 1.33-5.81 4.54-10.34 9.62-.26.28-.73.13-.77-.25l-.81-8.04c-.04-.37.13-.56.5-.58 4.56-.18 9.59-1.73 11.27-6.26 1.39-.37 1.67-1.47.86-3.31-.92-2.1-2.86-3.73-5.82-4.88-.33-.13-.48-.37-.45-.72.47-5.19 9.8-13.22 14.18-14.61 3.82-1.2 12.26.46 15.36 3.08a43.3 43.3 0 0 1 6.72 7.08c.19.25.28.54.29.85 0 .93.43 1.53 1.24 1.79.49.15.44.85-.06.94l-3.93.67c-.07.01-.14.04-.2.09-2.61 1.78-6.89 2.77-7.11 7.07-.02.32.08.6.29.84l3.06 3.46c.21.24.51.38.83.39l1.08.04Z"
      style={{
        fill: "#dbb661",
      }}
    />
    <path
      d="M49.91 68.94c2.84.74 5.43 1.88 7.76 3.43.96.63 2.04 2.32 3.38 2.36 5.33.17 10.6.85 15.8 2.03 4.6 1.04 6.94-.77 10.75-1.63 4.43-.99 8.93-1.18 13.52-.57-4.63 5.32-6.46 10.81-5.5 16.47.06.35-.04.64-.29.89-2.02 1.95-2.06 4.01-.11 6.18.22.25.33.54.33.87l.02 3.99c-2.77 1.81-5 1.8-6.69-.05-1.87-4.53-5.37-6.96-10.51-7.31-1.3.31-1.98-.26-2.05-1.7-.02-.34.09-.67.3-.93.54-.66.77-1.43.7-2.3a.637.637 0 0 0-.53-.58l-9.67-1.69c-3.46-1.6-5.04-.04-8.03-.27a.653.653 0 0 1-.41-.19l-3.5-3.59c-.25-.26-.55-.4-.91-.43L50 83.58l-.09-14.64ZM14.89 299.02l-2.9.21 2.9-.21Z"
      style={{
        fill: "#9b9e67",
      }}
    />
    <path
      d="M212.83 157.15c1.35-2.44 4.86-.47 7.32-1.05 2.05-.48 4.13-.5 6.25-.06.44.09.66.35.66.8v5.76c0 .25-.2.45-.45.46-4.85.13-12.19.49-13.87-4.96-.11-.33-.08-.64.09-.95Z"
      style={{
        fill: "#69573b",
      }}
    />
    <path
      d="M103 150.9c-2.67 3.01-3.55 6.27-2.64 9.78.16.63 1.07.61 1.2-.03l.5-2.48c.07-.36.4-.6.76-.55l.38.05c.21.03.33.24.26.44-.78 2.07-.54 3.94.73 5.61.23.31.28.64.17 1-.85 2.73-1.18 5.55-.98 8.46-2.65-.33-4.62-1.5-5.92-3.51a.611.611 0 0 1 .1-.79c7.73-7.15-4.81-10.15-.32-16.62 1.38-1.99 3.59-1.73 5.76-1.36ZM204.48 240.02c2.51.29 4.81 1.11 6.88 2.46.28.18.62.24.95.18 4.95-1 9.87.24 14.9.4l-.21 25.83-.31-11.09c-.04-1.49-1.56-2.49-2.95-1.94-.85.33-1.73.32-2.62-.03a.835.835 0 0 1-.54-.66 1.7 1.7 0 0 1-.02-.4.473.473 0 0 0-.43-.49l-12.65-1.2-3-13.06Z"
      style={{
        fill: "#3d2228",
      }}
    />
    <path
      d="m50.14 153.71 3.3.21c2.41 3.36 4.15 6.65 5.22 9.87.11.32.29.58.55.78 2.95 2.24 4.62 5.06 5.01 8.47-.55.08-1.03 0-1.43-.22-.28-.15-.48-.4-.58-.7-.69-2.15-1.85-3.99-3.5-5.52-1.12-1.03-2.74-1.22-3.97-2.39-.26-.24-.41-.57-.44-.92-.28-3.89-1.69-5.73-4.24-5.51l.08-4.07ZM227.12 208.01l.04 20.1-.1 2.24c-.01.29-.16.45-.45.48-7.89.66-15.75.73-23.58.22.57-3.07 1.37-6.12 2.38-9.16 1.74-5.23 1.59-8.99.67-14.08l21.04.2Z"
      style={{
        fill: "#432f32",
      }}
    />
    <path
      d="m147.36 99.6 4.01-.04c-.97 4.9-1.6 9.74-1.89 14.51-.35 5.61 3.5 10.69 1.98 16.92l-4.21-7.39c1.41-1.43 1.6-3.14.55-5.13-.15-.29-.21-.59-.17-.9.19-1.57-.05-3.08-.74-4.53-.13-.29-.19-.6-.18-.93l.65-12.51ZM153.77 169.15c-3.09 5.73-7.49 9.68-13.18 11.85 3.43-5.32 7.23-9.76 11.4-13.31.26-.22.49-.2.7.07l1.08 1.39Z"
      style={{
        fill: "#a17930",
      }}
    />
    <path
      d="M81.21 233.68c-.12-.52-.26-.81-.42-.86-.01-1.87.7-3.56 2.12-5.07.2-.22.22-.55.04-.79l-.72-.97c-.23-.3-.21-.59.05-.87l4.32-4.67 5.21-2.66c.31-.16.32-.61.01-.78-.47-.27-1.08-.23-1.82.1-4.93 2.24-8.78 4.99-11.54 8.25-3.26 1.77-5.4 4.83-6.42 9.17-.09.38-.59.47-.81.14-.43-.64-.56-1.35-.39-2.12.04-.18-.03-.28-.21-.3-.1-.01-.2 0-.29.06-.11.06-.2.19-.26.38-.9 2.88-1.94 5.16-1.54 8.32.29 2.33.48 4.69.56 7.06 0 .29.09.56.25.81l2.12 3.36c.17.27.4.33.68.18.32-.17.52-.43.61-.8.08-.34-.03-.78-.34-1.32a14.03 14.03 0 0 1-1.35-3.4c-.18-.72-.03-.8.46-.24 3.74 4.3 7.28 4.19 13.43 3.97-5.83 4.66-15.03 7.13-21.16 1.98-2.71-2.29-3.9-5.35-3.57-9.2.09-.99.71-2.97 1.88-5.94 1.37-3.47 1.94-7.18 1.71-11.12.23.54.31 1.03.24 1.46-.03.17.08.33.24.38.17.04.34-.05.4-.21 3.88-10.65 11.47-11.63 22.47-12.29.33-.02.44-.45.17-.63-3.47-2.33-5.86-5.47-7.19-9.44-.28-.84.66-1.56 1.4-1.07l.84.57c1.79 2.69 4.14 5.15 7.05 7.4.29.22.7-.02.65-.38-.12-.91-.44-1.79-.95-2.64a26.79 26.79 0 0 1-3.57-9.89c-.05-.36.09-.56.42-.6.23-.03.4.06.5.28l1.66 3.43c.34.7.52.66.54-.12.11-5.05.75-10.02 1.92-14.93.81-3.4 1.91-12.54-1.32-14.75l4.89-3.29c.29-.19.51-.13.65.19l1.74 4.01c.15.33.15.67 0 1.01-6.09 14.61-8.42 28.99-.87 43.5.25.49.1 1.09-.36 1.4-.51.33-.94.36-1.3.07-.73-.59-1.95-.37-2.83.51-2.42 2.43-5.01 4.16-6.67 7.15-1.14 2.05-2.25 4.12-3.34 6.21ZM176.8 193.65l-5.23 8.22c-.45.71.05 1.63.88 1.65 2.62.06 5.55.28 8.2.02.68-.07 1.21.15 1.58.64.37.49 0 1.19-.6 1.19-2.32-.01-4.65.15-7 .48-2.33.32-4.55 1.59-6.98 2.21-2.98.77-7.17 3.14-5.28 7.02.27.56-.32 1.15-.88.87l-1.62-.8a.807.807 0 0 0-.94.15 20.093 20.093 0 0 0-4.58 6.88c-.29.73-.45.7-.48-.09l-.08-2.75c3.76-10.45 12.71-20.81 23.01-25.69Z"
      style={{
        fill: "#1e162a",
      }}
    />
    <path
      d="m227.11 94.65.12 15.75c-3.92-.64-7.23.34-10.94.16-2.21-.11-4.39.1-6.56.62-.31.08-.64.06-.94-.06-1.55-.61-2.21-1.47-1.98-2.58 2.53-3.89 2.44-5.36 6.63-8.13.97-.64.82-2.11-.26-2.55-2.5-1 .56-5.62 1.5-6.77 1.63-1.37 2.77-3.17 3.4-5.39.17-.59.96-.69 1.28-.17.64 1.05.95 2.2.94 3.47 0 .33.18.65.47.82l3.47 1.98c.18.1.32.27.4.46.62 1.65 1.44 2.44 2.47 2.39Z"
      style={{
        fill: "#7f8f65",
      }}
    />
    <path
      d="M103.38 173.18c-.2-2.91.13-5.73.98-8.46.11-.36.06-.69-.17-1-1.27-1.67-1.51-3.54-.73-5.61.07-.2-.05-.41-.26-.44l-.38-.05a.678.678 0 0 0-.76.55l-.5 2.48c-.13.64-1.04.66-1.2.03-.91-3.51-.03-6.77 2.64-9.78l4.44-.23c1.54-.08 2.34 1.8 1.21 2.85-1.63 1.51-2.54 3.41-2.71 5.68-.03.33.06.62.27.87 1.13 1.41 1.68 3.01 1.64 4.81-.01.33-.13.62-.36.85-3.87 3.84-.62 7.47-2.87 11.8-.09.17-.34.09-.32-.1.15-1.53-.15-2.95-.92-4.25Z"
      style={{
        fill: "#6e4334",
      }}
    />
    <path
      d="m50 83.58 4.27.34c.36.03.66.17.91.43l3.5 3.59c.11.11.26.18.41.19 2.99.23 4.57-1.33 8.03.27.91 1.54.65 2.71-.78 3.5-.36.2-.48.5-.37.9l.98 3.36c.07.27.06.53-.03.79l-.1.25c-.6 1.61 1.05 3.15 2.62 2.44l8.93-4.04c5.14.35 8.64 2.78 10.51 7.31l-3.32-1.99c-.99-1.6-2.21-2.11-3.68-1.52-.33.13-.7.11-1.02-.06-1.89-.98-3.82-1.14-5.78-.48-.3.1-.56.26-.78.48-5.54 5.41-8.72 1.63-14.29.15-3.27-.87-6.57-2.08-9.89-3.64L50 83.58Z"
      style={{
        fill: "#7b7e52",
      }}
    />
    <path
      d="m30.33 13.44-1.66-.04c-.41-.01-.57.18-.47.58.56 2.26 1.52 4.22 1.69 6.55.24 3.27.65 6.2 1.23 8.78.12.53.41.71.88.54l-.23 1.05c-.1.45-.36.58-.77.37-.6-.31-1.14-.83-1.61-1.58.14 0 .27-.03.38-.07.3-.1.42-.31.35-.62-.73-3.27-1.51-8.05-2.34-14.33-.08-.57-.55-.74-1.42-.53.11-1.47.53-2.73 1.28-3.77.3-.42.94-.37 1.17.09l1.52 2.98Z"
      style={{
        fill: "#debf61",
      }}
    />
    <path
      d="M47.63 14.6c-.29.64-.4 1.21-.33 1.7-2.4.99-4.5 2.37-6.3 4.14-1.31-.21-2.56.03-3.74.72-.33-.87-.48-1.78-.46-2.73 0-.05 0-.09-.01-.13-.1-.58-.33-.78-.7-.6-.26.13-.41.34-.44.63l-.58 5.29c-1.35.71-2.34 1.61-2.98 2.71-.14-3.58-.84-7.06-2.1-10.43-.12-.31.01-.66.29-.83l.64-.37c.28 1.23.76 2.22 1.44 2.95.25.27.7.2.85-.14.64-1.43 1.65-2.48 3.02-3.15.36-.18.79 0 .9.39l.62 2c.18.56.87.77 1.32.4 2.41-1.99 5.26-2.84 8.56-2.55ZM22.83 82.36c.03 3.05-.4 6.04-1.31 8.99-.11.33.02.51.37.52.33.01.54-.1.64-.31.85-1.79 1.31-3.66 1.37-5.6 1.67.38 2.2 1.58 1.58 3.61-.1.33-.1.69.02 1.02.68 1.96 1.23 3.38.5 5.5-.72 2.11-1.49 4.45-2.31 7.01-.64.87-1.72 1.73-3.24 2.56-.45.24-.69.11-.74-.39l-.43-4.01 1.48-4.74c.09-.28-.1-.58-.39-.62l-.64-.08c-.53-.07-.84-.38-.92-.91-.37-2.49-.33-4.98.12-7.48.07-.38-.3-.7-.67-.58l-.65.21c-.53.16-.86-.02-1-.55-.71-2.63-.74-5.27-.1-7.93l1.11-.16c-.61 2.07-.76 4.21-.47 6.4.06.42.61.55.84.19.77-1.17 1.03-2.46.79-3.87-.07-.36-.04-.74.07-1.09.56-1.79.89-3.6 1-5.43.01-.22-.04-.37-.14-.44-.11-.08-.29-.11-.52-.1.67-.74 1.36-.65 2.09.28.11.14.19.31.22.49.4 2.42.23 4.79-.51 7.11-.28.86.8 1.5 1.42.84l.42-.44Zm-2.39 1.6-.67 6.9c-.02.25.14.47.39.52.24.05.48-.09.55-.33.69-2.27 1.03-4.62 1.03-7.03a.65.65 0 0 0-.62-.65.644.644 0 0 0-.68.59Zm1.44 19.51 3.28-12.58c.02-.07-.03-.14-.09-.16-.93-.25-2.42 2.38-3.33 5.87l-.06.21c-.91 3.48-.89 6.51.04 6.75h.01c.07.02.14-.02.16-.09ZM11.77 154.71c.21.42.32.89.35 1.4-.85-.39-1.48-.56-1.89-.49-.43.07-.5.27-.22.6 4.1 4.81 8.92 8.38 14.46 10.71-.67 1.16-1.21 1.63-1.62 1.42l-.11-.32c-.13-.35-.36-.59-.69-.72-3.68-1.49-6.86-3.7-9.53-6.65a.522.522 0 0 0-.85.59c2.15 4.16 5.46 6.49 9.92 6.99-.27.05-.47.12-.6.19-.1.05-.2.21-.29.46-.22.57-.09 1 .39 1.27-4.57.79-7.73 3.17-9.47 7.15-.1.22-.02.48.19.61s.49.08.64-.11c1.93-2.37 4.29-4.2 7.07-5.48l-.2.43c-.11.24-.07.45.14.62l.34.29c-3.57 2.21-6.72 5.03-9.47 8.48-.16.21-.24.35-.24.42.02.3.36.48.63.33l8.33-4.51c.03 1.29.59 1.88 1.7 1.76-.99 1.53-1.85 4.57-4.16 4.22l1.73-3.02c.18-.32-.18-.67-.5-.48a28.786 28.786 0 0 1-8.5 3.47c-.57.13-.83-.09-.78-.67.54-6.37 3.49-11.12 8.84-14.27a.3.3 0 0 0 0-.52c-5.33-3.17-8.31-7.96-8.92-14.35-.03-.37.13-.59.5-.64.87-.13 1.81.15 2.81.82ZM259.83 190.1c.09-.47-.12-.77-.63-.9.58-.39.73-.69.46-.89-6.31-4.65-12.37-9.6-18.16-14.86-.93-.85-1.59-.97-1.98-.36-.1 0-.23-.07-.4-.23-.21-.87.04-1.75.75-2.62l17.27 14.25c.49.41.65.3.49-.31-.35-1.33-.91-2.48-1.68-3.45l1.94-1.92 7.51 4.01c.26.14.59.06.77-.18.17-.24.14-.58-.08-.78l-7.76-7.2c.4-.14.57-.57.5-1.29l5.42 4.78c.39.35.55.26.49-.26-.48-3.92-4.29-6.04-7.54-7.38-.41-.9-.52-1.76-.35-2.58 3.73-1.07 6.41-3.41 8.04-7.04a.778.778 0 0 0-.46-1.06c-.13-.05-.31 0-.53.15l.12-1.24 2.13-1.78c.3-.25.37-.69.17-1.03a.808.808 0 0 0-.99-.31l-1.27.54c.1-.69-.16-1.05-.78-1.08 1.39-.76 2.82-1.17 4.27-1.24.38-.01.54.17.49.55-.78 5.83-3.74 12.47-9.76 14.4-.34.11-.35.59-.01.7 6.34 2.19 8.76 8.47 9.74 14.24.09.54-.13.75-.67.64-3.07-.62-5.91-1.79-8.52-3.5-.52-.34-1.15.26-.82.8l4.58 7.45c.37.6-.13 1.36-.83 1.26l-1.92-.28ZM33.15 197.07c3.89 2.37 4.3 10.15 4.53 14.49.22 4.05-.22 7.62-1.33 10.73l-2.86-6.1c.14-.35.5-.6 1.09-.76-.37-3.14-1.24-6.04-2.63-8.71-.15-.28-.2-.51-.17-.7.06-.3.26-.48.59-.55.33-.07.49.07.48.4-.07 2.03.68 3.04 2.25 3.05.45.85.71 1.86.77 3.03.01.17.09.22.24.14l.38-.21a.54.54 0 0 0 .31-.53c-.05-2.23-.54-4.39-1.47-6.48-.3-2.17-1.12-4.35-2.46-6.56-.23-.37-.13-.79.28-1.24ZM13.26 221.48l3.45 2.49c.29.21.6.3.95.27.92-.07 1.41-.52 1.46-1.35.22.23.28.55.17.94-.09.36-.32.54-.69.55-.27 0-.36.17-.28.5.13.57.23.89.3.94.14.11.21.26.2.45 0 .32-.18.47-.49.44-2.49-.19-3.86.23-4.09 1.27l-5.62-1.95a.899.899 0 0 1-.24-1.57c1.17-.88 2.59-1.48 4.25-1.8.34-.07.55-.18.62-.35.08-.2.08-.48 0-.83ZM30.11 224.37c1.23.86 1.53 1.19.89.99.25 2.98 1.13 5.74 2.64 8.27.94.29.61 1.17-.98 2.62-.8-2.93-3.38-9.26-2.55-11.88ZM263.55 297.1c3.23.85 6.16 2.13 8.8 3.84.68.44.52 1.48-.27 1.69l-8.39 2.2c-.38.1-.45.3-.21.61l3.24 4.12c.35.45.02 1.12-.55 1.1l-5.4-.13c-.42 0-.68.46-.44.81 1.66 2.38 2.76 4.99 3.31 7.84.09.49-.41.88-.86.67l-6.8-3.16c-.42-.2-.89.15-.82.61.31 1.95.09 3.87-.66 5.74-.11.28-.47.37-.7.17l-2.94-2.54-1.7-3.05c-.07-.13-.11-.12-.1.03.03.39-.12.55-.45.49-.46-.09-.65-.36-.57-.82l.11-.73.18.84c.01.05.05.08.1.07.05 0 .08-.04.08-.09l-.22-4.78c-.49-.69-.84-1.54-1.04-2.56.31-.87-.04-1.65-1.05-2.34.28-.35.71-.65 1.29-.91 1.73 3.07 4.52 5.53 8.36 7.39.46.22.52.14.18-.24l-10.87-12.32c-1.2.43-1.58.01-1.13-1.26.11-.33.32-.41.63-.24l7.47 4.17c1.04.58 2.21-.51 1.72-1.59-.25-.55-.1-.92.44-1.1 3.91 1.24 7.5 3.07 11.59.27.34-.23.31-.32-.1-.27-2.67.35-4.14.37-7.02-.34a15.07 15.07 0 0 0-4.77-.39c-1.08.58-2.18.4-3.29-.53-.24-.21-.21-.36.09-.47 2.55-.93 5.14-1.25 7.78-.96.31.03.48-.1.52-.41.03-.31-.01-.59-.12-.84 2.52-.91 4.05-1.11 4.58-.59Zm-5.33 15c.1.1.27.1.37 0l.14-.14c.1-.1.1-.27 0-.37l-8.1-8.02c-.1-.1-.27-.1-.37 0l-.14.14c-.1.1-.1.27 0 .37m2.6 10.97c-.21-.19-.53.04-.42.3l.94 2.25c.06.16.3.14.33-.03.17-1.03-.11-1.87-.85-2.52ZM23.83 301.11c0-.11.02-.22 0-.31-.02-.29-.17-.42-.46-.41l-6.24.31c-.28.02-.53.12-.76.29-1.87 1.45-3.32.32-5.31.93-.3.09-.31.21-.02.34 3.17 1.47 6.2 1.57 9.09.31l1.28 2.43c.17.33.42.41.75.24 1.06-.55 1.56-.52 1.49.09-2.4 2.29-4.58 4.69-6.55 7.2-.05.07-.08.13-.08.2 0 .08.04.17.09.27.06.13.14.14.24.04l8.78-8.77c.17 0 .33-.1.47-.31.05-.08.04-.18-.04-.24a.183.183 0 0 0-.24 0c-.14.14-.34.19-.59.16-.39-.05-.44-.21-.13-.46 1.37-1.13 2.84-1.64 4.41-1.52l.28 1.02c-3.03 3.14-6.33 5.64-8.43 9.5-.41.75-1.01 1.16-1.81 1.21-.52.15-.98.43-1.39.86-.29.31-.23.5.18.58.41.08.82-.06 1.23-.43 1.14-.79 2.3-1.53 3.48-2.22 2.93-1.7 4.03-3.48 5.67-6.23.45.49.47 1.12.04 1.91-.09.16-.05.34.1.55.06.08.12.08.19 0l1.04-1.31c.35-.44.68-.43 1 .03 1.79 2.55.15 5.2 2.79 6.64.71.39.96.99.75 1.8-.08 2.13.27 4 1.04 5.62.35.74.54.7.55-.12l.05-3.19c1.63-.43 3.23-.62 4.78-.58.87.03 1.38.37 1.53 1.02-.09 0-.16.05-.23.15-.1.15-.07.28.09.39 3.91 2.61 4.79 2.94 2.64.99.3-.46.93-.25 1.88.62.25.22.34.49.29.82-.17.96-.72 1.62-1.67 1.98-2.91.09-5.32-.81-7.22-2.71-.35-.35-.64-.3-.87.14-.25.5-.39 1.06-.42 1.69-.06 1.3-1.73 1.81-2.51.76l-2.55-3.43c.76-.93 1.04-1.74.85-2.44-.14-.48-.29-.48-.44-.01l-.78 2.46c-.79 2.99-2.04 5.74-3.74 8.27-.27.41-.9.3-1.03-.17l-1.82-6.72c-.11-.42-.65-.56-.96-.24l-2.1 2.16c-.31.32-.86.14-.91-.31l-.66-6.01c-.03-.25-.3-.4-.53-.3l-6.85 3.18a.654.654 0 0 1-.91-.72c.56-2.71 1.62-5.2 3.18-7.47a.66.66 0 0 0-.54-1.04h-5.08a.64.64 0 0 1-.51-1.02l3.11-4.24c.21-.29.14-.49-.21-.59l-5.38-1.52c-1-2.61.59-3.95 4.78-4.02l2.9-.21c2.35-.48 4.76-.45 7.22.09.37.08.7.25.99.5.57.49 1.29.56 2.17.2.34-.14.62.28.37.54-.37.38-.97.64-1.81.77Zm6.7 14.68c-.36 2.36-.76 4.33-1.2 5.91-.04.14.04.29.18.33.14.05.29-.03.34-.17a32.02 32.02 0 0 0 1.71-11.97c-.02-.52-.12-.54-.29-.05-.67 1.88-.49 4.29-.74 5.95Zm-1.59-5.43a23.925 23.925 0 0 0-1.75 11.49c0 .05.02.09.05.12.06.06.14.09.24.09.02 0 .04-.02.05-.04.13-4.09 1.31-7.52 1.82-11.55.13-1.05 0-1.09-.41-.11Zm-5.1 3.79c-.42.7-.67 1.48-.74 2.33-.08.84.05.87.38.09l.92-2.14c.06-.15 0-.33-.15-.4a.32.32 0 0 0-.41.12Z"
      style={{
        fill: "#debf61",
      }}
    />
    <path
      d="M50.06 157.77c2.55-.22 3.96 1.62 4.24 5.51.03.35.18.68.44.92 1.23 1.17 2.85 1.36 3.97 2.39 1.65 1.53 2.81 3.37 3.5 5.52.1.3.3.55.58.7.4.23.88.3 1.43.22.28.73-.12 1.68-1.21 2.87l-2.85 2.97c-2.98.9-6.34.75-10.08-.46l-.02-20.64ZM57.09 249.77l2.22 3.47c.2.31.14.55-.18.74l-8.93 5.24c-.22-.62-.36-.79-.41-.51l-.03-9.04c.25-.55.6-.89 1.06-1.04 1.64-.54 3.87 1.53 6.27 1.14Z"
      style={{
        fill: "#372231",
      }}
    />
    <path
      d="M164.04 239.05c3.68 4.11 7.04 10.58 4.91 15.63-.15.35-.38.43-.71.26-.92-.48-1.57-.8-2.64-.82-7.43-.12-15.01 1.71-22.31.26-.56-.11-.95-.63-.89-1.2l.48-4.57c.31 1.01.9 1.69 1.79 2.04.23.09.36.27.38.52l.04.5c.17 2.13 2.99 2.75 4.04.89.59-1.04.81-2.11.66-3.21-.04-.3.15-.59.45-.67.3-.08.6.08.72.36.56 1.38 1.61 1.88 3.15 1.51.39-.09.58-.34.55-.75l-.29-4.73 3.57 6.48c.37.67 1.36.57 1.58-.16l1.16-3.68a.58.58 0 0 1 1.06-.11c.71 1.27.81 2.61.3 4.01-.12.32.28.58.53.34 2.29-2.19 2.78-6.49 1.47-12.9Z"
      style={{
        fill: "#361319",
      }}
    />
    <path
      d="M82.58 107.96c-2.79 1.03-2.21 4.43-2.11 6.49a1.962 1.962 0 0 1-2.34 2.03c-5.4-1.05-10.74-1.48-16.01-1.29-.57.02-.73.35-.5.99.09.24.27.37.53.4 1.48.16 2.98.12 4.35.82 5.73 2.91 11.72 3.38 17.97 1.39 1.35-.43 2.57-.24 3.66.56.32.23.13.73-.26.7l-2.16-.19c-.33-.03-.64.04-.93.22-3.27 2.04-6.68 2.79-10.21 2.25-5.99-.91-10.37-1.49-13.14-1.73a1.2 1.2 0 0 0-.9.31l-4.4 3.94c1.15-1.29 1.85-2.52 2.1-3.7.2-.95-.89-1.64-1.67-1.06-1.91 1.42-3.88 1.46-5.91.11a.732.732 0 0 1-.35-.64l.02-4.36c0-.34.25-.64.59-.7 4.01-.71 3.32-4.93 6.91-4.39 3.36.51 6.61 1.41 9.76 2.72 2.48 1.02 12.6 3.6 12.23-1.18-.19-2.3.08-3.94 2.77-3.69Z"
      style={{
        fill: "#52513a",
      }}
    />
    <path
      d="M168.72 195.76c-.09-1.33 0-2.37.29-3.14.42-1.11.16-1.3-.77-.57a39.854 39.854 0 0 0-9.78 11.21c-.18.31-.64.26-.75-.08l-.56-1.67c-.09-.26-.25-.32-.49-.19l-.61.32c-.31.16-.62-.21-.41-.48l9.93-12.98c2.41-2.22 6.95-5.21 10.58-4.29 2.85.72 5.45 2.09 7.8 4.1.31.26.27.45-.11.58-5.43 1.77-10.47 4.16-15.12 7.19Z"
      style={{
        fill: "#5a3819",
      }}
    />
    <path
      d="M97.55 177.54c.27 6.61.17 12.96-.3 19.07-.17 2.24.68 5.18 2.55 8.82.16.31.26.29.31-.05l1.35-10.1c.04-.33.22-.53.55-.6.75-.16 1.1.07 1.06.69-.1 1.39.04 2.41.43 3.05-.52 3.96-.45 7.9.22 11.81.06.37.26.46.59.29.09-.05.18-.12.25-.23.06-.09.08-.21.07-.36-.41-5.91.72-11.42 3.4-16.53.18-.34.69-.2.67.18l-.53 10.17c0 .21.14.39.35.42.21.03.4-.1.45-.31.18-.81.63-1.43 1.35-1.88.29-.17.46-.43.53-.76l1.26-6.36c.17-.87 1.39-.95 1.67-.11 1.65 4.97 1.72 9.96.19 14.98-.09.31.02.47.35.49.76.05 1.26-.25 1.51-.9 1.14-3.03 2.71-5.84 4.72-8.43.47-.61.98-.9 1.53-.88.54.02.86.61.57 1.07-1.55 2.43-2.09 4.46-1.63 6.09-2.31 4.4-4.28 9.26-5.9 14.58-.1.33-.32.47-.66.4l-15.41-3.06c-.37-.07-.63-.28-.79-.62-1.63-3.53-3.91-6.57-4.51-10.35-1.65-10.35-.38-20.55 3.8-30.58Z"
      style={{
        fill: "#251726",
      }}
    />
    <path
      d="M125.56 66.18c-11.92-.95-22.31 13.8-25.65 23.41-.28.82-1.48.67-1.56-.19-1.2-13.07 15.96-22.56 26.69-25.98 1.59-.5 2.09.03 1.52 1.59l-.26.69c-.13.35-.37.51-.74.48ZM137.37 64.42c9.69 1.75 17.4 5.57 23.13 11.48 1.13 3.1 2.69 6 4.69 8.7.19.26.28.59.24.92-.48 3.93-.08 7.71 1.19 11.34-.27 1.08-.6 1.4-.98.95-3.18-3.71-4.8-7.22-5.36-12.09-.25-2.19-1.22-2.94-2.92-2.25-2.5-5.32-6.3-9.72-11.39-13.19-1.61-1.99-4.48-3.94-8.6-5.86ZM165.57 188.18l-9.93 12.98c-.21.27.1.64.41.48l.61-.32c.24-.13.4-.07.49.19l.56 1.67c.11.34.57.39.75.08 2.54-4.33 5.8-8.07 9.78-11.21.93-.73 1.19-.54.77.57-.29.77-.38 1.81-.29 3.14-5.39 3.49-9.83 8.14-13.3 13.94-.42-2.06.1-4.16 1.55-6.31.23-.33.18-.61-.15-.85l-.24-.17c-.25-.19-.46-.15-.65.1-2.37 3.35-3.85 7.07-4.44 11.15-.05.3-.19.55-.42.74-.37.29-.73.46-1.09.5.82-11.09 6.02-19.99 15.59-26.68Z"
      style={{
        fill: "#45211a",
      }}
    />
    <path
      d="M108.35 266.76c-3.24-1.95-8.01-4.42-11.05-7.46-.29-.29-.26-.52.11-.71l1.51-.74c.33-.16.73 0 .84.35 2.36 7.12 9.56 4.32 14.81 3.46.27-.04.52-.01.77.08l6.82 2.64c.31.12.33.55.04.7-3.62 1.83-10.12 3.92-13.85 1.68ZM121.06 268.32c-1.57 2.67-5.35 7.62-8.53 8.16-.34.05-.65-.2-.66-.55l-.21-5.51c-.01-.43.29-.81.71-.89l8.38-1.65c.43-.08.54.07.31.44Z"
      style={{
        fill: "#0b0a11",
      }}
    />
    <path
      d="M89.69 232.35c-.02-.55-.08-.96-.17-1.22-.27-.7-.43-.62-.5.24l-.59 7.46c-.03.35-.18.41-.45.2-2.24-1.68-.37-5.04-.41-7.38 0-.29-.4-.37-.52-.1-1.88 4.3-1.97 8.64-.27 13.03.21.55 1.03.4 1.03-.19v-2.47c0-.3.38-.42.56-.18l2.87 3.98c.11.56-.15 1.07-.78 1.54-1.81 1.36-3.64 2.48-5.5 3.37-6.15.22-9.69.33-13.43-3.97-.49-.56-.64-.48-.46.24.31 1.21.76 2.35 1.35 3.4.31.54.42.98.34 1.32-.09.37-.29.63-.61.8-.28.15-.51.09-.68-.18l-2.12-3.36c-.16-.25-.24-.52-.25-.81-.08-2.37-.27-4.73-.56-7.06-.4-3.16.64-5.44 1.54-8.32.06-.19.15-.32.26-.38.09-.05.19-.07.29-.06.18.02.25.12.21.3-.17.77-.04 1.48.39 2.12.22.33.72.24.81-.14 1.02-4.34 3.16-7.4 6.42-9.17-2.81 4.21-4.78 8.43-5.92 12.68-.12.45.26.89.72.82.19-.03.37-.13.56-.3.14-.13.24-.32.29-.55.39-1.62.9-2.9 1.53-3.83 1.26-1.43 2.49-3.35 3.69-5.76.18-.36.42-.54.73-.54s.44.16.36.47l-1.51 5.92c-.1.41.12.83.52.98.39.14.84-.04 1.02-.42.29-.61.4-1.28.34-2.01.16.05.3.34.42.86-.94 3.55-1.06 7.08-.37 10.6.21 1.03 1.14 1.9 2.17 1.35.29-.16.41-.51.28-.81-.49-1.14-.64-2.2-.43-3.18.46.65.71 1.34.76 2.08.01.1.06.15.16.15s.19 0 .28.01c.27 0 .37-.12.3-.37-.72-2.91-.87-5.85-.44-8.84.05-.31-.07-.54-.35-.68-.22-.11-.38-.13-.48-.07 2.03-5.29 5.32-9.47 9.87-12.53.12-.08.28-.06.37.05.1.1.1.26.01.37-3.43 4.13-3.17 5.35-3.65 10.54ZM146.2 233.1c3.98 4.17 5.89 6.63 8.17 11.96l.29 4.73c.03.41-.16.66-.55.75-1.54.37-2.59-.13-3.15-1.51a.612.612 0 0 0-.72-.36c-.3.08-.49.37-.45.67.15 1.1-.07 2.17-.66 3.21-1.05 1.86-3.87 1.24-4.04-.89l-.04-.5a.573.573 0 0 0-.38-.52c-.89-.35-1.48-1.03-1.79-2.04-.62-7.33-4.41-12.07-11.37-14.22-.35-.11-.41-.3-.17-.58 3.38-3.96 6.57-1.23 10.37-.41.33.07.64.02.93-.13 1.83-.98 3.01-1.03 3.56-.16Zm-5.63 3.67c2.25 2.35 4.29 4.91 6.13 7.68.21.31.18.6-.08.87-1.26 1.3-1.4 2.82-.41 4.57.17.31.35.31.54.02 3.6-5.56-3.48-13.39-7.78-16.18-.53-.35-1.16.28-.81.81.62.92 1.78 1.57 2.41 2.23Zm8.08 4.48c1.75 2.43 3.1 5.07 4.04 7.91.09.27.34.46.63.46h.47c.36 0 .62-.34.52-.68-.96-3.51-2.83-6.43-5.6-8.74-.19-.16-.48.03-.41.27.11.34.22.6.35.78Z"
      style={{
        fill: "#512218",
      }}
    />
    <path
      d="M224.36 52.92c-13.11-.13-26.17-.06-39.2.2-1.39.03-2.8-.65-4.35-.61-11.31.3-22.78.27-34.41-.08-.25-.01-.5.05-.73.17-1.75.91-1.86 1.67-.35 2.28l-8.79.05c.76-1.01 1.95-1.42 3.57-1.25.15.02.23-.05.22-.21-.01-.12-.01-.23-.01-.34 0-.13-.07-.2-.21-.21-9.09-.33-18.19-.29-27.29.12-5.05.23-17.4-.01-37.05-.73 4.35-1.56 8.54-1.31 12.88-1.56 7.26-.43 14.54-.2 21.78-.3 10.9-.16 21.13.14 31.7.33.44.01.85.19 1.17.49 1.52 1.47 3.07 1.38 4.64-.28.24-.27.59-.42.95-.43 7.16-.16 14.68.74 21.25.57 15.54-.39 32.44-1.33 48.64-1.25 2.75.01 5.35-.38 8.01-.77.73-.11 1.13.81.56 1.28-.63.52-1.41.67-2.32.45a.801.801 0 0 0-.93.48c-.17.44-.08.97.27 1.6ZM237.13 50.6c.23 13.03 0 26.03-.66 39.02-.21 3.95-.17 9.29.1 16.02.77 19.14.12 38.4.31 57.56.43 42.99-.85 86.03.72 129.01.02.65-.76.99-1.22.53l-6.63-6.77c1.46.03 2.21-.44 2.24-1.41 1.11-34.33 1.48-55.8 1.13-64.43-.24-5.93-.66-11.57-.15-17.64.68-8.1 1.09-17.82 1.23-29.17.29-23.58.57-47.16.82-70.74.01-.32.12-.64.33-.89.35-.42.52-.77.5-1.06-.81-12.63-.96-25.28-.45-37.93.16-4.06.74-8.09 1.73-12.1ZM46.55 52.92l.87.87c.24.24.35.53.32.87-.48 5.37 0 11.3-.13 16.03-.34 12.6.76 25.62-.27 38.15-.18 2.14.5 4.06.39 6.06-.67 12.85.11 25.89-.12 38.79-.13 7.27 1.21 16.16.23 23.99-.39 3.07-.42 5.74-.1 8.01.07.53.66.81 1.12.54.35-.21.58-.17.69.14.12.32.2.31.24-.03l.17-1.23.14 7.26-.33 12.52.05 14.81.21 18.91-.27 11.07.03 9.04c-1.19.19-1.74.98-1.65 2.38.5 7.03-.16 14.66-.34 21.74-.01.26.04.51.15.74.24.53.03 1.11-.63 1.73.04-.5-.38-.85-1.25-1.06-.33-.08-.5-.29-.51-.63-.25-14.18-.48-28.35-.68-42.51-.03-1.85.5-2.85 2.23-3.36.39-.12.6-.39.62-.8l.31-4.83a.725.725 0 0 0-.55-.75l-2.04-.48c-.37-.09-.55-.32-.54-.69.28-12.8.56-25.59.83-38.38.16-7.28 1.16-16.06 1.11-23.69-.02-2.65-1.15-4.91-.83-7.68 1.5-13.22.21-26.98-.27-40.26-.33-9-.31-25.12.07-48.37.11-6.37 1.89-11.86.73-18.9ZM239.12 172.85c.17.16.3.24.4.23 1.43 4.47 3.67 9.29 7.49 12.19 3.88 2.95 7.94 2.97 12.19 3.92.51.13.72.43.63.9-2.6 3.21-3.24 16.87-3.72 22.42-.03.32.06.65.24.92l.74 1.15c-.78 1.48-.98 3.11-.61 4.88.09.42.3.48.61.19.78-.72 1.25-1.74 1.41-3.06 3.03-1.55 5.74-1.85 8.12-.89.58.23.75.97.33 1.43l-3.89 4.26c-.26.28-.15.74.21.88l4.73 1.87c.35.14.5.55.32.89-1.18 2.18-3.96 2.35-6.08 3.02l-.71-.69c-.18-.17-.39-.28-.64-.33l-2.56-.46c-.33-.06-.37-.52-.05-.64l.65-.24c.39-.14.4-.68.02-.85l-1.51-.66a.785.785 0 0 1-.43-.95c.26-.85.02-1.31-.73-1.38a.433.433 0 0 0-.47.37l-.05.39-1.24-3.97c-.1-.32-.57-.29-.63.04-.31 1.72-.12 3.42.58 5.09.09.23.22.39.37.48.19.13.4.18.63.17.19 1.79.06 2.44-.39 1.97-2.56-3.86-2.08-7.31-2.68-10.82-1.49-8.69.04-16.04 2.66-24.98.1-.33-.01-.58-.32-.74-.75-.39-1.55-.58-2.4-.58l-5.8-2.56c-.52-.99-.98-1.29-1.37-.9-.51-1.68-.97-2.05-1.36-1.12l-5.51-9.57c-.19-.23.08-.98.82-2.27Zm20.27 50.97c2.25-1.01 3.62-4.52 5.42-6.39.18-.19.2-.39.07-.61-.21-.35-.71-.2-1.49.45-.23.19-.43.41-.62.64l-4.04 5.05c-.37.46.13 1.1.66.86Zm2.3-6.96c-2.15.42-4.2 3-3.99 5.21.04.36.51.46.69.15.97-1.69 2.24-3.1 3.79-4.25.53-.39.16-1.24-.49-1.11ZM225.53 285.15l1.55-.08c.19.3.27.7.24 1.21-.02.24.09.49.28.65l6.57 5.47c.49.41.2 1.2-.43 1.2-30.25-.14-60.81-.73-91.15.44-5.37.2-11.55-.38-16.05-.41-28.15-.21-56.3-.22-84.45-.05-.37.01-.46-.15-.27-.47.62-.99 1.19-1.5 1.7-1.52 6.67-1.35 11.6-2.08 14.79-2.21 14.69-.56 33.09-.32 50.93.27 35.63 1.17 72.32.58 110.07-1.77 2.69-.17 4.95-.47 6.78-.92.33-.08.49-.29.48-.64-.03-.55-.37-.94-1.04-1.17Z"
      style={{
        fill: "#cd9c35",
      }}
    />
    <path
      d="M153.77 169.15c2.04 1.85 2.08 3.99.13 6.43a32.97 32.97 0 0 1-7.74 8.71c-5.37 4.25-8.13 6.63-12.06 10.25-.3.27-.78.18-.95-.18a1.24 1.24 0 0 1-.11-.78c.03-.2.17-.41.4-.63 2.35-2.25 2.93-4.12 1.74-5.63l5.41-6.32c5.69-2.17 10.09-6.12 13.18-11.85Z"
      style={{
        fill: "#815923",
      }}
    />
    <path
      d="M140.55 98.17c.15-.03.29-.06.43-.09l6.38 1.52-.65 12.51c0 .33.05.64.18.93.69 1.45.93 2.96.74 4.53-.04.31.02.61.17.9 1.05 1.99.86 3.7-.55 5.13l-3.41-3.47c-.24-.25-.23-.48.04-.7 5.36-4.33-2.59-9.07-5.88-10.44l.98-.32c.33-.11.47-.33.4-.68-.09-.45.08-.79.51-1.04.15-.09.09-.32-.09-.32h-.57c-.53 0-.81-.62-.46-1.02 1.47-1.65 2.01-3.57 1.64-5.75-.05-.26.02-.48.21-.67l.24-.24c.12-.11.13-.24.02-.37l-.33-.41ZM98.97 229.65c1.17.39 1.88 1.29 2.14 2.7.07.37.29.56.66.58 5.04.26 15.39 1.62 17.58 6.74.08.19.21.23.39.12l.26-.15c.12-.07.23-.06.33.03 1.69 1.49 2.96 3.22 3.79 5.19-6.25-1.97-18.48-5.71-24.56-3.16-1.07.45-1.63.1-1.69-1.06-.19-3.84.17-7.5 1.1-10.99Z"
      style={{
        fill: "#cea44c",
      }}
    />
    <path
      d="m227.05 143.15.29 4.94c-.5.5-.67 1.08-.51 1.74.15.6-.45 1.11-1.01.87-1.63-.68-3.22-.76-4.77-.24-5.53 1.89-8.42-.31-13.27-1.44-6.77-1.57-13.65-2-20.65-1.29-2.93-.14-5.25-.85-6.98-2.14-1.76-3.16-.7-5.29 2.96-4.96 6.71.6 13.31.07 19.81-1.6 1.31-.34 2.72-.41 4.22-.21 3.39.45 6.73.25 10.02-.58.63-.16 1.19.45.97 1.07-.05.12-.07.23-.07.32 0 .23-.11.39-.34.47l-3.24 1.08c-.13.05-.25.13-.34.23-.99 1.14-2.25 1.52-3.8 1.15-.39-.1-.8.11-.95.48-.16.38-.02.81.33 1.02.86.53 1.88.67 3.07.44 3.25-.64 6.39-.3 9.42 1.02.3.13.65.11.93-.06l3.91-2.31Z"
      style={{
        fill: "#596042",
      }}
    />
    <path
      d="M152.37 158.93c-2.16.29-3.85 1.16-5.08 2.63-.21.25-.48.4-.8.45-1.83.29-3.64.32-5.43.11-2.56-.3-10.13 1.49-12.49 3.31-.27.21-.62.28-.96.2-2.05-.52-3.37.98-4.86 1.3-2.05.45-4.12.62-6.2.53-.33-.02-.63-.18-.83-.44-1.49-1.96-3.28-2.8-5.37-2.53l-.36-3.03c-.03-.31-.2-.59-.45-.77-.84-.61-1.16-1.44-.95-2.47.05-.27.17-.52.35-.72 1.67-1.95 2.37-4.23 2.1-6.82-.03-.28.19-.53.47-.54 5.18-.09 10.21-1.02 15.1-2.77.19-.06.35-.2.45-.37l14.68-24.09c.2-.33.47-.41.82-.26 7.63 3.33 8.12 17.83 9.66 24.02.08.32.07.64-.04.95-.91 2.67-1.7 4.85-.73 7.73.44 1.31.75 2.51.92 3.58Z"
      style={{
        fill: "#e5c978",
      }}
    />
    <path
      d="M164.04 239.05c1.31 6.41.82 10.71-1.47 12.9-.25.24-.65-.02-.53-.34.51-1.4.41-2.74-.3-4.01a.58.58 0 0 0-1.06.11l-1.16 3.68c-.22.73-1.21.83-1.58.16l-3.57-6.48c-2.28-5.33-4.19-7.79-8.17-11.96l3.61 1.48c.3.13.64.07.88-.15 2.01-1.82 4.21-2.17 6.62-1.06 2.99 1.39 5.23 3.28 6.73 5.67Z"
      style={{
        fill: "#6c391e",
      }}
    />
    <path
      d="M136.79 239.24c4.01 3.75 5.3 8.28 3.85 13.61-.07.27-.25.41-.53.43l-6.2.38c-1.43-1.39-3.52-2.31-6.28-2.74 3.03.14 5.43-.64 7.22-2.34.24-.23.4-.53.46-.86l1.48-8.48Z"
      style={{
        fill: "#b4853d",
      }}
    />
    <path
      d="M179.23 145.49c-.03-.31.28-.27.92.1 1.73 1.29 4.05 2 6.98 2.14l21.68 4.1c.67.13.67.26 0 .39l-7.95 1.55-23.09 1.2 1.46-9.48Z"
      style={{
        fill: "#3e4030",
      }}
    />
    <path
      d="m217.63 127.26 2.24.85c.35.13.58.38.7.73.27.79.73 1.47 1.39 2.04.24.2.56.3.88.26 1.21-.15 2.59.81 3.37.34.56-.34.8-1.13.72-2.37l.14 9.31c-2.94-2.07-9.29-5.77-13.99-6.25-2.97-.31-5.8 1.52-9.52.46a.64.64 0 0 1-.46-.58c-.07-1.35.49-1.91 1.7-1.67 3.14.63 5.6.06 7.39-1.71.24-.24.53-.39.86-.46l4.58-.95Z"
      style={{
        fill: "#606257",
      }}
    />
    <path
      d="M136.52 69.6c10.17 1.45 18.72 9.02 20.49 19.24.07.4-.1.57-.5.5l-6.14-1.02c.37-1.65.2-3.26-.52-4.81-.79-1.7-2.8-2.6-3.45-5-.09-.33-.26-.6-.51-.82l-9.37-8.09ZM151.46 130.99c1.52-6.23-2.33-11.31-1.98-16.92.29-4.77.92-9.61 1.89-14.51.69-.39 1.71-.6 3.05-.61.45 0 .6.21.45.64-3.63 10.53-3 18.66 1.96 27.88.13.23.13.52.01.76l-3.35 6.88c-.23.48-.93.4-1.06-.11l-.97-4.01Z"
      style={{
        fill: "#64421e",
      }}
    />
    <path
      d="M50.08 178.41c3.74 1.21 7.1 1.36 10.08.46-1.96 4.12 1.03 7.65 4.83 8.99 3.99 1.4 6.61.31 10.57-.04l-1.74 5.89c-4.3-1.63-9.16-1.51-13.05-2.01a.63.63 0 0 1-.55-.64c0-.33.27-.59.59-.61l1.97-.13c.21 0 .3-.27.15-.42a.906.906 0 0 0-.44-.21c-3.17-.68-6.37-1.2-9.59-1.56-.41-.05-.72-.16-.93-.34-.44-.4-.16-1.13.43-1.13 1.69 0 3.39-.04 5.09-.07.39 0 .67-.14.83-.39.24-.37.14-.53-.3-.46-2.97.43-5.59-.32-7.87-2.24l-.07-5.09Z"
      style={{
        fill: "#76442b",
      }}
    />
    <path
      d="M171.14 162.7c7.56 3.67 12.12 5.94 15.53 12.99l5.29 11.25c.1.21.02.45-.18.56s-.45.05-.58-.14l-1.72-2.62c-3.47-6.78-10.06-12.78-17.8-12.8-1.5 0-2.92-.11-4.26-.32l-.89-2.98c-.1-.33.02-.55.36-.65 2.43-.69 3.84-2.46 4.25-5.29Z"
      style={{
        fill: "#633b20",
      }}
    />
    <path
      d="M153.9 175.57c-.74 2.31-.3 4.21 1.33 5.68.27.24.27.49.02.74-.48.48-1.04.65-1.68.51-2.05-.33-4.23.27-6.56 1.82-5.75 3.84-10.27 8.33-13.55 13.48-.98 1.62-2.07 3.24-3.28 4.85-4.44 5.94-7.71 13.02-11.21 19.55-.48.89-1.09 1.22-1.83.99a.628.628 0 0 1-.41-.8c4.5-12.7 10.65-24.39 18.45-35.08 1.19 1.51.61 3.38-1.74 5.63-.23.22-.37.43-.4.63-.05.27-.01.53.11.78.17.36.65.45.95.18 3.93-3.62 6.69-6 12.06-10.25a32.97 32.97 0 0 0 7.74-8.71Z"
      style={{
        fill: "#513c26",
      }}
    />
    <path
      d="M140.57 236.77c-.63-.66-1.79-1.31-2.41-2.23-.35-.53.28-1.16.81-.81 4.3 2.79 11.38 10.62 7.78 16.18-.19.29-.37.29-.54-.02-.99-1.75-.85-3.27.41-4.57.26-.27.29-.56.08-.87a55.368 55.368 0 0 0-6.13-7.68ZM136.79 239.24l-1.48 8.48c-.06.33-.22.63-.46.86-1.79 1.7-4.19 2.48-7.22 2.34-2.03-.48-3.96-.62-6.01-1.33-3.68-1.28-10.24-3.18-13.87-1.34-.28.14-.47.36-.58.65-.29.8-.99 1.12-2.08.95 1.19-2.31 2.88-4.27 5.05-5.87.26-.19.59-.26.91-.19 1.83.41 3.64.79 5.45 1.12 4.18.76 7.92 2.98 12.05 3.71 6.89 1.22 2.66-9.77 1.43-12.36-.16-.34.14-.71.5-.63 2.63.57 4.74 1.78 6.31 3.61ZM148.65 241.26c-.13-.18-.24-.44-.35-.78-.07-.24.22-.43.41-.27 2.77 2.31 4.64 5.23 5.6 8.74.1.34-.16.68-.52.68h-.47c-.29 0-.54-.19-.63-.46-.94-2.84-2.29-5.48-4.04-7.91Z"
      style={{
        fill: "#9c6a37",
      }}
    />
    <path
      d="M106.4 183.37c-2.15 4.77-3.12 9.79-2.9 15.06-.39-.64-.53-1.66-.43-3.05.04-.62-.31-.85-1.06-.69-.33.07-.51.27-.55.6l-1.35 10.1c-.05.34-.15.36-.31.05-1.87-3.64-2.72-6.58-2.55-8.82.47-6.11.57-12.46.3-19.07.15-.21.34-.58.57-1.11.2-.44.44-.7.72-.79.29-.09.55-.03.79.16.27.21.37.48.31.81-.87 4.76 1.52 7.6 6.46 6.75ZM130.71 205.46l-7.19 21.42-3.23-2.35c-.31-.22-.39-.5-.24-.85 1.67-3.95 4.08-7.37 6.03-11.23 1.23-2.44 2.77-4.77 4.63-6.99Z"
      style={{
        fill: "#3c2925",
      }}
    />
    <path
      d="m227.02 85.89.09 8.77c-1.03.05-1.85-.74-2.47-2.39a.946.946 0 0 0-.4-.46l-3.47-1.98a.961.961 0 0 1-.47-.82c.01-1.27-.3-2.42-.94-3.47-.32-.52-1.11-.42-1.28.17-.63 2.22-1.77 4.02-3.4 5.39l-1.91-2.78c.35-.21.64-.5.85-.87l2.71-7.5c.25-.69 1.1-.93 1.68-.47 2.36 1.89 5.47 2.33 7.11 4.85.18.27.47.44.79.46.67.05 1.04.42 1.11 1.1Z"
      style={{
        fill: "#9ea87e",
      }}
    />
    <path
      d="M160.5 75.89c4.8 3.64 7.98 8.47 9.55 14.49 4.46 17.13 5.12 34.46 5.95 51.79.05 1.12-.19 2.38-.72 3.77-.95 2.5-1.25 5.12-.9 7.87.04.31-.1.62-.36.78l-4.43 2.79c.45-.86.33-1.48-.36-1.87a1.84 1.84 0 0 1-.65-.65 5.58 5.58 0 0 1-.78-2.67c0-.3-.1-.57-.28-.8-.61-.79-.88-1.64-.82-2.54.03-.4.24-.62.64-.65l2.19-.2c.45-.04.68-.29.68-.75-.04-3.76 1.7-7.46 1.7-10.52 0-3.73-1.29-7.15-3.86-10.26-.34-.41-1-.1-.9.42l1.47 7.49c.04.19.01.4-.08.57-.73 1.41-1.9 1.91-3.49 1.52-.44-.11-.63-.39-.58-.84l.4-3.43c.03-.29.03-.58-.02-.87-.96-5.62.52-10.47 2.48-15.93 2.49-6.94 2.46-12.21-.71-18.55-1.27-3.63-1.67-7.41-1.19-11.34a1.3 1.3 0 0 0-.24-.92c-2-2.7-3.56-5.6-4.69-8.7Z"
      style={{
        fill: "#1d111f",
      }}
    />
    <path
      d="M157.28 133.45c.67 4.12.51 8.2-.46 12.25-1.37 5.72-.46 8.67 4.18 12.14 1.63 1.22 2 2.69 1.12 4.42-.13.26-.44.38-.71.28a.573.573 0 0 1-.38-.66c.15-.75-.04-1.44-.57-2.05-.79-.91-2.28-.54-2.54.64-.27 1.2-.37 2.35-.31 3.44.22 4.24 7.08 6.36 2.05 11.33-.27.26-.4.58-.41.96-.04 2.05-.56 3.16-1.56 3.35-.83-.96-1.32-1.88-1.45-2.75-.05-.33.03-.66.2-.94 3.47-5.45-2.05-8.31-1.27-13.62.23-1.49.69-2.92 1.38-4.29.15-.29.16-.63.04-.93-.74-1.9-2.68-4.59-2.57-6.51.08-1.36.77-2.27.8-3.53.08-2.72-.58-5.63.14-8.08.51-1.7 1.28-3.52 2.32-5.45Z"
      style={{
        fill: "#632f15",
      }}
    />
    <path
      d="M124.12 244.86c-.83-1.97-2.1-3.7-3.79-5.19-.1-.09-.21-.1-.33-.03l-.26.15c-.18.11-.31.07-.39-.12-2.19-5.12-12.54-6.48-17.58-6.74-.37-.02-.59-.21-.66-.58-.26-1.41-.97-2.31-2.14-2.7.55-1.59 1.15-3.12 1.78-4.6 1.13-2.63 1.85-2 4.57-1.77 7.74.64 17.23 4.09 21.15 11.31 1.74 3.23 3 6.58 3.78 10.06.22.99-.71 1.86-1.69 1.56l-4.44-1.35ZM127.63 250.92c2.76.43 4.85 1.35 6.28 2.74l-27.99 5.21c-.35.07-.66-.02-.93-.25-2.46-2.1-1.07-6.31.1-8.77 1.09.17 1.79-.15 2.08-.95.11-.29.3-.51.58-.65 3.63-1.84 10.19.06 13.87 1.34 2.05.71 3.98.85 6.01 1.33Z"
      style={{
        fill: "#d5af5c",
      }}
    />
    <path
      d="M167.42 171.62c1.34.21 2.76.31 4.26.32 7.74.02 14.33 6.02 17.8 12.8l-3.09-.91c-.67-.2-.76-.05-.27.45 2.87 2.93 5.05 6.35 6.52 10.24-4-5.03-6.77-8-8.3-8.91-6.33-3.75-13.16-5.79-20.49-6.14-.75-.03-1.1-.94-.57-1.47 1.9-1.91 3.28-4.03 4.14-6.38Z"
      style={{
        fill: "#3e221e",
      }}
    />
    <path
      d="M50.15 183.51c2.28 1.92 4.9 2.67 7.87 2.24.44-.07.54.09.3.46-.16.25-.44.38-.83.39-1.7.03-3.4.06-5.09.07-.59 0-.87.73-.43 1.13.21.18.52.29.93.34 3.22.36 6.42.88 9.59 1.56.19.04.33.11.44.21.15.15.06.41-.15.42l-1.97.13a.63.63 0 0 0-.59.61c-.01.32.23.6.55.64 3.89.5 8.75.38 13.05 2.01l-.68 1.52c-5.7-1.37-9.35.59-14.08-.14-.68-.11-1.09-.53-1.22-1.28-.06-.34-.26-.53-.6-.57l-7.14-.88-.14-7.26c-.15-.26-.09-.79.19-1.6ZM50.03 238.61l8.2.5c-1.75 3.79-2.13 7.35-1.14 10.67-2.4.39-4.63-1.68-6.27-1.14-.46.15-.81.49-1.06 1.04l.27-11.07Z"
      style={{
        fill: "#563a35",
      }}
    />
    <path
      d="M227.9 200.35c.49 25.59.62 51.18.38 76.77 0 .29-.33.54-.99.75l-.29-8.99.21-25.83-.05-14.94-.04-20.1.78-7.66Z"
      style={{
        fill: "#c1921b",
      }}
    />
    <path
      d="m85.83 31.58-5.41 1.71c-.33.11-.7.01-.93-.26a10.72 10.72 0 0 0-3.58-2.71c-.29-.14-.51-.35-.67-.62-.55-.98-1.5-1.77-2.85-2.37.04-.61.17-1.03.39-1.27.21-.23.55-.21 1.04.05 3.61 1.93 7.62 3.75 12.01 5.47ZM109.11 35.13l-6.31 1.6c-1.95-.33-3.75-.16-5.39.49L84.07 33.6l3.43-1.58c6 .97 11.86.72 17.57-.77 2.58-.68 5.11-2.3 7.78-3.14 1.14-.35 2.01-.01 2.6 1.02 2.1 3.66-3.95 5.38-6.34 6ZM17.36 74.32l-.85 4.27c-.64 2.66-.61 5.3.1 7.93.14.53.47.71 1 .55l.65-.21c.37-.12.74.2.67.58-.45 2.5-.49 4.99-.12 7.48.08.53.39.84.92.91l.64.08c.29.04.48.34.39.62l-1.48 4.74c-4.38-10.22-8.71-22.29-6.76-34.21.06-.35.24-.62.53-.81 1.06-.7 2.12-.73 3.19-.09.3.18.46.45.49.8l.63 7.36ZM24.64 108.42c.63-.23 1.05.02 1.25.75.05.2.16.37.31.52.77.72 1.13 2.07 1.06 4.04l.47 2.84c.06.38.53.51.78.23.35-.39.78-.61 1.29-.68.53-.07.69.15.47.64-1.41 3.21-1.78 6.49-1.12 9.84.62 3.15 0 5.24-.38 8.17l-2.74 8.51c-.12.39-.6.53-.92.27-.36-.3-.45-.65-.28-1.04 3.91-8.8 1.66-23.14-1.96-31.69.2-.69.79-1.49 1.77-2.4ZM19.08 244.61l-.44 6.2c-.03.37-.23.56-.6.56h-.44c-.21 0-.36.1-.45.29-.93 2.05-1.38 4.2-1.36 6.45-1.29 2.98-1.99 6.36-2.11 10.14-.02.54-.71.73-1.01.28-.26-.39-.35-.94-.28-1.65.77-7.61 2.71-14.9 5.8-21.89.1-.23.28-.35.53-.37.11-.01.23-.01.36-.01ZM149.98 306.6l-.49-.61c-.07-.09-.16-.12-.27-.07-.31.13-.33.2-.06.21l-.91.67a.33.33 0 0 1-.38 0c-.15-.11-.16-.24-.04-.41 1.99-2.78 3.82-6.63 7.98-6.29.32.03.37.16.14.39l-5.97 6.11ZM153.56 306.88h-1.04c-.53 0-.79-.65-.4-1.01l4.27-3.91c.32-.3.84.01.72.44l-1.73 6.11c-.16.58-.36.59-.59.03l-.48-1.16c-.13-.33-.38-.5-.75-.5ZM178.92 313.23c-.29 1.7-1.69 2.92-4.19 3.67-.52-.18-1.09-.18-1.72.01a.308.308 0 0 1-.37-.18.31.31 0 0 1 .15-.39l6.13-3.11Z"
      style={{
        fill: "#f2e0a1",
      }}
    />
    <path
      d="M113.8 145.32a.407.407 0 0 1 .03.8c-4.17.88-8.82.19-12.67.39-3.37.17-6.74.03-10.11-.43a.323.323 0 0 1 0-.64c7.58-1.1 15.16-1.14 22.75-.12ZM128.6 308.85c-.2.27-.41.44-.64.51-.25.08-.43 0-.55-.22l-1.44-2.59-5.72-6.08c-.32-.35-.25-.53.22-.54 4.79-.16 7.85 4.73 8.13 8.92Z"
      style={{
        fill: "#d9c682",
      }}
    />
    <path
      d="M102.8 36.74c.39.7.33 1.34-.19 1.93-1.41 1.57-2.39 1.72-2.96.43.73-.34 1.11-.66 1.16-.97.06-.39-.1-.54-.49-.45-2.88.65-5.62 1.89-8.21 3.74-1.52-.38-2.47-.03-2.86 1.06-1.43.23-2.67-.39-3.7-1.86 2.03.29 3.89.15 5.6-.41 2.65-.87 2.57-1.23-.23-1.08-1.05.05-2.8.27-5.27.65-.16.03-.27.11-.32.26-.03.09-.04.19-.02.29-.29.07-.56.08-.79.03a.843.843 0 0 1-.64-.57c-.26-.75-.78-1.04-1.57-.87 4.37-1.81 9.41-2.37 15.1-1.69 1.64-.65 3.44-.82 5.39-.49ZM257 71.61c2.88 3.71 3.94 7.91 3.18 12.59l-.6 2.48c-.11.45-.39.61-.83.47l-.56-.18c-.73-.23-1 .02-.8.76.57 2.12.54 4.17-.11 6.14-1.28-.77-2.37-.74-3.27.08-1.07-1.66-1.87-3.54-2.41-5.63-.05-.19-.22-.16-.52.07-.17-1.07.11-1.69.82-1.87l2.2 5.73c.13.33.32.38.58.13.19-.19.25-.44.16-.75-.89-3.01-1.19-5.9-.88-8.67.13-1.15-.24-2.22-1.09-3.22L254.5 78c2.06 4.75-.86 8.29 1.72 13.44.28.57.41.53.38-.1-.13-2.62-1.65-5.58-.2-8.32.15-.27.2-.56.17-.87l-.72-6.15c-.03-.25-.17-.38-.42-.37h-.36c.06-.65.37-1.15.94-1.5.37.37.58.81.65 1.32.38 2.96.73 5.84 1.05 8.63.02.21.2.37.42.38.21 0 .4-.15.44-.36.34-1.84.29-10.18-2.5-10.55.58-.31.89-.95.93-1.94ZM243.81 97.85c3.91 5.25 5.59 11.29 5.04 18.12-.04.49-.57.78-1.01.56l-1.07-.55c-.37-.19-.54-.08-.5.34l.83 9.19c.04.39-.1.69-.42.9-.59.41-.79.9-.6 1.48a23.94 23.94 0 0 1 1.07 8.64.67.67 0 0 1-.98.55l-.61-.33c-.32-.17-.69.12-.59.47l1.61 5.57c.21.74-.57 1.38-1.25 1.01l-4.01-2.17c-.39-.49-.62-1.41-.69-2.77l2.88 2.83c.23.23.47.24.72.03.34-.29.35-.64.02-1.07-1.8-2.36-2.93-4.62-3.4-6.78-.51-2.37-1.11-4.06-1.8-5.07-1.4-4.72-1.09-9.19.93-13.4.99 3.25 2.51 6.25 4.54 8.99.34.45 1.06.22 1.07-.34.06-3.35-.36-6.66-1.27-9.91-.19-.69-.54-1.11-1.04-1.25-.59-.16-.81.06-.64.65l2.44 8.89c.04.15-.05.32-.2.36-.15.05-.29.04-.44-.03-.17-.08-.3-.26-.41-.55-1.63-4.48-2.66-9.47-3.11-14.98-.92-1.79.04-3.54 2.88-5.25.46 3.51 1.52 7.11 3.19 10.8.15.33.65.21.63-.15-.23-4.12-1.33-7.98-3.3-11.59-.14-.26-.5-.3-.69-.08-.13.14-.17.28-.14.41-.59-.78-.49-1.95.32-3.52Zm-.96 7.75c-.22 2.88.53 5.44 2.25 7.69.15.2.43.25.65.12a.49.49 0 0 0 .17-.63l-1.4-2.73a.475.475 0 0 1-.06-.24c.03-1.46-.24-2.9-.81-4.33-.44-1.11-.71-1.07-.8.12Zm.28 25.86-2.41-6.58c-.11-.31-.32-.4-.62-.27-.23.09-.32.26-.27.51.56 2.78 2.11 8.19 5.28 9.63.38.17.56.05.53-.37-.26-3.45-1.23-9.59-3.91-11.8-.38-.31-.49-.24-.34.23l2.64 8.34c.08.25-.05.51-.3.6a.485.485 0 0 1-.6-.29ZM246.54 186.71l-2.17 7.35c-.11.37.03.56.42.56h1.23c.37 0 .64.36.53.71l-1.78 5.89c-.11.37.02.5.4.39l1.12-.33c.46-.13.71.04.74.51.21 2.97-.13 5.87-1.02 8.71-.11.35-.04.66.23.92 1.9 1.84.44 8.27-.32 10.62-.13.41 0 .54.4.39l1.6-.62c.37-.14.77.1.82.49.79 6.5-.78 12.47-4.71 17.91-.27-.57-.5-.89-.68-.97 2.56-4.29 3.98-8.72 4.26-13.28a.466.466 0 0 0-.91-.17l-3.35 10.92c-1.71-1.75-2.75-3.85-3.14-6.32 1.1-.35 1.55-1.52 1.35-3.52-.27-2.67.52-6.15 2.35-10.46a.89.89 0 0 0 .16-.38c.06-.27.23-.4.5-.41.1 0 .21 0 .33-.02.22-.02.39.2.31.41a56.258 56.258 0 0 0-2.41 8.36c-.29 1.38.14 1.62 1.27.72.11-.09.29-.57.56-1.45.94-3.13 1.2-6.33.79-9.6-.08-.59-.29-.64-.63-.15l-1.38 1.96c-2.13 2.72-3.24 5.22-3.33 7.49-1.89-4.06-2.34-7.89-1.34-11.49.55.26.78.73.67 1.41-.05.33-.06.56-.01.7.07.24.2.41.38.52.28.17.48.1.6-.2l3.17-8.15c.18-.47.41-.49.7-.08.14.21.15.47.03.78a53.386 53.386 0 0 0-2.6 8.03c-.11.44.03.54.41.29 2.4-1.55 3.42-8.74 3.57-11.44.03-.63-.2-.76-.71-.37l-1.51 1.19c-.3.23-.71-.1-.55-.44 1-2.14 1.36-4.22 1.09-6.25.23-.13.35-.38.34-.76-.01-.57-.24-.67-.67-.29l-2.61 2.27c.55-4.63 1.92-9.05 4.13-13.25.39-.39.85-.09 1.37.9Zm-1.21 38.17c-2.03 1.26-2.68 6.08-2.48 8.18.04.37.56.42.66.06l2.28-7.9c.08-.27-.22-.49-.46-.34ZM35.33 204.88c.93 2.09 1.42 4.25 1.47 6.48 0 .24-.1.42-.31.53l-.38.21c-.15.08-.23.03-.24-.14-.06-1.17-.32-2.18-.77-3.03l-1.13-3.54c.24-.45.69-.62 1.36-.51ZM94.21 295.26c1.25 1.25 3.15 2.09 5.68 2.52.73 0 1.24-.45 1.51-1.32l5.79 4.28c.86.64 1 .51.43-.4-1.13-1.78-2.77-3.22-4.92-4.32l2.33-.49s-.11.12-.17.23c-.11.18-.07.33.11.44 2.37 1.41 3.86 3.48 4.46 6.19.1.44-.08.68-.53.73-1.97.19-3.66-.36-5.09-1.65-.27-.25-.59-.32-.95-.21-1.91.58-3.75.35-5.52-.68a1.1 1.1 0 0 0-1.07-.02c-3.94 2.07-9.27.86-13.17-.99l1.4-1.98c.29-.03.35.09.2.36-.08.15-.04.24.13.27l8.12 1.58c.25.05.5-.1.58-.34.08-.24-.03-.5-.26-.61-2.13-1.03-4.54-1.46-7.23-1.29.96-1.73 2.5-2.32 4.63-1.78.31.07.58.01.83-.19 1.08-.89 1.98-1 2.71-.33Zm-2.58 1.99 8.52 3.62c.24.1.52.01.65-.22s.06-.52-.15-.67a17.834 17.834 0 0 0-8.84-3.34c-.17-.01-.25.06-.25.23v.28c0 .05.02.08.07.1ZM189.52 297.48l-6.39 1.36c-.23.05-.38.27-.33.51.04.23.27.38.5.34l9.02-1.58c-.09 1.29.08 1.91.51 1.85-4.27 1.88-8.52 2.13-12.73.75-.33-.11-.66-.11-.99-.02-1.69.48-3.93 1.65-5.52.4-.31-.24-.6-.22-.87.05-1.34 1.35-2.96 2.08-4.87 2.19-.95.05-1.53-1.04-.94-1.79l4.37-5.62c-.39-.29.39-.27 2.33.04l-4.77 4.36c-.25.23-.21.41.1.54.2.08.42 0 .65-.2 1.63-1.51 3.44-2.79 5.42-3.82v.52c.02.41.21.54.6.41.61-.21.91-.22.89-.01l4.94-1.79c.15-.05.23-.21.19-.36a.3.3 0 0 0-.34-.23c-.25.04-.5-.01-.73-.15 2.51-.22 5.28-.02 8.31.59.62.13.84.68.65 1.66Zm-14.09 2.31.39 1c.05.14.2.2.34.15l.12-.05c4.84-1.88 8.65-3.71 8.51-4.08l-.07-.16c-.14-.37-4.18.87-9.02 2.75l-.12.05c-.14.05-.2.2-.15.34Z"
      style={{
        fill: "#d5ae43",
      }}
    />
    <path
      d="M191.74 199.73c2.8 6.03 6.71 13.67-.81 18.65l-5.8 1.01c-.3.05-.51.33-.48.64.03.31.3.54.61.52l7.06-.34c-.23 1.05.21 1.81 1.3 2.27.58.25.95.47 1.1.68.31.43.33.91.07 1.44l-3.67-.29-2.26-.67c-.3-.09-.52-.27-.67-.55-1.09-2.06-3.14-.99-4.61-1.08-3.47-.23-6.82-.66-10.03-1.28a.416.416 0 0 1-.34-.44.42.42 0 0 1 .38-.4c6.61-.67 12.66-2.84 18.17-6.51.3-.19.49-.47.57-.82 1.49-6.47-1.72-9.28-5.26-13.84-.18-.23-.14-.42.11-.55.19-.11.36-.09.5.05 1.19 1.18 2.55 1.68 4.06 1.51Z"
      style={{
        fill: "#251d32",
      }}
    />
    <path
      d="m96.84 229.88-1.09 8.51c-.17.44-.5.58-.97.42-.28-.1-.5-.3-.63-.56-.42-.87-1.01-1.24-1.76-1.1-.64-3.57-.53-6.81.32-9.7 1.03-.43 1.72-1.12 2.08-2.05.4-1.03 1.92-.77 1.95.33l.1 4.15ZM89.69 232.35c-.14 4.44.55 8.63 2.08 12.57.09.24.1.42.03.53-.1.14-.29.23-.56.27l-2.87-3.98c-.18-.24-.56-.12-.56.18v2.47c0 .59-.82.74-1.03.19-1.7-4.39-1.61-8.73.27-13.03.12-.27.52-.19.52.1.04 2.34-1.83 5.7.41 7.38.27.21.42.15.45-.2l.59-7.46c.07-.86.23-.94.5-.24.09.26.15.67.17 1.22Z"
      style={{
        fill: "#bf9653",
      }}
    />
    <path
      d="M70.27 30.22c2.56.13 4.83.88 6.82 2.23-2.53.51-4.77.13-6.72-1.12-.27-.18-.37-.43-.29-.74.03-.15.1-.27.19-.37ZM99.1 41.74c-1.04 1.04-2.48 1.52-4.33 1.44 1.25-1.33 2.71-2.15 4.37-2.47.41-.08.55.08.4.48-.08.21-.23.4-.44.55ZM29.01 58.57l.57.18c.41.13.35.72-.07.78-3.43.47-6.6-.19-9.51-1.96a.353.353 0 0 1-.14-.45.35.35 0 0 1 .42-.21l2.73.71c.27.07.44-.03.51-.31.14-.63.51-.95 1.11-.95 1.63.01 2.9-.03 3.7 1.62.14.29.37.49.68.59ZM252.87 79.74c.85 1 1.22 2.07 1.09 3.22-.31 2.77 0 5.66.88 8.67.09.31.03.56-.16.75-.26.25-.45.2-.58-.13l-2.2-5.73c-.18-2.13.14-4.39.97-6.78ZM20.44 83.96c.03-.35.33-.61.68-.59.35.02.62.3.62.65 0 2.41-.34 4.76-1.03 7.03-.07.24-.31.38-.55.33a.482.482 0 0 1-.39-.52l.67-6.9Z"
      style={{
        fill: "#edd585",
      }}
    />
    <ellipse
      cx={104}
      cy={95.35}
      rx={5.47}
      ry={1.68}
      style={{
        fill: "#edd585",
      }}
      transform="rotate(-.3 104.792 95.768)"
    />
    <path
      d="M19.09 117.09c-1.09 2.05-2.6 3.59-4.54 4.64-.37.19-.66.11-.87-.24-.31-.52-.66-.54-1.06-.07-.37.43-.56.36-.56-.21v-.56c0-.28.11-.51.32-.69 1.61-1.39 2.27-2.55 1.96-3.5l2.88-2.37a.472.472 0 0 1 .69.63l-1.13 1.67c-.13.19.11.41.3.28l1.15-.81c.3-.21.73-.07.83.29.07.25.08.56.03.94ZM243.13 131.46c.09.24.36.37.6.29.25-.09.38-.35.3-.6l-2.64-8.34c-.15-.47-.04-.54.34-.23 2.68 2.21 3.65 8.35 3.91 11.8.03.42-.15.54-.53.37-3.17-1.44-4.72-6.85-5.28-9.63-.05-.25.04-.42.27-.51.3-.13.51-.04.62.27l2.41 6.58ZM152.37 158.93c-.61 1.75-.79 3.47-.56 5.17.05.33-.07.67-.32.89-2 1.85-3.91 3.8-5.72 5.85-7.1 8.05-27.24 9.3-35.96 3.42-3.96-2.66-.53-6.75.54-9.77 2.09-.27 3.88.57 5.37 2.53.2.26.5.42.83.44 2.08.09 4.15-.08 6.2-.53 1.49-.32 2.81-1.82 4.86-1.3.34.08.69.01.96-.2 2.36-1.82 9.93-3.61 12.49-3.31 1.79.21 3.6.18 5.43-.11.32-.05.59-.2.8-.45 1.23-1.47 2.92-2.34 5.08-2.63ZM257.09 214.59c.65.5 1.12 1.17 1.41 2.01-.16 1.32-.63 2.34-1.41 3.06-.31.29-.52.23-.61-.19-.37-1.77-.17-3.4.61-4.88ZM253.79 254.85c0 1.22-.22 2.19-.66 2.91-.25.42-.42.39-.49-.1l-.74-5.2c.77-2.01 1.4-4.04 1.91-6.08.07-.3.25-.47.53-.5.35-.04.5.11.46.46l-1.01 8.51ZM102.7 296.02c2.15 1.1 3.79 2.54 4.92 4.32.57.91.43 1.04-.43.4l-5.79-4.28c-.42-.14-.7-.33-.85-.58-.13-.22.03-.5.29-.5.71.01 1.33.23 1.86.64ZM207.47 306.83a.2.2 0 0 1 .16.23l-.02.07c-.15.77-2.18 1-4.54.53l-.21-.05c-2.36-.47-4.14-1.48-3.99-2.24v-.07c.04-.11.14-.18.25-.16l8.35 1.69Z"
      style={{
        fill: "#edd585",
      }}
    />
    <path
      d="m108.22 23.15-1.49.15c.34-.17.41-.42.2-.76-.18-.3-.43-.38-.75-.24l-6.89 3.04c-.35.15-.27.66.1.72 1.05.17 2.23.07 3.52-.29-.71.72-.91 1.17-.59 1.34-1.17.19-2.25.61-3.23 1.25-.27.17-.36.4-.28.71.16.58.6.72 1.31.43.31-.13.6-.28.89-.46.65-.42 1.5-.43 2.55-.02l-3.92 1.33c-.28.1-.55.07-.81-.08a5.94 5.94 0 0 1-1.8-1.6c1.69-.68 1.76-1.96.21-3.85l8.59-3.43c.48-.19.51-.43.09-.74l-1.21-.88 4.13-.11c.41-.01.55.17.41.56l-1.03 2.93ZM17.39 146.51l-.13 2.56c-.33.07-.56.18-.7.34-.21.23-.2.44.04.64l20.73 16.88c-.31 1.31-1.08 1.68-2.3 1.09.58-.25.7-.59.36-1.03-.03-.04-.06-.08-.1-.11-5.85-4.87-11.81-9.75-17.89-14.64-.63-.5-1.18-.44-1.91-.3l-1.92-3.06c-.43-.69.33-1.5 1.05-1.12 1.47.78 2.39.36 2.77-1.25ZM37.1 172.65c0-.35-.2-.54-.57-.55-.14 0-.28.04-.39.14-6.19 5.76-12.73 11.1-19.61 16.01-.44.32-.39.53.14.62l.89.16c-.21.79-.41 1.21-.58 1.28h-2.85c-.47.02-.64-.21-.49-.66.49-1.47 1.3-2.84 2.42-4.1.57.34 1.01.4 1.32.18 5.21-3.67 11.23-8.49 18.05-14.47.21-.18.14-.52-.22-1.02l.65-.16c1-.24 1.9.66 1.66 1.66-.07.29-.21.59-.42.91ZM24.91 230.99c3.16 6.55 2.98 13.59 1.85 20.62-.04.25.13.49.38.54.11.02.24.01.37-.03 0 .81-.23 1.44-.68 1.9-.33.34-.91.14-.97-.33l-.15-1.1c-.06-.41-.24-.48-.55-.2l-.91.84c-.3-2.25-.8-4.35-1.49-6.28-.16-.45-.41-.77-.76-.94-.38-.19-.54-.07-.48.35l1.23 8.87c-1.74-.03-2.05 1.93-.93 5.88.3 1.07-.27 2.29-1.71 3.67l-1.48-10.4a.563.563 0 0 0-.63-.49c-.31.03-.54.3-.52.61l.37 5.29-1.37.65c-.56-.67-.79-1.44-.69-2.32-.02-2.25.43-4.4 1.36-6.45.09-.19.24-.29.45-.29h.44c.37 0 .57-.19.6-.56l.44-6.2c.2-.43.14-.91-.19-1.44-.23-.38-.14-.63.29-.76.31-.09.6-.01.87.24a.7.7 0 0 0 .91.05c.28-.21.36-.59.2-.9-1.37-2.56-1.88-5.32-1.53-8.28.05-.47.31-.69.78-.67.92.04 1.66.49 2.21 1.34.46.71.27 1.09-.57 1.15l-.58.05a.66.66 0 0 0-.58.5c-.21.95-.11 1.94.3 2.96l3.34 9.84c.07.19.27.3.47.24.19-.06.31-.26.26-.46l-2-8.27c.53-.16.93-.16 1.22.01.22.12.36.43.43.94.12.89.33 1.72.62 2.47.09.24.36.37.61.29.25-.09.38-.35.31-.6l-1.43-4.87c-.09-.3-.03-.57.16-.8l.39-.48c.25-.31.31-.64.16-1.01l-1.91-4.77c.39.07.75-.06 1.09-.4Zm-3.34 23.64c.95-1.87-.39-5.75-.95-7.57-.13-.42-.75-.35-.78.09-.18 2.57.16 5.05 1.01 7.44.11.32.56.35.72.04ZM255.41 236.65a.756.756 0 0 0-.16-.41c-.21-.25-.39-.22-.54.07a34.061 34.061 0 0 0-3.19 9.74c-.06.37.16.72.52.82.35.11.73-.08.87-.42l1.56-3.86c-.01.92.34 1.65 1.04 2.2.27.21.57.24.89.1.47-.22.83-.66 1.08-1.33l.26 2.33-.22 5.1c0 .42.18.56.57.41l.62-.22c.44-.17.73-.03.86.42 1.72 5.73.81 10.87-2.74 15.42-.37-1.68-1.03-3.06-1.97-4.15l1.75-6.53c.08-.31.04-.61-.12-.9-1.7-3.04.09-4.73.1-7.49 0-.46-.62-.6-.82-.19-1.2 2.51-1.27 4.93-.22 7.24l-1.76-.16 1.01-8.51c.04-.35-.11-.5-.46-.46-.28.03-.46.2-.53.5-.51 2.04-1.14 4.07-1.91 6.08-1.03-1.44-1.37-3.08-1.01-4.93.06-.33.01-.64-.15-.94-2.11-3.93.44-7.35 2.19-10.65.53-1 1.87-1.21 2.67-.41.17.18.11.56-.19 1.13Zm2.47 17-1.44 10c-.01.08.04.15.12.16h.05c.79.12 1.75-2.01 2.15-4.75l.05-.34c.39-2.75.07-5.06-.72-5.18h-.05c-.08-.01-.15.04-.16.11Z"
      style={{
        fill: "#d8b34a",
      }}
    />
    <path
      d="M47.3 16.31c.28.41.27.75-.02 1.04-1.61 1.62-3.7 2.65-6.28 3.1 1.8-1.77 3.9-3.15 6.3-4.14ZM174.51 27.15c.82.56 1.74.81 2.75.74.37-.03.55.15.55.52v.51c0 .7-.79 1.1-1.36.7-1.64-1.14-3.3-1.18-4.97-.13-.26.17-.54.21-.84.13-.67-.18-1.05-.43-1.16-.75.52-.43.81-.87.86-1.3 1.43-.67 2.82-.81 4.17-.42ZM18.51 30.47c.66.47 1.23 1.17 1.71 2.1-1.85-.35-3.32-1.2-4.43-2.54-.29-.36-.21-.55.25-.58.77-.05 1.6.29 2.47 1.02ZM62.68 37.87l-.22-.21a.452.452 0 0 0-.47-.1l-10.47 3.99c-.39.15-.7-.35-.39-.63 3.13-2.82 6.84-4.21 11.13-4.16.63 0 .97.32 1.04.95.04.39-.18.78-.67 1.19-2.66 2.23-5.82 3.62-9.49 4.17a.561.561 0 0 1-.29-1.08l9.75-3.76c.21-.08.24-.2.08-.36ZM224.27 40.17c1.51 1.17 1.36 1.44-.44.8l-8.46-3.02c-.36-.13-.73-.16-1.11-.1-.49.07-.89-.05-1.2-.38-.23-.24-.08-.64.25-.66 4.11-.26 7.77.86 10.96 3.36ZM21.05 39.58l-5.01.37c-2.76-.1-4.63-.99-7.27-1.35a.478.478 0 0 1-.43-.4c-.06-.22.13-.43.36-.41l12.02 1.13c.21.02.33.14.36.35 0 .1 0 .2-.03.31ZM99.65 39.1c-2.59 1.65-5.11 2.43-7.54 2.32 2.59-1.85 5.33-3.09 8.21-3.74.39-.09.55.06.49.45-.05.31-.43.63-1.16.97ZM103.59 42.31c.24-.5-.55-.31-2.37.56l-.1-.46c-.03-.15.03-.31.16-.4l5.84-4.51c.13-.1.32-.04.37.12.03.11.06.22.09.32.05.13.02.25-.07.35l-3.92 4.02Z"
      style={{
        fill: "#f4df94",
      }}
    />
    <path
      d="M223.84 42.15s.08.08.06.13c-.33.85-2.85.65-5.64-.44l-.31-.12c-2.79-1.09-4.78-2.65-4.45-3.49s.08-.08.13-.06l10.21 3.98ZM192.52 39.42c-.3.87-.71 1.17-1.24.9-2.97.76-5.71.41-8.23-1.05-.29-.17-.29-.34 0-.51.48-.3.99-.35 1.54-.15 2.55.93 5.19 1.2 7.94.81ZM258.81 41.83c-.06-.03-.09-.11-.05-.17.35-.67 1.77-.61 3.16.14l.3.16c1.4.75 2.23 1.89 1.88 2.56-.04.06-.11.09-.18.05l-5.11-2.74ZM36.48 60.1c.27 4.14-.8 7.95-3.21 11.43.41-3.95 1.48-7.76 3.21-11.43ZM244.17 72.69c-2.87-2.91-4.35-6.51-4.42-10.8.54-.38 1.06.4 1.57 2.34.58 2.24 1.53 5.06 2.85 8.46ZM24.29 84l-.39 1.97c-.06 1.94-.52 3.81-1.37 5.6-.1.21-.31.32-.64.31-.35-.01-.48-.19-.37-.52.91-2.95 1.34-5.94 1.31-8.99-.13-.79-.05-1.49.26-2.09.27-.52.45-.49.55.08l.65 3.64ZM32.7 100c-.68 4.76-1.67 8.82-2.98 12.17-.08.22-.19.36-.32.41-.15.06-.33.09-.56.09-.06-4.31 1.23-8.53 3.86-12.67ZM243.65 105.47c.57 1.43.84 2.87.81 4.33 0 .09.02.17.06.24l1.4 2.73c.11.22.04.5-.17.63-.22.13-.5.08-.65-.12-1.72-2.25-2.47-4.81-2.25-7.69.09-1.19.36-1.23.8-.12ZM35.73 106.89c1.75 6.28.55 11.91-3.6 16.89-.13.41-.4.65-.79.71-.28.05-.38-.07-.3-.34.07-.27.26-.47.56-.6.19-.09.34-.25.42-.44 1.82-4.39 2.76-8.96 2.81-13.71.03-2.17.33-3 .9-2.51ZM257.44 116.34c-.12-.37-.22-.52-.29-.44.18-.19.39-.28.64-.28.23-.01.44.12.54.32 1.01 1.98 2.45 3.6 4.31 4.86.26.18.35.52.21.8-.15.28-.48.4-.77.29-2.47-.95-4.01-2.8-4.64-5.55ZM240.63 138.85c-1.07-3.07-1.59-6.43-1.58-10.06.69 1.01 1.29 2.7 1.8 5.07.47 2.16 1.6 4.42 3.4 6.78.33.43.32.78-.02 1.07-.25.21-.49.2-.72-.03l-2.88-2.83ZM243.98 197.85c-1.78 2.05-2.83 4.3-3.14 6.74-.06.5-.64.73-1.03.42-.14-.11-.26-.33-.37-.64.29-2.26.82-4.03 1.6-5.3l2.61-2.27c.43-.38.66-.28.67.29 0 .38-.11.63-.34.76ZM33.49 216.2l2.86 6.1c.34 2.79.09 5.97-.74 9.53.08.17-.01.26-.28.29-.15 0-.27-.1-.27-.25 0-4.96-.69-9.7-2.1-14.23l-1.71-3.5c-.27-.57-.13-.71.43-.41.68.36 1.28 1.18 1.81 2.47ZM257.7 222.07c-.21-2.21 1.84-4.79 3.99-5.21.65-.13 1.02.72.49 1.11a13.791 13.791 0 0 0-3.79 4.25c-.18.31-.65.21-.69-.15ZM31 225.35c2.15 2.34 3.03 5.1 2.64 8.27-1.51-2.53-2.39-5.29-2.64-8.27ZM255.41 236.65l-.94 5.94-1.56 3.86a.72.72 0 0 1-.87.42.723.723 0 0 1-.52-.82c.58-3.43 1.64-6.67 3.19-9.74.15-.29.33-.32.54-.07.09.11.14.24.16.41ZM24.25 253.23c.11 1.63-.11 3.27-.68 4.91-.19.55-.33.53-.41-.04l-.41-2.87-1.23-8.87c-.06-.42.1-.54.48-.35.35.17.6.49.76.94.69 1.93 1.19 4.03 1.49 6.28ZM254.86 262.88l.69-7.87c-1.05-2.31-.98-4.73.22-7.24.2-.41.82-.27.82.19-.01 2.76-1.8 4.45-.1 7.49.16.29.2.59.12.9l-1.75 6.53ZM20.11 264.77c-1.37-.97-2.12-2.64-2.26-4.99l-.37-5.29c-.02-.31.21-.58.52-.61.31-.04.59.18.63.49l1.48 10.4ZM33.25 266.67c2.36 3.28 3.43 7.02 3.2 11.21-1.78-3.6-2.85-7.34-3.2-11.21ZM242.73 267.32c.18 3.72-.76 6.62-2.81 8.69.01-3.35.94-6.24 2.81-8.69ZM11.4 282.61c2.79 1.72 4.31 4.15 4.58 7.3l-.44-.03c-.3-.02-.52-.16-.65-.43l-3.49-6.84ZM52.37 295.55c3.88-.05 7.43 1.33 10.66 4.12-4.01-.65-7.56-2.02-10.66-4.12ZM213.75 300.14s-.01 0-.02-.01v-.04c-.35-.89 1.61-2.46 4.36-3.52l.5-.19c2.76-1.05 5.27-1.18 5.61-.3V296.14l-10.46 4ZM86.04 297.55c2.69-.17 5.1.26 7.23 1.29.23.11.34.37.26.61-.08.24-.33.39-.58.34l-8.12-1.58c-.17-.03-.21-.12-.13-.27.15-.27.09-.39-.2-.36.91-.16 1.43-.17 1.54-.03Z"
      style={{
        fill: "#f4df94",
      }}
    />
    <path
      d="M14.07 53.25c.61.41.9 1.04.87 1.91-.19-.37-.5-.35-.93.08-.17.17-.32.41-.45.72-7.43 18.26-2.13 38.05 6.01 55.79.04.09.11.13.2.12.34 0 .38-.05.11-.1.39.15.69.31.9.48.2.16.3.45.3.86-.03 4.36-.7 5.68-1.99 3.97.05-.38.04-.69-.03-.94a.54.54 0 0 0-.83-.29l-1.15.81c-.19.13-.43-.09-.3-.28l1.13-1.67a.472.472 0 0 0-.69-.63l-2.88 2.37c.46-1.64 1.51-3.02 3.16-4.14.51-.35.46-.54-.16-.58-1.99-.11-3.03-.7-3.12-1.78-3.74-10.43-6.21-22.37-7.4-35.82-.49-5.51.1-10.31 1.76-14.41.88-2.18.68-3.9 1.13-6.12l.13.65c.06.3.2.56.41.77.83.87 1.44 1.11 1.82.71l2-2.48ZM257.19 123.7l-.85 1.29c-.19.28-.26.59-.23.92.63 6.8 1.55 13.57 2.76 20.32.33 1.81 1.31 2.01 2.93 1.57.66-.18 1.21.52.88 1.12l-2.05 3.71c0-.36-.22-.54-.68-.54-.23 0-.46.09-.71.27-6.62 4.76-13.1 10.05-19.43 15.88l-.71-1.54 20.36-16.4c.57-.46.14-1.38-.58-1.23l-4.32.92c-.4.09-.47-.33-.2-1.26.18-.05.33-.16.46-.34.18-.25.16-.48-.06-.7l-.25-.25c.18-2.73-1.16-4.24-1.39-6.61-.13-1.28-.05-2.19-.4-3.47-1.99-7.41-.14-13.91.18-21.39.05-1.06.51-1.74 1.39-2.05.45-.15.6 0 .43.44-1.93 5.2-1.11 8.31 2.47 9.34ZM31.66 217.7l1.3-.06c1.41 4.53 2.11 9.27 2.1 14.23 0 .15.12.26.27.25.27-.03.36-.12.28-.29.11.04.19.12.23.25.05.16.16.22.33.19l.71-.13a91.769 91.769 0 0 0-2.71 9.23c-.48 2-1.63 2.99-2.37 4.9-.17.45-.06.54.34.28 2.13-1.37 3.19-3.27 3.18-5.72 0-.31.15-.52.44-.63l.86-.33c.2-.07.34-.25.37-.46l.59-4.08-.02 10.59-.35-2c-.06-.32-.48-.41-.66-.14l-3.02 4.5c-.13.19-.13.45 0 .64.9 1.29-.71 3.38-1.22 4.74-.19.51-.03.83.5.96l.54.14c.31.08.46.28.45.59v.93c-2.53 4.54-5.89 6.96-10.1 7.27-.35.02-.6.19-.75.51a231.39 231.39 0 0 0-3.42 7.76c-3 7.17-3.34 13.91-1.01 20.21l1.82 2.54c-.56.27-.86.8-.9 1.61-3.01-3.71-6.38-4.49-10.11-2.35-.5-.1-.91-.61-1.23-1.54-.15-.41 0-.66.41-.77.67-.18 1.37-.22 2.08-.12.13.02.26 0 .38-.06.61-.3.69-.98.23-2.03.75-.17 1.6.43 2.55 1.81.28.41.6.44.95.09.39-.39.78-.46 1.17-.21.43.29.61.18.56-.33-.04-.41-.19-.67-.45-.76-.27-3.15-1.79-5.58-4.58-7.3 1.11-.19.56-.13-1.63.2-2.27-5.82-3.3-11.21-3.11-16.18.5-12.72 3.03-25.6 7.58-38.65.23-1.04 1.6-1.46 4.09-1.27.31.03.48-.12.49-.44a.508.508 0 0 0-.2-.45c-.07-.05-.17-.37-.3-.94-.08-.33.01-.49.28-.5.37 0 .6-.19.69-.55.11-.39.05-.71-.17-.94-.21-1.47.06-2.78.82-3.93.34-.51.53-.46.58.15l.36 4.54c.03.46.67.55.84.12.62-1.59.82-3.3.6-5.12l.87-.07c.55 3-.1 5.32-1.96 6.95-.27.23-.26.46 0 .69 1.66 1.38 2.88 2.97 3.67 4.77-.34.34-.7.47-1.09.4l-3.73-4.51c-.27-.33-.5-.3-.7.08-1.64 3.14-2.89 7.53-3.8 9.88-5.64 14.64-7.78 29.94-2.51 44.54.99 2.73 1.71 2.66 2.18-.2.79-4.77 2.18-9.34 4.17-13.71.13-.29.08-.63-.13-.87-1.59-1.85-2.53-3.91-2.82-6.16l1.37-.65c.14 2.35.89 4.02 2.26 4.99 1.44-1.38 2.01-2.6 1.71-3.67-1.12-3.95-.81-5.91.93-5.88l.41 2.87c.08.57.22.59.41.04.57-1.64.79-3.28.68-4.91l.91-.84c.31-.28.49-.21.55.2l.15 1.1c.06.47.64.67.97.33.45-.46.68-1.09.68-1.9l4.87-10.93c.15-.33.12-.65-.11-.94-4.08-5.31-5.5-11.34-4.25-18.08.06-.33.46-.47.71-.24.95.88 1.89 1.01 2.82.39.2 1.54.81 2.78 1.84 3.71.43.39.56.3.41-.26l-2.14-8.07Zm1 18.55c1.59-1.45 1.92-2.33.98-2.62.39-3.17-.49-5.93-2.64-8.27.64.2.34-.13-.89-.99-.17-.25-.41-.33-.73-.24-.33.09-.5.32-.51.67-.03 4.63 1.06 8.98 3.27 13.03.21.39.42.39.63 0 .19-.36.15-.89-.11-1.58Zm-4.57 17.63c-.47 1.14-.22 1.32.75.55 1.41-1.13 2.55-2.5 3.41-4.11.17-.32-.18-.67-.5-.5-1.71.91-2.93 2.26-3.66 4.06Zm2.72 3.14-.51-.69a.224.224 0 0 0-.31-.05l-.15.11c-3.25 2.4-5.74 4.54-5.56 4.78l.14.19c.17.24 2.95-1.52 6.2-3.93l.14-.1c.1-.07.12-.21.05-.31ZM136.22 295.74c1.3 1.33 2.51 1.27 3.64-.17 2.74 4.13 4.57 8.28 5.49 12.45.06.3.21.55.44.75 1.03.88 1.37 2.01 1.04 3.39-.06.26-.02.51.12.75l.15.25c.14.24.26.23.36-.03l1.24-3.38c-.08-1.36.35-2.41 1.28-3.16l5.97-6.11c.23-.23.18-.36-.14-.39-4.16-.34-5.99 3.51-7.98 6.29-.12.17-.11.3.04.41.11.08.27.08.38 0l.91-.67-1.66 2.21c-.61-.67-.84-1.33-.69-1.96 1.37-5.63 4.99-8.22 10.88-7.79-.52.07-.86.25-1.02.55-.13.25-.09.56.13.93.91 1.54 1.72 1.69 2.43.46-1.7 4.26-2.16 8.28-4.39 12.13-1.62 1.05-2.67 2.01-3.14 2.88-4.23.21-6.81 1.89-6.93 6.33l-1.54 3.02c-.11.22-.07.4.14.54.25.17.46.13.63-.1.83-1.18 1.72-2.15 2.68-2.9 6.53-5.08 15.32-12.76 24.47-10.62.33.08.37.23.1.44l-3.41 2.68c-11.35 2.58-20.53 8.64-27.52 18.19-1.63 2.24-3.3 1.07-4.67-.62-7.55-9.34-15.13-14.44-26.79-17.59-.32-.09-.51.03-.58.36-.02.11-.03.24-.03.39-.42-.79-1.1-.85-2.03-.16.17-.3.09-.6-.25-.9l.5-.18c.3-.11.39-.5.15-.73l-1.33-1.23c-.45-.42-.37-.64.25-.65 2-.05 3.67-.62 5.6-.11 8.26 2.2 15.14 6.55 20.65 13.04.29.35.86.06.75-.38l-1.38-5.5c-.09-.35-.28-.62-.58-.81l-3.34-2.09.44-.87c.17-.35.45-.5.84-.43l.67.12c.14.02.22-.04.25-.17.45-2.13.17-4.05-.84-5.76-.28-4.19-3.34-9.08-8.13-8.92-.47.01-.54.19-.22.54l5.72 6.08c.05.95-.83.61-2.65-1.03l-3.37-2.75c-.41.21-.75.07-1.03-.41a.165.165 0 0 1 0-.19c.86-1.96.74-3.1-.35-3.43 5.07-.71 8.62 1.53 10.67 6.72l.94 2.92c.17.54.34.54.5-.01 1.29-4.49 3.14-8.69 5.55-12.62Zm2.72 2.13.19 32.25c0 .35.48.44.61.12 1.93-4.83 3.49-9.71 4.69-14.66 1.2-4.9-2.75-13.71-4.95-17.85-.37-.69-.55-.64-.54.14Zm-2.49.6c-.68 1.55-1.38 3.07-2.11 4.55-4.75 9.68-1.4 18.03 2.15 27.01.16.41.78.3.78-.14l.06-31.24c0-1.47-.29-1.53-.88-.18Zm17.86 8.9.48 1.16c.23.56.43.55.59-.03l1.73-6.11c.12-.43-.4-.74-.72-.44l-4.27 3.91c-.39.36-.13 1.01.4 1.01h1.04c.37 0 .62.17.75.5Zm-.69 3.51c.5-.39.74-.86.73-1.39-.01-.49-.27-.89-.8-1.2-1.24-.73-2.22-.37-2.94 1.08-.71 1.42-1.39 2.76-2.06 4.02-.2.38.12.83.55.76 1.75-.29 3.08-1.19 3.99-2.68.14-.23.32-.42.53-.59Z"
      style={{
        fill: "#cea12e",
      }}
    />
    <path
      d="M251.15 17.65c-.14.65-.51 1.32-1.1 2.03.19-1.32-.07-2.24-.76-2.77-.34-.25-.57-.18-.7.22-1.35 4.09-2.1 8.47-2.27 13.15l-.93.94c-.24.24-.45.22-.64-.07-.4-.65-.62-1.42-.67-2.29.64-.21 1.07-.76 1.3-1.67.75-3 1.43-5.97 1.65-9.07.1-1.44 1.48-3.4.91-4.65-.19-.41-.39-.42-.6-.02-2.13 4.01-3.24 8.33-3.33 12.96l-.25-1.6c-.05-.36-.26-.52-.63-.49-1.27.1-1.74-.12-1.39-.66l-1.05-5.67c-.05-.31-.24-.43-.55-.37-.49.09-.74.52-.77 1.28-.66-.79-1.23-.53-1.7.8-.11.3-.32.46-.64.49l-2.22.16c-1.19-1.82-3.11-3-5.74-3.53.37-.46.6-1.21.69-2.26 3.14-.05 5.59.83 7.36 2.64.81.84 2.2 0 1.85-1.11-.14-.45-.09-.91.16-1.37.19-.35.47-.45.84-.29 1.28.57 2.26 1.46 2.94 2.69.25.45.9.44 1.14-.02l3.58-6.96a.54.54 0 0 1 .99.08l2.53 7.43ZM263.04 33.37c-2.25-.24-4.05.22-5.42 1.38a1.4 1.4 0 0 1-1.93-.11c-.52-.54-.52-1.38-.01-1.93l4.61-4.92 5.59-.24c.64-.03 1.03.71.64 1.22l-3.48 4.6ZM244.17 72.69c-1.32-3.4-2.27-6.22-2.85-8.46-.51-1.94-1.03-2.72-1.57-2.34-.44-.87-.32-1.91.37-3.11.17-.3.36-.32.59-.06 3.14 3.58 4.29 8.24 3.46 13.97ZM262.16 110.24l5.22 1.66c.86.28 1.1 1.39.42 2-1.07.95-2.58 1.6-4.54 1.95l-1.84-1.21c-.25-.17-.43-.39-.55-.66-.42-.94-1.19-1.45-2.32-1.54-.25-.02-.37-.32-.19-.5l.26-.26c.11-.11.25-.16.41-.15 1.77.11 2.82-.32 3.13-1.29ZM11.4 282.61l3.49 6.84c.13.27.35.41.65.43l.44.03c.26.09.41.35.45.76.05.51-.13.62-.56.33-.39-.25-.78-.18-1.17.21-.35.35-.67.32-.95-.09-.95-1.38-1.8-1.98-2.55-1.81-1.17-2.29-1.64-4.46-1.43-6.5 2.19-.33 2.74-.39 1.63-.2ZM19.44 296.17l-.27.69c-.13.33-.38.49-.73.49-1.69-.01-3.24-.42-4.67-1.24-.33-.18-.62-.14-.87.13-.19.19-.35.32-.5.37l-3.07-2.79c3.73-2.14 7.1-1.36 10.11 2.35ZM246.2 307.73c1.01.69 1.36 1.47 1.05 2.34-.36.85-.27 1.73.28 2.62l.62 3.9-.11.73c-.08.46.11.73.57.82.33.06.48-.1.45-.49-.01-.15.03-.16.1-.03l1.7 3.05-2.05 7.28c-.17.62-1.02.69-1.29.11l-3.55-7.5a.315.315 0 0 0-.53-.06l-2.4 2.86c-.89 1.06-2.6.19-2.26-1.15.17-.65 0-1.15-.51-1.5a.714.714 0 0 0-.91.1c-1.93 2.02-4.5 2.9-7.71 2.65-1.63-1.77-1.04-3.11 1.79-4.02-.51 1.61.17 1.27 2.06-1.02 1.75-1.37 3.8-.98 6.16 1.16-.12.29-.06.53.18.72.24.19.41.14.5-.16l1.47-4.81c-.28-1.01.13-1.39 1.22-1.12.36.09.58-.04.65-.41.1-.48.21-.95.34-1.41.11-.37.2-.37.27 0l.27 1.5 1.74 8.37s.06.08.1.08c.05-.01.09-.05.08-.1l-1.03-9.8c-1.48-1.72-1.81-3.36-.98-4.92.22-.42.49-.61.8-.56.32.05.63.3.93.76Zm-11.92 13.23c.97-.4 1.87-.93 2.72-1.58.63-.49.56-.62-.21-.39-1.12.33-2.01.93-2.66 1.78-.19.25-.14.32.15.19Z"
      style={{
        fill: "#e0c268",
      }}
    />
    <path
      d="m244.08 28.87-.07-2.45c.09-4.63 1.2-8.95 3.33-12.96.21-.4.41-.39.6.02.57 1.25-.81 3.21-.91 4.65-.22 3.1-.9 6.07-1.65 9.07-.23.91-.66 1.46-1.3 1.67ZM26.36 14.15c.87-.21 1.34-.04 1.42.53.83 6.28 1.61 11.06 2.34 14.33.07.31-.05.52-.35.62-.11.04-.24.06-.38.07l-2.48-6.09c.17-2.88-.16-4.99-.97-6.32-.26-1.19-.12-2.24.42-3.14ZM250.05 19.69c-.66.77-.81 1.85-.46 3.23-.55 2.68-1.64 5.14-3.27 7.37.17-4.68.92-9.06 2.27-13.15.13-.4.36-.47.7-.22.69.53.95 1.45.76 2.77ZM37.26 21.17c-.09.8-.82 1.62-2.19 2.46l.58-5.29c.03-.29.18-.5.44-.63.37-.18.6.02.7.6.01.04.01.08.01.13-.02.95.13 1.86.46 2.73ZM241.74 23.67c-2.39-.75-3.18-2.33-2.37-4.76.03-.76.28-1.19.77-1.28.31-.06.5.06.55.37l1.05 5.67ZM25.37 24.67c-.85.13-1.69-.47-2.52-1.8-.37-1.04-.34-1.82.11-2.35.26-.31.47-.28.63.09l1.78 4.06ZM106.73 23.31c-1.06 1.39-2.33 2.21-3.82 2.47-1.29.36-2.47.46-3.52.29-.37-.06-.45-.57-.1-.72l6.89-3.04c.32-.14.57-.06.75.24.21.34.14.59-.2.76ZM174.57 25.87c-2.08-.16-3.68-.98-4.8-2.46 0-.22.05-.4.18-.55.21-.25.46-.31.75-.19l6.74 2.82c.22.09.33.33.26.56-.07.23-.3.37-.53.32l-2.6-.5ZM27.81 36.13c-3.09-1.65-5.85-3.84-8.26-6.57l-3.5-5.29a.329.329 0 0 1 .07-.44c.13-.11.33-.1.45.02l11.56 11.41c.18.18.19.48 0 .67-.09.1-.2.17-.33.2ZM129.1 23.99c.03-.12.14-.21.27-.19.12.01.22.11.22.24.11 6.05-2.42 12.9-8.76 14.53-.55.14-.89-.58-.44-.92 4.62-3.47 7.52-8.03 8.71-13.66ZM155.64 38.24c-5.46.67-8.37-7.68-8.53-11.88 0-.23.3-.29.39-.08 1.83 4.48 4.6 8.27 8.31 11.38.39.33.34.52-.17.58ZM105.55 27.51l.92 1.23c.37.49.25.7-.36.62l-2.55-.34c-1.05-.41-1.9-.4-2.55.02-.29.18-.58.33-.89.46-.71.29-1.15.15-1.31-.43-.08-.31.01-.54.28-.71.98-.64 2.06-1.06 3.23-1.25 1.06-.41 2.14-.28 3.23.4ZM13.42 30.17c.06-.09.18-.12.27-.06l2.21 1.41c1.55.99 2.64 2.04 2.44 2.35l-.17.27c-.2.31-1.61-.25-3.15-1.23l-2.22-1.42a.193.193 0 0 1-.06-.26l.68-1.06ZM20.73 35.78l4.44 2.01c.41.19.41.36-.02.53-.43.17-1.03.17-1.79.01-.25-.33-.79-.51-1.62-.56-4.49-.29-8.98-.69-13.47-1.22-.47-.05-.48-.17-.05-.35 4.25-1.77 8.42-1.91 12.51-.42ZM262.71 34.9c1.5.49 3.05.72 4.65.71.33 0 .56.08.7.23.11.13.16.27.15.44-.03.33-.2.44-.51.33-3.45-1.22-5.05.76-7.92.92-2.33.13-4.66.02-6.99-.33 3.39-1.92 6.69-2.69 9.92-2.3ZM85.55 40.62c.01-.14-.07-.24-.24-.29-.02-.1-.01-.2.02-.29.05-.15.16-.23.32-.26 2.47-.38 4.22-.6 5.27-.65 2.8-.15 2.88.21.23 1.08-1.71.56-3.57.7-5.6.41ZM15.85 49.11c-.29 1.68-.88 3.06-1.78 4.14l-2 2.48-.42-.11c-.32-.09-.4-.27-.24-.55l3.36-5.87c.17-.29.41-.4.74-.33.17.03.28.11.34.24ZM256.07 73.54c2.79.37 2.84 8.71 2.5 10.55a.45.45 0 0 1-.44.36.431.431 0 0 1-.42-.38c-.32-2.79-.67-5.67-1.05-8.63-.07-.51-.28-.95-.65-1.32.06-.14.08-.33.06-.58ZM19.19 74.08c.23-.01.41.02.52.1.1.07.15.22.14.44-.11 1.83-.44 3.64-1 5.43-.11.35-.14.73-.07 1.09.24 1.41-.02 2.7-.79 3.87-.23.36-.78.23-.84-.19-.29-2.19-.14-4.33.47-6.4l1.57-4.34ZM254.01 93.94l1.31 7.42c.03.35-.14.52-.49.53-.14 0-.27-.09-.31-.22l-3.68-10.81c-.15-1-.07-1.83.24-2.48.3-.23.47-.26.52-.07.54 2.09 1.34 3.97 2.41 5.63ZM21.88 103.47c-.02.07-.09.11-.16.09h-.01c-.93-.24-.95-3.27-.04-6.75l.06-.21c.91-3.49 2.4-6.12 3.33-5.87.06.02.11.09.09.16l-3.28 12.58ZM243.8 101.97c-.1-.2-.2-.4-.31-.61-.03-.13.01-.27.14-.41.19-.22.55-.18.69.08 1.97 3.61 3.07 7.47 3.3 11.59.02.36-.48.48-.63.15-1.67-3.69-2.73-7.29-3.19-10.8ZM240.92 107.22c.45 5.51 1.48 10.5 3.11 14.98.11.29.24.47.41.55.15.07.29.08.44.03.15-.04.24-.21.2-.36l-2.44-8.89c-.17-.59.05-.81.64-.65.5.14.85.56 1.04 1.25.91 3.25 1.33 6.56 1.27 9.91-.01.56-.73.79-1.07.34a29.409 29.409 0 0 1-4.54-8.99c-.7-3.06-.39-5.78.94-8.17Z"
      style={{
        fill: "#f6e39c",
      }}
    />
    <ellipse
      cx={32.22}
      cy={116.6}
      rx={4.84}
      ry={0.73}
      style={{
        fill: "#f6e39c",
      }}
      transform="rotate(-74.8 32.223 116.594)"
    />
    <path
      d="M19.26 118.77c.16-.22.5-.13.54.14.11.77.03 1.51-.22 2.24-.19.55-.39.55-.61 0-.34-.85-.24-1.64.29-2.39ZM243.41 215.85c.25-.06.41.13.5.56-1.83 4.31-2.62 7.79-2.35 10.46.2 2-.25 3.17-1.35 3.52-.56-2.18-.6-4.53-.13-7.05.09-2.27 1.2-4.77 3.33-7.49ZM30.11 224.37c-.83 2.62 1.75 8.95 2.55 11.88.26.69.3 1.22.11 1.58-.21.39-.42.39-.63 0-2.21-4.05-3.3-8.4-3.27-13.03.01-.35.18-.58.51-.67.32-.09.56 0 .73.24ZM243.35 239.24c-.33-.7-.33-1.54 0-2.53l3.35-10.92a.466.466 0 0 1 .91.17c-.28 4.56-1.7 8.99-4.26 13.28ZM257.88 253.65c0-.07.08-.12.16-.11h.05c.79.12 1.11 2.43.72 5.18l-.05.34c-.4 2.74-1.36 4.87-2.15 4.76h-.05a.154.154 0 0 1-.12-.17l1.44-10ZM215.22 300.51l9.39-3.49c.29-.11.52.26.3.47-3.15 2.97-6.93 4.31-11.34 4-.34-.02-.73-.27-.89-.57-.16-.29-.02-.53.3-.54.24-.01.44 0 .59.03.87.15 1.42.18 1.65.1ZM63.04 301.42c-4.07.42-7.66-.61-10.76-3.08l.27-.33c.2-.24.45-.31.74-.2l9.75 3.61Z"
      style={{
        fill: "#f6e39c",
      }}
    />
    <path
      d="m104.71 19.78 1.21.88c.42.31.39.55-.09.74l-8.59 3.43c1.05-1.42 2.47-2.56 4.24-3.43.39-.19.25-.77-.18-.77h-.5c-.33 0-.59.13-.78.39-.64.84-1.46 1.13-2.45.88-.3-.07-.6.14-.63.45-.13 1.23-.93 2.05-2.42 2.46.43-4.71 2.66-7.74 6.68-9.08.41-.13.61.01.61.44v2.99c0 .37.18.59.54.66.81.17 1.6.16 2.36-.04ZM61.29 23.79a.39.39 0 0 0-.33.39c.01.19.17.35.36.37l3.22.26c.15.01.27.13.28.28 0 .15-.09.28-.23.32-2.49.63-4.82.28-6.97-1.03a.701.701 0 0 1 .17-1.27c2.06-.62 4.16-.72 6.29-.29.14.03.24.16.24.3a.3.3 0 0 1-.26.29l-2.77.38Z"
      style={{
        fill: "#e6c874",
      }}
    />
    <ellipse
      cx={233.08}
      cy={29.58}
      rx={3.02}
      ry={0.84}
      style={{
        fill: "#e6c874",
      }}
      transform="rotate(-25.6 233.093 29.582)"
    />
    <path
      d="m58.55 45.24 22.97-.04c10.97 2.26 22.32 2.98 34.05 2.16.23-.01.37.12.4.39.05.31-.08.49-.39.55-3.16.62-6.34 1.06-9.54 1.33-6.65.54-14.14-1.14-21.37-.82-11.32.51-22.62.67-33.94 1.26-.33 0-.62-.09-.86-.32-1.44-1.38-.77-2.86 1-3.44 2.45-.79 5.01-1.15 7.68-1.07ZM24.59 50.22c2.16 1.18 2.6 2.89 1.33 5.13-.16.28-.37.34-.64.17-1.39-.87-2.2-2.23-2.45-4.09-.21-1.56.38-1.96 1.76-1.21ZM39.65 71.75l-.32-11.84c-.18-1.8.35-5.36 2.62-5.69 1.66-.25 2.35 1.17 2.27 2.69a929.6 929.6 0 0 0-1.31 59.28c0 .22-.17.41-.39.44a.437.437 0 0 1-.47-.34c-.15-.73-.47-1.48-.5-2.23-.43-14.05-1.06-28.16-1.9-42.31ZM32.7 100c1.77 4.86 1.83 11.28-3.41 14.1a.399.399 0 0 1-.55-.52c.09-.21.13-.52.1-.91.23 0 .41-.03.56-.09.13-.05.24-.19.32-.41 1.31-3.35 2.3-7.41 2.98-12.17ZM19.54 214.09c.01.66.39 1.09 1.16 1.3.32.09.54.28.65.59l.97 2.67c.22 1.82.02 3.53-.6 5.12-.17.43-.81.34-.84-.12l-.36-4.54c-.05-.61-.24-.66-.58-.15-.76 1.15-1.03 2.46-.82 3.93-.05.83-.54 1.28-1.46 1.35-.35.03-.66-.06-.95-.27l-3.45-2.49-3.82-4.21a.957.957 0 0 1 .34-1.53c2.53-1.05 4.93-.8 7.18.74.24.16.56.12.74-.11l1.84-2.28ZM210.61 308.67c1.47.07 2.61.86 3.43 2.37-3.29 1.07-6.4.77-9.34-.9-.37-.21-.35-.4.04-.56 1.77-.72 3.73-1.02 5.87-.91ZM181.34 314.39c-.02 3.16-1.13 5.21-3.34 6.16-.33-2.09.78-4.15 3.34-6.16Z"
      style={{
        fill: "#e6c874",
      }}
    />
    <path
      d="M229.76 14.56c-.09 1.05-.32 1.8-.69 2.26l-.12.42c-2.67.03-4.73.2-7.53-.16-2.95-.39-5.91-.37-8.87.04-.43.06-.8.22-1.11.49-.33.29-.28.47.15.54l.5.08c-10.28 1.39-17.77 7.34-27.61 9.52-.24.05-.29.37-.07.49l7.57 4.05 4.28 1.08c.28.07.58-.05.73-.3.91-1.45 2.23-2.29 3.96-2.51.44-.05.69-.3.76-.74l.15-1c.05-.29.19-.51.42-.68a12.06 12.06 0 0 1 4.52-1.98c.33-.07.54-.27.61-.6l.5-2.15c4.4-2.38 8.16-2.95 11.29-1.71-.68.41-.98.86-.89 1.37-1.86-.57-3.76-.68-5.71-.34-.32.06-.35.51-.04.61l.96.3c.11.03.2.1.26.21l.22.36c.13.21-.04.48-.29.46l-2.94-.29a.334.334 0 0 0-.28.56c.19.21.47.33.83.38 2.01.26 3.65.35 4.94.26l-1.16 1.44c-4.25-.85-8.31-.18-12.18 2.03-.13.07-.14.16-.04.27l.24.23c.09.09.18.1.28.03.75-.48 1.67-.73 2.75-.76.4-.01.65.29.56.68-.08.39-.47.72-.87.74-2.87.14-5.39 1.09-7.56 2.85a.708.708 0 0 0 .36 1.25l3.9.5c.02.23-.09.55-.34.97l-11.47-2.72-9.47-5.51c-.32-.19-.6-.14-.84.14-3.38 3.88-7.5 4.67-12.36 2.38a.634.634 0 0 1-.33-.79c.29-.84.88-.99 1.75-.44.11.32.49.57 1.16.75.3.08.58.04.84-.13 1.67-1.05 3.33-1.01 4.97.13.57.4 1.36 0 1.36-.7v-.51c0-.37-.18-.55-.55-.52-1.01.07-1.93-.18-2.75-.74l.06-1.29 2.6.5c.23.05.46-.09.53-.32a.455.455 0 0 0-.26-.56l-6.74-2.82c-.29-.12-.54-.06-.75.19a.75.75 0 0 0-.18.55l-1.81.04-.9-2.9c-.12-.41.02-.67.42-.8.84-.28 1.89-.33 3.14-.14l-.23 1.15c-.08.4.07.68.44.84l7.24 3.07c.24.1.51 0 .63-.22.13-.22.06-.5-.15-.65l-3.99-2.76c-.21-.15-.23-.31-.05-.49l.19-.18c.22-.22.58-.25.83-.06l1.71 1.32c.39.31.56.21.51-.29-.25-2.08-1.21-3.27-2.9-3.57-.38-.45-.44-.96-.19-1.53.15-.33.39-.45.74-.37 1.18.28 2.03.87 2.54 1.76.02 2.85 1.17 5.16 3.45 6.91 4.01-.53 6.93-1.23 8.75-2.09 12.62-5.95 21.52-10.56 35.72-6.88.33.09.64.03.91-.18.99-.73 1.98-1 2.99-.82ZM25.75 74.97c3.02.87 5.69 3.19 8.02 6.98.27.38.37.84.28 1.38-.05.3-.23.43-.52.4l-1.26-.12c-.33-.03-.42.1-.27.39l2.04 4.26c.15.31.11.67-.1.95-.62.8-.53 1.35.28 1.66.29.11.52.34.61.64.37 1.18.94 2.16 1.69 2.93 0 .63-.3.97-.94 1.04l-3.57-4.13a.308.308 0 0 0-.41-.05c-.13.09-.17.27-.09.41l2.41 4.09c.15.25.24.52.29.81.49 3.49 1.58 6.8 3.28 9.91.92.58.33.7-1.76.37-.57-.49-.87.34-.9 2.51-.05 4.75-.99 9.32-2.81 13.71-.08.19-.23.35-.42.44-.3.13-.49.33-.56.6-.08.27.02.39.3.34.39-.06.66-.3.79-.71.69.02 1.05.22 1.06.59-1.51 3.13-2.33 6.38-2.46 9.73 0 .39.17.53.54.42 2.58-.74 3.92-4.92 4.6-7.22.03-.12.11-.18.24-.18h.4c.25 0 .35.12.3.36-1.01 5.45-1.7 9.16-5.01 13.83-.53.76-.4.9.39.41l2.31-1.41c-.39.71-.34 1.17.14 1.36-1.49 1.34-2.99 2-4.49 1.98a.57.57 0 0 1-.54-.74l1.76-5.89c.06-.19-.14-.37-.33-.3l-1.25.45c-.4.14-.8-.19-.75-.61.09-.73 0-1.33-.27-1.8.37-2.93 1-5.02.38-8.17-.66-3.35-.29-6.63 1.12-9.84.22-.49.06-.71-.47-.64-.51.07-.94.29-1.29.68a.45.45 0 0 1-.78-.23l-.47-2.84c.09-6.02 1.76-11.29 5.03-15.81.2-.28.23-.58.09-.9l-5.19-11.39a.371.371 0 0 0-.46-.2c-.19.06-.29.24-.25.43 1.03 4.58 2.18 17.29-1.12 20.85l-1.15-.65c2.03-5.18 1.86-6.16-.52-2.95.82-2.56 1.59-4.9 2.31-7.01.73-2.12.18-3.54-.5-5.5-.12-.33-.12-.69-.02-1.02.62-2.03.09-3.23-1.58-3.61l.39-1.97c.47.83.88 1.33 1.22 1.52.37.21.81-.13.7-.54-.18-.66.2-1.22 1.14-1.69l3.94 5.14c.15.2.43.25.65.13.22-.13.3-.4.2-.63-1.01-2.23-2.64-3.94-4.91-5.12-.43.47-.57.35-.4-.36.06-.25.22-.42.47-.49.56-.18.93-.54 1.12-1.09.53.7 1.09.94 1.7.72.38-.14.4-.33.07-.56l-6.04-4.36c.94-.08 1.47-.64 1.6-1.69Zm3.09 37.7c.03.39 0 .7-.1.91-.16.35.21.7.55.52 5.24-2.82 5.18-9.24 3.41-14.1-2.63 4.14-3.92 8.36-3.86 12.67Zm2.11 8.59c.39.11 1.27-1.9 1.97-4.48.71-2.58.96-4.75.56-4.86-.39-.11-1.27 1.9-1.97 4.48-.71 2.58-.96 4.75-.56 4.86ZM240.25 207.32c.29-.64.74-.86 1.35-.67.29.09.38.27.26.56l-1.35 3.23c-.21.52-.4.51-.57-.02-.29-.95-.19-1.99.31-3.1ZM90.71 307.98l4.29 3.1c.29.21.55.19.8-.06l.74-.74a.7.7 0 0 1 .82-.14c.93.45 1.24 1.33.93 2.64-.03.12-.09.21-.16.26-.11.08-.26.13-.45.14-.31.03-.43.19-.35.49.05.18.17.34.36.47.66 1.06 1.53 1.86 2.62 2.4.27.14.51.09.72-.14.49-.55 1.08-.69 1.76-.4.09.04.1.08 0 .13l-2.33 1.29c-.21.12-.39.09-.55-.09-.34-.38-.76-.54-1.27-.48-.39.04-.73-.06-1.03-.3-.77-.62-1.12-1.42-1.07-2.4a.506.506 0 0 0-.66-.51l-.8.27c-10.11.55-17.84 7.5-27.31 9.45-5.64 1.16-11.34.96-17.1-.6-.33-.09-.65-.06-.95.1-1.23.65-2.44.88-3.64.67.95-.36 1.5-1.02 1.67-1.98.05-.33-.04-.6-.29-.82-.95-.87-1.58-1.08-1.88-.62l-1.82-1.4c.92-.25 1.63-.14 2.13.31.25.22.54.28.87.19.7-.2 1.27-.59 1.72-1.18 1.35 1.18 3.11 1.8 5.28 1.86.22 0 .44-.09.56-.27l.17-.23c.33.28.87.51 1.6.7 7.03.84 12.71-.15 19.39-3.49 5-2.49 10.24-4.46 15.73-5.91.41-.11.47-.31.17-.62-.77-.79-1.78-1.34-3.02-1.63-2.53-1.71-5.28-2.82-8.25-3.31a.782.782 0 0 0-.79.33c-.89 1.33-2.13 2.14-3.7 2.45-.29.06-.44.23-.47.52-.19 2.01-4.12 3.09-6.23 4.16-.51.26-.58.61-.22 1.04.13.15.13.29.02.43-.3.36-.56.64-.61.66-3.44 1.4-6.19 3.34-10.01 2.3-.08-.67-.35-1.32-.82-1.93-.25-.31-.21-.59.12-.83l4.65-3.41 5.92.55c.32.03.63-.02.94-.13l2.47-.91c.58-.21.6-.46.06-.75l-1.37-.74c-.39-.21-.39-.41.01-.62 1.22-.63 2.44-.9 3.65-.83.32.02.62-.05.91-.21l2.27-1.28c.17.07.35-.05.56-.37.19-.29.14-.51-.17-.67-.32-.16-.38-.52-.19-1.08.15-.44.61-.69 1.06-.6 4.79.99 8.97 2.58 12.53 4.77Z"
      style={{
        fill: "#d3a739",
      }}
    />
    <path
      d="M177.94 17.62c2.57 1.31 3.72 3.62 3.45 6.91-2.28-1.75-3.43-4.06-3.45-6.91ZM218.31 23.08c.49-.01.71.09.67.28-.19.99-1.09 1.74-2.72 2.23-1.29.09-2.93 0-4.94-.26-.36-.05-.64-.17-.83-.38a.334.334 0 0 1 .28-.56l2.94.29c.25.02.42-.25.29-.46l-.22-.36a.415.415 0 0 0-.26-.21l-.96-.3c-.31-.1-.28-.55.04-.61 1.95-.34 3.85-.23 5.71.34ZM226.19 32.69c-.75.31-.98.1-.69-.65l2.39-6.29a.5.5 0 0 1 .62-.3c.25.09.4.35.33.61l-.45 1.71c-.06.23-.07.47-.02.7.45 2.01-.28 3.41-2.18 4.22ZM215.1 27.03c-.97.47-1.77 1.08-2.42 1.83-.21.25-.47.4-.79.47-.91.19-1.77.81-2.58 1.84-1.5 1.93-3.76 3.15-6.77 3.68l-3.9-.5a.708.708 0 0 1-.36-1.25c2.17-1.76 4.69-2.71 7.56-2.85.4-.02.79-.35.87-.74.09-.39-.16-.69-.56-.68-1.08.03-2 .28-2.75.76-.1.07-.19.06-.28-.03l-.24-.23c-.1-.11-.09-.2.04-.27 3.87-2.21 7.93-2.88 12.18-2.03ZM40.36 29.13c-.06-.03-.08-.1-.06-.16l.03-.04c.42-.87 1.82-1.06 3.14-.42l.28.14c1.31.63 2.04 1.85 1.61 2.72l-.02.05c-.03.06-.1.08-.16.05l-4.82-2.34ZM51.28 37.79c-.77-3.11 1.8-6.96 5.07-7.56.46-.09.6.09.41.52-.72 1.62-2.24 6.76-4.63 7.51-.37.12-.76-.1-.85-.47ZM15.85 49.11c-.06-.13-.17-.21-.34-.24-.33-.07-.57.04-.74.33l-3.36 5.87c-.16.28-.08.46.24.55l.42.11c-.38.4-.99.16-1.82-.71-.21-.21-.35-.47-.41-.77l-.13-.65 1.97-5.64c.91.04 1.6-.19 2.08-.7.86-.92 2.39-.49 2.66.73.03.15-.16.53-.57 1.12ZM36.48 60.1c-1.73 3.67-2.8 7.48-3.21 11.43-.27 1.17-.79 1.42-1.54.73-.41-.38-.62-.94-.55-1.51.51-4.15 1.8-8.04 3.86-11.69.19-.35.72-.24.77.15.06.46.28.76.67.89ZM251.27 64.96c.18.06.28.25.24.44-.05.18-.23.3-.42.27-2.73-.44-5.01-1.63-6.85-3.58-.82-.87.05-2.27 1.2-1.91 1.68.53 3.07 1.4 4.17 2.61.23.25.34.54.35.88.01.57.45 1 1.31 1.29ZM242.23 97.46c-1.39 3.27-2.25 6.45-2.56 9.52 0 .11-.1.19-.21.19-.11 0-.2-.07-.22-.18-.51-3.09-.52-6.03-.04-8.82 1.55-.81 2.56-1.04 3.03-.71ZM238.99 233.04c.15-1.14.37-1.15.67-.04.89 3.29 2.3 9.64 4.64 12.63.1.13.09.31-.02.43-.11.13-.29.15-.43.06-1.76-1.14-2.77-2.74-3.04-4.81a.981.981 0 0 0-.6-.82l-.68-.32a.885.885 0 0 1-.55-.75 25.7 25.7 0 0 1 0-6.38ZM33.25 266.67c.35 3.87 1.42 7.61 3.2 11.21 0 .55-.25 1.06-.72 1.53-.3.31-.55.27-.76-.1-2.08-3.8-3.33-7.85-3.76-12.16-.04-.45.15-.89.5-1.16.95-.71 1.46-.49 1.54.68ZM239.92 276.01c2.05-2.07 2.99-4.97 2.81-8.69l.39-.93c.28-.65 1.23-.5 1.3.2.45 4.83-.73 9.23-3.56 13.18-.23.33-.45.32-.67-.01-1.03-1.58-1.12-2.83-.27-3.75ZM25.42 273.61l-.41-.41c-.37-.37-.29-.53.23-.49 3.32.28 5.75 1.83 7.3 4.66a.73.73 0 0 1-.83 1.05c-1.63-.42-5.87-2.19-5.98-4.13 0-.27-.12-.49-.31-.68ZM250.31 274.27v.3c0 .35-.12.64-.37.87-1.55 1.51-3.42 2.48-5.6 2.91-.33.06-.5-.08-.49-.41.09-3.27 4.41-4.63 7.02-5.39.21-.06.43.04.52.23.1.19.04.42-.13.55l-.76.56c-.13.09-.19.22-.19.38ZM26.58 287.62l-3.27 2.81c-.56.49-1.44.17-1.57-.56-.34-2.02-.03-3.91.93-5.68.15-.27.13-.6-.05-.85l-.32-.46c.14-.03.26-.1.35-.21a.61.61 0 0 0-.06-.85c-.65-.59-1.4-.65-2.23-.17a.38.38 0 0 1-.57-.38c.05-.39.24-.65.57-.76 3.55-1.22 5.32-2.29 9.3-1.61.35.06.42.24.21.53-.13.17-.31.24-.56.19a.662.662 0 0 0-.77.48c-.25.98-.9 1.51-1.95 1.58-.53.03-.73.31-.61.83l.65 2.81c.03.14.02.28-.04.42-.54 1.21-.54 1.83 0 1.88ZM250.34 286.89c-.68-.87-.65-2.11.1-3.73.19-.33.56-.39 1.11-.19.11.04.2.12.26.23l2.17 4.45c.37.75-.51 1.5-1.19 1.01l-2.45-1.77ZM267.1 293.7l-3.55 3.39c-.53-.52-2.06-.32-4.58.59-.7 0-1.24-.16-1.61-.49-.29-.26-.36-.57-.2-.94 1.61-3.75 6.16-3.81 9.64-3.41.28.03.4.19.37.48 0 .11-.04.23-.07.38ZM54.79 307.36c-.1.01-.2.01-.29.01a.656.656 0 0 1-.44-.19c-1.12-1.04-3.97-4.69-3.08-6.4.59-1.14 2.17-1.24 2.67-.17l3.15 6.74c.21.45.07.71-.42.78-.34.04-.6-.07-.78-.34a.869.869 0 0 0-.81-.43ZM228.35 310.52c.4.69.45 1.37.16 2.06-.3.71-.57.7-.82-.03l-2.18-6.43c-.16-.49.34-.93.8-.71 1.82.88 2.71 2.4 2.67 4.56-.01.18-.1.3-.27.36l-.33.11s-.05.04-.03.08ZM76.92 305.92l-2.27 1.28c-.29.16-.59.23-.91.21-1.21-.07-2.43.2-3.65.83-.4.21-.4.41-.01.62l1.37.74c.54.29.52.54-.06.75l-2.47.91c-.31.11-.62.16-.94.13l-5.92-.55c1.88-3.68 3.12-.55 5.06-1.63.15-.08.1-.32-.07-.33l-.6-.04a.52.52 0 0 1-.46-.62c.19-.86.86-1.41 2.01-1.66.98.05 1.94.07 2.88.07 2.19 0 3.67-1.47 6.04-.71ZM45.39 306.96c.07-.02.14.01.17.07l.02.05c.38.91-.45 2.12-1.85 2.71l-.36.15c-1.4.59-2.85.33-3.23-.57l-.02-.05c-.03-.07 0-.14.07-.17l5.2-2.19ZM236.23 309.12c.08.04.12.14.08.23l-.05.12c-.39.89-1.83 1.11-3.23.5l-.64-.28c-1.4-.61-2.22-1.82-1.83-2.71l.05-.12c.04-.09.14-.13.23-.09l5.39 2.35ZM100.71 312.89l5.51 2.61c.93-.69 1.61-.63 2.03.16l1.11 2.37c.15.31-.09.66-.43.65l-6.11-.21c-.78-.03-1.39.66-1.29 1.43l.3 2.26c.05.36-.32.63-.65.47-3.49-1.68-6.66-4.3-6.09-8.72l.8-.27c.33-.11.68.15.66.51-.05.98.3 1.78 1.07 2.4.3.24.64.34 1.03.3.51-.06.93.1 1.27.48.16.18.34.21.55.09l2.33-1.29c.09-.05.08-.09 0-.13-.68-.29-1.27-.15-1.76.4-.21.23-.45.28-.72.14-1.09-.54-1.96-1.34-2.62-2.4.35-.66.74-.77 1.15-.33.15.16.32.18.49.05l1.38-.97ZM151.7 315.54l-5.9 6.72c-.3.34-.83.3-.99-.08-.01-.05-.03-.15-.04-.31.12-4.44 2.7-6.12 6.93-6.33Z"
      style={{
        fill: "#e5c76d",
      }}
    />
    <path
      d="m250.84 90.86 3.68 10.81c.04.13.17.22.31.22.35 0 .52-.18.49-.53.39.42.49.77.32 1.04-.7 1.12-2.36 1-2.9-.2-1.75-3.88-4.37-7.01-1.9-11.34ZM252.72 109.96c1.99 1.05 2.91 2.98 2.76 5.81-.01.31.1.61.3.83.83.91 1.38.82 1.66-.26.63 2.75 2.17 4.6 4.64 5.55.29.11.62 0 .77-.29a.63.63 0 0 0-.21-.8c-1.86-1.26-3.3-2.88-4.31-4.86-.1-.2-.31-.33-.54-.32-.25 0-.46.09-.64.28-.11-1.37.29-2 1.2-1.91 1.37 2.95 3.23 5.42 5.57 7.39.17.14.34.22.49.23.22.03.38-.03.49-.18.22-.29.18-.53-.11-.74a6.167 6.167 0 0 1-2.27-2.96l.5-1.18 4.18 4.55c.22.24.22.48 0 .71-2.25 2.48-5.06 1.45-7.84.08a.71.71 0 0 0-.85.19l-1.33 1.62c-3.58-1.03-4.4-4.14-2.47-9.34.17-.45.02-.59-.43-.44-.88.31-1.34.99-1.39 2.05-.32 7.48-2.17 13.98-.18 21.39.35 1.28.27 2.19.4 3.47.23 2.37 1.57 3.88 1.39 6.61-2.18-2.29-4.83-14.62-4.82-18.03a64.44 64.44 0 0 1 3.03-19.45ZM246.37 279.14l7.67 1.83c-.72.54-.75 1.09-.08 1.66.29.25.63.35 1.01.31l3.94-.42c.29-.03.44.1.45.38.35 7.23-3.29 15.5-11.53 15.54-4.05.03-10.24-4.06-8.62-8.73 3.36 4.94 7.37 5.99 12.04 3.15.91-.55 1.25-1.35 1.02-2.39-.3-1.35-1.38-2.18-3.23-2.48.57-.33 1-.7 1.3-1.11l2.45 1.77c.68.49 1.56-.26 1.19-1.01l-2.17-4.45a.485.485 0 0 0-.26-.23c-.55-.2-.92-.14-1.11.19l-.14-.7c-.05-.26-.21-.42-.47-.49-.83-.2-1.98-1.14-3.46-2.82ZM51.79 306.7l-1.19 2.59c-.99.81-1.78 1.83-2.37 3.07-.11.24-.39.36-.64.27l-.27-.09c-.07-.02-.1-.1-.07-.17.69-1.53.94-3.13.76-4.81-.16-1.42 1.14-2.57 2.54-2.24 1.03.24 1.45.7 1.24 1.38ZM53.57 316.32l.93 3.07-.17.23a.64.64 0 0 1-.56.27c-2.17-.06-3.93-.68-5.28-1.86l5.08-1.71Z"
      style={{
        fill: "#e0ba56",
      }}
    />
  </svg>
    </SvgIcon>
  );
};
export default Monalisa;
